/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NonDeclaredType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Any; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Unit; });
/* harmony export (immutable) */ __webpack_exports__["g"] = Option;
/* unused harmony export some */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FableArray; });
/* harmony export (immutable) */ __webpack_exports__["h"] = Tuple;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FableFunction; });
/* harmony export (immutable) */ __webpack_exports__["d"] = GenericParam;
/* harmony export (immutable) */ __webpack_exports__["e"] = Interface;
/* harmony export (immutable) */ __webpack_exports__["v"] = makeGeneric;
/* unused harmony export isGeneric */
/* harmony export (immutable) */ __webpack_exports__["t"] = getDefinition;
/* harmony export (immutable) */ __webpack_exports__["s"] = extendInfo;
/* unused harmony export hasInterface */
/* harmony export (immutable) */ __webpack_exports__["u"] = getPropertyNames;
/* unused harmony export isArray */
/* harmony export (immutable) */ __webpack_exports__["y"] = toString;
/* unused harmony export hash */
/* harmony export (immutable) */ __webpack_exports__["p"] = equals;
/* harmony export (immutable) */ __webpack_exports__["k"] = comparePrimitives;
/* harmony export (immutable) */ __webpack_exports__["j"] = compare;
/* harmony export (immutable) */ __webpack_exports__["q"] = equalsRecords;
/* harmony export (immutable) */ __webpack_exports__["l"] = compareRecords;
/* harmony export (immutable) */ __webpack_exports__["r"] = equalsUnions;
/* harmony export (immutable) */ __webpack_exports__["m"] = compareUnions;
/* unused harmony export createDisposable */
/* unused harmony export createAtom */
/* harmony export (immutable) */ __webpack_exports__["n"] = createObj;
/* unused harmony export toPlainJsObj */
/* unused harmony export jsOptions */
/* harmony export (immutable) */ __webpack_exports__["x"] = round;
/* harmony export (immutable) */ __webpack_exports__["w"] = randomNext;
/* harmony export (immutable) */ __webpack_exports__["o"] = defaultArg;
/* unused harmony export defaultArgWith */
/* unused harmony export applyOperator */
/* unused harmony export parseNumber */
/* unused harmony export tryParse */
/* unused harmony export parse */
/* unused harmony export unescapeDataString */
/* unused harmony export escapeDataString */
/* unused harmony export escapeUriString */
/* unused harmony export clear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var NonDeclaredType = function () {
    function NonDeclaredType(kind, definition, generics) {
        _classCallCheck(this, NonDeclaredType);

        this.kind = kind;
        this.definition = definition;
        this.generics = generics;
    }

    _createClass(NonDeclaredType, [{
        key: "Equals",
        value: function Equals(other) {
            if (this.kind === other.kind && this.definition === other.definition) {
                return _typeof(this.generics) === "object" ? equalsRecords(this.generics, other.generics) : this.generics === other.generics;
            }
            return false;
        }
    }]);

    return NonDeclaredType;
}();
var Any = new NonDeclaredType("Any");
var Unit = new NonDeclaredType("Unit");
function Option(t) {
    return new NonDeclaredType("Option", null, [t]);
}
// HACK: For unit values use a truthy empty object (see #478, #1135, #1136)
function some(value) {
    return value == null ? {} : value;
}
function FableArray(t) {
    var isTypedArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var def = null;
    var genArg = null;
    if (isTypedArray) {
        def = t;
    } else {
        genArg = t;
    }
    return new NonDeclaredType("Array", def, [genArg]);
}

function Tuple(types) {
    return new NonDeclaredType("Tuple", null, types);
}
function FableFunction(types) {
    return new NonDeclaredType("Function", null, types);
}

function GenericParam(definition) {
    return new NonDeclaredType("GenericParam", definition);
}
function Interface(definition) {
    return new NonDeclaredType("Interface", definition);
}
function makeGeneric(typeDef, genArgs) {
    return new NonDeclaredType("GenericType", typeDef, genArgs);
}
function isGeneric(typ) {
    return typ instanceof NonDeclaredType && typ.kind === "GenericType";
}
/**
 * Returns the parent if this is a declared generic type or the argument otherwise.
 * Attention: Unlike .NET this doesn't throw an exception if type is not generic.
 */
function getDefinition(typ) {
    return isGeneric(typ) ? typ.definition : typ;
}
function extendInfo(cons, info) {
    var parent = Object.getPrototypeOf(cons.prototype);
    if (typeof parent[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection] === "function") {
        var newInfo = {};
        var parentInfo = parent[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]();
        Object.getOwnPropertyNames(info).forEach(function (k) {
            var i = info[k];
            if ((typeof i === "undefined" ? "undefined" : _typeof(i)) === "object") {
                newInfo[k] = Array.isArray(i) ? (parentInfo[k] || []).concat(i) : Object.assign(parentInfo[k] || {}, i);
            } else {
                newInfo[k] = i;
            }
        });
        return newInfo;
    }
    return info;
}
function hasInterface(obj, interfaceName) {
    if (interfaceName === "System.Collections.Generic.IEnumerable") {
        return typeof obj[Symbol.iterator] === "function";
    } else if (typeof obj[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection] === "function") {
        var interfaces = obj[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]().interfaces;
        return Array.isArray(interfaces) && interfaces.indexOf(interfaceName) > -1;
    }
    return false;
}
/**
 * Returns:
 * - Records: array with names of fields
 * - Classes: array with names of getters
 * - Nulls and unions: empty array
 * - JS Objects: The result of calling Object.getOwnPropertyNames
 */
function getPropertyNames(obj) {
    if (obj == null) {
        return [];
    }
    var propertyMap = typeof obj[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection] === "function" ? obj[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]().properties || [] : obj;
    return Object.getOwnPropertyNames(propertyMap);
}
function isArray(obj) {
    return Array.isArray(obj) || ArrayBuffer.isView(obj);
}
function toString(obj) {
    var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    function isObject(x) {
        return x !== null && (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" && !(x instanceof Number) && !(x instanceof String) && !(x instanceof Boolean);
    }
    if (obj == null || typeof obj === "number") {
        return String(obj);
    }
    if (typeof obj === "string") {
        return quoteStrings ? JSON.stringify(obj) : obj;
    }
    if (typeof obj.ToString === "function") {
        return obj.ToString();
    }
    if (hasInterface(obj, "FSharpUnion")) {
        var info = obj[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]();
        var uci = info.cases[obj.tag];
        switch (uci.length) {
            case 1:
                return uci[0];
            case 2:
                // For simplicity let's always use parens, in .NET they're ommitted in some cases
                return uci[0] + " (" + toString(obj.data, true) + ")";
            default:
                return uci[0] + " (" + obj.data.map(function (x) {
                    return toString(x, true);
                }).join(",") + ")";
        }
    }
    try {
        return JSON.stringify(obj, function (k, v) {
            return v && v[Symbol.iterator] && !Array.isArray(v) && isObject(v) ? Array.from(v) : v && typeof v.ToString === "function" ? toString(v) : v;
        });
    } catch (err) {
        // Fallback for objects with circular references
        return "{" + Object.getOwnPropertyNames(obj).map(function (k) {
            return k + ": " + String(obj[k]);
        }).join(", ") + "}";
    }
}
function hash(x) {
    if (x != null && typeof x.GetHashCode === "function") {
        return x.GetHashCode();
    } else {
        var s = JSON.stringify(x);
        var h = 5381;
        var i = 0;
        var len = s.length;
        while (i < len) {
            h = h * 33 ^ s.charCodeAt(i++);
        }
        return h;
    }
}
function equals(x, y) {
    // Optimization if they are referencially equal
    if (x === y) {
        return true;
    } else if (x == null) {
        return y == null;
    } else if (y == null) {
        return false;
    } else if (Object.getPrototypeOf(x) !== Object.getPrototypeOf(y)) {
        return false;
        // Equals override or IEquatable implementation
    } else if (typeof x.Equals === "function") {
        return x.Equals(y);
    } else if (Array.isArray(x)) {
        if (x.length !== y.length) {
            return false;
        }
        for (var i = 0; i < x.length; i++) {
            if (!equals(x[i], y[i])) {
                return false;
            }
        }
        return true;
    } else if (ArrayBuffer.isView(x)) {
        if (x.byteLength !== y.byteLength) {
            return false;
        }
        var dv1 = new DataView(x.buffer);
        var dv2 = new DataView(y.buffer);
        for (var _i = 0; _i < x.byteLength; _i++) {
            if (dv1.getUint8(_i) !== dv2.getUint8(_i)) {
                return false;
            }
        }
        return true;
    } else if (x instanceof Date) {
        return x.getTime() === y.getTime();
    } else {
        return false;
    }
}
function comparePrimitives(x, y) {
    return x === y ? 0 : x < y ? -1 : 1;
}
function compare(x, y) {
    // Optimization if they are referencially equal
    if (x === y) {
        return 0;
    } else if (x == null) {
        return y == null ? 0 : -1;
    } else if (y == null) {
        return 1; // everything is bigger than null
    } else if (Object.getPrototypeOf(x) !== Object.getPrototypeOf(y)) {
        return -1;
        // Some types (see Long.ts) may just implement the function and not the interface
        // else if (hasInterface(x, "System.IComparable"))
    } else if (typeof x.CompareTo === "function") {
        return x.CompareTo(y);
    } else if (Array.isArray(x)) {
        if (x.length !== y.length) {
            return x.length < y.length ? -1 : 1;
        }
        for (var i = 0, j = 0; i < x.length; i++) {
            j = compare(x[i], y[i]);
            if (j !== 0) {
                return j;
            }
        }
        return 0;
    } else if (ArrayBuffer.isView(x)) {
        if (x.byteLength !== y.byteLength) {
            return x.byteLength < y.byteLength ? -1 : 1;
        }
        var dv1 = new DataView(x.buffer);
        var dv2 = new DataView(y.buffer);
        for (var _i2 = 0, b1 = 0, b2 = 0; _i2 < x.byteLength; _i2++) {
            b1 = dv1.getUint8(_i2), b2 = dv2.getUint8(_i2);
            if (b1 < b2) {
                return -1;
            }
            if (b1 > b2) {
                return 1;
            }
        }
        return 0;
    } else if (x instanceof Date) {
        var xtime = x.getTime();
        var ytime = y.getTime();
        return xtime === ytime ? 0 : xtime < ytime ? -1 : 1;
    } else if ((typeof x === "undefined" ? "undefined" : _typeof(x)) === "object") {
        var xhash = hash(x);
        var yhash = hash(y);
        if (xhash === yhash) {
            return equals(x, y) ? 0 : -1;
        } else {
            return xhash < yhash ? -1 : 1;
        }
    } else {
        return x < y ? -1 : 1;
    }
}
function equalsRecords(x, y) {
    // Optimization if they are referencially equal
    if (x === y) {
        return true;
    } else {
        var keys = getPropertyNames(x);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                if (!equals(x[key], y[key])) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return true;
    }
}
function compareRecords(x, y) {
    // Optimization if they are referencially equal
    if (x === y) {
        return 0;
    } else {
        var keys = getPropertyNames(x);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                var res = compare(x[key], y[key]);
                if (res !== 0) {
                    return res;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return 0;
    }
}
function equalsUnions(x, y) {
    return x === y || x.tag === y.tag && equals(x.data, y.data);
}
function compareUnions(x, y) {
    if (x === y) {
        return 0;
    } else {
        var res = x.tag < y.tag ? -1 : x.tag > y.tag ? 1 : 0;
        return res !== 0 ? res : compare(x.data, y.data);
    }
}
function createDisposable(f) {
    return _defineProperty({
        Dispose: f
    }, __WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection, function () {
        return { interfaces: ["System.IDisposable"] };
    });
}
// tslint forbids non-arrow functions, but it's
// necessary here to use the arguments object
/* tslint:disable */
function createAtom(value) {
    var atom = value;
    return function () {
        return arguments.length === 0 ? atom : (atom = arguments[0], void 0);
    };
}
/* tslint:enable */
var CaseRules = {
    None: 0,
    LowerFirst: 1
};
function isList(o) {
    if (o != null) {
        if (typeof o[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection] === "function") {
            return o[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]().type === "Microsoft.FSharp.Collections.FSharpList";
        }
    }
    return false;
}
function createObj(fields) {
    var caseRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CaseRules.None;
    var casesCache = arguments[2];

    var iter = fields[Symbol.iterator]();
    var cur = iter.next();
    var o = {};
    while (!cur.done) {
        var value = cur.value;
        if (Array.isArray(value)) {
            o[value[0]] = value[1];
        } else {
            casesCache = casesCache || new Map();
            var proto = Object.getPrototypeOf(value);
            var cases = casesCache.get(proto);
            if (cases == null) {
                if (typeof proto[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection] === "function") {
                    cases = proto[__WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection]().cases;
                    casesCache.set(proto, cases);
                }
            }
            var caseInfo = cases != null ? cases[value.tag] : null;
            if (Array.isArray(caseInfo)) {
                var key = caseInfo[0];
                if (caseRule === CaseRules.LowerFirst) {
                    key = key[0].toLowerCase() + key.substr(1);
                }
                o[key] = caseInfo.length === 1 ? true : isList(value.data) ? createObj(value.data, caseRule, casesCache) : value.data;
            } else {
                throw new Error("Cannot infer key and value of " + value);
            }
        }
        cur = iter.next();
    }
    return o;
}
function toPlainJsObj(source) {
    if (source != null && source.constructor !== Object) {
        var target = {};
        var props = Object.getOwnPropertyNames(source);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = props[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var p = _step3.value;

                target[p] = source[p];
            }
            // Copy also properties from prototype, see #192
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        var proto = Object.getPrototypeOf(source);
        if (proto != null) {
            props = Object.getOwnPropertyNames(proto);
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = props[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _p = _step4.value;

                    var prop = Object.getOwnPropertyDescriptor(proto, _p);
                    if (prop.value) {
                        target[_p] = prop.value;
                    } else if (prop.get) {
                        target[_p] = prop.get.apply(source);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
        return target;
    } else {
        return source;
    }
}
function jsOptions(mutator) {
    var opts = {};
    mutator(opts);
    return opts;
}
function round(value) {
    var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var m = Math.pow(10, digits);
    var n = +(digits ? value * m : value).toFixed(8);
    var i = Math.floor(n);
    var f = n - i;
    var e = 1e-8;
    var r = f > 0.5 - e && f < 0.5 + e ? i % 2 === 0 ? i : i + 1 : Math.round(n);
    return digits ? r / m : r;
}
function randomNext(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}
function defaultArg(arg, defaultValue, f) {
    return arg == null ? defaultValue : f != null ? f(arg) : arg;
}
function defaultArgWith(arg, defThunk) {
    return arg == null ? defThunk() : arg;
}
function applyOperator(x, y, operator) {
    function getMethod(obj) {
        if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
            var cons = Object.getPrototypeOf(obj).constructor;
            if (typeof cons[operator] === "function") {
                return cons[operator];
            }
        }
        return null;
    }
    var meth = getMethod(x);
    if (meth != null) {
        return meth(x, y);
    }
    meth = getMethod(y);
    if (meth != null) {
        return meth(x, y);
    }
    switch (operator) {
        case "op_Addition":
            return x + y;
        case "op_Subtraction":
            return x - y;
        case "op_Multiply":
            return x * y;
        case "op_Division":
            return x / y;
        case "op_Modulus":
            return x % y;
        case "op_LeftShift":
            return x << y;
        case "op_RightShift":
            return x >> y;
        case "op_BitwiseAnd":
            return x & y;
        case "op_BitwiseOr":
            return x | y;
        case "op_ExclusiveOr":
            return x ^ y;
        case "op_LogicalNot":
            return x + y;
        case "op_UnaryNegation":
            return !x;
        case "op_BooleanAnd":
            return x && y;
        case "op_BooleanOr":
            return x || y;
        default:
            return null;
    }
}
function parseNumber(v) {
    return +v;
}
function tryParse(v, initial, parser, fn) {
    if (v != null) {
        var a = parser.exec(v);
        if (a !== null) {
            return [true, fn(a[1])];
        }
    }
    return [false, initial];
}
function parse(v, initial, parser, fn) {
    var a = tryParse(v, initial, parser, fn);
    if (a[0]) {
        return a[1];
    } else {
        // TODO FormatException ?
        throw new Error("Input string was not in a correct format.");
    }
}
function unescapeDataString(s) {
    // https://stackoverflow.com/a/4458580/524236
    return decodeURIComponent(s.replace(/\+/g, "%20"));
}
function escapeDataString(s) {
    return encodeURIComponent(s).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A");
}
function escapeUriString(s) {
    return encodeURI(s);
}
// ICollection.Clear method can be called on IDictionary
// too so we need to make a runtime check (see #1120)
function clear(col) {
    if (Array.isArray(col)) {
        col.splice(0);
    } else {
        col.clear();
    }
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getType;
var types = new Map();
function setType(fullName, cons) {
    types.set(fullName, cons);
}
function getType(fullName) {
    return types.get(fullName);
}
/* harmony default export */ __webpack_exports__["a"] = ({
    reflection: Symbol("reflection")
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Enumerator */
/* unused harmony export getEnumerator */
/* unused harmony export toIterator */
/* harmony export (immutable) */ __webpack_exports__["B"] = toList;
/* unused harmony export ofList */
/* unused harmony export ofArray */
/* unused harmony export append */
/* unused harmony export average */
/* harmony export (immutable) */ __webpack_exports__["a"] = averageBy;
/* harmony export (immutable) */ __webpack_exports__["e"] = concat;
/* harmony export (immutable) */ __webpack_exports__["c"] = collect;
/* harmony export (immutable) */ __webpack_exports__["b"] = choose;
/* harmony export (immutable) */ __webpack_exports__["d"] = compareWith;
/* unused harmony export delay */
/* unused harmony export empty */
/* unused harmony export enumerateWhile */
/* unused harmony export enumerateThenFinally */
/* unused harmony export enumerateUsing */
/* unused harmony export exactlyOne */
/* harmony export (immutable) */ __webpack_exports__["g"] = except;
/* harmony export (immutable) */ __webpack_exports__["h"] = exists;
/* unused harmony export exists2 */
/* harmony export (immutable) */ __webpack_exports__["i"] = filter;
/* unused harmony export where */
/* harmony export (immutable) */ __webpack_exports__["j"] = fold;
/* harmony export (immutable) */ __webpack_exports__["k"] = foldBack;
/* unused harmony export fold2 */
/* unused harmony export foldBack2 */
/* harmony export (immutable) */ __webpack_exports__["l"] = forAll;
/* unused harmony export forAll2 */
/* harmony export (immutable) */ __webpack_exports__["D"] = tryHead;
/* harmony export (immutable) */ __webpack_exports__["m"] = head;
/* unused harmony export initialize */
/* unused harmony export initializeInfinite */
/* unused harmony export tryItem */
/* unused harmony export item */
/* harmony export (immutable) */ __webpack_exports__["o"] = iterate;
/* unused harmony export iterate2 */
/* unused harmony export iterateIndexed */
/* unused harmony export iterateIndexed2 */
/* harmony export (immutable) */ __webpack_exports__["n"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["E"] = tryLast;
/* harmony export (immutable) */ __webpack_exports__["p"] = last;
/* harmony export (immutable) */ __webpack_exports__["f"] = count;
/* harmony export (immutable) */ __webpack_exports__["q"] = map;
/* harmony export (immutable) */ __webpack_exports__["r"] = mapIndexed;
/* unused harmony export indexed */
/* unused harmony export map2 */
/* unused harmony export mapIndexed2 */
/* unused harmony export map3 */
/* unused harmony export chunkBySize */
/* unused harmony export mapFold */
/* unused harmony export mapFoldBack */
/* unused harmony export max */
/* unused harmony export maxBy */
/* unused harmony export min */
/* unused harmony export minBy */
/* unused harmony export pairwise */
/* unused harmony export permute */
/* unused harmony export rangeStep */
/* unused harmony export rangeChar */
/* harmony export (immutable) */ __webpack_exports__["t"] = range;
/* unused harmony export readOnly */
/* harmony export (immutable) */ __webpack_exports__["u"] = reduce;
/* unused harmony export reduceBack */
/* unused harmony export replicate */
/* harmony export (immutable) */ __webpack_exports__["v"] = reverse;
/* harmony export (immutable) */ __webpack_exports__["w"] = scan;
/* unused harmony export scanBack */
/* harmony export (immutable) */ __webpack_exports__["x"] = singleton;
/* unused harmony export skip */
/* unused harmony export skipWhile */
/* harmony export (immutable) */ __webpack_exports__["y"] = sortWith;
/* unused harmony export sum */
/* harmony export (immutable) */ __webpack_exports__["z"] = sumBy;
/* unused harmony export tail */
/* harmony export (immutable) */ __webpack_exports__["A"] = take;
/* harmony export (immutable) */ __webpack_exports__["C"] = truncate;
/* unused harmony export takeWhile */
/* unused harmony export tryFind */
/* unused harmony export find */
/* unused harmony export tryFindBack */
/* unused harmony export findBack */
/* unused harmony export tryFindIndex */
/* unused harmony export findIndex */
/* unused harmony export tryFindIndexBack */
/* unused harmony export findIndexBack */
/* harmony export (immutable) */ __webpack_exports__["F"] = tryPick;
/* harmony export (immutable) */ __webpack_exports__["s"] = pick;
/* unused harmony export unfold */
/* unused harmony export zip */
/* unused harmony export zip3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Array__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Enumerator = function () {
    function Enumerator(iter) {
        _classCallCheck(this, Enumerator);

        this.iter = iter;
    }

    _createClass(Enumerator, [{
        key: "MoveNext",
        value: function MoveNext() {
            var cur = this.iter.next();
            this.current = cur.value;
            return !cur.done;
        }
    }, {
        key: "Reset",
        value: function Reset() {
            throw new Error("JS iterators cannot be reset");
        }
    }, {
        key: "Dispose",
        value: function Dispose() {
            return;
        }
    }, {
        key: "Current",
        get: function get() {
            return this.current;
        }
    }, {
        key: "get_Current",
        get: function get() {
            return this.current;
        }
    }]);

    return Enumerator;
}();
function getEnumerator(o) {
    return typeof o.GetEnumerator === "function" ? o.GetEnumerator() : new Enumerator(o[Symbol.iterator]());
}
function toIterator(en) {
    return {
        next: function next() {
            return en.MoveNext() ? { done: false, value: en.Current } : { done: true, value: null };
        }
    };
}
function __failIfNone(res) {
    if (res == null) {
        throw new Error("Seq did not contain any matching element");
    }
    return res;
}
function toList(xs) {
    return foldBack(function (x, acc) {
        return new __WEBPACK_IMPORTED_MODULE_1__ListClass__["a" /* default */](x, acc);
    }, xs, new __WEBPACK_IMPORTED_MODULE_1__ListClass__["a" /* default */]());
}
function ofList(xs) {
    return delay(function () {
        return unfold(function (x) {
            return x.tail != null ? [x.head, x.tail] : null;
        }, xs);
    });
}
function ofArray(xs) {
    return delay(function () {
        return unfold(function (i) {
            return i < xs.length ? [xs[i], i + 1] : null;
        }, 0);
    });
}
function append(xs, ys) {
    return delay(function () {
        var firstDone = false;
        var i = xs[Symbol.iterator]();
        var iters = [i, null];
        return unfold(function () {
            var cur = void 0;
            if (!firstDone) {
                cur = iters[0].next();
                if (!cur.done) {
                    return [cur.value, iters];
                } else {
                    firstDone = true;
                    iters = [null, ys[Symbol.iterator]()];
                }
            }
            cur = iters[1].next();
            return !cur.done ? [cur.value, iters] : null;
        }, iters);
    });
}
function average(xs) {
    var count = 1;
    var sum = reduce(function (acc, x) {
        count++;
        return acc + x;
    }, xs);
    return sum / count;
}
function averageBy(f, xs) {
    var count = 1;
    var sum = reduce(function (acc, x) {
        count++;
        return (count === 2 ? f(acc) : acc) + f(x);
    }, xs);
    return sum / count;
}
function concat(xs) {
    return delay(function () {
        var iter = xs[Symbol.iterator]();
        var output = { value: null };
        return unfold(function (innerIter) {
            var hasFinished = false;
            while (!hasFinished) {
                if (innerIter == null) {
                    var cur = iter.next();
                    if (!cur.done) {
                        innerIter = cur.value[Symbol.iterator]();
                    } else {
                        hasFinished = true;
                    }
                } else {
                    var _cur = innerIter.next();
                    if (!_cur.done) {
                        output = { value: _cur.value };
                        hasFinished = true;
                    } else {
                        innerIter = null;
                    }
                }
            }
            return innerIter != null && output != null ? [output.value, innerIter] : null;
        }, null);
    });
}
function collect(f, xs) {
    return concat(map(f, xs));
}
function choose(f, xs) {
    return delay(function () {
        return unfold(function (iter) {
            var cur = iter.next();
            while (!cur.done) {
                var y = f(cur.value);
                if (y != null) {
                    return [y, iter];
                }
                cur = iter.next();
            }
            return null;
        }, xs[Symbol.iterator]());
    });
}
function compareWith(f, xs, ys) {
    var nonZero = tryFind(function (i) {
        return i !== 0;
    }, map2(function (x, y) {
        return f(x, y);
    }, xs, ys));
    return nonZero != null ? nonZero : count(xs) - count(ys);
}
function delay(f) {
    return _defineProperty({}, Symbol.iterator, function () {
        return f()[Symbol.iterator]();
    });
}
function empty() {
    return unfold(function () {
        return void 0;
    });
}
function enumerateWhile(cond, xs) {
    return concat(unfold(function () {
        return cond() ? [xs, true] : null;
    }));
}
function enumerateThenFinally(xs, finalFn) {
    return delay(function () {
        var iter = void 0;
        try {
            iter = xs[Symbol.iterator]();
        } catch (err) {
            return void 0;
        } finally {
            finalFn();
        }
        return unfold(function (it) {
            try {
                var cur = it.next();
                return !cur.done ? [cur.value, it] : null;
            } catch (err) {
                return void 0;
            } finally {
                finalFn();
            }
        }, iter);
    });
}
function enumerateUsing(disp, work) {
    var isDisposed = false;
    var disposeOnce = function disposeOnce() {
        if (!isDisposed) {
            isDisposed = true;
            disp.Dispose();
        }
    };
    try {
        return enumerateThenFinally(work(disp), disposeOnce);
    } catch (err) {
        return void 0;
    } finally {
        disposeOnce();
    }
}
function exactlyOne(xs) {
    var iter = xs[Symbol.iterator]();
    var fst = iter.next();
    if (fst.done) {
        throw new Error("Seq was empty");
    }
    var snd = iter.next();
    if (!snd.done) {
        throw new Error("Seq had multiple items");
    }
    return fst.value;
}
function except(itemsToExclude, source) {
    var exclusionItems = Array.from(itemsToExclude);
    var testIsNotInExclusionItems = function testIsNotInExclusionItems(element) {
        return !exclusionItems.some(function (excludedItem) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["p" /* equals */])(excludedItem, element);
        });
    };
    return filter(testIsNotInExclusionItems, source);
}
function exists(f, xs) {
    var cur = void 0;
    for (var iter = xs[Symbol.iterator]();;) {
        cur = iter.next();
        if (cur.done) {
            break;
        }
        if (f(cur.value)) {
            return true;
        }
    }
    return false;
}
function exists2(f, xs, ys) {
    var cur1 = void 0;
    var cur2 = void 0;
    for (var iter1 = xs[Symbol.iterator](), iter2 = ys[Symbol.iterator]();;) {
        cur1 = iter1.next();
        cur2 = iter2.next();
        if (cur1.done || cur2.done) {
            break;
        }
        if (f(cur1.value, cur2.value)) {
            return true;
        }
    }
    return false;
}
function filter(f, xs) {
    return delay(function () {
        return unfold(function (iter) {
            var cur = iter.next();
            while (!cur.done) {
                if (f(cur.value)) {
                    return [cur.value, iter];
                }
                cur = iter.next();
            }
            return null;
        }, xs[Symbol.iterator]());
    });
}
function where(f, xs) {
    return filter(f, xs);
}
function fold(f, acc, xs) {
    if (Array.isArray(xs) || ArrayBuffer.isView(xs)) {
        return xs.reduce(f, acc);
    } else {
        var cur = void 0;
        for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
            cur = iter.next();
            if (cur.done) {
                break;
            }
            acc = f(acc, cur.value, i);
        }
        return acc;
    }
}
function foldBack(f, xs, acc) {
    var arr = Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs : Array.from(xs);
    for (var i = arr.length - 1; i >= 0; i--) {
        acc = f(arr[i], acc, i);
    }
    return acc;
}
function fold2(f, acc, xs, ys) {
    var iter1 = xs[Symbol.iterator]();
    var iter2 = ys[Symbol.iterator]();
    var cur1 = void 0;
    var cur2 = void 0;
    for (var i = 0;; i++) {
        cur1 = iter1.next();
        cur2 = iter2.next();
        if (cur1.done || cur2.done) {
            break;
        }
        acc = f(acc, cur1.value, cur2.value, i);
    }
    return acc;
}
function foldBack2(f, xs, ys, acc) {
    var ar1 = Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs : Array.from(xs);
    var ar2 = Array.isArray(ys) || ArrayBuffer.isView(ys) ? ys : Array.from(ys);
    for (var i = ar1.length - 1; i >= 0; i--) {
        acc = f(ar1[i], ar2[i], acc, i);
    }
    return acc;
}
function forAll(f, xs) {
    return fold(function (acc, x) {
        return acc && f(x);
    }, true, xs);
}
function forAll2(f, xs, ys) {
    return fold2(function (acc, x, y) {
        return acc && f(x, y);
    }, true, xs, ys);
}
function tryHead(xs) {
    var iter = xs[Symbol.iterator]();
    var cur = iter.next();
    return cur.done ? null : cur.value;
}
function head(xs) {
    return __failIfNone(tryHead(xs));
}
function initialize(n, f) {
    return delay(function () {
        return unfold(function (i) {
            return i < n ? [f(i), i + 1] : null;
        }, 0);
    });
}
function initializeInfinite(f) {
    return delay(function () {
        return unfold(function (i) {
            return [f(i), i + 1];
        }, 0);
    });
}
function tryItem(i, xs) {
    if (i < 0) {
        return null;
    }
    if (Array.isArray(xs) || ArrayBuffer.isView(xs)) {
        return i < xs.length ? xs[i] : null;
    }
    for (var j = 0, iter = xs[Symbol.iterator]();; j++) {
        var cur = iter.next();
        if (cur.done) {
            return null;
        }
        if (j === i) {
            return cur.value;
        }
    }
}
function item(i, xs) {
    return __failIfNone(tryItem(i, xs));
}
function iterate(f, xs) {
    fold(function (_, x) {
        return f(x);
    }, null, xs);
}
function iterate2(f, xs, ys) {
    fold2(function (_, x, y) {
        return f(x, y);
    }, null, xs, ys);
}
function iterateIndexed(f, xs) {
    fold(function (_, x, i) {
        return f(i, x);
    }, null, xs);
}
function iterateIndexed2(f, xs, ys) {
    fold2(function (_, x, y, i) {
        return f(i, x, y);
    }, null, xs, ys);
}
function isEmpty(xs) {
    var i = xs[Symbol.iterator]();
    return i.next().done;
}
function tryLast(xs) {
    try {
        return reduce(function (_, x) {
            return x;
        }, xs);
    } catch (err) {
        return null;
    }
}
function last(xs) {
    return __failIfNone(tryLast(xs));
}
// A export function 'length' method causes problems in JavaScript -- https://github.com/Microsoft/TypeScript/issues/442
function count(xs) {
    return Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs.length : fold(function (acc, x) {
        return acc + 1;
    }, 0, xs);
}
function map(f, xs) {
    return delay(function () {
        return unfold(function (iter) {
            var cur = iter.next();
            return !cur.done ? [f(cur.value), iter] : null;
        }, xs[Symbol.iterator]());
    });
}
function mapIndexed(f, xs) {
    return delay(function () {
        var i = 0;
        return unfold(function (iter) {
            var cur = iter.next();
            return !cur.done ? [f(i++, cur.value), iter] : null;
        }, xs[Symbol.iterator]());
    });
}
function indexed(xs) {
    return mapIndexed(function (i, x) {
        return [i, x];
    }, xs);
}
function map2(f, xs, ys) {
    return delay(function () {
        var iter1 = xs[Symbol.iterator]();
        var iter2 = ys[Symbol.iterator]();
        return unfold(function () {
            var cur1 = iter1.next();
            var cur2 = iter2.next();
            return !cur1.done && !cur2.done ? [f(cur1.value, cur2.value), null] : null;
        });
    });
}
function mapIndexed2(f, xs, ys) {
    return delay(function () {
        var i = 0;
        var iter1 = xs[Symbol.iterator]();
        var iter2 = ys[Symbol.iterator]();
        return unfold(function () {
            var cur1 = iter1.next();
            var cur2 = iter2.next();
            return !cur1.done && !cur2.done ? [f(i++, cur1.value, cur2.value), null] : null;
        });
    });
}
function map3(f, xs, ys, zs) {
    return delay(function () {
        var iter1 = xs[Symbol.iterator]();
        var iter2 = ys[Symbol.iterator]();
        var iter3 = zs[Symbol.iterator]();
        return unfold(function () {
            var cur1 = iter1.next();
            var cur2 = iter2.next();
            var cur3 = iter3.next();
            return !cur1.done && !cur2.done && !cur3.done ? [f(cur1.value, cur2.value, cur3.value), null] : null;
        });
    });
}
function chunkBySize(size, xs) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_0__Array__["a" /* chunkBySize */])(size, Array.from(xs));
    return ofArray(result.map(ofArray));
}
function mapFold(f, acc, xs, transform) {
    var result = [];
    var r = void 0;
    var cur = void 0;
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        cur = iter.next();
        if (cur.done) {
            break;
        }

        var _f = f(acc, cur.value);

        var _f2 = _slicedToArray(_f, 2);

        r = _f2[0];
        acc = _f2[1];

        result.push(r);
    }
    return transform !== void 0 ? [transform(result), acc] : [result, acc];
}
function mapFoldBack(f, xs, acc, transform) {
    var arr = Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs : Array.from(xs);
    var result = [];
    var r = void 0;
    for (var i = arr.length - 1; i >= 0; i--) {
        var _f3 = f(arr[i], acc);

        var _f4 = _slicedToArray(_f3, 2);

        r = _f4[0];
        acc = _f4[1];

        result.push(r);
    }
    return transform !== void 0 ? [transform(result), acc] : [result, acc];
}
function max(xs) {
    return reduce(function (acc, x) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(acc, x) === 1 ? acc : x;
    }, xs);
}
function maxBy(f, xs) {
    return reduce(function (acc, x) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(f(acc), f(x)) === 1 ? acc : x;
    }, xs);
}
function min(xs) {
    return reduce(function (acc, x) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(acc, x) === -1 ? acc : x;
    }, xs);
}
function minBy(f, xs) {
    return reduce(function (acc, x) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(f(acc), f(x)) === -1 ? acc : x;
    }, xs);
}
function pairwise(xs) {
    return skip(2, scan(function (last, next) {
        return [last[1], next];
    }, [0, 0], xs));
}
function permute(f, xs) {
    return ofArray(Object(__WEBPACK_IMPORTED_MODULE_0__Array__["c" /* permute */])(f, Array.from(xs)));
}
function rangeStep(first, step, last) {
    if (step === 0) {
        throw new Error("Step cannot be 0");
    }
    return delay(function () {
        return unfold(function (x) {
            return step > 0 && x <= last || step < 0 && x >= last ? [x, x + step] : null;
        }, first);
    });
}
function rangeChar(first, last) {
    return delay(function () {
        return unfold(function (x) {
            return x <= last ? [x, String.fromCharCode(x.charCodeAt(0) + 1)] : null;
        }, first);
    });
}
function range(first, last) {
    return rangeStep(first, 1, last);
}
function readOnly(xs) {
    return map(function (x) {
        return x;
    }, xs);
}
function reduce(f, xs) {
    if (Array.isArray(xs) || ArrayBuffer.isView(xs)) {
        return xs.reduce(f);
    }
    var iter = xs[Symbol.iterator]();
    var cur = iter.next();
    if (cur.done) {
        throw new Error("Seq was empty");
    }
    var acc = cur.value;
    while (true) {
        cur = iter.next();
        if (cur.done) {
            break;
        }
        acc = f(acc, cur.value);
    }
    return acc;
}
function reduceBack(f, xs) {
    var ar = Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs : Array.from(xs);
    if (ar.length === 0) {
        throw new Error("Seq was empty");
    }
    var acc = ar[ar.length - 1];
    for (var i = ar.length - 2; i >= 0; i--) {
        acc = f(ar[i], acc, i);
    }
    return acc;
}
function replicate(n, x) {
    return initialize(n, function () {
        return x;
    });
}
function reverse(xs) {
    var ar = Array.isArray(xs) || ArrayBuffer.isView(xs) ? xs.slice(0) : Array.from(xs);
    return ofArray(ar.reverse());
}
function scan(f, seed, xs) {
    return delay(function () {
        var iter = xs[Symbol.iterator]();
        return unfold(function (acc) {
            if (acc == null) {
                return [seed, seed];
            }
            var cur = iter.next();
            if (!cur.done) {
                acc = f(acc, cur.value);
                return [acc, acc];
            }
            return void 0;
        }, null);
    });
}
function scanBack(f, xs, seed) {
    return reverse(scan(function (acc, x) {
        return f(x, acc);
    }, seed, reverse(xs)));
}
function singleton(y) {
    return unfold(function (x) {
        return x != null ? [x, null] : null;
    }, y);
}
function skip(n, xs) {
    return _defineProperty({}, Symbol.iterator, function () {
        var iter = xs[Symbol.iterator]();
        for (var i = 1; i <= n; i++) {
            if (iter.next().done) {
                throw new Error("Seq has not enough elements");
            }
        }
        return iter;
    });
}
function skipWhile(f, xs) {
    return delay(function () {
        var hasPassed = false;
        return filter(function (x) {
            return hasPassed || (hasPassed = !f(x));
        }, xs);
    });
}
function sortWith(f, xs) {
    var ys = Array.from(xs);
    return ofArray(ys.sort(f));
}
function sum(xs) {
    return fold(function (acc, x) {
        return acc + x;
    }, 0, xs);
}
function sumBy(f, xs) {
    return fold(function (acc, x) {
        return acc + f(x);
    }, 0, xs);
}
function tail(xs) {
    var iter = xs[Symbol.iterator]();
    var cur = iter.next();
    if (cur.done) {
        throw new Error("Seq was empty");
    }
    return _defineProperty({}, Symbol.iterator, function () {
        return iter;
    });
}
function take(n, xs) {
    var truncate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return delay(function () {
        var iter = xs[Symbol.iterator]();
        return unfold(function (i) {
            if (i < n) {
                var cur = iter.next();
                if (!cur.done) {
                    return [cur.value, i + 1];
                }
                if (!truncate) {
                    throw new Error("Seq has not enough elements");
                }
            }
            return void 0;
        }, 0);
    });
}
function truncate(n, xs) {
    return take(n, xs, true);
}
function takeWhile(f, xs) {
    return delay(function () {
        var iter = xs[Symbol.iterator]();
        return unfold(function (i) {
            var cur = iter.next();
            if (!cur.done && f(cur.value)) {
                return [cur.value, null];
            }
            return void 0;
        }, 0);
    });
}
function tryFind(f, xs, defaultValue) {
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        var cur = iter.next();
        if (cur.done) {
            return defaultValue === void 0 ? null : defaultValue;
        }
        if (f(cur.value, i)) {
            return cur.value;
        }
    }
}
function find(f, xs) {
    return __failIfNone(tryFind(f, xs));
}
function tryFindBack(f, xs, defaultValue) {
    var match = null;
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        var cur = iter.next();
        if (cur.done) {
            return match === null ? defaultValue === void 0 ? null : defaultValue : match;
        }
        if (f(cur.value, i)) {
            match = cur.value;
        }
    }
}
function findBack(f, xs) {
    return __failIfNone(tryFindBack(f, xs));
}
function tryFindIndex(f, xs) {
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        var cur = iter.next();
        if (cur.done) {
            return null;
        }
        if (f(cur.value, i)) {
            return i;
        }
    }
}
function findIndex(f, xs) {
    return __failIfNone(tryFindIndex(f, xs));
}
function tryFindIndexBack(f, xs) {
    var match = -1;
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        var cur = iter.next();
        if (cur.done) {
            return match === -1 ? null : match;
        }
        if (f(cur.value, i)) {
            match = i;
        }
    }
}
function findIndexBack(f, xs) {
    return __failIfNone(tryFindIndexBack(f, xs));
}
function tryPick(f, xs) {
    for (var i = 0, iter = xs[Symbol.iterator]();; i++) {
        var cur = iter.next();
        if (cur.done) {
            break;
        }
        var y = f(cur.value, i);
        if (y != null) {
            return y;
        }
    }
    return void 0;
}
function pick(f, xs) {
    return __failIfNone(tryPick(f, xs));
}
function unfold(f, acc) {
    return _defineProperty({}, Symbol.iterator, function () {
        return {
            next: function next() {
                var res = f(acc);
                if (res != null) {
                    acc = res[1];
                    return { done: false, value: res[0] };
                }
                return { done: true };
            }
        };
    });
}
function zip(xs, ys) {
    return map2(function (x, y) {
        return [x, y];
    }, xs, ys);
}
function zip3(xs, ys, zs) {
    return map3(function (x, y, z) {
        return [x, y, z];
    }, xs, ys, zs);
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = append;
/* unused harmony export choose */
/* unused harmony export collect */
/* unused harmony export concat */
/* harmony export (immutable) */ __webpack_exports__["c"] = filter;
/* unused harmony export where */
/* unused harmony export initialize */
/* harmony export (immutable) */ __webpack_exports__["d"] = map;
/* unused harmony export mapIndexed */
/* unused harmony export indexed */
/* unused harmony export partition */
/* unused harmony export replicate */
/* harmony export (immutable) */ __webpack_exports__["f"] = reverse;
/* unused harmony export singleton */
/* unused harmony export slice */
/* unused harmony export unzip */
/* unused harmony export unzip3 */
/* unused harmony export groupBy */
/* unused harmony export splitAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Seq__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__ListClass__["b"]; });







/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]);

function append(xs, ys) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        return new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, acc);
    }, ys, reverse(xs));
}
function choose(f, xs) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        var y = f(x);
        return y != null ? new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](y, acc) : acc;
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs);
    return reverse(r);
}
function collect(f, xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        return append(acc, f(x));
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs);
}
// TODO: should be xs: Iterable<List<T>>
function concat(xs) {
    return collect(function (x) {
        return x;
    }, xs);
}
function filter(f, xs) {
    return reverse(Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        return f(x) ? new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, acc) : acc;
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs));
}
function where(f, xs) {
    return filter(f, xs);
}
function initialize(n, f) {
    if (n < 0) {
        throw new Error("List length must be non-negative");
    }
    var xs = new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]();
    for (var i = 1; i <= n; i++) {
        xs = new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](f(n - i), xs);
    }
    return xs;
}
function map(f, xs) {
    return reverse(Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        return new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](f(x), acc);
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs));
}
function mapIndexed(f, xs) {
    return reverse(Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x, i) {
        return new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](f(i, x), acc);
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs));
}
function indexed(xs) {
    return mapIndexed(function (i, x) {
        return [i, x];
    }, xs);
}
function partition(f, xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        var lacc = acc[0];
        var racc = acc[1];
        return f(x) ? [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, lacc), racc] : [lacc, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, racc)];
    }, [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]()], reverse(xs));
}
function replicate(n, x) {
    return initialize(n, function () {
        return x;
    });
}
function reverse(xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x) {
        return new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, acc);
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs);
}
function singleton(x) {
    return new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]());
}
function slice(lower, upper, xs) {
    var noLower = lower == null;
    var noUpper = upper == null;
    return reverse(Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, x, i) {
        return (noLower || lower <= i) && (noUpper || i <= upper) ? new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](x, acc) : acc;
    }, new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), xs));
}
/* ToDo: instance unzip() */
function unzip(xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["k" /* foldBack */])(function (xy, acc) {
        return [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](xy[0], acc[0]), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](xy[1], acc[1])];
    }, xs, [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]()]);
}
/* ToDo: instance unzip3() */
function unzip3(xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["k" /* foldBack */])(function (xyz, acc) {
        return [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](xyz[0], acc[0]), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](xyz[1], acc[1]), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](xyz[2], acc[2])];
    }, xs, [new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_0__ListClass__["a" /* default */]()]);
}
function groupBy(f, xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["q" /* map */])(function (k) {
        return [k[0], Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["B" /* toList */])(k[1])];
    }, Object(__WEBPACK_IMPORTED_MODULE_1__Map__["c" /* groupBy */])(f, xs)));
}
function splitAt(index, xs) {
    if (index < 0) {
        throw new Error("The input must be non-negative.");
    }
    var i = 0;
    var last = xs;
    var first = new Array(index);
    while (i < index) {
        if (last.tail == null) {
            throw new Error("The input sequence has an insufficient number of elements.");
        }
        first[i] = last.head;
        last = last.tail;
        i++;
    }
    return [Object(__WEBPACK_IMPORTED_MODULE_0__ListClass__["b" /* ofArray */])(first), last];
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compare */
/* unused harmony export compareTo */
/* unused harmony export startsWith */
/* unused harmony export indexOfAny */
/* harmony export (immutable) */ __webpack_exports__["c"] = printf;
/* unused harmony export toConsole */
/* harmony export (immutable) */ __webpack_exports__["e"] = toText;
/* unused harmony export toFail */
/* harmony export (immutable) */ __webpack_exports__["a"] = fsFormat;
/* unused harmony export format */
/* unused harmony export endsWith */
/* unused harmony export initialize */
/* unused harmony export insert */
/* unused harmony export isNullOrEmpty */
/* unused harmony export isNullOrWhiteSpace */
/* unused harmony export join */
/* unused harmony export validateGuid */
/* harmony export (immutable) */ __webpack_exports__["b"] = newGuid;
/* unused harmony export guidToArray */
/* unused harmony export arrayToGuid */
/* unused harmony export toBase64String */
/* unused harmony export fromBase64String */
/* unused harmony export padLeft */
/* unused harmony export padRight */
/* unused harmony export remove */
/* unused harmony export replace */
/* unused harmony export replicate */
/* unused harmony export getCharAtIndex */
/* harmony export (immutable) */ __webpack_exports__["d"] = split;
/* unused harmony export trim */
/* unused harmony export filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegExp__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(0);



var fsFormatRegExp = /(^|[^%])%([0+ ]*)(-?\d+)?(?:\.(\d+))?(\w)/;
var formatRegExp = /\{(\d+)(,-?\d+)?(?:\:(.+?))?\}/g;
// From https://stackoverflow.com/a/13653180/3922220
var guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var StringComparison = {
    CurrentCulture: 0,
    CurrentCultureIgnoreCase: 1,
    InvariantCulture: 2,
    InvariantCultureIgnoreCase: 3,
    Ordinal: 4,
    OrdinalIgnoreCase: 5
};
function cmp(x, y, ic) {
    function isIgnoreCase(i) {
        return i === true || i === StringComparison.CurrentCultureIgnoreCase || i === StringComparison.InvariantCultureIgnoreCase || i === StringComparison.OrdinalIgnoreCase;
    }
    function isOrdinal(i) {
        return i === StringComparison.Ordinal || i === StringComparison.OrdinalIgnoreCase;
    }
    if (x == null) {
        return y == null ? 0 : -1;
    }
    if (y == null) {
        return 1;
    } // everything is bigger than null
    if (isOrdinal(ic)) {
        if (isIgnoreCase(ic)) {
            x = x.toLowerCase();
            y = y.toLowerCase();
        }
        return x === y ? 0 : x < y ? -1 : 1;
    } else {
        if (isIgnoreCase(ic)) {
            x = x.toLocaleLowerCase();
            y = y.toLocaleLowerCase();
        }
        return x.localeCompare(y);
    }
}
function compare() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    switch (args.length) {
        case 2:
            return cmp(args[0], args[1], false);
        case 3:
            return cmp(args[0], args[1], args[2]);
        case 4:
            return cmp(args[0], args[1], args[2] === true);
        case 5:
            return cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), false);
        case 6:
            return cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), args[5]);
        case 7:
            return cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), args[5] === true);
        default:
            throw new Error("String.compare: Unsupported number of parameters");
    }
}
function compareTo(x, y) {
    return cmp(x, y, false);
}
function startsWith(str, pattern, ic) {
    if (str.length >= pattern.length) {
        return cmp(str.substr(0, pattern.length), pattern, ic) === 0;
    }
    return false;
}
function indexOfAny(str, anyOf) {
    if (str == null || str === "") {
        return -1;
    }
    var startIndex = (arguments.length <= 2 ? 0 : arguments.length - 2) > 0 ? arguments.length <= 2 ? undefined : arguments[2] : 0;
    if (startIndex < 0) {
        throw new Error("String.indexOfAny: Start index cannot be negative");
    }
    var length = (arguments.length <= 2 ? 0 : arguments.length - 2) > 1 ? arguments.length <= 3 ? undefined : arguments[3] : str.length - startIndex;
    if (length < 0) {
        throw new Error("String.indexOfAny: Length cannot be negative");
    }
    if (length > str.length - startIndex) {
        throw new Error("String.indexOfAny: Invalid startIndex and length");
    }
    str = str.substr(startIndex, length);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = anyOf[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            var index = str.indexOf(c);
            if (index > -1) {
                return index + startIndex;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return -1;
}
function toHex(value) {
    return value < 0 ? "ff" + (16777215 - (Math.abs(value) - 1)).toString(16) : value.toString(16);
}
function printf(input, argsLength) {
    return {
        input: input,
        cont: fsFormat(input, argsLength)
    };
}
function toConsole(arg) {
    return arg.cont(function (x) {
        console.log(x);
    });
}
function toText(arg) {
    return arg.cont(function (x) {
        return x;
    });
}
function toFail(arg) {
    return arg.cont(function (x) {
        throw new Error(x);
    });
}
function fsFormat(str, argsLength) {
    function formatOnce(str2, rep) {
        return str2.replace(fsFormatRegExp, function (_, prefix, flags, pad, precision, format) {
            switch (format) {
                case "f":
                case "F":
                    rep = rep.toFixed(precision || 6);
                    break;
                case "g":
                case "G":
                    rep = rep.toPrecision(precision);
                    break;
                case "e":
                case "E":
                    rep = rep.toExponential(precision);
                    break;
                case "O":
                    rep = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["y" /* toString */])(rep);
                    break;
                case "A":
                    rep = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["y" /* toString */])(rep, true);
                    break;
                case "x":
                    rep = toHex(Number(rep));
                    break;
                case "X":
                    rep = toHex(Number(rep)).toUpperCase();
                    break;
            }
            var plusPrefix = flags.indexOf("+") >= 0 && parseInt(rep, 10) >= 0;
            pad = parseInt(pad, 10);
            if (!isNaN(pad)) {
                var ch = pad >= 0 && flags.indexOf("0") >= 0 ? "0" : " ";
                rep = padLeft(rep, Math.abs(pad) - (plusPrefix ? 1 : 0), ch, pad < 0);
            }
            var once = prefix + (plusPrefix ? "+" + rep : rep);
            return once.replace(/%/g, "%%");
        });
    }
    return function (cont) {
        if (argsLength > 0) {
            var printer = function printer() {
                for (var _len2 = arguments.length, args2 = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args2[_key2] = arguments[_key2];
                }

                var strCopy = str;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = args2[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var arg = _step2.value;

                        strCopy = formatOnce(strCopy, arg);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return cont(strCopy.replace(/%%/g, "%"));
            };
            // Attach the arguments length for partial applications
            printer.argsLength = argsLength;
            return printer;
        } else {
            return cont(str);
        }
    };
}
function format(str) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
    }

    return str.replace(formatRegExp, function (match, idx, pad, pattern) {
        var rep = args[idx];
        var padSymbol = " ";
        if (typeof rep === "number") {
            switch ((pattern || "").substring(0, 1)) {
                case "f":
                case "F":
                    rep = pattern.length > 1 ? rep.toFixed(pattern.substring(1)) : rep.toFixed(2);
                    break;
                case "g":
                case "G":
                    rep = pattern.length > 1 ? rep.toPrecision(pattern.substring(1)) : rep.toPrecision();
                    break;
                case "e":
                case "E":
                    rep = pattern.length > 1 ? rep.toExponential(pattern.substring(1)) : rep.toExponential();
                    break;
                case "p":
                case "P":
                    rep = (pattern.length > 1 ? (rep * 100).toFixed(pattern.substring(1)) : (rep * 100).toFixed(2)) + " %";
                    break;
                case "x":
                    rep = toHex(Number(rep));
                    break;
                case "X":
                    rep = toHex(Number(rep)).toUpperCase();
                    break;
                default:
                    var m = /^(0+)(\.0+)?$/.exec(pattern);
                    if (m != null) {
                        var decs = 0;
                        if (m[2] != null) {
                            rep = rep.toFixed(decs = m[2].length - 1);
                        }
                        pad = "," + (m[1].length + (decs ? decs + 1 : 0)).toString();
                        padSymbol = "0";
                    } else if (pattern) {
                        rep = pattern;
                    }
            }
        } else if (rep instanceof Date) {
            if (pattern.length === 1) {
                switch (pattern) {
                    case "D":
                        rep = rep.toDateString();
                        break;
                    case "T":
                        rep = rep.toLocaleTimeString();
                        break;
                    case "d":
                        rep = rep.toLocaleDateString();
                        break;
                    case "t":
                        rep = rep.toLocaleTimeString().replace(/:\d\d(?!:)/, "");
                        break;
                    case "o":
                    case "O":
                        if (rep.kind === 2 /* Local */) {
                                var offset = rep.getTimezoneOffset() * -1;
                                rep = format("{0:yyyy-MM-dd}T{0:HH:mm}:{1:00.000}{2}{3:00}:{4:00}", rep, Object(__WEBPACK_IMPORTED_MODULE_0__Date__["k" /* second */])(rep), offset >= 0 ? "+" : "-", ~~(offset / 60), offset % 60);
                            } else {
                            rep = rep.toISOString();
                        }
                }
            } else {
                rep = pattern.replace(/(\w)\1*/g, function (match2) {
                    var rep2 = match2;
                    switch (match2.substring(0, 1)) {
                        case "y":
                            rep2 = match2.length < 4 ? Object(__WEBPACK_IMPORTED_MODULE_0__Date__["m" /* year */])(rep) % 100 : Object(__WEBPACK_IMPORTED_MODULE_0__Date__["m" /* year */])(rep);
                            break;
                        case "h":
                            rep2 = rep.getHours() > 12 ? Object(__WEBPACK_IMPORTED_MODULE_0__Date__["e" /* hour */])(rep) % 12 : Object(__WEBPACK_IMPORTED_MODULE_0__Date__["e" /* hour */])(rep);
                            break;
                        case "M":
                            rep2 = Object(__WEBPACK_IMPORTED_MODULE_0__Date__["h" /* month */])(rep);
                            break;
                        case "d":
                            rep2 = Object(__WEBPACK_IMPORTED_MODULE_0__Date__["d" /* day */])(rep);
                            break;
                        case "H":
                            rep2 = Object(__WEBPACK_IMPORTED_MODULE_0__Date__["e" /* hour */])(rep);
                            break;
                        case "m":
                            rep2 = Object(__WEBPACK_IMPORTED_MODULE_0__Date__["g" /* minute */])(rep);
                            break;
                        case "s":
                            rep2 = Object(__WEBPACK_IMPORTED_MODULE_0__Date__["k" /* second */])(rep);
                            break;
                    }
                    if (rep2 !== match2 && rep2 < 10 && match2.length > 1) {
                        rep2 = "0" + rep2;
                    }
                    return rep2;
                });
            }
        }
        pad = parseInt((pad || "").substring(1), 10);
        if (!isNaN(pad)) {
            rep = padLeft(rep, Math.abs(pad), padSymbol, pad < 0);
        }
        return rep;
    });
}
function endsWith(str, search) {
    var idx = str.lastIndexOf(search);
    return idx >= 0 && idx === str.length - search.length;
}
function initialize(n, f) {
    if (n < 0) {
        throw new Error("String length must be non-negative");
    }
    var xs = new Array(n);
    for (var i = 0; i < n; i++) {
        xs[i] = f(i);
    }
    return xs.join("");
}
function insert(str, startIndex, value) {
    if (startIndex < 0 || startIndex > str.length) {
        throw new Error("startIndex is negative or greater than the length of this instance.");
    }
    return str.substring(0, startIndex) + value + str.substring(startIndex);
}
function isNullOrEmpty(str) {
    return typeof str !== "string" || str.length === 0;
}
function isNullOrWhiteSpace(str) {
    return typeof str !== "string" || /^\s*$/.test(str);
}
function join(delimiter, xs) {
    var xs2 = xs;
    var len = arguments.length;
    if (len > 2) {
        xs2 = Array(len - 1);
        for (var key = 1; key < len; key++) {
            xs2[key - 1] = arguments[key];
        }
    } else if (!Array.isArray(xs)) {
        xs2 = Array.from(xs);
    }
    return xs2.map(function (x) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["y" /* toString */])(x);
    }).join(delimiter);
}
/** Validates UUID as specified in RFC4122 (versions 1-5). Trims braces. */
function validateGuid(str, doNotThrow) {
    var trimmed = trim(str, "both", "{", "}");
    if (guidRegex.test(trimmed)) {
        return doNotThrow ? [true, trimmed] : trimmed;
    } else if (doNotThrow) {
        return [false, "00000000-0000-0000-0000-000000000000"];
    }
    throw new Error("Guid should contain 32 digits with 4 dashes: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx");
}
/* tslint:disable */
// From https://gist.github.com/LeverOne/1308368
function newGuid() {
    var b = "";
    for (var a = 0; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-") {}
    return b;
}
// Maps for number <-> hex string conversion
var _convertMapsInitialized = false;
var _byteToHex = void 0;
var _hexToByte = void 0;
function initConvertMaps() {
    _byteToHex = new Array(256);
    _hexToByte = {};
    for (var i = 0; i < 256; i++) {
        _byteToHex[i] = (i + 0x100).toString(16).substr(1);
        _hexToByte[_byteToHex[i]] = i;
    }
    _convertMapsInitialized = true;
}
/** Parse a UUID into it's component bytes */
// Adapted from https://github.com/zefferus/uuid-parse
function guidToArray(s) {
    if (!_convertMapsInitialized) {
        initConvertMaps();
    }
    var i = 0;
    var buf = new Uint8Array(16);
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
        switch (i) {
            // .NET saves first three byte groups with differten endianness
            // See https://stackoverflow.com/a/16722909/3922220
            case 0:
            case 1:
            case 2:
            case 3:
                buf[3 - i++] = _hexToByte[oct];
                break;
            case 4:
            case 5:
                buf[9 - i++] = _hexToByte[oct];
                break;
            case 6:
            case 7:
                buf[13 - i++] = _hexToByte[oct];
                break;
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
                buf[i++] = _hexToByte[oct];
                break;
        }
    });
    // Zero out remaining bytes if string was short
    while (i < 16) {
        buf[i++] = 0;
    }
    return buf;
}
/** Convert UUID byte array into a string */
function arrayToGuid(buf) {
    if (buf.length !== 16) {
        throw new Error("Byte array for GUID must be exactly 16 bytes long");
    }
    if (!_convertMapsInitialized) {
        initConvertMaps();
    }
    return _byteToHex[buf[3]] + _byteToHex[buf[2]] + _byteToHex[buf[1]] + _byteToHex[buf[0]] + "-" + _byteToHex[buf[5]] + _byteToHex[buf[4]] + "-" + _byteToHex[buf[7]] + _byteToHex[buf[6]] + "-" + _byteToHex[buf[8]] + _byteToHex[buf[9]] + "-" + _byteToHex[buf[10]] + _byteToHex[buf[11]] + _byteToHex[buf[12]] + _byteToHex[buf[13]] + _byteToHex[buf[14]] + _byteToHex[buf[15]];
}
/* tslint:enable */
function notSupported(name) {
    throw new Error("The environment doesn't support '" + name + "', please use a polyfill.");
}
function toBase64String(inArray) {
    var str = "";
    for (var i = 0; i < inArray.length; i++) {
        str += String.fromCharCode(inArray[i]);
    }
    return typeof btoa === "function" ? btoa(str) : notSupported("btoa");
}
function fromBase64String(b64Encoded) {
    var binary = typeof atob === "function" ? atob(b64Encoded) : notSupported("atob");
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
function padLeft(str, len, ch, isRight) {
    ch = ch || " ";
    str = String(str);
    len = len - str.length;
    for (var i = 0; i < len; i++) {
        str = isRight ? str + ch : ch + str;
    }
    return str;
}
function padRight(str, len, ch) {
    return padLeft(str, len, ch, true);
}
function remove(str, startIndex, count) {
    if (startIndex >= str.length) {
        throw new Error("startIndex must be less than length of string");
    }
    if (typeof count === "number" && startIndex + count > str.length) {
        throw new Error("Index and count must refer to a location within the string.");
    }
    return str.slice(0, startIndex) + (typeof count === "number" ? str.substr(startIndex + count) : "");
}
function replace(str, search, replace) {
    return str.replace(new RegExp(Object(__WEBPACK_IMPORTED_MODULE_1__RegExp__["a" /* escape */])(search), "g"), replace);
}
function replicate(n, x) {
    return initialize(n, function () {
        return x;
    });
}
function getCharAtIndex(input, index) {
    if (index < 0 || index > input.length) {
        throw new Error("System.IndexOutOfRangeException: Index was outside the bounds of the array.");
    }
    return input[index];
}
function split(str, splitters, count, removeEmpty) {
    count = typeof count === "number" ? count : null;
    removeEmpty = typeof removeEmpty === "number" ? removeEmpty : null;
    if (count < 0) {
        throw new Error("Count cannot be less than zero");
    }
    if (count === 0) {
        return [];
    }
    var splitters2 = splitters;
    if (!Array.isArray(splitters)) {
        var len = arguments.length;
        splitters2 = Array(len - 1);
        for (var key = 1; key < len; key++) {
            splitters2[key - 1] = arguments[key];
        }
    }
    splitters2 = splitters2.map(function (x) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__RegExp__["a" /* escape */])(x);
    });
    splitters2 = splitters2.length > 0 ? splitters2 : [" "];
    var i = 0;
    var splits = [];
    var reg = new RegExp(splitters2.join("|"), "g");
    while (count == null || count > 1) {
        var m = reg.exec(str);
        if (m === null) {
            break;
        }
        if (!removeEmpty || m.index - i > 0) {
            count = count != null ? count - 1 : count;
            splits.push(str.substring(i, m.index));
        }
        i = reg.lastIndex;
    }
    if (!removeEmpty || str.length - i > 0) {
        splits.push(str.substring(i));
    }
    return splits;
}
function trim(str, side) {
    for (var _len4 = arguments.length, chars = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        chars[_key4 - 2] = arguments[_key4];
    }

    if (side === "both" && chars.length === 0) {
        return str.trim();
    }
    if (side === "start" || side === "both") {
        var reg = chars.length === 0 ? /^\s+/ : new RegExp("^[" + Object(__WEBPACK_IMPORTED_MODULE_1__RegExp__["a" /* escape */])(chars.join("")) + "]+");
        str = str.replace(reg, "");
    }
    if (side === "end" || side === "both") {
        var _reg = chars.length === 0 ? /\s+$/ : new RegExp("[" + Object(__WEBPACK_IMPORTED_MODULE_1__RegExp__["a" /* escape */])(chars.join("")) + "]+$");
        str = str.replace(_reg, "");
    }
    return str;
}
function filter(pred, x) {
    return x.split("").filter(pred).join("");
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ReadData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ReadBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ReadBooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BookDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BookDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BookStatsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BasicStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthorizationUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LoggedUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessTokenData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BooksCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ReadData = function () {
    function ReadData(readAt, startedAt) {
        _classCallCheck(this, ReadData);

        this.ReadAt = readAt;
        this.StartedAt = startedAt;
    }

    _createClass(ReadData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.ReadData",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    ReadAt: Date,
                    StartedAt: Date
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ReadData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.ReadData", ReadData);
var ReadBook = function () {
    function ReadBook(readData, numPages, bookTitle, authorName, reviewId, shelves, smallImageUrl, bookId) {
        _classCallCheck(this, ReadBook);

        this.ReadData = readData;
        this.NumPages = numPages | 0;
        this.BookTitle = bookTitle;
        this.AuthorName = authorName;
        this.ReviewId = reviewId | 0;
        this.Shelves = shelves;
        this.SmallImageUrl = smallImageUrl;
        this.BookId = bookId | 0;
    }

    _createClass(ReadBook, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.ReadBook",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    ReadData: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(ReadData),
                    NumPages: "number",
                    BookTitle: "string",
                    AuthorName: "string",
                    ReviewId: "number",
                    Shelves: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])("string"),
                    SmallImageUrl: "string",
                    BookId: "number"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ReadBook;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.ReadBook", ReadBook);
var ReadBooks = function () {
    function ReadBooks(books) {
        _classCallCheck(this, ReadBooks);

        this.Books = books;
    }

    _createClass(ReadBooks, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.ReadBooks",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Books: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(ReadBook)
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ReadBooks;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.ReadBooks", ReadBooks);
var BookDetail = function () {
    function BookDetail(id, genres, originalPublicationYear, language) {
        _classCallCheck(this, BookDetail);

        this.Id = id | 0;
        this.Genres = genres;
        this.OriginalPublicationYear = originalPublicationYear;
        this.Language = language;
    }

    _createClass(BookDetail, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.BookDetail",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Id: "number",
                    Genres: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])("string"),
                    OriginalPublicationYear: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("number"),
                    Language: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string")
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return BookDetail;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.BookDetail", BookDetail);
var BookDetails = function () {
    function BookDetails(details) {
        _classCallCheck(this, BookDetails);

        this.Details = details;
    }

    _createClass(BookDetails, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.BookDetails",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Details: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(BookDetail)
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return BookDetails;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.BookDetails", BookDetails);
var BookStatsData = function () {
    function BookStatsData(book, daysCount, speed) {
        _classCallCheck(this, BookStatsData);

        this.Book = book;
        this.DaysCount = daysCount | 0;
        this.Speed = speed;
    }

    _createClass(BookStatsData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.BookStatsData",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Book: ReadBook,
                    DaysCount: "number",
                    Speed: "number"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return BookStatsData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.BookStatsData", BookStatsData);
var BasicStats = function () {
    function BasicStats(booksCount, pagesCount, slowestBook, fastestBook, averageSpeed, averagePagesCount) {
        _classCallCheck(this, BasicStats);

        this.BooksCount = booksCount | 0;
        this.PagesCount = pagesCount | 0;
        this.SlowestBook = slowestBook;
        this.FastestBook = fastestBook;
        this.AverageSpeed = averageSpeed;
        this.AveragePagesCount = averagePagesCount;
    }

    _createClass(BasicStats, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.BasicStats",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    BooksCount: "number",
                    PagesCount: "number",
                    SlowestBook: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(BookStatsData),
                    FastestBook: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(BookStatsData),
                    AverageSpeed: "number",
                    AveragePagesCount: "number"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return BasicStats;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.BasicStats", BasicStats);
var AuthorizationUserData = function () {
    function AuthorizationUserData(token, tokenSecret, url) {
        _classCallCheck(this, AuthorizationUserData);

        this.Token = token;
        this.TokenSecret = tokenSecret;
        this.Url = url;
    }

    _createClass(AuthorizationUserData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.AuthorizationUserData",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Token: "string",
                    TokenSecret: "string",
                    Url: "string"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return AuthorizationUserData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.AuthorizationUserData", AuthorizationUserData);
var LoggedUserData = function () {
    function LoggedUserData(accessToken, accessTokenSecret, userName) {
        _classCallCheck(this, LoggedUserData);

        this.AccessToken = accessToken;
        this.AccessTokenSecret = accessTokenSecret;
        this.UserName = userName;
    }

    _createClass(LoggedUserData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.LoggedUserData",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    AccessToken: "string",
                    AccessTokenSecret: "string",
                    UserName: "string"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return LoggedUserData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.LoggedUserData", LoggedUserData);
var AccessTokenData = function () {
    function AccessTokenData(accessToken, accessTokenSecret) {
        _classCallCheck(this, AccessTokenData);

        this.accessToken = accessToken;
        this.accessTokenSecret = accessTokenSecret;
    }

    _createClass(AccessTokenData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.AccessTokenData",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    accessToken: "string",
                    accessTokenSecret: "string"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return AccessTokenData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.AccessTokenData", AccessTokenData);
var State = function () {
    function State(logged, readBooks, accessData, loggedUserName, booksDetails) {
        _classCallCheck(this, State);

        this.Logged = logged;
        this.ReadBooks = readBooks;
        this.AccessData = accessData;
        this.LoggedUserName = loggedUserName;
        this.BooksDetails = booksDetails;
    }

    _createClass(State, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.State",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Logged: "boolean",
                    ReadBooks: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(ReadBook),
                    AccessData: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(AccessTokenData),
                    LoggedUserName: "string",
                    BooksDetails: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(BookDetail)
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return State;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.State", State);
var BooksCount = function () {
    function BooksCount(count) {
        _classCallCheck(this, BooksCount);

        this.Count = count | 0;
    }

    _createClass(BooksCount, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Model.BooksCount",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Count: "number"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return BooksCount;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Model.BooksCount", BooksCount);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = minValue;
/* unused harmony export maxValue */
/* harmony export (immutable) */ __webpack_exports__["j"] = parse;
/* unused harmony export tryParse */
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* unused harmony export now */
/* unused harmony export utcNow */
/* harmony export (immutable) */ __webpack_exports__["l"] = today;
/* unused harmony export isLeapYear */
/* unused harmony export daysInMonth */
/* unused harmony export toUniversalTime */
/* unused harmony export toLocalTime */
/* unused harmony export timeOfDay */
/* harmony export (immutable) */ __webpack_exports__["c"] = date;
/* unused harmony export kind */
/* harmony export (immutable) */ __webpack_exports__["d"] = day;
/* harmony export (immutable) */ __webpack_exports__["e"] = hour;
/* unused harmony export millisecond */
/* harmony export (immutable) */ __webpack_exports__["g"] = minute;
/* harmony export (immutable) */ __webpack_exports__["h"] = month;
/* harmony export (immutable) */ __webpack_exports__["k"] = second;
/* harmony export (immutable) */ __webpack_exports__["m"] = year;
/* unused harmony export dayOfWeek */
/* unused harmony export ticks */
/* unused harmony export ofTicks */
/* unused harmony export toBinary */
/* unused harmony export dayOfYear */
/* unused harmony export add */
/* harmony export (immutable) */ __webpack_exports__["a"] = addDays;
/* unused harmony export addHours */
/* unused harmony export addMinutes */
/* unused harmony export addSeconds */
/* unused harmony export addMilliseconds */
/* unused harmony export addTicks */
/* unused harmony export addYears */
/* unused harmony export addMonths */
/* unused harmony export subtract */
/* unused harmony export toLongDateString */
/* unused harmony export toShortDateString */
/* unused harmony export toLongTimeString */
/* unused harmony export toShortTimeString */
/* unused harmony export equals */
/* unused harmony export compare */
/* unused harmony export compareTo */
/* unused harmony export op_Addition */
/* harmony export (immutable) */ __webpack_exports__["i"] = op_Subtraction;
/* unused harmony export isDaylightSavingTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Long__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimeSpan__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(0);



function minValue() {
    return parse(-8640000000000000, 1);
}
function maxValue() {
    return parse(8640000000000000, 1);
}
/* tslint:disable */
function parse(v, kind) {
    if (kind == null) {
        kind = typeof v === "string" && v.slice(-1) === "Z" ? 1 /* UTC */ : 2 /* Local */;
    }
    var date = v == null ? new Date() : new Date(v);
    if (isNaN(date.getTime())) {
        // Check if this is a time-only string, which JS Date parsing cannot handle (see #1045)
        if (typeof v === "string" && /^(?:[01]?\d|2[0-3]):(?:[0-5]?\d)(?::[0-5]?\d(?:\.\d+)?)?(?:\s*[AaPp][Mm])?$/.test(v)) {
            var d = new Date();
            date = new Date(d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate() + " " + v);
        } else {
            throw new Error("The string is not a valid Date.");
        }
    }
    if (kind === 2 /* Local */) {
            date.kind = kind;
        }
    return date;
}
/* tslint:enable */
function tryParse(v) {
    try {
        return [true, parse(v)];
    } catch (_err) {
        return [false, minValue()];
    }
}
function create(year, month, day) /* Local */{
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var kind = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 2;

    var date = void 0;
    if (kind === 2 /* Local */) {
            date = new Date(year, month - 1, day, h, m, s, ms);
            date.kind = kind;
        } else {
        date = new Date(Date.UTC(year, month - 1, day, h, m, s, ms));
    }
    if (year <= 99) {
        date.setFullYear(year, month - 1, day);
    }
    if (isNaN(date.getTime())) {
        throw new Error("The parameters describe an unrepresentable Date.");
    }
    return date;
}
function now() {
    return parse();
}
function utcNow() {
    return parse(null, 1);
}
function today() {
    return date(now());
}
function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function daysInMonth(year, month) {
    return month === 2 ? isLeapYear(year) ? 29 : 28 : month >= 8 ? month % 2 === 0 ? 31 : 30 : month % 2 === 0 ? 30 : 31;
}
function toUniversalTime(d) {
    return d.kind === 2 /* Local */ ? new Date(d.getTime()) : d;
}
function toLocalTime(d) {
    if (d.kind === 2 /* Local */) {
            return d;
        } else {
        var d2 = new Date(d.getTime());
        d2.kind = 2 /* Local */;
        return d2;
    }
}
function timeOfDay(d) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__TimeSpan__["a" /* create */])(0, hour(d), minute(d), second(d), millisecond(d));
}
function date(d) {
    return create(year(d), month(d), day(d), 0, 0, 0, 0, d.kind || 1 /* UTC */);
}
function kind(d) {
    return d.kind || 1 /* UTC */;
}
function day(d) {
    return d.kind === 2 /* Local */ ? d.getDate() : d.getUTCDate();
}
function hour(d) {
    return d.kind === 2 /* Local */ ? d.getHours() : d.getUTCHours();
}
function millisecond(d) {
    return d.kind === 2 /* Local */ ? d.getMilliseconds() : d.getUTCMilliseconds();
}
function minute(d) {
    return d.kind === 2 /* Local */ ? d.getMinutes() : d.getUTCMinutes();
}
function month(d) {
    return (d.kind === 2 /* Local */ ? d.getMonth() : d.getUTCMonth()) + 1;
}
function second(d) {
    return d.kind === 2 /* Local */ ? d.getSeconds() : d.getUTCSeconds();
}
function year(d) {
    return d.kind === 2 /* Local */ ? d.getFullYear() : d.getUTCFullYear();
}
function dayOfWeek(d) {
    return d.kind === 2 /* Local */ ? d.getDay() : d.getUTCDay();
}
function ticks(d) {
    return __WEBPACK_IMPORTED_MODULE_0__Long__["a" /* fromNumber */](d.getTime()).add(62135596800000) // UnixEpochMilliseconds
    .sub(d.kind === 2 /* Local */ ? d.getTimezoneOffset() * 60 * 1000 : 0).mul(10000);
}
function ofTicks(ticks) {
    return parse(ticks.div(10000).sub(62135596800000).toNumber(), 1 /* UTC */);
}
function toBinary(d) {
    return ticks(d);
}
function dayOfYear(d) {
    var _year = year(d);
    var _month = month(d);
    var _day = day(d);
    for (var i = 1; i < _month; i++) {
        _day += daysInMonth(_year, i);
    }
    return _day;
}
function add(d, ts) {
    return parse(d.getTime() + ts, d.kind || 1 /* UTC */);
}
function addDays(d, v) {
    return parse(d.getTime() + v * 86400000, d.kind || 1 /* UTC */);
}
function addHours(d, v) {
    return parse(d.getTime() + v * 3600000, d.kind || 1 /* UTC */);
}
function addMinutes(d, v) {
    return parse(d.getTime() + v * 60000, d.kind || 1 /* UTC */);
}
function addSeconds(d, v) {
    return parse(d.getTime() + v * 1000, d.kind || 1 /* UTC */);
}
function addMilliseconds(d, v) {
    return parse(d.getTime() + v, d.kind || 1 /* UTC */);
}
function addTicks(d, t) {
    return parse(__WEBPACK_IMPORTED_MODULE_0__Long__["a" /* fromNumber */](d.getTime()).add(t.div(10000)).toNumber(), d.kind || 1 /* UTC */);
}
function addYears(d, v) {
    var newMonth = month(d);
    var newYear = year(d) + v;
    var _daysInMonth = daysInMonth(newYear, newMonth);
    var newDay = Math.min(_daysInMonth, day(d));
    return create(newYear, newMonth, newDay, hour(d), minute(d), second(d), millisecond(d), d.kind || 1 /* UTC */);
}
function addMonths(d, v) {
    var newMonth = month(d) + v;
    var newMonth_ = 0;
    var yearOffset = 0;
    if (newMonth > 12) {
        newMonth_ = newMonth % 12;
        yearOffset = Math.floor(newMonth / 12);
        newMonth = newMonth_;
    } else if (newMonth < 1) {
        newMonth_ = 12 + newMonth % 12;
        yearOffset = Math.floor(newMonth / 12) + (newMonth_ === 12 ? -1 : 0);
        newMonth = newMonth_;
    }
    var newYear = year(d) + yearOffset;
    var _daysInMonth = daysInMonth(newYear, newMonth);
    var newDay = Math.min(_daysInMonth, day(d));
    return create(newYear, newMonth, newDay, hour(d), minute(d), second(d), millisecond(d), d.kind || 1 /* UTC */);
}
function subtract(d, that) {
    return typeof that === "number" ? parse(d.getTime() - that, d.kind || 1 /* UTC */) : d.getTime() - that.getTime();
}
function toLongDateString(d) {
    return d.toDateString();
}
function toShortDateString(d) {
    return d.toLocaleDateString();
}
function toLongTimeString(d) {
    return d.toLocaleTimeString();
}
function toShortTimeString(d) {
    return d.toLocaleTimeString().replace(/:\d\d(?!:)/, "");
}
function equals(d1, d2) {
    return d1.getTime() === d2.getTime();
}
function compare(x, y) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(x, y);
}
function compareTo(x, y) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["j" /* compare */])(x, y);
}
function op_Addition(x, y) {
    return add(x, y);
}
function op_Subtraction(x, y) {
    return subtract(x, y);
}
function isDaylightSavingTime(x) {
    var jan = new Date(x.getFullYear(), 0, 1);
    var jul = new Date(x.getFullYear(), 6, 1);
    return isDST(jan.getTimezoneOffset(), jul.getTimezoneOffset(), x.getTimezoneOffset());
}
function isDST(janOffset, julOffset, tOffset) {
    return Math.min(janOffset, julOffset) === tOffset;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = groupBy;
/* unused harmony export countBy */
/* unused harmony export MapTree */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* unused harmony export add */
/* unused harmony export remove */
/* unused harmony export containsValue */
/* unused harmony export tryGetValue */
/* unused harmony export exists */
/* unused harmony export find */
/* unused harmony export tryFind */
/* unused harmony export filter */
/* unused harmony export fold */
/* unused harmony export foldBack */
/* unused harmony export forAll */
/* unused harmony export isEmpty */
/* unused harmony export iterate */
/* unused harmony export map */
/* unused harmony export partition */
/* unused harmony export findKey */
/* unused harmony export tryFindKey */
/* unused harmony export pick */
/* unused harmony export tryPick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comparer__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }













// ----------------------------------------------
// These functions belong to Seq.ts but are
// implemented here to prevent cyclic dependencies
function groupBy(f, xs) {
    var keys = [];
    var iter = xs[Symbol.iterator]();
    var acc = create();
    var cur = iter.next();
    while (!cur.done) {
        var k = f(cur.value);
        var vs = tryFind(k, acc);
        if (vs == null) {
            keys.push(k);
            acc = add(k, [cur.value], acc);
        } else {
            vs.push(cur.value);
        }
        cur = iter.next();
    }
    return keys.map(function (k) {
        return [k, acc.get(k)];
    });
}
function countBy(f, xs) {
    return groupBy(f, xs).map(function (kv) {
        return [kv[0], kv[1].length];
    });
}
var MapTree = function MapTree(tag, data) {
    _classCallCheck(this, MapTree);

    this.tag = tag | 0;
    this.data = data;
};
function tree_sizeAux(acc, m) {
    sizeAux: while (true) {
        if (m.tag === 1) {
            return acc + 1 | 0;
        } else if (m.tag === 2) {
            acc = tree_sizeAux(acc + 1, m.data[2]);
            m = m.data[3];
            continue sizeAux;
        } else {
            return acc | 0;
        }
    }
}
function tree_size(x) {
    return tree_sizeAux(0, x);
}
function tree_empty() {
    return new MapTree(0);
}
function tree_height(_arg1) {
    return _arg1.tag === 1 ? 1 : _arg1.tag === 2 ? _arg1.data[4] : 0;
}
function tree_isEmpty(m) {
    return m.tag === 0 ? true : false;
}
function tree_mk(l, k, v, r) {
    var matchValue = l.tag === 0 ? r.tag === 0 ? 0 : 1 : 1;
    switch (matchValue) {
        case 0:
            return new MapTree(1, [k, v]);
        case 1:
            var hl = tree_height(l) | 0;
            var hr = tree_height(r) | 0;
            var m = (hl < hr ? hr : hl) | 0;
            return new MapTree(2, [k, v, l, r, m + 1]);
    }
    throw new Error("internal error: Map.tree_mk");
}
function tree_rebalance(t1, k, v, t2) {
    var t1h = tree_height(t1);
    var t2h = tree_height(t2);
    if (t2h > t1h + 2) {
        if (t2.tag === 2) {
            if (tree_height(t2.data[2]) > t1h + 1) {
                if (t2.data[2].tag === 2) {
                    return tree_mk(tree_mk(t1, k, v, t2.data[2].data[2]), t2.data[2].data[0], t2.data[2].data[1], tree_mk(t2.data[2].data[3], t2.data[0], t2.data[1], t2.data[3]));
                } else {
                    throw new Error("rebalance");
                }
            } else {
                return tree_mk(tree_mk(t1, k, v, t2.data[2]), t2.data[0], t2.data[1], t2.data[3]);
            }
        } else {
            throw new Error("rebalance");
        }
    } else {
        if (t1h > t2h + 2) {
            if (t1.tag === 2) {
                if (tree_height(t1.data[3]) > t2h + 1) {
                    if (t1.data[3].tag === 2) {
                        return tree_mk(tree_mk(t1.data[2], t1.data[0], t1.data[1], t1.data[3].data[2]), t1.data[3].data[0], t1.data[3].data[1], tree_mk(t1.data[3].data[3], k, v, t2));
                    } else {
                        throw new Error("rebalance");
                    }
                } else {
                    return tree_mk(t1.data[2], t1.data[0], t1.data[1], tree_mk(t1.data[3], k, v, t2));
                }
            } else {
                throw new Error("rebalance");
            }
        } else {
            return tree_mk(t1, k, v, t2);
        }
    }
}
function tree_add(comparer, k, v, m) {
    if (m.tag === 1) {
        var c = comparer.Compare(k, m.data[0]);
        if (c < 0) {
            return new MapTree(2, [k, v, new MapTree(0), m, 2]);
        } else if (c === 0) {
            return new MapTree(1, [k, v]);
        }
        return new MapTree(2, [k, v, m, new MapTree(0), 2]);
    } else if (m.tag === 2) {
        var _c = comparer.Compare(k, m.data[0]);
        if (_c < 0) {
            return tree_rebalance(tree_add(comparer, k, v, m.data[2]), m.data[0], m.data[1], m.data[3]);
        } else if (_c === 0) {
            return new MapTree(2, [k, v, m.data[2], m.data[3], m.data[4]]);
        }
        return tree_rebalance(m.data[2], m.data[0], m.data[1], tree_add(comparer, k, v, m.data[3]));
    }
    return new MapTree(1, [k, v]);
}
function tree_find(comparer, k, m) {
    var res = tree_tryFind(comparer, k, m);
    if (res != null) {
        return res;
    }
    throw new Error("key not found");
}
function tree_tryFind(comparer, k, m) {
    tryFind: while (true) {
        if (m.tag === 1) {
            var c = comparer.Compare(k, m.data[0]) | 0;
            if (c === 0) {
                return m.data[1];
            } else {
                return null;
            }
        } else if (m.tag === 2) {
            var c_1 = comparer.Compare(k, m.data[0]) | 0;
            if (c_1 < 0) {
                comparer = comparer;
                k = k;
                m = m.data[2];
                continue tryFind;
            } else if (c_1 === 0) {
                return m.data[1];
            } else {
                comparer = comparer;
                k = k;
                m = m.data[3];
                continue tryFind;
            }
        } else {
            return null;
        }
    }
}
function tree_partition1(comparer, f, k, v, acc1, acc2) {
    return f(k, v) ? [tree_add(comparer, k, v, acc1), acc2] : [acc1, tree_add(comparer, k, v, acc2)];
}
function tree_partitionAux(comparer, f, s, acc_0, acc_1) {
    var acc = [acc_0, acc_1];
    if (s.tag === 1) {
        return tree_partition1(comparer, f, s.data[0], s.data[1], acc[0], acc[1]);
    } else if (s.tag === 2) {
        var acc_2 = tree_partitionAux(comparer, f, s.data[3], acc[0], acc[1]);
        var acc_3 = tree_partition1(comparer, f, s.data[0], s.data[1], acc_2[0], acc_2[1]);
        return tree_partitionAux(comparer, f, s.data[2], acc_3[0], acc_3[1]);
    }
    return acc;
}
function tree_partition(comparer, f, s) {
    return tree_partitionAux(comparer, f, s, tree_empty(), tree_empty());
}
function tree_filter1(comparer, f, k, v, acc) {
    return f(k, v) ? tree_add(comparer, k, v, acc) : acc;
}
function tree_filterAux(comparer, f, s, acc) {
    return s.tag === 1 ? tree_filter1(comparer, f, s.data[0], s.data[1], acc) : s.tag === 2 ? tree_filterAux(comparer, f, s.data[3], tree_filter1(comparer, f, s.data[0], s.data[1], tree_filterAux(comparer, f, s.data[2], acc))) : acc;
}
function tree_filter(comparer, f, s) {
    return tree_filterAux(comparer, f, s, tree_empty());
}
function tree_spliceOutSuccessor(m) {
    if (m.tag === 1) {
        return [m.data[0], m.data[1], new MapTree(0)];
    } else if (m.tag === 2) {
        if (m.data[2].tag === 0) {
            return [m.data[0], m.data[1], m.data[3]];
        } else {
            var kvl = tree_spliceOutSuccessor(m.data[2]);
            return [kvl[0], kvl[1], tree_mk(kvl[2], m.data[0], m.data[1], m.data[3])];
        }
    }
    throw new Error("internal error: Map.spliceOutSuccessor");
}
function tree_remove(comparer, k, m) {
    if (m.tag === 1) {
        var c = comparer.Compare(k, m.data[0]);
        if (c === 0) {
            return new MapTree(0);
        } else {
            return m;
        }
    } else if (m.tag === 2) {
        var _c2 = comparer.Compare(k, m.data[0]);
        if (_c2 < 0) {
            return tree_rebalance(tree_remove(comparer, k, m.data[2]), m.data[0], m.data[1], m.data[3]);
        } else if (_c2 === 0) {
            if (m.data[2].tag === 0) {
                return m.data[3];
            } else {
                if (m.data[3].tag === 0) {
                    return m.data[2];
                } else {
                    var input = tree_spliceOutSuccessor(m.data[3]);
                    return tree_mk(m.data[2], input[0], input[1], input[2]);
                }
            }
        } else {
            return tree_rebalance(m.data[2], m.data[0], m.data[1], tree_remove(comparer, k, m.data[3]));
        }
    } else {
        return tree_empty();
    }
}
function tree_mem(comparer, k, m) {
    mem: while (true) {
        if (m.tag === 1) {
            return comparer.Compare(k, m.data[0]) === 0;
        } else if (m.tag === 2) {
            var c = comparer.Compare(k, m.data[0]) | 0;
            if (c < 0) {
                comparer = comparer;
                k = k;
                m = m.data[2];
                continue mem;
            } else if (c === 0) {
                return true;
            } else {
                comparer = comparer;
                k = k;
                m = m.data[3];
                continue mem;
            }
        } else {
            return false;
        }
    }
}
function tree_iter(f, m) {
    if (m.tag === 1) {
        f(m.data[0], m.data[1]);
    } else if (m.tag === 2) {
        tree_iter(f, m.data[2]);
        f(m.data[0], m.data[1]);
        tree_iter(f, m.data[3]);
    }
}
function tree_tryPick(f, m) {
    if (m.tag === 1) {
        return f(m.data[0], m.data[1]);
    } else if (m.tag === 2) {
        var matchValue = tree_tryPick(f, m.data[2]);
        if (matchValue == null) {
            var matchValue_1 = f(m.data[0], m.data[1]);
            if (matchValue_1 == null) {
                return tree_tryPick(f, m.data[3]);
            } else {
                var res = matchValue_1;
                return res;
            }
        } else {
            return matchValue;
        }
    } else {
        return null;
    }
}
function tree_exists(f, m) {
    return m.tag === 1 ? f(m.data[0], m.data[1]) : m.tag === 2 ? (tree_exists(f, m.data[2]) ? true : f(m.data[0], m.data[1])) ? true : tree_exists(f, m.data[3]) : false;
}
function tree_forall(f, m) {
    return m.tag === 1 ? f(m.data[0], m.data[1]) : m.tag === 2 ? (tree_forall(f, m.data[2]) ? f(m.data[0], m.data[1]) : false) ? tree_forall(f, m.data[3]) : false : true;
}
function tree_mapi(f, m) {
    return m.tag === 1 ? new MapTree(1, [m.data[0], f(m.data[0], m.data[1])]) : m.tag === 2 ? new MapTree(2, [m.data[0], f(m.data[0], m.data[1]), tree_mapi(f, m.data[2]), tree_mapi(f, m.data[3]), m.data[4]]) : tree_empty();
}
function tree_foldBack(f, m, x) {
    return m.tag === 1 ? f(m.data[0], m.data[1], x) : m.tag === 2 ? tree_foldBack(f, m.data[2], f(m.data[0], m.data[1], tree_foldBack(f, m.data[3], x))) : x;
}
function tree_fold(f, x, m) {
    return m.tag === 1 ? f(x, m.data[0], m.data[1]) : m.tag === 2 ? tree_fold(f, f(tree_fold(f, x, m.data[2]), m.data[0], m.data[1]), m.data[3]) : x;
}
// function tree_foldFromTo(
//     comparer: IComparer<any>, lo: any, hi: any,
//     f: (k:any, v: any, acc: any) => any, m: MapTree, x: any): any {
//   if (m.tag === 1) {
//     var cLoKey = comparer.Compare(lo, m.data[0]);
//     var cKeyHi = comparer.Compare(m.data[0], hi);
//     var x_1 = (cLoKey <= 0 ? cKeyHi <= 0 : false) ? f(m.data[0], m.data[1], x) : x;
//     return x_1;
//   } else if (m.tag === 2) {
//     var cLoKey = comparer.Compare(lo, m.data[0]);
//     var cKeyHi = comparer.Compare(m.data[0], hi);
//     var x_1 = cLoKey < 0 ? tree_foldFromTo(comparer, lo, hi, f, m.data[2], x) : x;
//     var x_2 = (cLoKey <= 0 ? cKeyHi <= 0 : false) ? f(m.data[0], m.data[1], x_1) : x_1;
//     var x_3 = cKeyHi < 0 ? tree_foldFromTo(comparer, lo, hi, f, m.data[3], x_2) : x_2;
//     return x_3;
//   }
//   return x;
// }
// function tree_foldSection(
//     comparer: IComparer<any>, lo: any, hi: any,
//     f: (k: any, v: any, acc: any) => any, m: MapTree, x: any) {
//   return comparer.Compare(lo, hi) === 1 ? x : tree_foldFromTo(comparer, lo, hi, f, m, x);
// }
// function tree_loop(m: MapTree, acc: any): List<[any,any]> {
//   return m.tag === 1
//     ? new List([m.data[0], m.data[1]], acc)
//     : m.tag === 2
//       ? tree_loop(m.data[2], new List([m.data[0], m.data[1]], tree_loop(m.data[3], acc)))
//       : acc;
// }
// function tree_toList(m: MapTree) {
//   return tree_loop(m, new List());
// }
// function tree_toArray(m: MapTree) {
//   return Array.from(tree_toList(m));
// }
// function tree_ofList(comparer: IComparer<any>, l: List<[any,any]>) {
//   return Seq.fold((acc: MapTree, tupledArg: [any, any]) => {
//     return tree_add(comparer, tupledArg[0], tupledArg[1], acc);
//   }, tree_empty(), l);
// }
function tree_mkFromEnumerator(comparer, acc, e) {
    var cur = e.next();
    while (!cur.done) {
        acc = tree_add(comparer, cur.value[0], cur.value[1], acc);
        cur = e.next();
    }
    return acc;
}
// function tree_ofArray(comparer: IComparer<any>, arr: ArrayLike<[any,any]>) {
//   var res = tree_empty();
//   for (var i = 0; i <= arr.length - 1; i++) {
//     res = tree_add(comparer, arr[i][0], arr[i][1], res);
//   }
//   return res;
// }
function tree_ofSeq(comparer, c) {
    var ie = c[Symbol.iterator]();
    return tree_mkFromEnumerator(comparer, tree_empty(), ie);
}
// function tree_copyToArray(s: MapTree, arr: ArrayLike<any>, i: number) {
//   tree_iter((x, y) => { arr[i++] = [x, y]; }, s);
// }
function tree_collapseLHS(stack) {
    if (stack.tail != null) {
        if (stack.head.tag === 1) {
            return stack;
        } else if (stack.head.tag === 2) {
            return tree_collapseLHS(Object(__WEBPACK_IMPORTED_MODULE_1__ListClass__["b" /* ofArray */])([stack.head.data[2], new MapTree(1, [stack.head.data[0], stack.head.data[1]]), stack.head.data[3]], stack.tail));
        } else {
            return tree_collapseLHS(stack.tail);
        }
    } else {
        return new __WEBPACK_IMPORTED_MODULE_1__ListClass__["a" /* default */]();
    }
}
function tree_mkIterator(s) {
    return { stack: tree_collapseLHS(new __WEBPACK_IMPORTED_MODULE_1__ListClass__["a" /* default */](s, new __WEBPACK_IMPORTED_MODULE_1__ListClass__["a" /* default */]())), started: false };
}
function tree_moveNext(i) {
    function current(it) {
        if (it.stack.tail == null) {
            return null;
        } else if (it.stack.head.tag === 1) {
            return [it.stack.head.data[0], it.stack.head.data[1]];
        }
        throw new Error("Please report error: Map iterator, unexpected stack for current");
    }
    if (i.started) {
        if (i.stack.tail == null) {
            return { done: true, value: null };
        } else {
            if (i.stack.head.tag === 1) {
                i.stack = tree_collapseLHS(i.stack.tail);
                return {
                    done: i.stack.tail == null,
                    value: current(i)
                };
            } else {
                throw new Error("Please report error: Map iterator, unexpected stack for moveNext");
            }
        }
    } else {
        i.started = true;
        return {
            done: i.stack.tail == null,
            value: current(i)
        };
    }
}

var FableMap = function () {
    /** Do not call, use Map.create instead. */
    function FableMap() {
        _classCallCheck(this, FableMap);

        return;
    }

    _createClass(FableMap, [{
        key: "ToString",
        value: function ToString() {
            return "map [" + Array.from(this).map(function (x) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__Util__["y" /* toString */])(x);
            }).join("; ") + "]";
        }
    }, {
        key: "Equals",
        value: function Equals(m2) {
            return this.CompareTo(m2) === 0;
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(m2) {
            var _this = this;

            return this === m2 ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["d" /* compareWith */])(function (kvp1, kvp2) {
                var c = _this.comparer.Compare(kvp1[0], kvp2[0]);
                return c !== 0 ? c : Object(__WEBPACK_IMPORTED_MODULE_4__Util__["j" /* compare */])(kvp1[1], kvp2[1]);
            }, this, m2);
        }
    }, {
        key: Symbol.iterator,
        value: function value() {
            var i = tree_mkIterator(this.tree);
            return {
                next: function next() {
                    return tree_moveNext(i);
                }
            };
        }
    }, {
        key: "entries",
        value: function entries() {
            return this[Symbol.iterator]();
        }
    }, {
        key: "keys",
        value: function keys() {
            return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["q" /* map */])(function (kv) {
                return kv[0];
            }, this);
        }
    }, {
        key: "values",
        value: function values() {
            return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["q" /* map */])(function (kv) {
                return kv[1];
            }, this);
        }
    }, {
        key: "get",
        value: function get(k) {
            return tree_find(this.comparer, k, this.tree);
        }
    }, {
        key: "has",
        value: function has(k) {
            return tree_mem(this.comparer, k, this.tree);
        }
        /** Mutating method */

    }, {
        key: "set",
        value: function set(k, v) {
            this.tree = tree_add(this.comparer, k, v, this.tree);
        }
        /** Mutating method */

    }, {
        key: "delete",
        value: function _delete(k) {
            // TODO: Is calculating the size twice is more performant than calling tree_mem?
            var oldSize = tree_size(this.tree);
            this.tree = tree_remove(this.comparer, k, this.tree);
            return oldSize > tree_size(this.tree);
        }
        /** Mutating method */

    }, {
        key: "clear",
        value: function clear() {
            this.tree = tree_empty();
        }
    }, {
        key: __WEBPACK_IMPORTED_MODULE_3__Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Microsoft.FSharp.Collections.FSharpMap",
                interfaces: ["System.IEquatable", "System.IComparable", "System.Collections.Generic.IDictionary"]
            };
        }
    }, {
        key: "size",
        get: function get() {
            return tree_size(this.tree);
        }
    }]);

    return FableMap;
}();

/* harmony default export */ __webpack_exports__["b"] = (FableMap);

function from(comparer, tree) {
    var map = new FableMap();
    map.tree = tree;
    map.comparer = comparer || new __WEBPACK_IMPORTED_MODULE_0__Comparer__["a" /* default */]();
    return map;
}
function create(ie, comparer) {
    comparer = comparer || new __WEBPACK_IMPORTED_MODULE_0__Comparer__["a" /* default */]();
    return from(comparer, ie ? tree_ofSeq(comparer, ie) : tree_empty());
}
function add(k, v, map) {
    return from(map.comparer, tree_add(map.comparer, k, v, map.tree));
}
function remove(item, map) {
    return from(map.comparer, tree_remove(map.comparer, item, map.tree));
}
function containsValue(v, map) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, k) {
        return acc || Object(__WEBPACK_IMPORTED_MODULE_4__Util__["p" /* equals */])(map.get(k), v);
    }, false, map.keys());
}
function tryGetValue(map, key, defaultValue) {
    return map.has(key) ? [true, map.get(key)] : [false, defaultValue];
}
function exists(f, map) {
    return tree_exists(f, map.tree);
}
function find(k, map) {
    return tree_find(map.comparer, k, map.tree);
}
function tryFind(k, map) {
    return tree_tryFind(map.comparer, k, map.tree);
}
function filter(f, map) {
    return from(map.comparer, tree_filter(map.comparer, f, map.tree));
}
function fold(f, seed, map) {
    return tree_fold(f, seed, map.tree);
}
function foldBack(f, map, seed) {
    return tree_foldBack(f, map.tree, seed);
}
function forAll(f, map) {
    return tree_forall(f, map.tree);
}
function isEmpty(map) {
    return tree_isEmpty(map.tree);
}
function iterate(f, map) {
    tree_iter(f, map.tree);
}
function map(f, map) {
    return from(map.comparer, tree_mapi(f, map.tree));
}
function partition(f, map) {
    var rs = tree_partition(map.comparer, f, map.tree);
    return [from(map.comparer, rs[0]), from(map.comparer, rs[1])];
}
function findKey(f, map) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["s" /* pick */])(function (kv) {
        return f(kv[0], kv[1]) ? kv[0] : null;
    }, map);
}
function tryFindKey(f, map) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["F" /* tryPick */])(function (kv) {
        return f(kv[0], kv[1]) ? kv[0] : null;
    }, map);
}
function pick(f, map) {
    var res = tryPick(f, map);
    if (res != null) {
        return res;
    }
    throw new Error("key not found");
}
function tryPick(f, map) {
    return tree_tryPick(f, map.tree);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CurriedLambda;
/* harmony export (immutable) */ __webpack_exports__["b"] = partialApply;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function CurriedLambda(f, expectedArgsLength) {
    if (f.curried === true) {
        return f;
    }
    var curriedFn = function curriedFn() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // _this = _this || this;
        var actualArgsLength = Math.max(args.length, 1);
        expectedArgsLength = Math.max(expectedArgsLength || f.length, 1);
        if (actualArgsLength >= expectedArgsLength) {
            var restArgs = args.splice(expectedArgsLength);
            var res = f.apply(undefined, args);
            if (typeof res === "function") {
                var newLambda = CurriedLambda(res);
                return restArgs.length === 0 ? newLambda : newLambda.apply(undefined, _toConsumableArray(restArgs));
            } else {
                return res;
            }
        } else {
            return CurriedLambda(function () {
                for (var _len2 = arguments.length, args2 = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args2[_key2] = arguments[_key2];
                }

                return f.apply(undefined, _toConsumableArray(args.concat(args2)));
            }, expectedArgsLength - actualArgsLength);
        }
    };
    curriedFn.curried = true;
    return curriedFn;
}
function partialApply(f, args) {
    var lambda = f.curried === true ? f : CurriedLambda(f, f.argsLength || f.length);
    return lambda.apply(undefined, _toConsumableArray(args));
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(61);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ofArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// This module is split from List.ts to prevent cyclic dependencies
function ofArray(args, base) {
    var acc = base || new List();
    for (var i = args.length - 1; i >= 0; i--) {
        acc = new List(args[i], acc);
    }
    return acc;
}

var List = function () {
    function List(head, tail) {
        _classCallCheck(this, List);

        this.head = head;
        this.tail = tail;
    }

    _createClass(List, [{
        key: "ToString",
        value: function ToString() {
            return "[" + Array.from(this).map(function (x) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["y" /* toString */])(x);
            }).join("; ") + "]";
        }
    }, {
        key: "Equals",
        value: function Equals(x) {
            // Optimization if they are referencially equal
            if (this === x) {
                return true;
            } else {
                var iter1 = this[Symbol.iterator]();
                var iter2 = x[Symbol.iterator]();
                while (true) {
                    var cur1 = iter1.next();
                    var cur2 = iter2.next();
                    if (cur1.done) {
                        return cur2.done ? true : false;
                    } else if (cur2.done) {
                        return false;
                    } else if (!Object(__WEBPACK_IMPORTED_MODULE_1__Util__["p" /* equals */])(cur1.value, cur2.value)) {
                        return false;
                    }
                }
            }
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(x) {
            // Optimization if they are referencially equal
            if (this === x) {
                return 0;
            } else {
                var acc = 0;
                var iter1 = this[Symbol.iterator]();
                var iter2 = x[Symbol.iterator]();
                while (true) {
                    var cur1 = iter1.next();
                    var cur2 = iter2.next();
                    if (cur1.done) {
                        return cur2.done ? acc : -1;
                    } else if (cur2.done) {
                        return 1;
                    } else {
                        acc = Object(__WEBPACK_IMPORTED_MODULE_1__Util__["j" /* compare */])(cur1.value, cur2.value);
                        if (acc !== 0) {
                            return acc;
                        }
                    }
                }
            }
        }
    }, {
        key: Symbol.iterator,
        value: function value() {
            var cur = this;
            return {
                next: function next() {
                    var tmp = cur;
                    cur = cur.tail;
                    return { done: tmp.tail == null, value: tmp.head };
                }
            };
        }
        //   append(ys: List<T>): List<T> {
        //     return append(this, ys);
        //   }
        //   choose<U>(f: (x: T) => U, xs: List<T>): List<U> {
        //     return choose(f, this);
        //   }
        //   collect<U>(f: (x: T) => List<U>): List<U> {
        //     return collect(f, this);
        //   }
        //   filter(f: (x: T) => boolean): List<T> {
        //     return filter(f, this);
        //   }
        //   where(f: (x: T) => boolean): List<T> {
        //     return filter(f, this);
        //   }
        //   map<U>(f: (x: T) => U): List<U> {
        //     return map(f, this);
        //   }
        //   mapIndexed<U>(f: (i: number, x: T) => U): List<U> {
        //     return mapIndexed(f, this);
        //   }
        //   partition(f: (x: T) => boolean): [List<T>, List<T>] {
        //     return partition(f, this) as [List<T>, List<T>];
        //   }
        //   reverse(): List<T> {
        //     return reverse(this);
        //   }
        //   slice(lower: number, upper: number): List<T> {
        //     return slice(lower, upper, this);
        //   }

    }, {
        key: __WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Microsoft.FSharp.Collections.FSharpList",
                interfaces: ["System.IEquatable", "System.IComparable"]
            };
        }
    }, {
        key: "length",
        get: function get() {
            var cur = this;
            var acc = 0;
            while (cur.tail != null) {
                cur = cur.tail;
                acc++;
            }
            return acc;
        }
    }]);

    return List;
}();

/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distinctBy */
/* harmony export (immutable) */ __webpack_exports__["c"] = distinct;
/* unused harmony export SetTree */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* unused harmony export isEmpty */
/* unused harmony export add */
/* unused harmony export addInPlace */
/* unused harmony export remove */
/* unused harmony export union */
/* unused harmony export op_Addition */
/* unused harmony export unionInPlace */
/* unused harmony export unionMany */
/* unused harmony export difference */
/* unused harmony export op_Subtraction */
/* unused harmony export differenceInPlace */
/* harmony export (immutable) */ __webpack_exports__["d"] = intersect;
/* unused harmony export intersectInPlace */
/* unused harmony export intersectMany */
/* unused harmony export isProperSubsetOf */
/* unused harmony export isProperSubset */
/* unused harmony export isSubsetOf */
/* unused harmony export isSubset */
/* unused harmony export isProperSupersetOf */
/* unused harmony export isProperSuperset */
/* unused harmony export isSupersetOf */
/* unused harmony export isSuperset */
/* unused harmony export copyTo */
/* unused harmony export partition */
/* unused harmony export filter */
/* unused harmony export map */
/* unused harmony export exists */
/* unused harmony export forAll */
/* unused harmony export fold */
/* unused harmony export foldBack */
/* unused harmony export iterate */
/* unused harmony export minimumElement */
/* unused harmony export minElement */
/* unused harmony export maximumElement */
/* unused harmony export maxElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comparer__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// tslint:disable:max-line-length












// ----------------------------------------------
// These functions belong to Seq.ts but are
// implemented here to prevent cyclic dependencies
function distinctBy(f, xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["b" /* choose */])(function (tup) {
        return tup[0];
    }, Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["w" /* scan */])(function (tup, x) {
        var acc = tup[1];
        var k = f(x);
        return acc.has(k) ? [null, acc] : [x, add(k, acc)];
    }, [null, create()], xs));
}
function distinct(xs) {
    return distinctBy(function (x) {
        return x;
    }, xs);
}
var SetTree = function SetTree(tag, data) {
    _classCallCheck(this, SetTree);

    this.tag = tag | 0;
    this.data = data;
};
var tree_tolerance = 2;
function tree_countAux(s, acc) {
    countAux: while (true) {
        if (s.tag === 1) {
            return acc + 1 | 0;
        } else if (s.tag === 0) {
            return acc | 0;
        } else {
            var _var5 = s.data[1];
            acc = tree_countAux(s.data[2], acc + 1);
            s = _var5;
            continue countAux;
        }
    }
}
function tree_count(s) {
    return tree_countAux(s, 0);
}
function tree_SetOne(n) {
    return new SetTree(1, [n]);
}
function tree_SetNode(x, l, r, h) {
    return new SetTree(2, [x, l, r, h]);
}
function tree_height(t) {
    return t.tag === 1 ? 1 : t.tag === 2 ? t.data[3] : 0;
}
function tree_mk(l, k, r) {
    var matchValue = l.tag === 0 ? r.tag === 0 ? 0 : 1 : 1;
    switch (matchValue) {
        case 0:
            return tree_SetOne(k);
        case 1:
            var hl = tree_height(l) | 0;
            var hr = tree_height(r) | 0;
            var m = (hl < hr ? hr : hl) | 0;
            return tree_SetNode(k, l, r, m + 1);
    }
    throw new Error("internal error: Set.tree_mk");
}
function tree_rebalance(t1, k, t2) {
    var t1h = tree_height(t1);
    var t2h = tree_height(t2);
    if (t2h > t1h + tree_tolerance) {
        if (t2.tag === 2) {
            if (tree_height(t2.data[1]) > t1h + 1) {
                if (t2.data[1].tag === 2) {
                    return tree_mk(tree_mk(t1, k, t2.data[1].data[1]), t2.data[1].data[0], tree_mk(t2.data[1].data[2], t2.data[0], t2.data[2]));
                } else {
                    throw new Error("rebalance");
                }
            } else {
                return tree_mk(tree_mk(t1, k, t2.data[1]), t2.data[0], t2.data[2]);
            }
        } else {
            throw new Error("rebalance");
        }
    } else {
        if (t1h > t2h + tree_tolerance) {
            if (t1.tag === 2) {
                if (tree_height(t1.data[2]) > t2h + 1) {
                    if (t1.data[2].tag === 2) {
                        return tree_mk(tree_mk(t1.data[1], t1.data[0], t1.data[2].data[1]), t1.data[2].data[0], tree_mk(t1.data[2].data[2], k, t2));
                    } else {
                        throw new Error("rebalance");
                    }
                } else {
                    return tree_mk(t1.data[1], t1.data[0], tree_mk(t1.data[2], k, t2));
                }
            } else {
                throw new Error("rebalance");
            }
        } else {
            return tree_mk(t1, k, t2);
        }
    }
}
function tree_add(comparer, k, t) {
    if (t.tag === 1) {
        var c = comparer.Compare(k, t.data[0]);
        if (c < 0) {
            return tree_SetNode(k, new SetTree(0), t, 2);
        } else if (c === 0) {
            return t;
        } else {
            return tree_SetNode(k, t, new SetTree(0), 2);
        }
    } else if (t.tag === 0) {
        return tree_SetOne(k);
    } else {
        var _c = comparer.Compare(k, t.data[0]);
        if (_c < 0) {
            return tree_rebalance(tree_add(comparer, k, t.data[1]), t.data[0], t.data[2]);
        } else if (_c === 0) {
            return t;
        } else {
            return tree_rebalance(t.data[1], t.data[0], tree_add(comparer, k, t.data[2]));
        }
    }
}
function tree_balance(comparer, t1, k, t2) {
    var matchValue = t1.tag === 1 ? t2.tag === 0 ? [1, t1] : t2.tag === 1 ? [2, t1.data[0], t2] : [2, t1.data[0], t2] : t1.tag === 2 ? t2.tag === 1 ? [3, t2.data[0], t1] : t2.tag === 2 ? [4, t1.data[3], t2.data[3], t1.data[0], t2.data[0], t1.data[1], t1.data[2], t2.data[1], t2.data[2]] : [1, t1] : [0, t2];
    switch (matchValue[0]) {
        case 0:
            return tree_add(comparer, k, matchValue[1]);
        case 1:
            return tree_add(comparer, k, matchValue[1]);
        case 2:
            return tree_add(comparer, k, tree_add(comparer, matchValue[1], matchValue[2]));
        case 3:
            return tree_add(comparer, k, tree_add(comparer, matchValue[1], matchValue[2]));
        case 4:
            if (matchValue[1] + tree_tolerance < matchValue[2]) {
                return tree_rebalance(tree_balance(comparer, t1, k, matchValue[7]), matchValue[4], matchValue[8]);
            } else if (matchValue[2] + tree_tolerance < matchValue[1]) {
                return tree_rebalance(matchValue[5], matchValue[3], tree_balance(comparer, matchValue[6], k, t2));
            } else {
                return tree_mk(t1, k, t2);
            }
    }
    throw new Error("internal error: Set.tree_balance");
}
function tree_split(comparer, pivot, t) {
    if (t.tag === 1) {
        var c = comparer.Compare(t.data[0], pivot);
        if (c < 0) {
            return [t, false, new SetTree(0)];
        } else if (c === 0) {
            return [new SetTree(0), true, new SetTree(0)];
        } else {
            return [new SetTree(0), false, t];
        }
    } else if (t.tag === 0) {
        return [new SetTree(0), false, new SetTree(0)];
    } else {
        var _c2 = comparer.Compare(pivot, t.data[0]);
        if (_c2 < 0) {
            var patternInput = tree_split(comparer, pivot, t.data[1]);
            return [patternInput[0], patternInput[1], tree_balance(comparer, patternInput[2], t.data[0], t.data[2])];
        } else if (_c2 === 0) {
            return [t.data[1], true, t.data[2]];
        } else {
            var _patternInput = tree_split(comparer, pivot, t.data[2]);
            return [tree_balance(comparer, t.data[1], t.data[0], _patternInput[0]), _patternInput[1], _patternInput[2]];
        }
    }
}
function tree_spliceOutSuccessor(t) {
    if (t.tag === 1) {
        return [t.data[0], new SetTree(0)];
    } else if (t.tag === 2) {
        if (t.data[1].tag === 0) {
            return [t.data[0], t.data[2]];
        } else {
            var patternInput = tree_spliceOutSuccessor(t.data[1]);
            return [patternInput[0], tree_mk(patternInput[1], t.data[0], t.data[2])];
        }
    } else {
        throw new Error("internal error: Map.spliceOutSuccessor");
    }
}
function tree_remove(comparer, k, t) {
    if (t.tag === 1) {
        var c = comparer.Compare(k, t.data[0]);
        if (c === 0) {
            return new SetTree(0);
        } else {
            return t;
        }
    } else if (t.tag === 2) {
        var _c3 = comparer.Compare(k, t.data[0]);
        if (_c3 < 0) {
            return tree_rebalance(tree_remove(comparer, k, t.data[1]), t.data[0], t.data[2]);
        } else if (_c3 === 0) {
            var matchValue = [t.data[1], t.data[2]];
            if (matchValue[0].tag === 0) {
                return t.data[2];
            } else if (matchValue[1].tag === 0) {
                return t.data[1];
            } else {
                var patternInput = tree_spliceOutSuccessor(t.data[2]);
                return tree_mk(t.data[1], patternInput[0], patternInput[1]);
            }
        } else {
            return tree_rebalance(t.data[1], t.data[0], tree_remove(comparer, k, t.data[2]));
        }
    } else {
        return t;
    }
}
function tree_mem(comparer, k, t) {
    mem: while (true) {
        if (t.tag === 1) {
            return comparer.Compare(k, t.data[0]) === 0;
        } else if (t.tag === 0) {
            return false;
        } else {
            var c = comparer.Compare(k, t.data[0]) | 0;
            if (c < 0) {
                comparer = comparer;
                k = k;
                t = t.data[1];
                continue mem;
            } else if (c === 0) {
                return true;
            } else {
                comparer = comparer;
                k = k;
                t = t.data[2];
                continue mem;
            }
        }
    }
}
function tree_iter(f, t) {
    if (t.tag === 1) {
        f(t.data[0]);
    } else if (t.tag !== 0) {
        tree_iter(f, t.data[1]);
        f(t.data[0]);
        tree_iter(f, t.data[2]);
    }
}
function tree_foldBack(f, m, x) {
    return m.tag === 1 ? f(m.data[0], x) : m.tag === 0 ? x : tree_foldBack(f, m.data[1], f(m.data[0], tree_foldBack(f, m.data[2], x)));
}
function tree_fold(f, x, m) {
    if (m.tag === 1) {
        return f(x, m.data[0]);
    } else if (m.tag === 0) {
        return x;
    } else {
        var x_1 = tree_fold(f, x, m.data[1]);
        var x_2 = f(x_1, m.data[0]);
        return tree_fold(f, x_2, m.data[2]);
    }
}
function tree_forall(f, m) {
    return m.tag === 1 ? f(m.data[0]) : m.tag === 0 ? true : (f(m.data[0]) ? tree_forall(f, m.data[1]) : false) ? tree_forall(f, m.data[2]) : false;
}
function tree_exists(f, m) {
    return m.tag === 1 ? f(m.data[0]) : m.tag === 0 ? false : (f(m.data[0]) ? true : tree_exists(f, m.data[1])) ? true : tree_exists(f, m.data[2]);
}
function tree_isEmpty(m) {
    return m.tag === 0 ? true : false;
}
function tree_subset(comparer, a, b) {
    return tree_forall(function (x) {
        return tree_mem(comparer, x, b);
    }, a);
}
function tree_psubset(comparer, a, b) {
    return tree_forall(function (x) {
        return tree_mem(comparer, x, b);
    }, a) ? tree_exists(function (x) {
        return !tree_mem(comparer, x, a);
    }, b) : false;
}
function tree_filterAux(comparer, f, s, acc) {
    if (s.tag === 1) {
        if (f(s.data[0])) {
            return tree_add(comparer, s.data[0], acc);
        } else {
            return acc;
        }
    } else if (s.tag === 0) {
        return acc;
    } else {
        var acc_1 = f(s.data[0]) ? tree_add(comparer, s.data[0], acc) : acc;
        return tree_filterAux(comparer, f, s.data[1], tree_filterAux(comparer, f, s.data[2], acc_1));
    }
}
function tree_filter(comparer, f, s) {
    return tree_filterAux(comparer, f, s, new SetTree(0));
}
function tree_diffAux(comparer, m, acc) {
    diffAux: while (true) {
        if (m.tag === 1) {
            return tree_remove(comparer, m.data[0], acc);
        } else if (m.tag === 0) {
            return acc;
        } else {
            var _var6 = comparer;
            var _var7 = m.data[1];
            acc = tree_diffAux(comparer, m.data[2], tree_remove(comparer, m.data[0], acc));
            comparer = _var6;
            m = _var7;
            continue diffAux;
        }
    }
}
function tree_diff(comparer, a, b) {
    return tree_diffAux(comparer, b, a);
}
function tree_union(comparer, t1, t2) {
    var matchValue = t1.tag === 0 ? [1, t2] : t1.tag === 1 ? t2.tag === 0 ? [2, t1] : t2.tag === 1 ? [3, t1.data[0], t2] : [3, t1.data[0], t2] : t2.tag === 0 ? [2, t1] : t2.tag === 1 ? [4, t2.data[0], t1] : [0, t1.data[3], t2.data[3], t1.data[0], t2.data[0], t1.data[1], t1.data[2], t2.data[1], t2.data[2]];
    switch (matchValue[0]) {
        case 0:
            if (matchValue[1] > matchValue[2]) {
                var patternInput = tree_split(comparer, matchValue[3], t2);
                return tree_balance(comparer, tree_union(comparer, matchValue[5], patternInput[0]), matchValue[3], tree_union(comparer, matchValue[6], patternInput[2]));
            } else {
                var patternInput_1 = tree_split(comparer, matchValue[4], t1);
                return tree_balance(comparer, tree_union(comparer, matchValue[7], patternInput_1[0]), matchValue[4], tree_union(comparer, matchValue[8], patternInput_1[2]));
            }
        case 1:
            return matchValue[1];
        case 2:
            return matchValue[1];
        case 3:
            return tree_add(comparer, matchValue[1], matchValue[2]);
        case 4:
            return tree_add(comparer, matchValue[1], matchValue[2]);
    }
    throw new Error("internal error: Set.tree_union");
}
function tree_intersectionAux(comparer, b, m, acc) {
    intersectionAux: while (true) {
        if (m.tag === 1) {
            if (tree_mem(comparer, m.data[0], b)) {
                return tree_add(comparer, m.data[0], acc);
            } else {
                return acc;
            }
        } else if (m.tag === 0) {
            return acc;
        } else {
            var acc_1 = tree_intersectionAux(comparer, b, m.data[2], acc);
            var acc_2 = tree_mem(comparer, m.data[0], b) ? tree_add(comparer, m.data[0], acc_1) : acc_1;
            comparer = comparer;
            b = b;
            m = m.data[1];
            acc = acc_2;
            continue intersectionAux;
        }
    }
}
function tree_intersection(comparer, a, b) {
    return tree_intersectionAux(comparer, b, a, new SetTree(0));
}
function tree_partition1(comparer, f, k, acc1, acc2) {
    return f(k) ? [tree_add(comparer, k, acc1), acc2] : [acc1, tree_add(comparer, k, acc2)];
}
function tree_partitionAux(comparer, f, s, acc_0, acc_1) {
    var acc = [acc_0, acc_1];
    if (s.tag === 1) {
        return tree_partition1(comparer, f, s.data[0], acc[0], acc[1]);
    } else if (s.tag === 0) {
        return acc;
    } else {
        var acc_2 = tree_partitionAux(comparer, f, s.data[2], acc[0], acc[1]);
        var acc_3 = tree_partition1(comparer, f, s.data[0], acc_2[0], acc_2[1]);
        return tree_partitionAux(comparer, f, s.data[1], acc_3[0], acc_3[1]);
    }
}
function tree_partition(comparer, f, s) {
    return tree_partitionAux(comparer, f, s, new SetTree(0), new SetTree(0));
}
// function tree_$MatchSetNode$MatchSetEmpty$(s: SetTree) {
//   return s.tag === 1 ? new Choice("Choice1Of2", [[s.data[0], new SetTree(0), new SetTree(0)]]) : s.tag === 0 ? new Choice("Choice2Of2", [null]) : new Choice("Choice1Of2", [[s.data[0], s.data[1], s.data[2]]]);
// }
function tree_minimumElementAux(s, n) {
    return s.tag === 1 ? s.data[0] : s.tag === 0 ? n : tree_minimumElementAux(s.data[1], s.data[0]);
}
function tree_minimumElementOpt(s) {
    return s.tag === 1 ? s.data[0] : s.tag === 0 ? null : tree_minimumElementAux(s.data[1], s.data[0]);
}
function tree_maximumElementAux(s, n) {
    return s.tag === 1 ? s.data[0] : s.tag === 0 ? n : tree_maximumElementAux(s.data[2], s.data[0]);
}
function tree_maximumElementOpt(s) {
    return s.tag === 1 ? s.data[0] : s.tag === 0 ? null : tree_maximumElementAux(s.data[2], s.data[0]);
}
function tree_minimumElement(s) {
    var matchValue = tree_minimumElementOpt(s);
    if (matchValue == null) {
        throw new Error("Set contains no elements");
    } else {
        return matchValue;
    }
}
function tree_maximumElement(s) {
    var matchValue = tree_maximumElementOpt(s);
    if (matchValue == null) {
        throw new Error("Set contains no elements");
    } else {
        return matchValue;
    }
}
function tree_collapseLHS(stack) {
    collapseLHS: while (true) {
        if (stack.tail != null) {
            if (stack.head.tag === 1) {
                return stack;
            } else if (stack.head.tag === 2) {
                stack = Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([stack.head.data[1], tree_SetOne(stack.head.data[0]), stack.head.data[2]], stack.tail);
                continue collapseLHS;
            } else {
                stack = stack.tail;
                continue collapseLHS;
            }
        } else {
            return new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]();
        }
    }
}
function tree_mkIterator(s) {
    return { stack: tree_collapseLHS(new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](s, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]())), started: false };
}
// function tree_notStarted() {
//   throw new Error("Enumeration not started");
// };
// var alreadyFinished = $exports.alreadyFinished = function () {
//   throw new Error("Enumeration already started");
// };
function tree_moveNext(i) {
    function current(it) {
        if (it.stack.tail == null) {
            return null;
        } else if (it.stack.head.tag === 1) {
            return it.stack.head.data[0];
        }
        throw new Error("Please report error: Set iterator, unexpected stack for current");
    }
    if (i.started) {
        if (i.stack.tail == null) {
            return { done: true, value: null };
        } else {
            if (i.stack.head.tag === 1) {
                i.stack = tree_collapseLHS(i.stack.tail);
                return {
                    done: i.stack.tail == null,
                    value: current(i)
                };
            } else {
                throw new Error("Please report error: Set iterator, unexpected stack for moveNext");
            }
        }
    } else {
        i.started = true;
        return {
            done: i.stack.tail == null,
            value: current(i)
        };
    }
}
function tree_compareStacks(comparer, l1, l2) {
    compareStacks: while (true) {
        var matchValue = l1.tail != null ? l2.tail != null ? l2.head.tag === 1 ? l1.head.tag === 1 ? [4, l1.head.data[0], l2.head.data[0], l1.tail, l2.tail] : l1.head.tag === 2 ? l1.head.data[1].tag === 0 ? [6, l1.head.data[1], l1.head.data[0], l1.head.data[2], l2.head.data[0], l1.tail, l2.tail] : [9, l1.head.data[0], l1.head.data[1], l1.head.data[2], l1.tail] : [10, l2.head.data[0], l2.tail] : l2.head.tag === 2 ? l2.head.data[1].tag === 0 ? l1.head.tag === 1 ? [5, l1.head.data[0], l2.head.data[0], l2.head.data[2], l1.tail, l2.tail] : l1.head.tag === 2 ? l1.head.data[1].tag === 0 ? [7, l1.head.data[0], l1.head.data[2], l2.head.data[0], l2.head.data[2], l1.tail, l2.tail] : [9, l1.head.data[0], l1.head.data[1], l1.head.data[2], l1.tail] : [11, l2.head.data[0], l2.head.data[1], l2.head.data[2], l2.tail] : l1.head.tag === 1 ? [8, l1.head.data[0], l1.tail] : l1.head.tag === 2 ? [9, l1.head.data[0], l1.head.data[1], l1.head.data[2], l1.tail] : [11, l2.head.data[0], l2.head.data[1], l2.head.data[2], l2.tail] : l1.head.tag === 1 ? [8, l1.head.data[0], l1.tail] : l1.head.tag === 2 ? [9, l1.head.data[0], l1.head.data[1], l1.head.data[2], l1.tail] : [3, l1.tail, l2.tail] : [2] : l2.tail != null ? [1] : [0];
        switch (matchValue[0]) {
            case 0:
                return 0;
            case 1:
                return -1;
            case 2:
                return 1;
            case 3:
                comparer = comparer;
                l1 = matchValue[1];
                l2 = matchValue[2];
                continue compareStacks;
            case 4:
                var c = comparer.Compare(matchValue[1], matchValue[2]) | 0;
                if (c !== 0) {
                    return c | 0;
                } else {
                    comparer = comparer;
                    l1 = matchValue[3];
                    l2 = matchValue[4];
                    continue compareStacks;
                }
            case 5:
                var c_1 = comparer.Compare(matchValue[1], matchValue[2]) | 0;
                if (c_1 !== 0) {
                    return c_1 | 0;
                } else {
                    comparer = comparer;
                    l1 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](new SetTree(0), matchValue[4]);
                    l2 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](matchValue[3], matchValue[5]);
                    continue compareStacks;
                }
            case 6:
                var c_2 = comparer.Compare(matchValue[2], matchValue[4]) | 0;
                if (c_2 !== 0) {
                    return c_2 | 0;
                } else {
                    comparer = comparer;
                    l1 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](matchValue[3], matchValue[5]);
                    l2 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](matchValue[1], matchValue[6]);
                    continue compareStacks;
                }
            case 7:
                var c_3 = comparer.Compare(matchValue[1], matchValue[3]) | 0;
                if (c_3 !== 0) {
                    return c_3 | 0;
                } else {
                    comparer = comparer;
                    l1 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](matchValue[2], matchValue[5]);
                    l2 = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](matchValue[4], matchValue[6]);
                    continue compareStacks;
                }
            case 8:
                comparer = comparer;
                l1 = Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([new SetTree(0), tree_SetOne(matchValue[1])], matchValue[2]);
                l2 = l2;
                continue compareStacks;
            case 9:
                comparer = comparer;
                l1 = Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([matchValue[2], tree_SetNode(matchValue[1], new SetTree(0), matchValue[3], 0)], matchValue[4]);
                l2 = l2;
                continue compareStacks;
            case 10:
                comparer = comparer;
                l1 = l1;
                l2 = Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([new SetTree(0), tree_SetOne(matchValue[1])], matchValue[2]);
                continue compareStacks;
            case 11:
                comparer = comparer;
                l1 = l1;
                l2 = Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([matchValue[2], tree_SetNode(matchValue[1], new SetTree(0), matchValue[3], 0)], matchValue[4]);
                continue compareStacks;
        }
    }
}
function tree_compare(comparer, s1, s2) {
    if (s1.tag === 0) {
        return s2.tag === 0 ? 0 : -1;
    } else {
        return s2.tag === 0 ? 1 : tree_compareStacks(comparer, Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([s1]), Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])([s2]));
    }
}
function tree_mkFromEnumerator(comparer, acc, e) {
    var cur = e.next();
    while (!cur.done) {
        acc = tree_add(comparer, cur.value, acc);
        cur = e.next();
    }
    return acc;
}
function tree_ofSeq(comparer, c) {
    var ie = c[Symbol.iterator]();
    return tree_mkFromEnumerator(comparer, new SetTree(0), ie);
}

var FableSet = function () {
    /** Do not call, use Set.create instead. */
    function FableSet() {
        _classCallCheck(this, FableSet);

        return;
    }

    _createClass(FableSet, [{
        key: "ToString",
        value: function ToString() {
            return "set [" + Array.from(this).map(function (x) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__Util__["y" /* toString */])(x);
            }).join("; ") + "]";
        }
    }, {
        key: "Equals",
        value: function Equals(s2) {
            return this.CompareTo(s2) === 0;
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(s2) {
            return this === s2 ? 0 : tree_compare(this.comparer, this.tree, s2.tree);
        }
    }, {
        key: Symbol.iterator,
        value: function value() {
            var i = tree_mkIterator(this.tree);
            return {
                next: function next() {
                    return tree_moveNext(i);
                }
            };
        }
    }, {
        key: "values",
        value: function values() {
            return this[Symbol.iterator]();
        }
    }, {
        key: "has",
        value: function has(v) {
            return tree_mem(this.comparer, v, this.tree);
        }
        /** Mutating method */

    }, {
        key: "add",
        value: function add(v) {
            this.tree = tree_add(this.comparer, v, this.tree);
            return this;
        }
        /** Mutating method */

    }, {
        key: "delete",
        value: function _delete(v) {
            // TODO: Is calculating the size twice is more performant than calling tree_mem?
            var oldSize = tree_count(this.tree);
            this.tree = tree_remove(this.comparer, v, this.tree);
            return oldSize > tree_count(this.tree);
        }
        /** Mutating method */

    }, {
        key: "clear",
        value: function clear() {
            this.tree = new SetTree(0);
        }
    }, {
        key: __WEBPACK_IMPORTED_MODULE_3__Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Microsoft.FSharp.Collections.FSharpSet",
                interfaces: ["System.IEquatable", "System.IComparable"]
            };
        }
    }, {
        key: "size",
        get: function get() {
            return tree_count(this.tree);
        }
    }]);

    return FableSet;
}();

/* harmony default export */ __webpack_exports__["b"] = (FableSet);

function from(comparer, tree) {
    var s = new FableSet();
    s.tree = tree;
    s.comparer = comparer || new __WEBPACK_IMPORTED_MODULE_0__Comparer__["a" /* default */]();
    return s;
}
function create(ie, comparer) {
    comparer = comparer || new __WEBPACK_IMPORTED_MODULE_0__Comparer__["a" /* default */]();
    return from(comparer, ie ? tree_ofSeq(comparer, ie) : new SetTree(0));
}
function isEmpty(s) {
    return tree_isEmpty(s.tree);
}
function add(item, s) {
    return from(s.comparer, tree_add(s.comparer, item, s.tree));
}
function addInPlace(item, s) {
    return s.has(item) ? false : (s.add(item), true);
}
function remove(item, s) {
    return from(s.comparer, tree_remove(s.comparer, item, s.tree));
}
function union(set1, set2) {
    return set2.tree.tag === 0 ? set1 : set1.tree.tag === 0 ? set2 : from(set1.comparer, tree_union(set1.comparer, set1.tree, set2.tree));
}
function op_Addition(set1, set2) {
    return union(set1, set2);
}
function unionInPlace(set1, set2) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["o" /* iterate */])(function (x) {
        set1.add(x);
    }, set2);
}
function unionMany(sets) {
    // Pass args as union(s, acc) instead of union(acc, s)
    // to discard the comparer of the first empty set
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["j" /* fold */])(function (acc, s) {
        return union(s, acc);
    }, create(), sets);
}
function difference(set1, set2) {
    return set1.tree.tag === 0 ? set1 : set2.tree.tag === 0 ? set1 : from(set1.comparer, tree_diff(set1.comparer, set1.tree, set2.tree));
}
function op_Subtraction(set1, set2) {
    return difference(set1, set2);
}
function differenceInPlace(set1, set2) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["o" /* iterate */])(function (x) {
        set1.delete(x);
    }, set2);
}
function intersect(set1, set2) {
    return set2.tree.tag === 0 ? set2 : set1.tree.tag === 0 ? set1 : from(set1.comparer, tree_intersection(set1.comparer, set1.tree, set2.tree));
}
function intersectInPlace(set1, set2) {
    var set2_ = set2 instanceof Set ? set2 : new Set(set2);
    Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["o" /* iterate */])(function (x) {
        if (!set2_.has(x)) {
            set1.delete(x);
        }
    }, set1);
}
function intersectMany(sets) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["u" /* reduce */])(function (s1, s2) {
        return intersect(s1, s2);
    }, sets);
}
function isProperSubsetOf(set1, set2) {
    if (set1 instanceof FableSet && set2 instanceof FableSet) {
        return tree_psubset(set1.comparer, set1.tree, set2.tree);
    } else {
        set2 = set2 instanceof Set ? set2 : new Set(set2);
        return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["l" /* forAll */])(function (x) {
            return set2.has(x);
        }, set1) && Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["h" /* exists */])(function (x) {
            return !set1.has(x);
        }, set2);
    }
}
function isProperSubset(set1, set2) {
    return isProperSubsetOf(set1, set2);
}
function isSubsetOf(set1, set2) {
    if (set1 instanceof FableSet && set2 instanceof FableSet) {
        return tree_subset(set1.comparer, set1.tree, set2.tree);
    } else {
        set2 = set2 instanceof Set ? set2 : new Set(set2);
        return Object(__WEBPACK_IMPORTED_MODULE_2__Seq__["l" /* forAll */])(function (x) {
            return set2.has(x);
        }, set1);
    }
}
function isSubset(set1, set2) {
    return isSubsetOf(set1, set2);
}
function isProperSupersetOf(set1, set2) {
    if (set1 instanceof FableSet && set2 instanceof FableSet) {
        return tree_psubset(set1.comparer, set2.tree, set1.tree);
    } else {
        return isProperSubset(set2 instanceof Set ? set2 : new Set(set2), set1);
    }
}
function isProperSuperset(set1, set2) {
    return isProperSupersetOf(set1, set2);
}
function isSupersetOf(set1, set2) {
    if (set1 instanceof FableSet && set2 instanceof FableSet) {
        return tree_subset(set1.comparer, set2.tree, set1.tree);
    } else {
        return isSubset(set2 instanceof Set ? set2 : new Set(set2), set1);
    }
}
function isSuperset(set1, set2) {
    return isSupersetOf(set1, set2);
}
function copyTo(xs, arr, arrayIndex, count) {
    if (!Array.isArray(arr) && !ArrayBuffer.isView(arr)) {
        throw new Error("Array is invalid");
    }
    count = count || arr.length;
    var i = arrayIndex || 0;
    var iter = xs[Symbol.iterator]();
    while (count--) {
        var el = iter.next();
        if (el.done) {
            break;
        }
        arr[i++] = el.value;
    }
}
function partition(f, s) {
    if (s.tree.tag === 0) {
        return [s, s];
    } else {
        var tuple = tree_partition(s.comparer, f, s.tree);
        return [from(s.comparer, tuple[0]), from(s.comparer, tuple[1])];
    }
}
function filter(f, s) {
    if (s.tree.tag === 0) {
        return s;
    } else {
        return from(s.comparer, tree_filter(s.comparer, f, s.tree));
    }
}
function map(f, s) {
    var comparer = new __WEBPACK_IMPORTED_MODULE_0__Comparer__["a" /* default */]();
    return from(comparer, tree_fold(function (acc, k) {
        return tree_add(comparer, f(k), acc);
    }, new SetTree(0), s.tree));
}
function exists(f, s) {
    return tree_exists(f, s.tree);
}
function forAll(f, s) {
    return tree_forall(f, s.tree);
}
function fold(f, seed, s) {
    return tree_fold(f, seed, s.tree);
}
function foldBack(f, s, seed) {
    return tree_foldBack(f, s.tree, seed);
}
function iterate(f, s) {
    tree_iter(f, s.tree);
}
function minimumElement(s) {
    return tree_minimumElement(s.tree);
}
function minElement(s) {
    return tree_minimumElement(s.tree);
}
function maximumElement(s) {
    return tree_maximumElement(s.tree);
}
function maxElement(s) {
    return tree_maximumElement(s.tree);
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export key */
/* harmony export (immutable) */ __webpack_exports__["c"] = load;
/* harmony export (immutable) */ __webpack_exports__["e"] = save;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearReadBooks;
/* unused harmony export detailsKey */
/* harmony export (immutable) */ __webpack_exports__["d"] = loadDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = saveDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Serialize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_fs__ = __webpack_require__(5);



var key = "readBooks";
function load() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Serialize__["a" /* ofJson */])(localStorage.getItem(key), {
        T: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */]))
    });
}
function save(data) {
    localStorage.setItem(key, Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Serialize__["b" /* toJson */])(data));
}
function clearReadBooks() {
    localStorage.removeItem(key);
}
var detailsKey = "details";
function loadDetails() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Serialize__["a" /* ofJson */])(localStorage.getItem(detailsKey), {
        T: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */]))
    });
}
function saveDetails(data) {
    localStorage.setItem(detailsKey, Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Serialize__["b" /* toJson */])(data));
}
function clearDetails() {
    localStorage.removeItem(detailsKey);
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromEqualityComparer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Comparer = function () {
    function Comparer(f) {
        _classCallCheck(this, Comparer);

        this.Compare = f || __WEBPACK_IMPORTED_MODULE_1__Util__["j" /* compare */];
    }

    _createClass(Comparer, [{
        key: __WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection,
        value: function value() {
            return { interfaces: ["System.IComparer"] };
        }
    }]);

    return Comparer;
}();

/* harmony default export */ __webpack_exports__["a"] = (Comparer);

function fromEqualityComparer(comparer) {
    // Sometimes IEqualityComparer also implements IComparer
    if (typeof comparer.Compare === "function") {
        return new Comparer(comparer.Compare);
    } else {
        return new Comparer(function (x, y) {
            var xhash = comparer.GetHashCode(x);
            var yhash = comparer.GetHashCode(y);
            if (xhash === yhash) {
                return comparer.Equals(x, y) ? 0 : -1;
            } else {
                return xhash < yhash ? -1 : 1;
            }
        });
    }
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = map;
/* unused harmony export mapIndexed */
/* unused harmony export indexed */
/* unused harmony export addRangeInPlace */
/* unused harmony export copyTo */
/* unused harmony export partition */
/* harmony export (immutable) */ __webpack_exports__["c"] = permute;
/* unused harmony export removeInPlace */
/* unused harmony export setSlice */
/* unused harmony export sortInPlaceBy */
/* unused harmony export unzip */
/* unused harmony export unzip3 */
/* harmony export (immutable) */ __webpack_exports__["a"] = chunkBySize;
/* unused harmony export getSubArray */
/* unused harmony export fill */
/* unused harmony export splitAt */
function map(f, source, TargetCons) {
    var target = new TargetCons(source.length);
    for (var i = 0; i < source.length; i++) {
        target[i] = f(source[i]);
    }
    return target;
}
function mapIndexed(f, source, TargetCons) {
    var target = new TargetCons(source.length);
    for (var i = 0; i < source.length; i++) {
        target[i] = f(i, source[i]);
    }
    return target;
}
function indexed(source) {
    return mapIndexed(function (i, x) {
        return [i, x];
    }, source, Array);
}
function addRangeInPlace(range, xs) {
    var iter = range[Symbol.iterator]();
    var cur = iter.next();
    while (!cur.done) {
        xs.push(cur.value);
        cur = iter.next();
    }
}
function copyTo(source, sourceIndex, target, targetIndex, count) {
    while (count--) {
        target[targetIndex++] = source[sourceIndex++];
    }
}
function partition(f, xs) {
    var ys = [];
    var zs = [];
    var j = 0;
    var k = 0;
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i])) {
            ys[j++] = xs[i];
        } else {
            zs[k++] = xs[i];
        }
    }
    return [ys, zs];
}
function permute(f, xs) {
    // Keep the type of the array
    var ys = xs.map(function () {
        return null;
    });
    var checkFlags = new Array(xs.length);
    for (var i = 0; i < xs.length; i++) {
        var j = f(i);
        if (j < 0 || j >= xs.length) {
            throw new Error("Not a valid permutation");
        }
        ys[j] = xs[i];
        checkFlags[j] = 1;
    }
    for (var _i = 0; _i < xs.length; _i++) {
        if (checkFlags[_i] !== 1) {
            throw new Error("Not a valid permutation");
        }
    }
    return ys;
}
function removeInPlace(item, xs) {
    var i = xs.indexOf(item);
    if (i > -1) {
        xs.splice(i, 1);
        return true;
    }
    return false;
}
function setSlice(target, lower, upper, source) {
    var length = (upper || target.length - 1) - lower;
    if (ArrayBuffer.isView(target) && source.length <= length) {
        target.set(source, lower);
    } else {
        for (var i = lower | 0, j = 0; j <= length; i++, j++) {
            target[i] = source[j];
        }
    }
}
function sortInPlaceBy(f, xs) {
    var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return xs.sort(function (x, y) {
        x = f(x);
        y = f(y);
        return (x < y ? -1 : x === y ? 0 : 1) * dir;
    });
}
function unzip(xs) {
    var bs = new Array(xs.length);
    var cs = new Array(xs.length);
    for (var i = 0; i < xs.length; i++) {
        bs[i] = xs[i][0];
        cs[i] = xs[i][1];
    }
    return [bs, cs];
}
function unzip3(xs) {
    var bs = new Array(xs.length);
    var cs = new Array(xs.length);
    var ds = new Array(xs.length);
    for (var i = 0; i < xs.length; i++) {
        bs[i] = xs[i][0];
        cs[i] = xs[i][1];
        ds[i] = xs[i][2];
    }
    return [bs, cs, ds];
}
function chunkBySize(size, xs) {
    if (size < 1) {
        throw new Error("The input must be positive. parameter name: chunkSize");
    }
    if (xs.length === 0) {
        return [[]];
    }
    var result = [];
    // add each chunk to the result
    for (var x = 0; x < Math.ceil(xs.length / size); x++) {
        var start = x * size;
        var end = start + size;
        result.push(xs.slice(start, end));
    }
    return result;
}
function getSubArray(xs, startIndex, count) {
    return xs.slice(startIndex, startIndex + count);
}
function fill(target, targetIndex, count, value) {
    target.fill(value, targetIndex, targetIndex + count);
}
function splitAt(index, xs) {
    if (index < 0) {
        throw new Error("The input must be non-negative.");
    }
    if (index > xs.length) {
        throw new Error("The input sequence has an insufficient number of elements.");
    }
    return [xs.slice(0, index), xs.slice(index)];
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ordinal */
/* unused harmony export createCentury */
/* unused harmony export createDecade */
/* unused harmony export centuries */
/* unused harmony export decades */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return periods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);



function ordinal(i) {
    if (i === 0) {
        return "";
    } else {
        var matchValue = i % 100 | 0;
        var $var1 = matchValue === 11 ? [0] : matchValue === 12 ? [0] : matchValue === 13 ? [0] : [1];

        switch ($var1[0]) {
            case 0:
                return "th";

            case 1:
                var matchValue_1 = i % 10 | 0;

                if (matchValue_1 === 1) {
                    return "st";
                } else if (matchValue_1 === 2) {
                    return "nd";
                } else if (matchValue_1 === 3) {
                    return "rd";
                } else {
                    return "th";
                }

        }
    }
}
function createCentury(i) {
    if (i < 0) {
        var index = Math.abs(i) | 0;
        var min = i * 100 | 0;
        return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i%s century BC", 2))(index, ordinal(index)), min, min + 99];
    } else {
        var index_1 = i + 1 | 0;
        var min_1 = i * 100 + 1 | 0;
        return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i%s century", 2))(index_1, ordinal(index_1)), min_1, min_1 + 99];
    }
}
function createDecade(i) {
    var min = 1900 + i * 10 | 0;
    var label = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%is", 1))(min);
    return [label, min, min + 10];
}
var centuries = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(function (source) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (i) {
        return createCentury(i);
    }, source);
}(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["t" /* range */])(-30, 30))));
var decades = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(function (source) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (i) {
        return createDecade(i);
    }, source);
}(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["t" /* range */])(0, 100))));
var periods = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["a" /* append */])(centuries, decades);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidReadBook */
/* unused harmony export bookSpeed */
/* unused harmony export createBookData */
/* harmony export (immutable) */ __webpack_exports__["a"] = averageSpeed;
/* harmony export (immutable) */ __webpack_exports__["d"] = validBooks;
/* harmony export (immutable) */ __webpack_exports__["c"] = booksSpeed;
/* harmony export (immutable) */ __webpack_exports__["b"] = basicStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_TimeSpan__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);






function isValidReadBook(book) {
    if (function () {
        return book.ReadData != null;
    }()) {
        return book.NumPages > 0;
    } else {
        return false;
    }
}
function bookSpeed(book) {
    var readData = book.ReadData;
    var startDate = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["c" /* date */])(readData.StartedAt);
    var endDate = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["c" /* date */])(readData.ReadAt);

    var daysCount = function () {
        var copyOfStruct = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["i" /* op_Subtraction */])(endDate, startDate);
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_TimeSpan__["b" /* totalDays */])(copyOfStruct);
    }() + 1;

    return book.NumPages / daysCount;
}
function createBookData(book, bookSpeed_1) {
    return new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["f" /* BookStatsData */](book, ~~(book.NumPages / bookSpeed_1), bookSpeed_1);
}
function averageSpeed(books) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["n" /* isEmpty */])(books)) {
        return 0;
    } else {
        var getBookDays = function getBookDays(book) {
            var readData = book.ReadData;
            var daysCount = ~~function () {
                var copyOfStruct = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["i" /* op_Subtraction */])(readData.ReadAt, readData.StartedAt);
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_TimeSpan__["b" /* totalDays */])(copyOfStruct);
            }() | 0;
            return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var1) {
                return function () {
                    var objectArg = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["c" /* date */])(readData.StartedAt);
                    return function (arg00) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["a" /* addDays */])(objectArg, arg00);
                    };
                }()(function (value) {
                    return value;
                }($var1));
            }, Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["t" /* range */])(0, daysCount)));
        };

        var days = Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__["c" /* distinct */])(function (source) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(getBookDays, source);
        }(books));
        var pagesCount = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["z" /* sumBy */])(function (book_1) {
            return book_1.NumPages;
        }, books);
        var daysCount_1 = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(days);
        return pagesCount / daysCount_1;
    }
}
function validBooks(readBooks) {
    return Array.from(function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (book) {
            return isValidReadBook(book);
        }, source);
    }(readBooks));
}
function booksSpeed(validBooks_1) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var2, $var3) {
        return -Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function (b) {
            return b.Speed;
        }($var2), function (b) {
            return b.Speed;
        }($var3));
    }, Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (r) {
        return createBookData(r, bookSpeed(r));
    }, validBooks_1));
}
function basicStats(readBooks) {
    var validBooks_1 = validBooks(readBooks);
    var booksSpeed_1 = booksSpeed(validBooks_1);
    var fastestBook = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["D" /* tryHead */])(booksSpeed_1);
    var slowestBook = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["E" /* tryLast */])(booksSpeed_1);
    var averagePagesCount = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["n" /* isEmpty */])(validBooks_1) ? 0 : Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["a" /* averageBy */])(function (p) {
        return p.NumPages;
    }, validBooks_1);
    return new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["c" /* BasicStats */](validBooks_1.length, Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["z" /* sumBy */])(function (p_1) {
        return p_1.NumPages;
    }, validBooks_1), slowestBook, fastestBook, averageSpeed(validBooks_1), averagePagesCount);
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export code */
/* unused harmony export serverUrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = completeUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = completeUrlWithToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = completeUrlWithClientUrl;
/* unused harmony export keyValuePair */
/* harmony export (immutable) */ __webpack_exports__["d"] = getQueryVariable;
/* harmony export (immutable) */ __webpack_exports__["e"] = navigateTo;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeTokenFromLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);


var code = "/2TrzMFxBGuQedl8nYG0Q4wWeP3Rw9pg/pUhqqnyPxQ1wnl/ayPHFQ==";
var serverUrl = "https://bookworm-stats-api.now.sh/api/";
function completeUrl(methodName, query) {
    return serverUrl + methodName + query + Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("&code=%s", 1))(code);
}
function completeUrlWithToken(methodName, token, tokenSecret) {
    var query = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("?token=%s&tokenSecret=%s", 2))(token, tokenSecret);
    return completeUrl(methodName, query);
}
function completeUrlWithClientUrl(methodName) {
    var query = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("?clientSideUrl=%s", 1))(location.origin);
    return completeUrl(methodName, query);
}
function keyValuePair(_var) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["d" /* split */])(_var, "=");

    if (parts.length === 2) {
        var valuePart = parts[1];
        var keyPart = parts[0];
        return [decodeURIComponent(keyPart), decodeURIComponent(valuePart)];
    } else {
        return ["", ""];
    }
}
function getQueryVariable(variable) {
    var query = window.location.search.substr(1);
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["D" /* tryHead */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tuple) {
        return tuple[1];
    }, Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (tupledArg) {
        return tupledArg[0] === variable;
    }, function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (_var) {
            return keyValuePair(_var);
        }, source);
    }(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["d" /* split */])(query, "&")))));
}
function navigateTo(url) {
    location.href = url;
}
function removeTokenFromLocation() {
    var currentState = history.state;
    history.replaceState(currentState, "", location.origin);
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Fetch_types */
/* unused harmony export fetch */
/* unused harmony export tryFetch */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAs;
/* unused harmony export tryFetchAs */
/* unused harmony export postRecord */
/* unused harmony export tryPostRecord */
/* unused harmony export putRecord */
/* unused harmony export tryPutRecord */
/* unused harmony export patchRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_fs__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fable_core_1_2_4_fable_core_Serialize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var Fetch_types = function (__exports) {
        var HttpRequestHeaders = __exports.HttpRequestHeaders = function () {
                function HttpRequestHeaders(tag, data) {
                        _classCallCheck(this, HttpRequestHeaders);

                        this.tag = tag;
                        this.data = data;
                }

                _createClass(HttpRequestHeaders, [{
                        key: __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
                        value: function value() {
                                return {
                                        type: "Fable.PowerPack.Fetch.Fetch_types.HttpRequestHeaders",
                                        interfaces: ["FSharpUnion", "System.IEquatable"],
                                        cases: [["Accept", "string"], ["Accept-Charset", "string"], ["Accept-Encoding", "string"], ["Accept-Language", "string"], ["Accept-Datetime", "string"], ["Authorization", "string"], ["Cache-Control", "string"], ["Connection", "string"], ["Cookie", "string"], ["Content-Length", "string"], ["Content-MD5", "string"], ["Content-Type", "string"], ["Date", "string"], ["Expect", "string"], ["Forwarded", "string"], ["From", "string"], ["Host", "string"], ["If-Match", "string"], ["If-Modified-Since", "string"], ["If-None-Match", "string"], ["If-Range", "string"], ["If-Unmodified-Since", "string"], ["Max-Forwards", "number"], ["Origin", "string"], ["Pragma", "string"], ["Proxy-Authorization", "string"], ["Range", "string"], ["Referer", "string"], ["SOAPAction", "string"], ["TE", "string"], ["User-Agent", "string"], ["Upgrade", "string"], ["Via", "string"], ["Warning", "string"], ["X-Requested-With", "string"], ["DNT", "string"], ["X-Forwarded-For", "string"], ["X-Forwarded-Host", "string"], ["X-Forwarded-Proto", "string"], ["Front-End-Https", "string"], ["X-Http-Method-Override", "string"], ["X-ATT-DeviceId", "string"], ["X-Wap-Profile", "string"], ["Proxy-Connection", "string"], ["X-UIDH", "string"], ["X-Csrf-Token", "string"], ["Custom", "string", __WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["a" /* Any */]]]
                                };
                        }
                }, {
                        key: "Equals",
                        value: function Equals(other) {
                                return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
                        }
                }]);

                return HttpRequestHeaders;
        }();

        Object(__WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.PowerPack.Fetch.Fetch_types.HttpRequestHeaders", HttpRequestHeaders);

        var RequestProperties = __exports.RequestProperties = function () {
                function RequestProperties(tag, data) {
                        _classCallCheck(this, RequestProperties);

                        this.tag = tag;
                        this.data = data;
                }

                _createClass(RequestProperties, [{
                        key: __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
                        value: function value() {
                                return {
                                        type: "Fable.PowerPack.Fetch.Fetch_types.RequestProperties",
                                        interfaces: ["FSharpUnion", "System.IEquatable"],
                                        cases: [["Method", "string"], ["Headers", Object(__WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("Fable.PowerPack.Fetch.Fetch_types.IHttpRequestHeaders")], ["Body", __WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["a" /* Any */]], ["Mode", "string"], ["Credentials", "string"], ["Cache", "string"]]
                                };
                        }
                }, {
                        key: "Equals",
                        value: function Equals(other) {
                                return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
                        }
                }]);

                return RequestProperties;
        }();

        Object(__WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.PowerPack.Fetch.Fetch_types.RequestProperties", RequestProperties);
        return __exports;
}({});

function _fetch(url, init) {
        return fetch(url, Object(__WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(init, 1)).then(function (response) {
                if (response.ok) {
                        return response;
                } else {
                        throw new Error(response.status.toString() + " " + response.statusText + " for URL " + response.url);
                }
        });
}


function tryFetch(url, init) {
        return __WEBPACK_IMPORTED_MODULE_2__Promise_fs__["a" /* Promise */].result(_fetch(url, init));
}
function fetchAs(url, init, _genArgs) {
        return _fetch(url, init).then(function (fetched) {
                return fetched.text();
        }).then(function (json) {
                return Object(__WEBPACK_IMPORTED_MODULE_3__fable_core_1_2_4_fable_core_Serialize__["a" /* ofJson */])(json, {
                        T: _genArgs.T
                });
        });
}
function tryFetchAs(url, init, _genArgs) {
        return __WEBPACK_IMPORTED_MODULE_2__Promise_fs__["a" /* Promise */].result(fetchAs(url, init, {
                T: _genArgs.T
        }));
}
function postRecord(url, record, properties) {
        var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new Fetch_types.RequestProperties(0, "POST"), new Fetch_types.RequestProperties(1, _defineProperty({}, "Content-Type", "application/json")), new Fetch_types.RequestProperties(2, Object(__WEBPACK_IMPORTED_MODULE_3__fable_core_1_2_4_fable_core_Serialize__["b" /* toJson */])(record))]);
        return function (init) {
                return _fetch(url, init);
        }(Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["a" /* append */])(defaultProps, properties));
}
function tryPostRecord(url, record, properties) {
        return __WEBPACK_IMPORTED_MODULE_2__Promise_fs__["a" /* Promise */].result(postRecord(url, record, properties));
}
function putRecord(url, record, properties) {
        var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new Fetch_types.RequestProperties(0, "PUT"), new Fetch_types.RequestProperties(1, _defineProperty({}, "Content-Type", "application/json")), new Fetch_types.RequestProperties(2, Object(__WEBPACK_IMPORTED_MODULE_3__fable_core_1_2_4_fable_core_Serialize__["b" /* toJson */])(record))]);
        return function (init) {
                return _fetch(url, init);
        }(Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["a" /* append */])(defaultProps, properties));
}
function tryPutRecord(url, record, properties) {
        return __WEBPACK_IMPORTED_MODULE_2__Promise_fs__["a" /* Promise */].result(putRecord(url, record, properties));
}
function patchRecord(url, record, properties) {
        var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new Fetch_types.RequestProperties(0, "PATCH"), new Fetch_types.RequestProperties(1, _defineProperty({}, "Content-Type", "application/json")), new Fetch_types.RequestProperties(2, Object(__WEBPACK_IMPORTED_MODULE_3__fable_core_1_2_4_fable_core_Serialize__["b" /* toJson */])(record))]);
        return function (init) {
                return _fetch(url, init);
        }(Object(__WEBPACK_IMPORTED_MODULE_4__fable_core_1_2_4_fable_core_List__["a" /* append */])(defaultProps, properties));
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Globals */
/* harmony export (immutable) */ __webpack_exports__["b"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = removeCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Globals = function () {
    function Globals() {
        _classCallCheck(this, Globals);
    }

    _createClass(Globals, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Global.Globals",
                properties: {
                    cookies: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("Fable.Import.Global.CookiesStatic")
                }
            };
        }
    }]);

    return Globals;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Global.Globals", Globals);
function setCookie(key, value, expires) {
    var settings = _defineProperty({
        get expires() {
            return expires;
        }

    }, __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection, function () {
        return {
            interfaces: ["Fable.Import.Global.CookieSettings"]
        };
    });

    Cookies.set(key, value, settings);
}
function removeCookie(key) {
    var settings = _defineProperty({
        get expires() {
            return null;
        }

    }, __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection, function () {
        return {
            interfaces: ["Fable.Import.Global.CookieSettings"]
        };
    });

    Cookies.remove(key, settings);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export deflate */
/* harmony export (immutable) */ __webpack_exports__["b"] = toJson;
/* unused harmony export inflate */
/* harmony export (immutable) */ __webpack_exports__["a"] = ofJson;
/* unused harmony export toJsonWithTypeInfo */
/* unused harmony export ofJsonWithTypeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Reflection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Set__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Util__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// tslint:disable:ban-types













function deflate(v) {
    if (ArrayBuffer.isView(v)) {
        return Array.from(v);
    } else if (v != null && (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object") {
        if (v instanceof __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */] || v instanceof __WEBPACK_IMPORTED_MODULE_5__Set__["b" /* default */] || v instanceof Set) {
            return Array.from(v);
        } else if (v instanceof __WEBPACK_IMPORTED_MODULE_2__Map__["b" /* default */] || v instanceof Map) {
            var stringKeys = null;
            return Object(__WEBPACK_IMPORTED_MODULE_4__Seq__["j" /* fold */])(function (o, kv) {
                if (stringKeys === null) {
                    stringKeys = typeof kv[0] === "string";
                }
                o[stringKeys ? kv[0] : toJson(kv[0])] = kv[1];
                return o;
            }, {}, v);
        }
        var reflectionInfo = typeof v[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection] === "function" ? v[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection]() : {};
        if (reflectionInfo.properties) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__Seq__["j" /* fold */])(function (o, prop) {
                return o[prop] = v[prop], o;
            }, {}, Object.getOwnPropertyNames(reflectionInfo.properties));
        } else if (reflectionInfo.cases) {
            var caseInfo = reflectionInfo.cases[v.tag];
            var caseName = caseInfo[0];
            var fieldsLength = caseInfo.length - 1;
            if (fieldsLength === 0) {
                return caseName;
            } else {
                // Prevent undefined assignment from removing case property; see #611:
                return _defineProperty({}, caseName, v.data !== void 0 ? v.data : null);
            }
        }
    }
    return v;
}
function toJson(o) {
    return JSON.stringify(o, function (k, v) {
        return deflate(v);
    });
}
function combine(path1, path2) {
    return typeof path2 === "number" ? path1 + "[" + path2 + "]" : (path1 ? path1 + "." : "") + path2;
}
function isNullable(typ) {
    if (typeof typ === "string") {
        return typ !== "boolean" && typ !== "number";
    } else if (typ instanceof __WEBPACK_IMPORTED_MODULE_8__Util__["f" /* NonDeclaredType */]) {
        return typ.kind !== "Array" && typ.kind !== "Tuple";
    } else {
        var info = typeof typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection] === "function" ? typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection]() : null;
        return info ? info.nullable : true;
    }
}
function invalidate(val, typ, path) {
    throw new Error(Object(__WEBPACK_IMPORTED_MODULE_6__String__["a" /* fsFormat */])("%A", val) + " " + (path ? "(" + path + ")" : "") + " is not of type " + Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["a" /* getTypeFullName */])(typ));
}
function needsInflate(enclosing) {
    var typ = enclosing.head;
    if (typeof typ === "string") {
        return false;
    }
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_8__Util__["f" /* NonDeclaredType */]) {
        switch (typ.kind) {
            case "Option":
            case "Array":
                return typ.definition != null || needsInflate(new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](typ.generics[0], enclosing));
            case "Tuple":
                return typ.generics.some(function (x) {
                    return needsInflate(new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](x, enclosing));
                });
            case "Function":
                return false;
            case "GenericParam":
                return needsInflate(Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(typ.definition, enclosing.tail));
            case "GenericType":
                return true;
            default:
                return false;
        }
    }
    return true;
}
function inflateArray(arr, enclosing, path) {
    if (!Array.isArray) {
        invalidate(arr, "array", path);
    }
    // TODO: Validate non-inflated elements
    return needsInflate(enclosing) ? arr.map(function (x, i) {
        return inflate(x, enclosing, combine(path, i));
    }) : arr;
}
function inflateMap(obj, keyEnclosing, valEnclosing, path) {
    var inflateKey = keyEnclosing.head !== "string";
    var inflateVal = needsInflate(valEnclosing);
    return Object.getOwnPropertyNames(obj).map(function (k) {
        var key = inflateKey ? inflate(JSON.parse(k), keyEnclosing, combine(path, k)) : k;
        var val = inflateVal ? inflate(obj[k], valEnclosing, combine(path, k)) : obj[k];
        return [key, val];
    });
}
function inflateList(val, enclosing, path) {
    var ar = [];
    var li = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]();
    var cur = val;
    var inf = needsInflate(enclosing);
    while (cur.tail != null) {
        ar.push(inf ? inflate(cur.head, enclosing, path) : cur.head);
        cur = cur.tail;
    }
    ar.reverse();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = ar[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var a = _step.value;

            li = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](a, li);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return li;
}
function inflateUnion(val, typ, info, path, inflateField) {
    var caseName = void 0;
    // Same shape as runtime DUs, for example, if they've been serialized with `JSON.stringify`
    if (typeof val.tag === "number") {
        return Object.assign(new typ(), val);
    } else if (typeof val === "string") {
        // Cases without fields are serialized as strings by `toJson`
        caseName = val;
    } else {
        // Non-empty cases are serialized as `{ "MyCase": [1, 2] }` by `toJson`
        caseName = Object.getOwnPropertyNames(val)[0];
    }
    // Locate case index
    var tag = -1;
    for (var i = 0; info.cases[i] != null; i++) {
        if (info.cases[i][0] === caseName) {
            tag = i;
            break;
        }
    }
    // Validate
    if (tag === -1) {
        invalidate(val, typ, path);
    }
    var caseInfo = info.cases[tag];
    var inflatedData = void 0;
    if (caseInfo.length > 2) {
        inflatedData = [];
        var data = val[caseName];
        path = combine(path, caseName);
        for (var _i = 0; _i < data.length; _i++) {
            inflatedData.push(inflateField ? inflateField(data[_i], caseInfo[_i + 1], combine(path, _i)) : data[_i]);
        }
    } else if (caseInfo.length > 1) {
        inflatedData = inflateField ? inflateField(val[caseName], caseInfo[1], combine(path, caseName)) : val[caseName];
    }
    return new typ(tag, inflatedData);
}
function inflate(val, typ, path) {
    var enclosing = null;
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]) {
        enclosing = typ;
        typ = typ.head;
    } else {
        enclosing = new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](typ, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]());
    }
    if (val == null) {
        if (!isNullable(typ)) {
            invalidate(val, typ, path);
        }
        return val;
    } else if (typeof typ === "string") {
        if ((typ === "boolean" || typ === "number" || typ === "string") && (typeof val === "undefined" ? "undefined" : _typeof(val)) !== typ) {
            invalidate(val, typ, path);
        }
        return val;
    } else if (typ instanceof __WEBPACK_IMPORTED_MODULE_8__Util__["f" /* NonDeclaredType */]) {
        switch (typ.kind) {
            case "Unit":
                return null;
            case "Option":
                return inflate(val, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](typ.generics[0], enclosing), path);
            case "Array":
                if (typ.definition != null) {
                    return new typ.definition(val);
                } else {
                    return inflateArray(val, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](typ.generics[0], enclosing), path);
                }
            case "Tuple":
                return typ.generics.map(function (x, i) {
                    return inflate(val[i], new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](x, enclosing), combine(path, i));
                });
            case "Function":
                return val;
            case "GenericParam":
                return inflate(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(typ.definition, enclosing.tail), path);
            case "GenericType":
                var def = typ.definition;
                if (def === __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */]) {
                    return Array.isArray(val) ? Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])(inflateArray(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), path)) : inflateList(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), path);
                }
                // TODO: Should we try to inflate also sets and maps serialized with `JSON.stringify`?
                if (def === __WEBPACK_IMPORTED_MODULE_5__Set__["b" /* default */]) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__Set__["a" /* create */])(inflateArray(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), path));
                }
                if (def === Set) {
                    return new Set(inflateArray(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), path));
                }
                if (def === __WEBPACK_IMPORTED_MODULE_2__Map__["b" /* default */]) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__Map__["a" /* create */])(inflateMap(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(1, enclosing), path));
                }
                if (def === Map) {
                    return new Map(inflateMap(val, Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(0, enclosing), Object(__WEBPACK_IMPORTED_MODULE_3__Reflection__["b" /* resolveGeneric */])(1, enclosing), path));
                }
                return inflate(val, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](typ.definition, enclosing), path);
            default:
                // case "Interface": // case "Any":
                return val;
        }
    } else if (typeof typ === "function") {
        if (typ === Date) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__Date__["j" /* parse */])(val);
        }
        if (typeof typ.ofJSON === "function") {
            return typ.ofJSON(val);
        }
        var info = typeof typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection] === "function" ? typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection]() : {};
        // Union types
        if (info.cases) {
            return inflateUnion(val, typ, info, path, function (fi, t, p) {
                return inflate(fi, new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](t, enclosing), path);
            });
        }
        if (info.properties) {
            var newObj = new typ();
            var properties = info.properties;
            var ks = Object.getOwnPropertyNames(properties);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = ks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var k = _step2.value;

                    newObj[k] = inflate(val[k], new __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */](properties[k], enclosing), combine(path, k));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return newObj;
        }
        return val;
    }
    throw new Error("Unexpected type when deserializing JSON: " + typ);
}
function inflatePublic(val, genArgs) {
    return inflate(val, genArgs ? genArgs.T : null, "");
}

function ofJson(json, genArgs) {
    return inflate(JSON.parse(json), genArgs ? genArgs.T : null, "");
}
// TODO: Dates and types with `toJSON` are not adding the $type field
function toJsonWithTypeInfo(val) {
    return JSON.stringify(val, function (k, v) {
        if (ArrayBuffer.isView(v)) {
            return Array.from(v);
        } else if (v != null && (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object") {
            var info = typeof v[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection] === "function" ? v[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection]() : {};
            if (v instanceof __WEBPACK_IMPORTED_MODULE_1__List__["b" /* default */] || v instanceof __WEBPACK_IMPORTED_MODULE_5__Set__["b" /* default */] || v instanceof Set) {
                return {
                    $type: info.type || "System.Collections.Generic.HashSet",
                    $values: Array.from(v)
                };
            } else if (v instanceof __WEBPACK_IMPORTED_MODULE_2__Map__["b" /* default */] || v instanceof Map) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__Seq__["j" /* fold */])(function (o, kv) {
                    o[kv[0]] = kv[1];return o;
                }, { $type: info.type || "System.Collections.Generic.Dictionary" }, v);
            } else if (info.properties) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__Seq__["j" /* fold */])(function (o, prop) {
                    return o[prop] = v[prop], o;
                }, { $type: info.type }, Object.getOwnPropertyNames(info.properties));
            } else if (info.cases) {
                var _ref2;

                var uci = info.cases[v.tag];
                return _ref2 = {}, _defineProperty(_ref2, uci[0], v.data !== void 0 ? v.data : null), _defineProperty(_ref2, "$type", info.type), _ref2;
            }
        }
        return v;
    });
}
function ofJsonWithTypeInfo(json, genArgs) {
    var parsed = JSON.parse(json, function (key, v) {
        if (v == null) {
            return v;
        } else if ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && typeof v.$type === "string") {
            // Remove generic args and assembly info added by Newtonsoft.Json
            var type = v.$type.replace("+", ".");
            var i = type.indexOf("`");
            delete v.$type;
            if (i > -1) {
                type = type.substr(0, i);
            } else {
                i = type.indexOf(",");
                type = i > -1 ? type.substr(0, i) : type;
            }
            if (type === "System.Collections.Generic.List" || type.indexOf("[]") === type.length - 2) {
                return v.$values;
            }
            if (type === "Microsoft.FSharp.Collections.FSharpList") {
                return Object(__WEBPACK_IMPORTED_MODULE_1__List__["e" /* ofArray */])(v.$values);
            } else if (type === "Microsoft.FSharp.Collections.FSharpSet") {
                return Object(__WEBPACK_IMPORTED_MODULE_5__Set__["a" /* create */])(v.$values);
            } else if (type === "System.Collections.Generic.HashSet") {
                return new Set(v.$values);
            } else if (type === "Microsoft.FSharp.Collections.FSharpMap") {
                return Object(__WEBPACK_IMPORTED_MODULE_2__Map__["a" /* create */])(Object.getOwnPropertyNames(v).map(function (k) {
                    return [k, v[k]];
                }));
            } else if (type === "System.Collections.Generic.Dictionary") {
                return new Map(Object.getOwnPropertyNames(v).map(function (k) {
                    return [k, v[k]];
                }));
            } else {
                var typ = Object(__WEBPACK_IMPORTED_MODULE_7__Symbol__["b" /* getType */])(type);
                if (typ) {
                    if (typeof typ.ofJSON === "function") {
                        return typ.ofJSON(v);
                    }
                    var info = typeof typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection] === "function" ? typ.prototype[__WEBPACK_IMPORTED_MODULE_7__Symbol__["a" /* default */].reflection]() : {};
                    if (info.cases) {
                        return inflateUnion(v, typ, info, key);
                    }
                    return Object.assign(new typ(), v);
                }
            }
        } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:[+-]\d{2}:\d{2}|Z)$/.test(v)) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__Date__["j" /* parse */])(v);
        } else {
            return v;
        }
    });
    var expected = genArgs ? genArgs.T : null;
    if (parsed != null && typeof expected === "function" && !(parsed instanceof Object(__WEBPACK_IMPORTED_MODULE_8__Util__["t" /* getDefinition */])(expected))) {
        throw new Error("JSON is not of type " + expected.name + ": " + json);
    }
    return parsed;
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Long */
/* unused harmony export isLong */
/* unused harmony export fromInt */
/* harmony export (immutable) */ __webpack_exports__["a"] = fromNumber;
/* unused harmony export fromBits */
/* unused harmony export fromString */
/* unused harmony export fromValue */
/* unused harmony export ZERO */
/* unused harmony export UZERO */
/* unused harmony export ONE */
/* unused harmony export UONE */
/* unused harmony export NEG_ONE */
/* unused harmony export MAX_VALUE */
/* unused harmony export MAX_UNSIGNED_VALUE */
/* unused harmony export MIN_VALUE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Int32__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Symbol__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Source: https://github.com/dcodeIO/long.js/blob/master/LICENSE
// tslint:disable:curly
// tslint:disable:member-access
// tslint:disable:member-ordering


// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * @class A Long class for representing a 64 bit two's-complement integer value.
 */
var Long = function () {
    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     * @param {number} low The low (signed) 32 bits of the long
     * @param {number} high The high (signed) 32 bits of the long
     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
     */
    function Long(low, high, unsigned) {
        _classCallCheck(this, Long);

        /**
         * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.eq = this.equals;
        /**
         * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.neq = this.notEquals;
        /**
         * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.lt = this.lessThan;
        /**
         * Tests if this Long's value is less than or equal the specified's.
         * This is an alias of {@link Long#lessThanOrEqual}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.lte = this.lessThanOrEqual;
        /**
         * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.gt = this.greaterThan;
        /**
         * Tests if this Long's value is greater than or equal the specified's.
         * This is an alias of {@link Long#greaterThanOrEqual}.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        this.gte = this.greaterThanOrEqual;
        /**
         * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
         * @param {!Long|number|string} other Other value
         * @returns {number} 0 if they are the same, 1 if the this is greater and -1
         *  if the given one is greater
         */
        this.comp = this.compare;
        /**
         * Negates this Long's value. This is an alias of {@link Long#negate}.
         * @returns {!Long} Negated Long
         */
        this.neg = this.negate;
        /**
         * Returns this Long's absolute value. This is an alias of {@link Long#absolute}.
         * @returns {!Long} Absolute Long
         */
        this.abs = this.absolute;
        /**
         * Returns the difference of this and the specified  This is an alias of {@link Long#subtract}.
         * @param {!Long|number|string} subtrahend Subtrahend
         * @returns {!Long} Difference
         */
        this.sub = this.subtract;
        /**
         * Returns the product of this and the specified  This is an alias of {@link Long#multiply}.
         * @param {!Long|number|string} multiplier Multiplier
         * @returns {!Long} Product
         */
        this.mul = this.multiply;
        /**
         * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Quotient
         */
        this.div = this.divide;
        /**
         * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Remainder
         */
        this.mod = this.modulo;
        /**
         * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        this.shl = this.shiftLeft;
        /**
         * Returns this Long with bits arithmetically shifted to the right by the given amount.
         * This is an alias of {@link Long#shiftRight}.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        this.shr = this.shiftRight;
        /**
         * Returns this Long with bits logically shifted to the right by the given amount.
         * This is an alias of {@link Long#shiftRightUnsigned}.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        this.shru = this.shiftRightUnsigned;
        // Aliases for compatibility with Fable
        this.Equals = this.equals;
        this.CompareTo = this.compare;
        this.ToString = this.toString;
        this.low = low | 0;
        this.high = high | 0;
        this.unsigned = !!unsigned;
    }
    /**
     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
     * @returns {number}
     */


    _createClass(Long, [{
        key: "toInt",
        value: function toInt() {
            return this.unsigned ? this.low >>> 0 : this.low;
        }
        /**
         * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
         * @returns {number}
         */

    }, {
        key: "toNumber",
        value: function toNumber() {
            if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
            return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
        }
        /**
         * Converts the Long to a string written in the specified radix.
         * @param {number=} radix Radix (2-36), defaults to 10
         * @returns {string}
         * @override
         * @throws {RangeError} If `radix` is out of range
         */

    }, {
        key: "toString",
        value: function toString() {
            var radix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

            radix = radix || 10;
            if (radix < 2 || 36 < radix) throw RangeError("radix");
            if (this.isZero()) return "0";
            if (this.isNegative()) {
                if (this.eq(MIN_VALUE)) {
                    // We need to change the Long value before it can be negated, so we remove
                    // the bottom-most digit in this base and then recurse to do the rest.
                    var radixLong = fromNumber(radix);
                    var div = this.div(radixLong);
                    var rem1 = div.mul(radixLong).sub(this);
                    return div.toString(radix) + rem1.toInt().toString(radix);
                } else return "-" + this.neg().toString(radix);
            }
            // Do several (6) digits each time through the loop, so as to
            // minimize the calls to the very expensive emulated div.
            var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned);
            var rem = this;
            var result = "";
            while (true) {
                var remDiv = rem.div(radixToPower);
                var intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0;
                var digits = intval.toString(radix);
                rem = remDiv;
                if (rem.isZero()) return digits + result;else {
                    while (digits.length < 6) {
                        digits = "0" + digits;
                    }result = "" + digits + result;
                }
            }
        }
        /**
         * Gets the high 32 bits as a signed integer.
         * @returns {number} Signed high bits
         */

    }, {
        key: "getHighBits",
        value: function getHighBits() {
            return this.high;
        }
        /**
         * Gets the high 32 bits as an unsigned integer.
         * @returns {number} Unsigned high bits
         */

    }, {
        key: "getHighBitsUnsigned",
        value: function getHighBitsUnsigned() {
            return this.high >>> 0;
        }
        /**
         * Gets the low 32 bits as a signed integer.
         * @returns {number} Signed low bits
         */

    }, {
        key: "getLowBits",
        value: function getLowBits() {
            return this.low;
        }
        /**
         * Gets the low 32 bits as an unsigned integer.
         * @returns {number} Unsigned low bits
         */

    }, {
        key: "getLowBitsUnsigned",
        value: function getLowBitsUnsigned() {
            return this.low >>> 0;
        }
        /**
         * Gets the number of bits needed to represent the absolute value of this
         * @returns {number}
         */

    }, {
        key: "getNumBitsAbs",
        value: function getNumBitsAbs() {
            if (this.isNegative()) return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
            var val = this.high !== 0 ? this.high : this.low;
            var bit = void 0;
            for (bit = 31; bit > 0; bit--) {
                if ((val & 1 << bit) !== 0) break;
            }return this.high !== 0 ? bit + 33 : bit + 1;
        }
        /**
         * Tests if this Long's value equals zero.
         * @returns {boolean}
         */

    }, {
        key: "isZero",
        value: function isZero() {
            return this.high === 0 && this.low === 0;
        }
        /**
         * Tests if this Long's value is negative.
         * @returns {boolean}
         */

    }, {
        key: "isNegative",
        value: function isNegative() {
            return !this.unsigned && this.high < 0;
        }
        /**
         * Tests if this Long's value is positive.
         * @returns {boolean}
         */

    }, {
        key: "isPositive",
        value: function isPositive() {
            return this.unsigned || this.high >= 0;
        }
        /**
         * Tests if this Long's value is odd.
         * @returns {boolean}
         */

    }, {
        key: "isOdd",
        value: function isOdd() {
            return (this.low & 1) === 1;
        }
        /**
         * Tests if this Long's value is even.
         * @returns {boolean}
         */

    }, {
        key: "isEven",
        value: function isEven() {
            return (this.low & 1) === 0;
        }
        /**
         * Tests if this Long's value equals the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "equals",
        value: function equals(other) {
            if (!isLong(other)) other = fromValue(other);
            if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
            return this.high === other.high && this.low === other.low;
        }
        /**
         * Tests if this Long's value differs from the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "notEquals",
        value: function notEquals(other) {
            return !this.eq( /* validates */other);
        }
        /**
         * Tests if this Long's value is less than the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "lessThan",
        value: function lessThan(other) {
            return this.comp( /* validates */other) < 0;
        }
        /**
         * Tests if this Long's value is less than or equal the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "lessThanOrEqual",
        value: function lessThanOrEqual(other) {
            return this.comp( /* validates */other) <= 0;
        }
        /**
         * Tests if this Long's value is greater than the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "greaterThan",
        value: function greaterThan(other) {
            return this.comp( /* validates */other) > 0;
        }
        /**
         * Tests if this Long's value is greater than or equal the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */

    }, {
        key: "greaterThanOrEqual",
        value: function greaterThanOrEqual(other) {
            return this.comp( /* validates */other) >= 0;
        }
        /**
         * Compares this Long's value with the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {number} 0 if they are the same, 1 if the this is greater and -1
         *  if the given one is greater
         */

    }, {
        key: "compare",
        value: function compare(other) {
            if (!isLong(other)) other = fromValue(other);
            if (this.eq(other)) return 0;
            var thisNeg = this.isNegative();
            var otherNeg = other.isNegative();
            if (thisNeg && !otherNeg) return -1;
            if (!thisNeg && otherNeg) return 1;
            // At this point the sign bits are the same
            if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
            // Both are positive if at least one is unsigned
            return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
        }
        /**
         * Negates this Long's value.
         * @returns {!Long} Negated Long
         */

    }, {
        key: "negate",
        value: function negate() {
            if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
            return this.not().add(ONE);
        }
        /**
         * Returns this Long's absolute value.
         * @returns {!Long} Absolute Long
         */

    }, {
        key: "absolute",
        value: function absolute() {
            if (!this.unsigned && this.isNegative()) return this.negate();else return this;
        }
        /**
         * Returns the sum of this and the specified
         * @param {!Long|number|string} addend Addend
         * @returns {!Long} Sum
         */

    }, {
        key: "add",
        value: function add(addend) {
            if (!isLong(addend)) addend = fromValue(addend);
            // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
            var a48 = this.high >>> 16;
            var a32 = this.high & 0xFFFF;
            var a16 = this.low >>> 16;
            var a00 = this.low & 0xFFFF;
            var b48 = addend.high >>> 16;
            var b32 = addend.high & 0xFFFF;
            var b16 = addend.low >>> 16;
            var b00 = addend.low & 0xFFFF;
            var c48 = 0;
            var c32 = 0;
            var c16 = 0;
            var c00 = 0;
            c00 += a00 + b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 + b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 + b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 + b48;
            c48 &= 0xFFFF;
            return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
        }
        /**
         * Returns the difference of this and the specified
         * @param {!Long|number|string} subtrahend Subtrahend
         * @returns {!Long} Difference
         */

    }, {
        key: "subtract",
        value: function subtract(subtrahend) {
            if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
            return this.add(subtrahend.neg());
        }
        /**
         * Returns the product of this and the specified
         * @param {!Long|number|string} multiplier Multiplier
         * @returns {!Long} Product
         */

    }, {
        key: "multiply",
        value: function multiply(multiplier) {
            if (this.isZero()) return ZERO;
            if (!isLong(multiplier)) multiplier = fromValue(multiplier);
            if (multiplier.isZero()) return ZERO;
            if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
            if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
            if (this.isNegative()) {
                if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());else return this.neg().mul(multiplier).neg();
            } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
            // If both longs are small, use float multiplication
            if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
            // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
            // We can skip products that would overflow.
            var a48 = this.high >>> 16;
            var a32 = this.high & 0xFFFF;
            var a16 = this.low >>> 16;
            var a00 = this.low & 0xFFFF;
            var b48 = multiplier.high >>> 16;
            var b32 = multiplier.high & 0xFFFF;
            var b16 = multiplier.low >>> 16;
            var b00 = multiplier.low & 0xFFFF;
            var c48 = 0;
            var c32 = 0;
            var c16 = 0;
            var c00 = 0;
            c00 += a00 * b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 * b00;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c16 += a00 * b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 * b00;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a16 * b16;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a00 * b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
            c48 &= 0xFFFF;
            return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
        }
        /**
         * Returns this Long divided by the specified. The result is signed if this Long is signed or
         *  unsigned if this Long is unsigned.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Quotient
         */

    }, {
        key: "divide",
        value: function divide(divisor) {
            if (!isLong(divisor)) divisor = fromValue(divisor);
            if (divisor.isZero()) throw Error("division by zero");
            if (this.isZero()) return this.unsigned ? UZERO : ZERO;
            var rem = ZERO;
            var res = ZERO;
            if (!this.unsigned) {
                // This section is only relevant for signed longs and is derived from the
                // closure library as a whole.
                if (this.eq(MIN_VALUE)) {
                    if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                    else if (divisor.eq(MIN_VALUE)) return ONE;else {
                            // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                            var halfThis = this.shr(1);
                            var approx = halfThis.div(divisor).shl(1);
                            if (approx.eq(ZERO)) {
                                return divisor.isNegative() ? ONE : NEG_ONE;
                            } else {
                                rem = this.sub(divisor.mul(approx));
                                res = approx.add(rem.div(divisor));
                                return res;
                            }
                        }
                } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
                if (this.isNegative()) {
                    if (divisor.isNegative()) return this.neg().div(divisor.neg());
                    return this.neg().div(divisor).neg();
                } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
                res = ZERO;
            } else {
                // The algorithm below has not been made for unsigned longs. It's therefore
                // required to take special care of the MSB prior to running it.
                if (!divisor.unsigned) divisor = divisor.toUnsigned();
                if (divisor.gt(this)) return UZERO;
                if (divisor.gt(this.shru(1))) return UONE;
                res = UZERO;
            }
            // Repeat the following until the remainder is less than other:  find a
            // floating-point that approximates remainder / other *from below*, add this
            // into the result, and subtract it from the remainder.  It is critical that
            // the approximate value is less than or equal to the real value so that the
            // remainder never becomes negative.
            rem = this;
            while (rem.gte(divisor)) {
                // Approximate the result of division. This may be a little greater or
                // smaller than the actual value.
                var _approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
                // We will tweak the approximate result by changing it in the 48-th digit or
                // the smallest non-fractional digit, whichever is larger.
                // tslint:disable-next-line:prefer-const
                // tslint:disable-next-line:semicolon
                var log2 = Math.ceil(Math.log(_approx) / Math.LN2);
                var delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48);
                // Decrease the approximation until it is smaller than the remainder.  Note
                // that if it is too large, the product overflows and is negative.
                var approxRes = fromNumber(_approx);
                var approxRem = approxRes.mul(divisor);
                while (approxRem.isNegative() || approxRem.gt(rem)) {
                    _approx -= delta;
                    approxRes = fromNumber(_approx, this.unsigned);
                    approxRem = approxRes.mul(divisor);
                }
                // We know the answer can't be zero... and actually, zero would cause
                // infinite recursion since we would make no progress.
                if (approxRes.isZero()) approxRes = ONE;
                res = res.add(approxRes);
                rem = rem.sub(approxRem);
            }
            return res;
        }
        /**
         * Returns this Long modulo the specified.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Remainder
         */

    }, {
        key: "modulo",
        value: function modulo(divisor) {
            if (!isLong(divisor)) divisor = fromValue(divisor);
            return this.sub(this.div(divisor).mul(divisor));
        }
        /**
         * Returns the bitwise NOT of this
         * @returns {!Long}
         */

    }, {
        key: "not",
        value: function not() {
            return fromBits(~this.low, ~this.high, this.unsigned);
        }
        /**
         * Returns the bitwise AND of this Long and the specified.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */

    }, {
        key: "and",
        value: function and(other) {
            if (!isLong(other)) other = fromValue(other);
            return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
        }
        /**
         * Returns the bitwise OR of this Long and the specified.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */

    }, {
        key: "or",
        value: function or(other) {
            if (!isLong(other)) other = fromValue(other);
            return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
        }
        /**
         * Returns the bitwise XOR of this Long and the given one.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */

    }, {
        key: "xor",
        value: function xor(other) {
            if (!isLong(other)) other = fromValue(other);
            return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
        }
        /**
         * Returns this Long with bits shifted to the left by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */

    }, {
        key: "shiftLeft",
        value: function shiftLeft(numBits) {
            if (isLong(numBits)) numBits = numBits.toInt();
            numBits = numBits & 63;
            if (numBits === 0) return this;else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);else return fromBits(0, this.low << numBits - 32, this.unsigned);
        }
        /**
         * Returns this Long with bits arithmetically shifted to the right by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */

    }, {
        key: "shiftRight",
        value: function shiftRight(numBits) {
            if (isLong(numBits)) numBits = numBits.toInt();
            numBits = numBits & 63;
            if (numBits === 0) return this;else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
        }
        /**
         * Returns this Long with bits logically shifted to the right by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */

    }, {
        key: "shiftRightUnsigned",
        value: function shiftRightUnsigned(numBits) {
            if (isLong(numBits)) numBits = numBits.toInt();
            numBits = numBits & 63;
            if (numBits === 0) return this;else {
                var high = this.high;
                if (numBits < 32) {
                    var low = this.low;
                    return fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
                } else if (numBits === 32) return fromBits(high, 0, this.unsigned);else return fromBits(high >>> numBits - 32, 0, this.unsigned);
            }
        }
        /**
         * Converts this Long to signed.
         * @returns {!Long} Signed long
         */

    }, {
        key: "toSigned",
        value: function toSigned() {
            if (!this.unsigned) return this;
            return fromBits(this.low, this.high, false);
        }
        /**
         * Converts this Long to unsigned.
         * @returns {!Long} Unsigned long
         */

    }, {
        key: "toUnsigned",
        value: function toUnsigned() {
            if (this.unsigned) return this;
            return fromBits(this.low, this.high, true);
        }
        /**
         * Converts this Long to its byte representation.
         * @param {boolean=} le Whether little or big endian, defaults to big endian
         * @returns {!Array.<number>} Byte representation
         */

    }, {
        key: "toBytes",
        value: function toBytes(le) {
            return le ? this.toBytesLE() : this.toBytesBE();
        }
        /**
         * Converts this Long to its little endian byte representation.
         * @returns {!Array.<number>} Little endian byte representation
         */

    }, {
        key: "toBytesLE",
        value: function toBytesLE() {
            var hi = this.high;
            var lo = this.low;
            return [lo & 0xff, lo >>> 8 & 0xff, lo >>> 16 & 0xff, lo >>> 24 & 0xff, hi & 0xff, hi >>> 8 & 0xff, hi >>> 16 & 0xff, hi >>> 24 & 0xff];
        }
        /**
         * Converts this Long to its big endian byte representation.
         * @returns {!Array.<number>} Big endian byte representation
         */

    }, {
        key: "toBytesBE",
        value: function toBytesBE() {
            var hi = this.high;
            var lo = this.low;
            return [hi >>> 24 & 0xff, hi >>> 16 & 0xff, hi >>> 8 & 0xff, hi & 0xff, lo >>> 24 & 0xff, lo >>> 16 & 0xff, lo >>> 8 & 0xff, lo & 0xff];
        }
    }, {
        key: "toJSON",
        value: function toJSON() {
            return (!this.unsigned && !this.lessThan(0) ? "+" : "") + this.toString();
        }
    }, {
        key: __WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: this.unsigned ? "System.UInt64" : "System.Int64",
                interfaces: ["FSharpRecord", "System.IComparable"],
                properties: {
                    low: "number",
                    high: "number",
                    unsigned: "boolean"
                }
            };
        }
    }], [{
        key: "ofJSON",
        value: function ofJSON(str) {
            return fromString(str, !/^[+-]/.test(str));
        }
    }]);

    return Long;
}();
// A cache of the Long representations of small integer values.
var INT_CACHE = {};
// A cache of the Long representations of small unsigned integer values.
var UINT_CACHE = {};
/**
 * Tests if the specified object is a
 * @param {*} obj Object
 * @returns {boolean}
 */
function isLong(obj) {
    return obj && obj instanceof Long;
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
 * @returns {!Long} The corresponding Long value
 */
function fromInt(value) {
    var unsigned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var obj = void 0;
    var cachedObj = void 0;
    var cache = false;
    if (unsigned) {
        value >>>= 0;
        if (0 <= value && value < 256) {
            cache = true;
            cachedObj = UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (-128 <= value && value < 128) {
            cache = true;
            cachedObj = INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
 * @returns {!Long} The corresponding Long value
 */
function fromNumber(value) {
    var unsigned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (isNaN(value) || !isFinite(value)) {
        // TODO FormatException ?
        throw new Error("Input string was not in a correct format.");
    }
    if (unsigned) {
        if (value < 0) return UZERO;
        if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
        if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
    }
    if (value < 0) return fromNumber(-value, unsigned).neg();
    return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
 * @returns {!Long} The corresponding Long value
 */
function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
}
/**
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 */
var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to `false` for signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */
function fromString(str) {
    var unsigned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var radix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

    if (Object(__WEBPACK_IMPORTED_MODULE_0__Int32__["a" /* isValid */])(str, radix) === null) {
        // TODO FormatException ?
        throw new Error("Input string was not in a correct format.");
    }
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return ZERO;
    if (typeof unsigned === "number") {
        // For goog.math.long compatibility
        radix = unsigned, unsigned = false;
    } else {
        unsigned = !!unsigned;
    }
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p = str.indexOf("-");
    if (p > 0) throw Error("interior hyphen");else if (p === 0) {
        return fromString(str.substring(1), unsigned, radix).neg();
    }
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 8));
    var result = ZERO;
    for (var i = 0; i < str.length; i += 8) {
        var size = Math.min(8, str.length - i);
        var value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = fromNumber(pow_dbl(radix, size));
            result = result.mul(power).add(fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add(fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Converts the specified value to a
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @returns {!Long}
 */
function fromValue(val) {
    if (val /* is compatible */ instanceof Long) return val;
    if (typeof val === "number") return fromNumber(val);
    if (typeof val === "string") return fromString(val);
    // Throws for non-objects, converts non-instanceof Long:
    return fromBits(val.low, val.high, val.unsigned);
}
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
var TWO_PWR_16_DBL = 1 << 16;
var TWO_PWR_24_DBL = 1 << 24;
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
/**
 * Signed zero.
 * @type {!Long}
 */
var ZERO = fromInt(0);
/**
 * Unsigned zero.
 * @type {!Long}
 */
var UZERO = fromInt(0, true);
/**
 * Signed one.
 * @type {!Long}
 */
var ONE = fromInt(1);
/**
 * Unsigned one.
 * @type {!Long}
 */
var UONE = fromInt(1, true);
/**
 * Signed negative one.
 * @type {!Long}
 */
var NEG_ONE = fromInt(-1);
/**
 * Maximum signed value.
 * @type {!Long}
 */
var MAX_VALUE = fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0, false);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */
var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF | 0, 0xFFFFFFFF | 0, true);
/**
 * Minimum signed value.
 * @type {!Long}
 */
var MIN_VALUE = fromBits(0, 0x80000000 | 0, false);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* unused harmony export fromTicks */
/* unused harmony export fromDays */
/* unused harmony export fromHours */
/* unused harmony export fromMinutes */
/* unused harmony export fromSeconds */
/* unused harmony export days */
/* unused harmony export hours */
/* unused harmony export minutes */
/* unused harmony export seconds */
/* unused harmony export milliseconds */
/* unused harmony export ticks */
/* harmony export (immutable) */ __webpack_exports__["b"] = totalDays;
/* unused harmony export totalHours */
/* unused harmony export totalMinutes */
/* unused harmony export totalSeconds */
/* unused harmony export negate */
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export compare */
/* unused harmony export compareTo */
/* unused harmony export duration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Long__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(0);


function create() {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var m = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var ms = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    switch (arguments.length) {
        case 1:
            // ticks
            return fromTicks(arguments[0]);
        case 3:
            // h,m,s
            d = 0, h = arguments[0], m = arguments[1], s = arguments[2], ms = 0;
            break;
        default:
            // d,h,m,s,ms
            break;
    }
    return d * 86400000 + h * 3600000 + m * 60000 + s * 1000 + ms;
}
function fromTicks(ticks) {
    return ticks.div(10000).toNumber();
}
function fromDays(d) {
    return create(d, 0, 0, 0);
}
function fromHours(h) {
    return create(h, 0, 0);
}
function fromMinutes(m) {
    return create(0, m, 0);
}
function fromSeconds(s) {
    return create(0, 0, s);
}
function days(ts) {
    return Math.floor(ts / 86400000);
}
function hours(ts) {
    return Math.floor(ts % 86400000 / 3600000);
}
function minutes(ts) {
    return Math.floor(ts % 3600000 / 60000);
}
function seconds(ts) {
    return Math.floor(ts % 60000 / 1000);
}
function milliseconds(ts) {
    return Math.floor(ts % 1000);
}
function ticks(ts) {
    return __WEBPACK_IMPORTED_MODULE_0__Long__["a" /* fromNumber */](ts).mul(10000);
}
function totalDays(ts) {
    return ts / 86400000;
}
function totalHours(ts) {
    return ts / 3600000;
}
function totalMinutes(ts) {
    return ts / 60000;
}
function totalSeconds(ts) {
    return ts / 1000;
}
function negate(ts) {
    return ts * -1;
}
function add(ts1, ts2) {
    return ts1 + ts2;
}
function subtract(ts1, ts2) {
    return ts1 - ts2;
}
function compare(x, y) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["j" /* compare */])(x, y);
}
function compareTo(x, y) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["j" /* compare */])(x, y);
}
function duration(x) {
    return Math.abs(x);
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(49);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(43);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ChartTicks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChartAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ChartScales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LegendPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ChartLegend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ChartOptions; });
/* unused harmony export GenericDataset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CubicInterpolationMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LineDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PieDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ChartDataWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ChartInfo; });
/* unused harmony export rgba */
/* unused harmony export colorArray */
/* unused harmony export RenderedChart */
/* harmony export (immutable) */ __webpack_exports__["n"] = renderChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Colors_fs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var ChartTicks = function () {
    function ChartTicks(beginAtZero) {
        _classCallCheck(this, ChartTicks);

        this.BeginAtZero = beginAtZero;
    }

    _createClass(ChartTicks, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartTicks",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    BeginAtZero: "boolean"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartTicks;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartTicks", ChartTicks);
var ChartAxis = function () {
    function ChartAxis(ticks) {
        _classCallCheck(this, ChartAxis);

        this.Ticks = ticks;
    }

    _createClass(ChartAxis, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartAxis",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Ticks: ChartTicks
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartAxis;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartAxis", ChartAxis);
var ChartScales = function () {
    function ChartScales(yAxes, xAxes) {
        _classCallCheck(this, ChartScales);

        this.YAxes = yAxes;
        this.XAxes = xAxes;
    }

    _createClass(ChartScales, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartScales",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    YAxes: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(ChartAxis),
                    XAxes: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(ChartAxis)
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartScales;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartScales", ChartScales);
var LegendPosition = function () {
    function LegendPosition(tag, data) {
        _classCallCheck(this, LegendPosition);

        this.tag = tag;
        this.data = data;
    }

    _createClass(LegendPosition, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.LegendPosition",
                interfaces: ["FSharpUnion", "System.IEquatable", "System.IComparable"],
                cases: [["Top"], ["Left"], ["Bottom"], ["Right"]]
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["m" /* compareUnions */])(this, other) | 0;
        }
    }]);

    return LegendPosition;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.LegendPosition", LegendPosition);
var ChartLegend = function () {
    function ChartLegend(position, fullWidth) {
        _classCallCheck(this, ChartLegend);

        this.Position = position;
        this.FullWidth = fullWidth;
    }

    _createClass(ChartLegend, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartLegend",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Position: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(LegendPosition),
                    FullWidth: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("boolean")
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartLegend;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartLegend", ChartLegend);
var ChartOptions = function () {
    function ChartOptions(scales, title, legend) {
        _classCallCheck(this, ChartOptions);

        this.Scales = scales;
        this.Title = title;
        this.Legend = legend;
    }

    _createClass(ChartOptions, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartOptions",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Scales: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(ChartScales),
                    Title: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string"),
                    Legend: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(ChartLegend)
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartOptions;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartOptions", ChartOptions);
var GenericDataset = function () {
    function GenericDataset(label, data) {
        _classCallCheck(this, GenericDataset);

        this.Label = label;
        this.Data = data;
    }

    _createClass(GenericDataset, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.GenericDataset",
                interfaces: ["FSharpRecord", "System.IEquatable"],
                properties: {
                    Label: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string"),
                    Data: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("System.Collections.Generic.IEnumerable")
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }]);

    return GenericDataset;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.GenericDataset", GenericDataset);
var CubicInterpolationMode = function () {
    function CubicInterpolationMode(tag, data) {
        _classCallCheck(this, CubicInterpolationMode);

        this.tag = tag;
        this.data = data;
    }

    _createClass(CubicInterpolationMode, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.CubicInterpolationMode",
                interfaces: ["FSharpUnion", "System.IEquatable", "System.IComparable"],
                cases: [["Default"], ["Monotone"]]
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["m" /* compareUnions */])(this, other) | 0;
        }
    }]);

    return CubicInterpolationMode;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.CubicInterpolationMode", CubicInterpolationMode);
var LineDataset = function () {
    function LineDataset(label, data, fill, interpolationMode) {
        _classCallCheck(this, LineDataset);

        this.Label = label;
        this.Data = data;
        this.Fill = fill;
        this.InterpolationMode = interpolationMode;
    }

    _createClass(LineDataset, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.LineDataset",
                interfaces: ["FSharpRecord", "System.IEquatable"],
                properties: {
                    Label: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string"),
                    Data: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("System.Collections.Generic.IEnumerable"),
                    Fill: "boolean",
                    InterpolationMode: CubicInterpolationMode
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }]);

    return LineDataset;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.LineDataset", LineDataset);
var BarDataset = function () {
    function BarDataset(label, data, backgroundColor, borderColor, borderWidth) {
        _classCallCheck(this, BarDataset);

        this.Label = label;
        this.Data = data;
        this.BackgroundColor = backgroundColor;
        this.BorderColor = borderColor;
        this.BorderWidth = borderWidth;
    }

    _createClass(BarDataset, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.BarDataset",
                interfaces: ["FSharpRecord", "System.IEquatable"],
                properties: {
                    Label: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string"),
                    Data: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("System.Collections.Generic.IEnumerable"),
                    BackgroundColor: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Colors_fs__["a" /* Color */])),
                    BorderColor: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Colors_fs__["a" /* Color */])),
                    BorderWidth: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("number")
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }]);

    return BarDataset;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.BarDataset", BarDataset);
var PieDataset = function () {
    function PieDataset(label, data, backgroundColor, borderColor, borderWidth) {
        _classCallCheck(this, PieDataset);

        this.Label = label;
        this.Data = data;
        this.BackgroundColor = backgroundColor;
        this.BorderColor = borderColor;
        this.BorderWidth = borderWidth;
    }

    _createClass(PieDataset, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.PieDataset",
                interfaces: ["FSharpRecord", "System.IEquatable"],
                properties: {
                    Label: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("string"),
                    Data: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("System.Collections.Generic.IEnumerable"),
                    BackgroundColor: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Colors_fs__["a" /* Color */])),
                    BorderColor: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_2__Colors_fs__["a" /* Color */])),
                    BorderWidth: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])("number")
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }]);

    return PieDataset;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.PieDataset", PieDataset);
var ChartDataWrapper = function () {
    function ChartDataWrapper(labels, datasets) {
        _classCallCheck(this, ChartDataWrapper);

        this.Labels = labels;
        this.Datasets = datasets;
    }

    _createClass(ChartDataWrapper, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartDataWrapper",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Labels: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])("string"),
                    Datasets: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["d" /* GenericParam */])("a"))
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return ChartDataWrapper;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartDataWrapper", ChartDataWrapper);
var ChartData = function () {
    function ChartData(tag, data) {
        _classCallCheck(this, ChartData);

        this.tag = tag;
        this.data = data;
    }

    _createClass(ChartData, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartData",
                interfaces: ["FSharpUnion", "System.IEquatable"],
                cases: [["Bar", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: BarDataset
                })], ["HorizontalBar", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: BarDataset
                })], ["Line", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: LineDataset
                })], ["Radar", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: GenericDataset
                })], ["PolarArea", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: GenericDataset
                })], ["Pie", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: PieDataset
                })], ["Doughnut", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: GenericDataset
                })], ["Bubble", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(ChartDataWrapper, {
                    a: GenericDataset
                })]]
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
        }
    }]);

    return ChartData;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartData", ChartData);
var ChartInfo = function () {
    function ChartInfo(options, data, canvasId) {
        _classCallCheck(this, ChartInfo);

        this.Options = options;
        this.Data = data;
        this.CanvasId = canvasId;
    }

    _createClass(ChartInfo, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.ChartInfo",
                interfaces: ["FSharpRecord", "System.IEquatable"],
                properties: {
                    Options: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(ChartOptions),
                    Data: ChartData,
                    CanvasId: "string"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }]);

    return ChartInfo;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.ChartInfo", ChartInfo);

function append(fields, key, o, map) {
    if (o == null) {
        return fields;
    } else {
        return new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]([key, map(o)], fields);
    }
}

function createGenericDataset(dataset) {
    return {
        label: dataset.Label,
        data: Array.from(dataset.Data)
    };
}

function cubicinterpolationMode(_arg1) {
    if (_arg1.tag === 1) {
        return "monotone";
    } else {
        return "default";
    }
}

function createLineDataset(dataset) {
    return {
        label: dataset.Label,
        data: Array.from(dataset.Data),
        fill: dataset.Fill,
        cubicInterpolationMode: cubicinterpolationMode(dataset.InterpolationMode)
    };
}

function rgba(color) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("rgba(%i,%i,%i,%f)", 4))(~~color.R, ~~color.G, ~~color.B, color.A);
}
var colorArray = Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var1) {
    return function (source_1) {
        return Array.from(source_1);
    }(function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (color) {
            return rgba(color);
        }, source);
    }($var1));
});

function createBarDataset(dataset) {
    var fields = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([["label", dataset.Label], ["data", Array.from(dataset.Data)]]);
    var fields_1 = append(fields, "backgroundColor", dataset.BackgroundColor, colorArray);
    var fields_2 = append(fields_1, "borderColor", dataset.BorderColor, colorArray);
    var fields_3 = append(fields_2, "borderWidth", dataset.BorderWidth, function (x) {
        return x;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(fields_3, 0);
}

function createPieDataset(dataset) {
    var fields = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([["label", dataset.Label], ["data", Array.from(dataset.Data)]]);
    var fields_1 = append(fields, "backgroundColor", dataset.BackgroundColor, colorArray);
    var fields_2 = append(fields_1, "borderColor", dataset.BorderColor, colorArray);
    var fields_3 = append(fields_2, "borderWidth", dataset.BorderWidth, function (x) {
        return x;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(fields_3, 0);
}

function chartDataFields(data, createDataset) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([["labels", data.Labels], ["datasets", Array.from(function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(createDataset, source);
    }(data.Datasets))]]);
}

function createData(data) {
    var dataObjectFields = void 0;
    var $var2 = data.tag === 0 ? [1, data.data] : data.tag === 1 ? [1, data.data] : data.tag === 5 ? [2] : data.tag === 3 ? [3, data.data] : data.tag === 4 ? [3, data.data] : data.tag === 6 ? [3, data.data] : data.tag === 7 ? [3, data.data] : [0];

    switch ($var2[0]) {
        case 0:
            dataObjectFields = chartDataFields(data.data, function (dataset) {
                return createLineDataset(dataset);
            });
            break;

        case 1:
            dataObjectFields = chartDataFields($var2[1], function (dataset_1) {
                return createBarDataset(dataset_1);
            });
            break;

        case 2:
            dataObjectFields = chartDataFields(data.data, function (dataset_2) {
                return createPieDataset(dataset_2);
            });
            break;

        case 3:
            dataObjectFields = chartDataFields($var2[1], function (dataset_3) {
                return createGenericDataset(dataset_3);
            });
            break;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(dataObjectFields, 0);
}

function createAxis(a) {
    return {
        ticks: {
            beginAtZero: a.Ticks.BeginAtZero
        }
    };
}

function createScales(scales) {
    return {
        yAxes: Array.from(function (source) {
            return Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (a) {
                return createAxis(a);
            }, source);
        }(scales.YAxes)),
        xAxes: Array.from(function (source_1) {
            return Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (a_1) {
                return createAxis(a_1);
            }, source_1);
        }(scales.XAxes))
    };
}

function createLegendPosition(_arg1) {
    if (_arg1.tag === 1) {
        return "left";
    } else if (_arg1.tag === 2) {
        return "bottom";
    } else if (_arg1.tag === 3) {
        return "right";
    } else {
        return "top";
    }
}

function createLegend(legend) {
    if (legend == null) {
        return {
            display: false
        };
    } else {
        var fields = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([["display", true]]);
        var fields_1 = append(fields, "fullWidth", legend.FullWidth, function (x) {
            return x;
        });
        var fields_2 = append(fields_1, "position", legend.Position, function (_arg1) {
            return createLegendPosition(_arg1);
        });
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(fields_2, 0);
    }
}

function createTitle(title) {
    if (title == null) {
        return {
            display: false
        };
    } else {
        return {
            display: true,
            text: title
        };
    }
}

function createOptions(o) {
    var fields = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
    var fields_1 = append(fields, "scales", o.Scales, function (scales) {
        return createScales(scales);
    });
    var fields_2 = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](["legend", createLegend(o.Legend)], fields_1);
    var fields_3 = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](["title", createTitle(o.Title)], fields_2);
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["n" /* createObj */])(fields_3, 0);
}

function convertType(_arg1) {
    switch (_arg1.tag) {
        case 0:
            return "bar";

        case 1:
            return "horizontalBar";

        case 3:
            return "radar";

        case 4:
            return "polarArea";

        case 5:
            return "pie";

        case 6:
            return "doughnut";

        case 7:
            return "bubble";

        default:
            return "line";
    }
}

var RenderedChart = function () {
    function RenderedChart(destroy) {
        _classCallCheck(this, RenderedChart);

        this.Destroy = destroy;
    }

    _createClass(RenderedChart, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Fable.Import.Chartjs.RenderedChart",
                interfaces: ["FSharpRecord"],
                properties: {
                    Destroy: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["c" /* Function */])([__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["i" /* Unit */], __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["i" /* Unit */]])
                }
            };
        }
    }]);

    return RenderedChart;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.Import.Chartjs.RenderedChart", RenderedChart);
function renderChart(chart) {
    var ctx = document.getElementById(chart.CanvasId);
    var settings = {
        type: convertType(chart.Data),
        data: createData(chart.Data),
        options: function (option) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["o" /* defaultArg */])(option, null, function (o) {
                return createOptions(o);
            });
        }(chart.Options)
    };
    var chart_1 = new Chart(ctx, settings);
    return new RenderedChart(function () {
        chart_1.destroy();
    });
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Color = function () {
    function Color(r, g, b, a) {
        _classCallCheck(this, Color);

        this.R = r;
        this.G = g;
        this.B = b;
        this.A = a;
    }

    _createClass(Color, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Colors.Color",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    R: "number",
                    G: "number",
                    B: "number",
                    A: "number"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return Color;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Colors.Color", Color);
var colors = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new Color(128, 0, 0, 1), new Color(139, 0, 0, 1), new Color(165, 42, 42, 1), new Color(178, 34, 34, 1), new Color(220, 20, 60, 1), new Color(255, 0, 0, 1), new Color(255, 99, 71, 1), new Color(255, 127, 80, 1), new Color(205, 92, 92, 1), new Color(240, 128, 128, 1), new Color(233, 150, 122, 1), new Color(250, 128, 114, 1), new Color(255, 160, 122, 1), new Color(255, 69, 0, 1), new Color(255, 140, 0, 1), new Color(255, 165, 0, 1), new Color(255, 215, 0, 1), new Color(184, 134, 11, 1), new Color(218, 165, 32, 1), new Color(238, 232, 170, 1), new Color(189, 183, 107, 1), new Color(240, 230, 140, 1), new Color(128, 128, 0, 1), new Color(255, 255, 0, 1), new Color(154, 205, 50, 1), new Color(85, 107, 47, 1), new Color(107, 142, 35, 1), new Color(124, 252, 0, 1), new Color(127, 255, 0, 1), new Color(173, 255, 47, 1), new Color(0, 100, 0, 1), new Color(0, 128, 0, 1), new Color(34, 139, 34, 1), new Color(0, 255, 0, 1), new Color(50, 205, 50, 1), new Color(144, 238, 144, 1), new Color(152, 251, 152, 1), new Color(143, 188, 143, 1), new Color(0, 250, 154, 1), new Color(0, 255, 127, 1), new Color(46, 139, 87, 1), new Color(102, 205, 170, 1), new Color(60, 179, 113, 1), new Color(32, 178, 170, 1), new Color(47, 79, 79, 1), new Color(0, 128, 128, 1), new Color(0, 139, 139, 1), new Color(0, 255, 255, 1), new Color(0, 255, 255, 1), new Color(0, 206, 209, 1), new Color(64, 224, 208, 1), new Color(72, 209, 204, 1), new Color(175, 238, 238, 1), new Color(127, 255, 212, 1), new Color(176, 224, 230, 1), new Color(95, 158, 160, 1), new Color(70, 130, 180, 1), new Color(100, 149, 237, 1), new Color(0, 191, 255, 1), new Color(30, 144, 255, 1), new Color(173, 216, 230, 1), new Color(135, 206, 235, 1), new Color(135, 206, 250, 1), new Color(25, 25, 112, 1), new Color(0, 0, 128, 1), new Color(0, 0, 139, 1), new Color(0, 0, 205, 1), new Color(0, 0, 255, 1), new Color(65, 105, 225, 1), new Color(138, 43, 226, 1), new Color(75, 0, 130, 1), new Color(72, 61, 139, 1), new Color(106, 90, 205, 1), new Color(123, 104, 238, 1), new Color(147, 112, 219, 1), new Color(139, 0, 139, 1), new Color(148, 0, 211, 1), new Color(153, 50, 204, 1), new Color(186, 85, 211, 1), new Color(128, 0, 128, 1), new Color(216, 191, 216, 1), new Color(221, 160, 221, 1), new Color(238, 130, 238, 1), new Color(255, 0, 255, 1), new Color(218, 112, 214, 1), new Color(199, 21, 133, 1), new Color(219, 112, 147, 1), new Color(255, 20, 147, 1), new Color(255, 105, 180, 1), new Color(255, 182, 193, 1), new Color(245, 222, 179, 1), new Color(139, 69, 19, 1), new Color(160, 82, 45, 1), new Color(210, 105, 30, 1), new Color(205, 133, 63, 1), new Color(244, 164, 96, 1), new Color(222, 184, 135, 1), new Color(210, 180, 140, 1), new Color(188, 143, 143, 1), new Color(255, 228, 181, 1), new Color(255, 222, 173, 1), new Color(255, 218, 185, 1), new Color(112, 128, 144, 1), new Color(119, 136, 153, 1), new Color(0, 0, 0, 1), new Color(105, 105, 105, 1), new Color(128, 128, 128, 1), new Color(169, 169, 169, 1), new Color(192, 192, 192, 1)]);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = map;
/* unused harmony export mapError */
/* unused harmony export bind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Result = function () {
    function Result(tag, data) {
        _classCallCheck(this, Result);

        this.tag = tag | 0;
        this.data = data;
    }

    _createClass(Result, [{
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["r" /* equalsUnions */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["m" /* compareUnions */])(this, other);
        }
    }, {
        key: __WEBPACK_IMPORTED_MODULE_0__Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Microsoft.FSharp.Core.FSharpResult",
                interfaces: ["FSharpUnion", "System.IEquatable", "System.IComparable"],
                cases: [["Ok", __WEBPACK_IMPORTED_MODULE_1__Util__["a" /* Any */]], ["Error", __WEBPACK_IMPORTED_MODULE_1__Util__["a" /* Any */]]]
            };
        }
    }]);

    return Result;
}();

/* harmony default export */ __webpack_exports__["a"] = (Result);

function map(f, result) {
    return result.tag === 0 ? new Result(0, f(result.data)) : result;
}
function mapError(f, result) {
    return result.tag === 1 ? new Result(1, f(result.data)) : result;
}
function bind(f, result) {
    return result.tag === 0 ? f(result.data) : result;
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_fs__ = __webpack_require__(36);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "saveAccessToken", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "loadSavedBooks", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "loadDetails", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "store", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "saveBooks", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "saveBookDetails", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "login", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "token", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "secret", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["g"]; });


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = saveAccessToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadSavedBooks;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return saveBooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveBookDetails; });
/* harmony export (immutable) */ __webpack_exports__["c"] = login;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return token; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return secret; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fable_Import_Global_fs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReadBooksStorage_fs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fable_Import_Redux_fs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Reducer_fs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_fs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReadBooksDownloader_fs__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utils_fs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);













function saveAccessToken(userData) {
    Object(__WEBPACK_IMPORTED_MODULE_0__Fable_Import_Global_fs__["b" /* setCookie */])("accessToken", userData.AccessToken, 7);
    Object(__WEBPACK_IMPORTED_MODULE_0__Fable_Import_Global_fs__["b" /* setCookie */])("accessTokenSecret", userData.AccessTokenSecret, 7);
    Object(__WEBPACK_IMPORTED_MODULE_0__Fable_Import_Global_fs__["b" /* setCookie */])("userName", userData.UserName, 7);
    return userData;
}
function loadSavedBooks() {
    var savedBooks = Object(__WEBPACK_IMPORTED_MODULE_1__ReadBooksStorage_fs__["c" /* load */])();

    if (savedBooks == null) {
        return [];
    } else {
        return savedBooks;
    }
}
function loadDetails() {
    var savedDetails = Object(__WEBPACK_IMPORTED_MODULE_1__ReadBooksStorage_fs__["d" /* loadDetails */])();

    if (savedDetails == null) {
        return [];
    } else {
        return savedDetails;
    }
}
var store = Object(__WEBPACK_IMPORTED_MODULE_2__Fable_Import_Redux_fs__["a" /* createStore */])(function (state, action) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__Reducer_fs__["a" /* reducer */])(state, action);
}, new __WEBPACK_IMPORTED_MODULE_4__Model_fs__["l" /* State */](false, loadSavedBooks(), null, "", loadDetails()));
Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["render"])(Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_7__Components_fs__["a" /* App */], {
    Store: store
}), document.getElementById("content"));
var saveBooks = Object(__WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var1) {
    return function (arg00) {
        store.dispatch(arg00);
    }(function (arg0) {
        return {
            type: "SaveReadBooks",
            Item: arg0
        };
    }($var1));
});
var saveBookDetails = Object(__WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var2) {
    return function (arg00) {
        store.dispatch(arg00);
    }(function (arg0) {
        return {
            type: "SaveBooksDetails",
            Item: arg0
        };
    }($var2));
});
function login(accessToken, accessTokenSecret, userName) {
    Object(__WEBPACK_IMPORTED_MODULE_9__ReadBooksDownloader_fs__["a" /* startDownloadReadBooks */])(accessToken, accessTokenSecret, saveBooks, saveBookDetails);
    store.dispatch({
        type: "Login",
        Item1: accessToken,
        Item2: accessTokenSecret,
        Item3: userName
    });
}
var token = Object(__WEBPACK_IMPORTED_MODULE_10__Utils_fs__["d" /* getQueryVariable */])("oauth_token");
var secret = Cookies.get("authorizationTokenSecret");

if (token == null) {
    var token_1 = Cookies.get("accessToken");

    if (token_1 == null) {} else {
        var secret_1 = Cookies.get("accessTokenSecret");
        var userName = Cookies.get("userName");
        login(token_1, secret_1, userName);
    }
} else {
    var token_2 = token;
    var url = Object(__WEBPACK_IMPORTED_MODULE_10__Utils_fs__["c" /* completeUrlWithToken */])("authenticate", token_2, secret);
    Object(__WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__["a" /* fetchAs */])(url, new __WEBPACK_IMPORTED_MODULE_12_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](), {
        T: __WEBPACK_IMPORTED_MODULE_4__Model_fs__["h" /* LoggedUserData */]
    }).then(function ($var4) {
        return function () {
            Object(__WEBPACK_IMPORTED_MODULE_10__Utils_fs__["f" /* removeTokenFromLocation */])();
        }(function ($var3) {
            return function (userData_1) {
                login(userData_1.AccessToken, userData_1.AccessTokenSecret, userData_1.UserName);
            }(function (userData) {
                return saveAccessToken(userData);
            }($var3));
        }($var4));
    });
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
/* unused harmony export tryParse */
/* unused harmony export parse */
// TODO verify that this matches the behavior of .NET
var parseRadix10 = /^ *([\+\-]?[0-9]+) *$/;
// TODO verify that this matches the behavior of .NET
var parseRadix16 = /^ *([\+\-]?[0-9a-fA-F]+) *$/;
function isValid(s, radix) {
    if (s != null) {
        if (radix === 16) {
            return parseRadix16.exec(s);
        } else if (radix <= 10) {
            return parseRadix10.exec(s);
        }
    }
    return null;
}
// TODO does this perfectly match the .NET behavior ?
function tryParse(s, radix, initial) {
    var a = isValid(s, radix);
    if (a !== null) {
        var v = parseInt(a[1], radix);
        if (!Number.isNaN(v)) {
            return [true, v];
        }
    }
    return [false, initial];
}
function parse(s) {
    var radix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    var a = tryParse(s, radix, 0);
    if (a[0]) {
        return a[1];
    } else {
        // TODO FormatException ?
        throw new Error("Input string was not in a correct format.");
    }
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemberInfo */
/* harmony export (immutable) */ __webpack_exports__["b"] = resolveGeneric;
/* unused harmony export getType */
/* harmony export (immutable) */ __webpack_exports__["a"] = getTypeFullName;
/* unused harmony export getName */
/* unused harmony export getPrototypeOfType */
/* unused harmony export getProperties */
/* unused harmony export getUnionCases */
/* unused harmony export getPropertyValues */
/* unused harmony export getUnionFields */
/* unused harmony export makeUnion */
/* unused harmony export getTupleElements */
/* unused harmony export isTupleType */
/* unused harmony export getFunctionElements */
/* unused harmony export isFunctionType */
/* unused harmony export getGenericArguments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var MemberInfo = function () {
    function MemberInfo(name, index, declaringType, propertyType, unionFields) {
        _classCallCheck(this, MemberInfo);

        this.name = name;
        this.index = index;
        this.declaringType = declaringType;
        this.propertyType = propertyType;
        this.unionFields = unionFields;
    }

    _createClass(MemberInfo, [{
        key: "getUnionFields",
        value: function getUnionFields() {
            var _this = this;

            return this.unionFields.map(function (fi, i) {
                return new MemberInfo("unknown", i, _this.declaringType, fi);
            });
        }
    }]);

    return MemberInfo;
}();
function resolveGeneric(idx, enclosing) {
    try {
        var t = enclosing.head;
        if (t.generics == null) {
            return resolveGeneric(idx, enclosing.tail);
        } else {
            var name = typeof idx === "string" ? idx : Object.getOwnPropertyNames(t.generics)[idx];
            var resolved = t.generics[name];
            if (resolved == null) {
                return resolveGeneric(idx, enclosing.tail);
            } else if (resolved instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */] && resolved.kind === "GenericParam") {
                return resolveGeneric(resolved.definition, enclosing.tail);
            } else {
                return new __WEBPACK_IMPORTED_MODULE_0__List__["b" /* default */](resolved, enclosing);
            }
        }
    } catch (err) {
        throw new Error("Cannot resolve generic argument " + idx + ": " + err);
    }
}
function getType(obj) {
    var t = typeof obj === "undefined" ? "undefined" : _typeof(obj);
    switch (t) {
        case "boolean":
        case "number":
        case "string":
        case "function":
            return t;
        default:
            return Object.getPrototypeOf(obj).constructor;
    }
}
// TODO: This needs improvement, check namespace for non-custom types?
function getTypeFullName(typ, option) {
    function trim(fullName, opt) {
        if (typeof fullName !== "string") {
            return "unknown";
        }
        if (opt === "name") {
            var i = fullName.lastIndexOf(".");
            return fullName.substr(i + 1);
        }
        if (opt === "namespace") {
            var _i = fullName.lastIndexOf(".");
            return _i > -1 ? fullName.substr(0, _i) : "";
        }
        return fullName;
    }
    if (typeof typ === "string") {
        return typ;
    } else if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */]) {
        switch (typ.kind) {
            case "Unit":
                return "unit";
            case "Option":
                return getTypeFullName(typ.generics[0], option) + " option";
            case "Array":
                return getTypeFullName(typ.generics[0], option) + "[]";
            case "Tuple":
                return typ.generics.map(function (x) {
                    return getTypeFullName(x, option);
                }).join(" * ");
            case "Function":
                return "Func<" + typ.generics.map(function (x) {
                    return getTypeFullName(x, option);
                }).join(", ") + ">";
            case "GenericParam":
            case "Interface":
                return typ.definition;
            case "GenericType":
                return getTypeFullName(typ.definition, option);
            case "Any":
            default:
                return "unknown";
        }
    } else {
        // Attention: this doesn't work with Object.getPrototypeOf
        var proto = typ.prototype;
        return trim(typeof proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection] === "function" ? proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection]().type : null, option);
    }
}
function getName(x) {
    if (x instanceof MemberInfo) {
        return x.name;
    }
    return getTypeFullName(x, "name");
}
function getPrototypeOfType(typ) {
    if (typeof typ === "string") {
        return null;
    } else if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */]) {
        return typ.kind === "GenericType" ? typ.definition.prototype : null;
    } else {
        return typ.prototype;
    }
}
function getProperties(typ) {
    var proto = getPrototypeOfType(typ);
    if (proto != null && typeof proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection] === "function") {
        var info = proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection]();
        if (info.properties) {
            return Object.getOwnPropertyNames(info.properties).map(function (k, i) {
                return new MemberInfo(k, i, typ, info.properties[k]);
            });
        }
    }
    throw new Error("Type " + getTypeFullName(typ) + " doesn't contain property info.");
}
function getUnionCases(typ) {
    var proto = getPrototypeOfType(typ);
    if (proto != null && typeof proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection] === "function") {
        var info = proto[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection]();
        if (info.cases) {
            return info.cases.map(function (uci, i) {
                return new MemberInfo(uci[0], i, typ, null, uci.slice(1));
            });
        }
    }
    throw new Error("Type " + getTypeFullName(typ) + " doesn't contain union case info.");
}
function getPropertyValues(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Util__["u" /* getPropertyNames */])(obj).map(function (k) {
        return obj[k];
    });
}
function getUnionFields(obj, typ) {
    if (obj != null && typeof obj[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection] === "function") {
        var info = obj[__WEBPACK_IMPORTED_MODULE_1__Symbol__["a" /* default */].reflection]();
        if (info.cases) {
            var uci = info.cases[obj.tag];
            if (uci != null) {
                var fields = uci.length > 2 ? obj.data : uci.length > 1 ? [obj.data] : [];
                return [new MemberInfo(uci[0], obj.tag, typ, null, uci.slice(1)), fields];
            }
        }
    }
    throw new Error("Not an F# union type.");
}
function makeUnion(caseInfo, args) {
    var Cons = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["t" /* getDefinition */])(caseInfo.declaringType);
    switch (args.length) {
        case 0:
            return new Cons(caseInfo.index);
        case 1:
            return new Cons(caseInfo.index, args[0]);
        default:
            return new Cons(caseInfo.index, args);
    }
}
function getTupleElements(typ) {
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */] && typ.kind === "Tuple") {
        return typ.generics;
    }
    throw new Error("Type " + getTypeFullName(typ) + " is not a tuple type.");
}
function isTupleType(typ) {
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */]) {
        return typ.kind === "Tuple";
    }
    return false;
}
function getFunctionElements(typ) {
    if (typ === "function") {
        throw new Error("The type of the function must be known at compile time to get the elements.");
    }
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */] && typ.kind === "Function") {
        return typ.generics;
    }
    throw new Error("Type " + getTypeFullName(typ) + " is not a function type.");
}
function isFunctionType(typ) {
    return typ === "function" || typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */] && typ.kind === "Function";
}
function getGenericArguments(typ) {
    if (typ instanceof __WEBPACK_IMPORTED_MODULE_2__Util__["f" /* NonDeclaredType */]) {
        if (Array.isArray(typ.generics)) {
            return typ.generics;
        } else {
            var dic = typ.generics;
            return Object.keys(dic).map(function (k) {
                return dic[k];
            });
        }
    }
    return [];
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* harmony export (immutable) */ __webpack_exports__["a"] = escape;
/* unused harmony export unescape */
/* unused harmony export isMatch */
/* unused harmony export match */
/* unused harmony export matches */
/* unused harmony export options */
/* unused harmony export replace */
/* unused harmony export split */
function create(pattern, options) {
    var flags = "g";
    flags += options & 1 ? "i" : "";
    flags += options & 2 ? "m" : "";
    return new RegExp(pattern, flags);
}
// From http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
function escape(str) {
    return str.replace(/[\-\[\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
function unescape(str) {
    return str.replace(/\\([\-\[\/\{\}\(\)\*\+\?\.\\\^\$\|])/g, "$1");
}
function isMatch(str, pattern) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var reg = void 0;
    reg = str instanceof RegExp ? (reg = str, str = pattern, reg.lastIndex = options, reg) : reg = create(pattern, options);
    return reg.test(str);
}
function match(str, pattern) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var reg = void 0;
    reg = str instanceof RegExp ? (reg = str, str = pattern, reg.lastIndex = options, reg) : reg = create(pattern, options);
    return reg.exec(str);
}
function matches(str, pattern) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var reg = void 0;
    reg = str instanceof RegExp ? (reg = str, str = pattern, reg.lastIndex = options, reg) : reg = create(pattern, options);
    if (!reg.global) {
        throw new Error("Non-global RegExp"); // Prevent infinite loop
    }
    var m = reg.exec(str);
    var matches = [];
    while (m !== null) {
        matches.push(m);
        m = reg.exec(str);
    }
    return matches;
}
function options(reg) {
    var options = 256; // ECMAScript
    options |= reg.ignoreCase ? 1 : 0;
    options |= reg.multiline ? 2 : 0;
    return options;
}
function replace(reg, input, replacement, limit) {
    var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    function replacer() {
        var res = arguments[0];
        if (limit !== 0) {
            limit--;
            var _match = [];
            var len = arguments.length;
            for (var i = 0; i < len - 2; i++) {
                _match.push(arguments[i]);
            }
            _match.index = arguments[len - 2];
            _match.input = arguments[len - 1];
            res = replacement(_match);
        }
        return res;
    }
    if (typeof reg === "string") {
        var tmp = reg;
        reg = create(input, limit);
        input = tmp;
        limit = undefined;
    }
    if (typeof replacement === "function") {
        limit = limit == null ? -1 : limit;
        return input.substring(0, offset) + input.substring(offset).replace(reg, replacer);
    } else {
        // $0 doesn't work with JS regex, see #1155
        replacement = replacement.replace(/\$0/g, function (s) {
            return "$&";
        });
        if (limit != null) {
            var m = void 0;
            var sub1 = input.substring(offset);
            var _matches = matches(reg, sub1);
            var sub2 = matches.length > limit ? (m = _matches[limit - 1], sub1.substring(0, m.index + m[0].length)) : sub1;
            return input.substring(0, offset) + sub2.replace(reg, replacement) + input.substring(offset + sub2.length);
        } else {
            return input.replace(reg, replacement);
        }
    }
}
function split(reg, input, limit) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    if (typeof reg === "string") {
        var tmp = reg;
        reg = create(input, limit);
        input = tmp;
        limit = undefined;
    }
    input = input.substring(offset);
    return input.split(reg, limit);
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(41);

var createStore_ = __WEBPACK_IMPORTED_MODULE_0_redux__["a" /* createStore */];
function createStore(reducer, initState) {
    var jsReducer = function jsReducer(state, action) {
        var matchValue = action.type;
        var $var1 = typeof matchValue === "string" ? function () {
            var s = matchValue;
            return s.indexOf("@@") === 0;
        }() ? [0, matchValue] : [1] : [1];

        switch ($var1[0]) {
            case 0:
                return state;

            case 1:
                return reducer(state, action);
        }
    };

    var matchValue_1 = window.devToolsExtension;

    if (matchValue_1 == null) {
        return createStore_(jsReducer, initState);
    } else {
        return createStore_(jsReducer, initState, matchValue_1());
    }
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* unused harmony reexport combineReducers */
/* unused harmony reexport bindActionCreators */
/* unused harmony reexport applyMiddleware */
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(46);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(44);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(26);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(48);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(53);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(52)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(28);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flat */
/* unused harmony export merge */
/* unused harmony export saveReadBooks */
/* unused harmony export saveBooksDetails */
/* unused harmony export startDemo */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReadBooksStorage_fs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DemoDataBuilder_fs__ = __webpack_require__(58);







function flat(key, col) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var1) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["p" /* last */])($var1[1]);
    }, function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(key, source);
    }(col));
}
function merge(key) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var3) {
        return function (source) {
            return Array.from(source);
        }(function ($var2) {
            return function (col) {
                return flat(key, col);
            }(function (arrays) {
                return Array.from(Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["e" /* concat */])(arrays));
            }($var2));
        }($var3));
    });
}
function saveReadBooks(actualState, books) {
    var readBooks = function () {
        var clo1 = merge(function (r) {
            return r.ReviewId;
        });
        return function (arg10) {
            return clo1(arg10);
        };
    }()(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([actualState.ReadBooks, books]));

    Object(__WEBPACK_IMPORTED_MODULE_4__ReadBooksStorage_fs__["e" /* save */])(readBooks);
    return new __WEBPACK_IMPORTED_MODULE_5__Model_fs__["l" /* State */](actualState.Logged, readBooks, actualState.AccessData, actualState.LoggedUserName, actualState.BooksDetails);
}
function saveBooksDetails(actualState, details) {
    var mergedDetails = function () {
        var clo1 = merge(function (d) {
            return d.Id;
        });
        return function (arg10) {
            return clo1(arg10);
        };
    }()(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([actualState.BooksDetails, details]));

    Object(__WEBPACK_IMPORTED_MODULE_4__ReadBooksStorage_fs__["f" /* saveDetails */])(mergedDetails);
    return new __WEBPACK_IMPORTED_MODULE_5__Model_fs__["l" /* State */](actualState.Logged, actualState.ReadBooks, actualState.AccessData, actualState.LoggedUserName, mergedDetails);
}
function startDemo(actualState) {
    var ReadBooks = Object(__WEBPACK_IMPORTED_MODULE_6__DemoDataBuilder_fs__["b" /* readBooks */])();
    var BooksDetails = Object(__WEBPACK_IMPORTED_MODULE_6__DemoDataBuilder_fs__["a" /* bookDetails */])();
    return new __WEBPACK_IMPORTED_MODULE_5__Model_fs__["l" /* State */](true, ReadBooks, null, "Demo user", BooksDetails);
}
function reducer(state, action) {
    if (action.type === "SaveReadBooks") {
        return saveReadBooks(state, action.Item.Books);
    } else if (action.type === "SaveBooksDetails") {
        return saveBooksDetails(state, action.Item.Details);
    } else if (action.type === "StartDemo") {
        return startDemo(state);
    } else {
        var AccessData = new __WEBPACK_IMPORTED_MODULE_5__Model_fs__["a" /* AccessTokenData */](action.Item1, action.Item2);
        return new __WEBPACK_IMPORTED_MODULE_5__Model_fs__["l" /* State */](true, state.ReadBooks, AccessData, action.Item3, state.BooksDetails);
    }
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export random */
/* unused harmony export randomReadData */
/* unused harmony export randomShelves */
/* unused harmony export randomLanguage */
/* harmony export (immutable) */ __webpack_exports__["b"] = readBooks;
/* harmony export (immutable) */ __webpack_exports__["a"] = bookDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Array__ = __webpack_require__(14);




var random = {};
function randomReadData() {
    var year = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(function () {
        var copyOfStruct = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["l" /* today */])();
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(copyOfStruct) | 0;
    }() - 5, function () {
        var copyOfStruct_1 = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["l" /* today */])();
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(copyOfStruct_1) | 0;
    }()) | 0;
    var month = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(1, 12) | 0;
    var day = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(1, 28) | 0;
    var start = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["b" /* create */])(year, month, day);
    var length = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(1, 100) | 0;
    return new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["k" /* ReadData */](Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["a" /* addDays */])(start, length), start);
}
function randomShelves() {
    var matchValue = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(1, 5) | 0;

    switch (matchValue) {
        case 1:
            return ["owned"];

        case 2:
            return ["owned", "favorites"];

        case 3:
            return ["kindle"];

        case 4:
            return ["wtf"];

        case 5:
            return ["favorites"];

        default:
            return [];
    }
}
function randomLanguage() {
    var matchValue = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(1, 100) | 0;

    if (matchValue < 20) {
        return "Czech";
    } else if (matchValue < 30) {
        return "Slovak";
    } else if (matchValue < 40) {
        return "Spanish";
    } else {
        return "English";
    }
}
function readBooks() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Array__["b" /* map */])(function (b) {
        var ReadData = randomReadData();
        var Shelves = randomShelves();
        return new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](ReadData, b.NumPages, b.BookTitle, b.AuthorName, b.ReviewId, Shelves, b.SmallImageUrl, b.BookId);
    }, [new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 374, "The Hunger Games (The Hunger Games, #1)", "Suzanne Collins", 2767052, [], "https://images.gr-assets.com/books/1447303603s/2767052.jpg", 2767052), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 197, "The Alchemist", "Paulo Coelho", 865, [], "https://images.gr-assets.com/books/1483412266s/865.jpg", 865), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 325, "The Girl on the Train", "Paula Hawkins", 22557272, [], "https://images.gr-assets.com/books/1490903702s/22557272.jpg", 22557272), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1463, "Les Misérables", "Victor Hugo", 24280, [], "https://images.gr-assets.com/books/1411852091s/24280.jpg", 24280), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 530, "All the Light We Cannot See", "Anthony Doerr", 18143977, [], "https://images.gr-assets.com/books/1451445646s/18143977.jpg", 18143977), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 387, "Cinder (The Lunar Chronicles, #1)", "Marissa Meyer", 11235712, [], "https://images.gr-assets.com/books/1470056948s/11235712.jpg", 11235712), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 398, "The Princess Bride ", "William Goldman", 21787, [], "https://images.gr-assets.com/books/1327903636s/21787.jpg", 21787), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 227, "Fahrenheit 451", "Ray Bradbury", 17470674, [], "https://images.gr-assets.com/books/1469704347s/17470674.jpg", 17470674), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 964, "Anna Karenina", "Leo Tolstoy", 15823480, [], "https://images.gr-assets.com/books/1352422904s/15823480.jpg", 15823480), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 457, "One Hundred Years of Solitude", "Gabriel García Márquez", 320, [], "https://images.gr-assets.com/books/1327881361s/320.jpg", 320), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 182, "Lord of the Flies", "William Golding", 7624, [], "https://images.gr-assets.com/books/1327869409s/7624.jpg", 7624), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 489, "A Tale of Two Cities", "Charles Dickens", 1953, [], "https://images.gr-assets.com/books/1344922523s/1953.jpg", 1953), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 384, "The Maze Runner (Maze Runner, #1)", "James Dashner", 6186357, [], "https://images.gr-assets.com/books/1375596592s/6186357.jpg", 6186357), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 201, "If I Stay (If I Stay, #1)", "Gayle Forman", 4374400, [], "https://images.gr-assets.com/books/1347462970s/4374400.jpg", 4374400), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 482, "Clockwork Angel (The Infernal Devices, #1)", "Cassandra Clare", 7171637, [], "https://images.gr-assets.com/books/1454962884s/7171637.jpg", 7171637), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1276, "The Count of Monte Cristo", "Alexandre Dumas", 7126, [], "https://images.gr-assets.com/books/1309203605s/7126.jpg", 7126), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 449, "Little Women (Little Women, #1)", "Louisa May Alcott", 1934, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 1934), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 409, "Sense and Sensibility", "Jane Austen", 14935, [], "https://images.gr-assets.com/books/1397245675s/14935.jpg", 14935), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 283, "Bossypants", "Tina Fey", 9418327, [], "https://images.gr-assets.com/books/1481509554s/9418327.jpg", 9418327), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 325, "One Flew Over the Cuckoo's Nest", "Ken Kesey", 332613, [], "https://images.gr-assets.com/books/1485308778s/332613.jpg", 332613), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 529, "Middlesex", "Jeffrey Eugenides", 2187, [], "https://images.gr-assets.com/books/1437029776s/2187.jpg", 2187), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 329, "Yes Please", "Amy Poehler", 20910157, [], "https://images.gr-assets.com/books/1402815435s/20910157.jpg", 20910157), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 473, "Unbroken: A World War II Story of Survival, Resilience, and Redemption", "Laura Hillenbrand", 8664353, [], "https://images.gr-assets.com/books/1327861115s/8664353.jpg", 8664353), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 336, "The Secret Life of Bees", "Sue Monk Kidd", 37435, [], "https://images.gr-assets.com/books/1473454532s/37435.jpg", 37435), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 488, "Dracula", "Bram Stoker", 17245, [], "https://images.gr-assets.com/books/1387151694s/17245.jpg", 17245), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 545, "Crime and Punishment", "Fyodor Dostoyevsky", 7144, [], "https://images.gr-assets.com/books/1382846449s/7144.jpg", 7144), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 404, "Throne of Glass (Throne of Glass, #1)", "Sarah J. Maas", 7896527, [], "https://images.gr-assets.com/books/1335819760s/7896527.jpg", 7896527), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 283, "Romeo and Juliet", "William Shakespeare", 18135, [], "https://images.gr-assets.com/books/1327872146s/18135.jpg", 18135), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 399, "The Golden Compass (His Dark Materials, #1)", "Philip Pullman", 119322, [], "https://images.gr-assets.com/books/1451271747s/119322.jpg", 119322), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 457, "The 5th Wave (The 5th Wave, #1)", "Rick Yancey", 16101128, [], "https://images.gr-assets.com/books/1359853842s/16101128.jpg", 16101128), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 662, "The Name of the Wind (The Kingkiller Chronicle, #1)", "Patrick Rothfuss", 186074, [], "https://images.gr-assets.com/books/1472068073s/186074.jpg", 186074), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 332, "Vampire Academy (Vampire Academy, #1)", "Richelle Mead", 345627, [], "https://images.gr-assets.com/books/1361098973s/345627.jpg", 345627), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 422, "Daughter of Smoke & Bone (Daughter of Smoke & Bone, #1)", "Laini Taylor", 8490112, [], "https://images.gr-assets.com/books/1461353773s/8490112.jpg", 8490112), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 315, "Wild: From Lost to Found on the Pacific Crest Trail", "Cheryl Strayed", 12262741, [], "https://images.gr-assets.com/books/1453189881s/12262741.jpg", 12262741), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 206, "The Lion, the Witch, and the Wardrobe (Chronicles of Narnia, #1)", "C.S. Lewis", 100915, [], "https://images.gr-assets.com/books/1353029077s/100915.jpg", 100915), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 272, "Me Talk Pretty One Day", "David Sedaris", 4137, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 4137), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 429, "In the Woods (Dublin Murder Squad, #1)", "Tana French", 237209, [], "https://images.gr-assets.com/books/1348442606s/237209.jpg", 237209), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 369, "The Martian", "Andy Weir", 18007564, [], "https://images.gr-assets.com/books/1413706054s/18007564.jpg", 18007564), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 229, "An Abundance of Katherines", "John Green", 49750, [], "https://images.gr-assets.com/books/1360206426s/49750.jpg", 49750), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 222, "Is Everyone Hanging Out Without Me? (And Other Concerns)", "Mindy Kaling", 10335308, [], "https://images.gr-assets.com/books/1443264638s/10335308.jpg", 10335308), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 455, "The Cuckoo's Calling (Cormoran Strike, #1)", "Robert Galbraith", 16160797, [], "https://images.gr-assets.com/books/1358716559s/16160797.jpg", 16160797), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 474, "Emma", "Jane Austen", 6969, [], "https://images.gr-assets.com/books/1373627931s/6969.jpg", 6969), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 541, "The Odyssey", "Homer", 1381, [], "https://images.gr-assets.com/books/1390173285s/1381.jpg", 1381), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 604, "Dune", "Frank Herbert", 234225, [], "https://images.gr-assets.com/books/1434908555s/234225.jpg", 234225), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 374, "Ready Player One", "Ernest Cline", 9969571, [], "https://images.gr-assets.com/books/1489368740s/9969571.jpg", 9969571), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 505, "Great Expectations", "Charles Dickens", 2623, [], "https://images.gr-assets.com/books/1327920219s/2623.jpg", 2623), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 312, "The Graveyard Book", "Neil Gaiman", 2213661, [], "https://images.gr-assets.com/books/1303859949s/2213661.jpg", 2213661), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 496, "A Tree Grows in Brooklyn", "Betty  Smith", 14891, [], "https://images.gr-assets.com/books/1327883484s/14891.jpg", 14891), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 249, "Persuasion", "Jane Austen", 2156, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 2156), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 331, "The Secret Garden", "Frances Hodgson Burnett", 2998, [], "https://images.gr-assets.com/books/1327873635s/2998.jpg", 2998), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 399, "Across the Universe (Across the Universe, #1)", "Beth Revis", 8235178, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 8235178), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 132, "The Old Man and the Sea", "Ernest Hemingway", 2165, [], "https://images.gr-assets.com/books/1329189714s/2165.jpg", 2165), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 973, "The Pillars of the Earth", "Ken Follett", 5043, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 5043), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 368, "Perfect Chemistry (Perfect Chemistry, #1)", "Simone Elkeles", 4268157, [], "https://images.gr-assets.com/books/1439792475s/4268157.jpg", 4268157), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 123, "The Stranger", "Albert Camus", 49552, [], "https://images.gr-assets.com/books/1349927872s/49552.jpg", 49552), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 310, "Will Grayson, Will Grayson", "John Green", 6567017, [], "https://images.gr-assets.com/books/1368393890s/6567017.jpg", 6567017), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 444, "It's Kind of a Funny Story", "Ned Vizzini", 248704, [], "https://images.gr-assets.com/books/1420629730s/248704.jpg", 248704), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 409, "The Raven Boys (The Raven Cycle, #1)", "Maggie Stiefvater", 17675462, [], "https://images.gr-assets.com/books/1477103737s/17675462.jpg", 17675462), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 795, "The Brothers Karamazov", "Fyodor Dostoyevsky", 4934, [], "https://images.gr-assets.com/books/1427728126s/4934.jpg", 4934), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1116, "It", "Stephen King", 830502, [], "https://images.gr-assets.com/books/1334416842s/830502.jpg", 830502), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 423, "My Sister's Keeper", "Jodi Picoult", 10917, [], "https://images.gr-assets.com/books/1369504683s/10917.jpg", 10917), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 579, "A Discovery of Witches (All Souls Trilogy, #1)", "Deborah Harkness", 8667848, [], "https://images.gr-assets.com/books/1322168805s/8667848.jpg", 8667848), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 382, "Red Rising (Red Rising, #1)", "Pierce Brown", 15839976, [], "https://images.gr-assets.com/books/1461354651s/15839976.jpg", 15839976), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 335, "Unwind (Unwind, #1)", "Neal Shusterman", 764347, [], "https://images.gr-assets.com/books/1297677706s/764347.jpg", 764347), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 184, "Man's Search for Meaning", "Viktor E. Frankl", 4069, [], "https://images.gr-assets.com/books/1467136625s/4069.jpg", 4069), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 273, "The Art of War", "Sun Tzu", 10534, [], "https://images.gr-assets.com/books/1453417993s/10534.jpg", 10534), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 784, "Harry Potter and the Deathly Hallows (Harry Potter, #7)", "J.K. Rowling", 136251, [], "https://images.gr-assets.com/books/1474171184s/136251.jpg", 136251), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 415, "Truly Madly Guilty", "Liane Moriarty", 26247008, [], "https://images.gr-assets.com/books/1491249206s/26247008.jpg", 26247008), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 462, "Six of Crows (Six of Crows, #1)", "Leigh Bardugo", 23437156, [], "https://images.gr-assets.com/books/1459349344s/23437156.jpg", 23437156), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 224, "The Boy in the Striped Pajamas", "John Boyne", 39999, [], "https://images.gr-assets.com/books/1366228171s/39999.jpg", 39999), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 421, "A Court of Thorns and Roses (A Court of Thorns and Roses, #1)", "Sarah J. Maas", 16096824, [], "https://images.gr-assets.com/books/1491595796s/16096824.jpg", 16096824), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 208, "Speak", "Laurie Halse Anderson", 439288, [], "https://images.gr-assets.com/books/1310121762s/439288.jpg", 439288), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 64, "The Giving Tree", "Shel Silverstein", 370493, [], "https://images.gr-assets.com/books/1174210942s/370493.jpg", 370493), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 432, "The Devil Wears Prada (The Devil Wears Prada, #1)", "Lauren Weisberger", 5139, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 5139), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 233, "Girl with a Pearl Earring", "Tracy Chevalier", 2865, [], "https://images.gr-assets.com/books/1327197580s/2865.jpg", 2865), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 256, "The Sun Also Rises", "Ernest Hemingway", 3876, [], "https://images.gr-assets.com/books/1331828228s/3876.jpg", 3876), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 266, "Stardust", "Neil Gaiman", 16793, [], "https://images.gr-assets.com/books/1459127484s/16793.jpg", 16793), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 336, "Easy (Contours of the Heart, #1)", "Tammara Webber", 16056408, [], "https://images.gr-assets.com/books/1349370267s/16056408.jpg", 16056408), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 400, "A Darker Shade of Magic (Shades of Magic, #1)", "V.E. Schwab", 22055262, [], "https://images.gr-assets.com/books/1400322851s/22055262.jpg", 22055262), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 751, "John Adams", "David McCullough", 2203, [], "https://images.gr-assets.com/books/1478144278s/2203.jpg", 2203), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "The Unbearable Lightness of Being", "Milan Kundera", 9717, [], "https://images.gr-assets.com/books/1265401884s/9717.jpg", 9717), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 323, "Attachments", "Rainbow Rowell", 8909152, [], "https://images.gr-assets.com/books/1398982892s/8909152.jpg", 8909152), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 471, "For Whom the Bell Tolls", "Ernest Hemingway", 46170, [], "https://images.gr-assets.com/books/1170314772s/46170.jpg", 46170), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1153, "The Stand", "Stephen King", 149267, [], "https://images.gr-assets.com/books/1213131305s/149267.jpg", 149267), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 652, "Harry Potter and the Half-Blood Prince (Harry Potter, #6)", "J.K. Rowling", 1, [], "https://images.gr-assets.com/books/1361039191s/1.jpg", 1), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1125, "A Dance with Dragons (A Song of Ice and Fire, #5)", "George R.R. Martin", 10664113, [], "https://images.gr-assets.com/books/1327885335s/10664113.jpg", 10664113), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 394, "My Life Next Door", "Huntley Fitzpatrick", 12294652, [], "https://images.gr-assets.com/books/1394240144s/12294652.jpg", 12294652), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "A People's History of the United States", "Howard Zinn", 2767, [], "https://images.gr-assets.com/books/1407105086s/2767.jpg", 2767), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 306, "Cat's Cradle", "Kurt Vonnegut", 135479, [], "https://images.gr-assets.com/books/1327867150s/135479.jpg", 135479), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 276, "Dear John", "Nicholas Sparks", 5526, [], "https://images.gr-assets.com/books/1397749854s/5526.jpg", 5526), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 461, "Inferno (Robert Langdon, #4)", "Dan Brown", 17212231, [], "https://images.gr-assets.com/books/1397093185s/17212231.jpg", 17212231), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 925, "1Q84", "Haruki Murakami", 10357575, [], "https://images.gr-assets.com/books/1483103331s/10357575.jpg", 10357575), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 310, "Everything, Everything", "Nicola Yoon", 18692431, [], "https://images.gr-assets.com/books/1450515891s/18692431.jpg", 18692431), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 535, "City of Lost Souls (The Mortal Instruments, #5)", "Cassandra Clare", 8755776, [], "https://images.gr-assets.com/books/1460477703s/8755776.jpg", 8755776), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 705, "House of Leaves", "Mark Z. Danielewski", 24800, [], "https://images.gr-assets.com/books/1403889034s/24800.jpg", 24800), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 225, "The Adventures of Tom Sawyer", "Mark Twain", 24583, [], "https://images.gr-assets.com/books/1404811979s/24583.jpg", 24583), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 307, "On the Road", "Jack Kerouac", 70401, [], "https://images.gr-assets.com/books/1413588576s/70401.jpg", 70401), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 359, "Aristotle and Dante Discover the Secrets of the Universe (Aristotle and Dante Discover the Secrets of the Universe, #1)", "Benjamin Alire Sáenz", 12000020, [], "https://images.gr-assets.com/books/1328320260s/12000020.jpg", 12000020), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 698, "Lady Midnight (The Dark Artifices, #1)", "Cassandra Clare", 25494343, [], "https://images.gr-assets.com/books/1460477682s/25494343.jpg", 25494343), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1023, "Don Quixote", "Miguel de Cervantes Saavedra", 3836, [], "https://images.gr-assets.com/books/1364958765s/3836.jpg", 3836), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 118, "The Time Machine", "H.G. Wells", 2493, [], "https://images.gr-assets.com/books/1327942880s/2493.jpg", 2493), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 453, "City of Ashes (The Mortal Instruments, #2)", "Cassandra Clare", 1582996, [], "https://images.gr-assets.com/books/1432730356s/1582996.jpg", 1582996), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 337, "A Man Called Ove", "Fredrik Backman", 18774964, [], "https://images.gr-assets.com/books/1405259930s/18774964.jpg", 18774964), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 256, "Foundation (Foundation #1)", "Isaac Asimov", 29579, [], "https://images.gr-assets.com/books/1417900846s/29579.jpg", 29579), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 315, "Running with Scissors", "Augusten Burroughs", 242006, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 242006), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 446, "An Ember in the Ashes (An Ember in the Ashes, #1)", "Sabaa Tahir", 27774758, [], "https://images.gr-assets.com/books/1449158871s/27774758.jpg", 27774758), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 334, "Bared to You (Crossfire, #1)", "Sylvia Day", 20448515, [], "https://images.gr-assets.com/books/1433411511s/20448515.jpg", 20448515), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 393, "Dark Lover (Black Dagger Brotherhood, #1)", "J.R. Ward", 42899, [], "https://images.gr-assets.com/books/1429676285s/42899.jpg", 42899), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "Anna Dressed in Blood (Anna, #1)", "Kendare Blake", 9378297, [], "https://images.gr-assets.com/books/1398637405s/9378297.jpg", 9378297), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 374, "The God Delusion", "Richard Dawkins", 14743, [], "https://images.gr-assets.com/books/1347220693s/14743.jpg", 14743), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 278, "Orphan Train", "Christina Baker Kline", 15818107, [], "https://images.gr-assets.com/books/1362409483s/15818107.jpg", 15818107), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 240, "Why Not Me?", "Mindy Kaling", 30268522, [], "https://images.gr-assets.com/books/1473956249s/30268522.jpg", 30268522), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 470, "P.S. I Love You", "Cecelia Ahern", 366522, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 366522), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 92, "Alice in Wonderland (Alice's Adventures in Wonderland, #1)", "Jane Carruth", 13023, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 13023), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 314, "The Paris Wife", "Paula McLain", 8683812, [], "https://images.gr-assets.com/books/1320545874s/8683812.jpg", 8683812), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 399, "Jurassic Park", "Michael Crichton", 6424171, [], "https://images.gr-assets.com/books/1344371661s/6424171.jpg", 6424171), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1061, "A Feast for Crows (A Song of Ice and Fire, #4)", "George R.R. Martin", 13497, [], "https://images.gr-assets.com/books/1429538615s/13497.jpg", 13497), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 424, "City of Fallen Angels (The Mortal Instruments, #4)", "Cassandra Clare", 6752378, [], "https://images.gr-assets.com/books/1369452302s/6752378.jpg", 6752378), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 346, "All the Ugly and Wonderful Things", "Bryn Greenwood", 26114135, [], "https://images.gr-assets.com/books/1485510210s/26114135.jpg", 26114135), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 608, "Oliver Twist", "Charles Dickens", 18254, [], "https://images.gr-assets.com/books/1327868529s/18254.jpg", 18254), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 493, "Benjamin Franklin: An American Life", "Walter Isaacson", 10883, [], "https://images.gr-assets.com/books/1397772877s/10883.jpg", 10883), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 289, "Hamlet", "William Shakespeare", 1420, [], "https://images.gr-assets.com/books/1351051208s/1420.jpg", 1420), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 269, "Snow Flower and the Secret Fan", "Lisa See", 1103, [], "https://images.gr-assets.com/books/1327880508s/1103.jpg", 1103), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 210, "Tuesdays with Morrie", "Mitch Albom", 6900, [], "https://images.gr-assets.com/books/1423763749s/6900.jpg", 6900), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "Confess", "Colleen Hoover", 34324605, [], "https://images.gr-assets.com/books/1490524804s/34324605.jpg", 34324605), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 252, "The Shack", "William Paul Young", 1812457, [], "https://images.gr-assets.com/books/1344270232s/1812457.jpg", 1812457), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 478, "Watership Down (Watership Down #1)", "Richard Adams", 76620, [], "https://images.gr-assets.com/books/1405136931s/76620.jpg", 76620), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 371, "Hyperbole and a Half: Unfortunate Situations, Flawed Coping Mechanisms, Mayhem, and Other Things That Happened", "Allie Brosh", 17571564, [], "https://images.gr-assets.com/books/1409522492s/17571564.jpg", 17571564), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 109, "The Tales of Beedle the Bard", "J.K. Rowling", 3950967, [], "https://images.gr-assets.com/books/1373467575s/3950967.jpg", 3950967), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "Anne of Green Gables (Anne of Green Gables, #1)", "L.M. Montgomery", 8127, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 8127), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 410, "Hopeless (Hopeless, #1)", "Colleen Hoover", 15717943, [], "https://images.gr-assets.com/books/1353489892s/15717943.jpg", 15717943), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 207, "Into the Wild", "Jon Krakauer", 1845, [], "https://images.gr-assets.com/books/1403173986s/1845.jpg", 1845), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 467, "Kafka on the Shore", "Haruki Murakami", 4929, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 4929), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 294, "Sarah's Key", "Tatiana de Rosnay", 556602, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 556602), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 37, "Where the Wild Things Are", "Maurice Sendak", 19543, [], "https://images.gr-assets.com/books/1384434560s/19543.jpg", 19543), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 144, "The Strange Case of Dr. Jekyll and Mr. Hyde", "Robert Louis Stevenson", 51496, [], "https://images.gr-assets.com/books/1318116526s/51496.jpg", 51496), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 201, "The Metamorphosis", "Franz Kafka", 485894, [], "https://images.gr-assets.com/books/1359061917s/485894.jpg", 485894), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 223, "The Screwtape Letters", "C.S. Lewis", 17383917, [], "https://images.gr-assets.com/books/1414551641s/17383917.jpg", 17383917), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "Steal Like an Artist: 10 Things Nobody Told You About Being Creative", "Austin Kleon", 13099738, [], "https://images.gr-assets.com/books/1404576602s/13099738.jpg", 13099738), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 563, "The Girl Who Kicked the Hornet's Nest (Millennium, #3)", "Stieg Larsson", 6892870, [], "https://images.gr-assets.com/books/1327708260s/6892870.jpg", 6892870), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 217, "Lean In: Women, Work, and the Will to Lead", "Sheryl Sandberg", 16071764, [], "https://images.gr-assets.com/books/1364250803s/16071764.jpg", 16071764), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1177, "A Storm of Swords (A Song of Ice and Fire, #3)", "George R.R. Martin", 62291, [], "https://images.gr-assets.com/books/1471637043s/62291.jpg", 62291), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Fountainhead", "Ayn Rand", 2122, [], "https://images.gr-assets.com/books/1491163636s/2122.jpg", 2122), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 477, "Americanah", "Chimamanda Ngozi Adichie", 15796700, [], "https://images.gr-assets.com/books/1356654499s/15796700.jpg", 15796700), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 321, "Room", "Emma Donoghue", 7937843, [], "https://images.gr-assets.com/books/1344265419s/7937843.jpg", 7937843), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 324, "Beloved", "Toni Morrison", 6149, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 6149), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 399, "American Psycho", "Bret Easton Ellis", 28676, [], "https://images.gr-assets.com/books/1436934349s/28676.jpg", 28676), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 392, "Pushing the Limits (Pushing the Limits, #1)", "Katie McGarry", 10194514, [], "https://images.gr-assets.com/books/1322770025s/10194514.jpg", 10194514), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 397, "A Walk in the Woods: Rediscovering America on the Appalachian Trail", "Bill Bryson", 9791, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 9791), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 251, "Northanger Abbey", "Jane Austen", 50398, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 50398), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 304, "Under the Tuscan Sun", "Frances Mayes", 480479, [], "https://images.gr-assets.com/books/1320524083s/480479.jpg", 480479), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "It Ends with Us", "Colleen Hoover", 27362503, [], "https://images.gr-assets.com/books/1470427482s/27362503.jpg", 27362503), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "Stiff: The Curious Lives of Human Cadavers", "Mary Roach", 32145, [], "https://images.gr-assets.com/books/1347656489s/32145.jpg", 32145), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 369, "Just One Day (Just One Day, #1)", "Gayle Forman", 17623975, [], "https://images.gr-assets.com/books/1368722144s/17623975.jpg", 17623975), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 154, "The Wonderful Wizard of Oz (Oz, #1)", "L. Frank Baum", 236093, [], "https://images.gr-assets.com/books/1398003737s/236093.jpg", 236093), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 293, "A Farewell to Arms", "Ernest Hemingway", 10799, [], "https://images.gr-assets.com/books/1313714836s/10799.jpg", 10799), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 188, "Heart of Darkness", "Joseph Conrad", 4900, [], "https://images.gr-assets.com/books/1392799983s/4900.jpg", 4900), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1006, "Jonathan Strange & Mr Norrell", "Susanna Clarke", 14201, [], "https://images.gr-assets.com/books/1357027589s/14201.jpg", 14201), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 376, "Good in Bed (Cannie Shapiro, #1)", "Jennifer Weiner", 14748, [], "https://images.gr-assets.com/books/1327936464s/14748.jpg", 14748), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 250, "Brain on Fire: My Month of Madness", "Susannah Cahalan", 13547180, [], "https://images.gr-assets.com/books/1353173297s/13547180.jpg", 13547180), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 490, "The Return of the King (The Lord of the Rings, #3)", "J.R.R. Tolkien", 18512, [], "https://images.gr-assets.com/books/1389977161s/18512.jpg", 18512), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 541, "Cutting for Stone", "Abraham Verghese", 3591262, [], "https://images.gr-assets.com/books/1327931601s/3591262.jpg", 3591262), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 451, "The Omnivore's Dilemma: A Natural History of Four Meals", "Michael Pollan", 3109, [], "https://images.gr-assets.com/books/1393804353s/3109.jpg", 3109), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1216, "The Lord of the Rings (The Lord of the Rings, #1-3)", "J.R.R. Tolkien", 33, [], "https://images.gr-assets.com/books/1411114164s/33.jpg", 33), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 338, "The Silence of the Lambs  (Hannibal Lecter, #2)", "Thomas Harris", 23807, [], "https://images.gr-assets.com/books/1390426249s/23807.jpg", 23807), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 340, "Safe Haven", "Nicholas Sparks", 7812659, [], "https://images.gr-assets.com/books/1344268800s/7812659.jpg", 7812659), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 329, "Madame Bovary", "Gustave Flaubert", 2175, [], "https://images.gr-assets.com/books/1335676143s/2175.jpg", 2175), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 255, "The Trial", "Franz Kafka", 17690, [], "https://images.gr-assets.com/books/1320399438s/17690.jpg", 17690), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 374, "The Truth About Forever", "Sarah Dessen", 51737, [], "https://images.gr-assets.com/books/1362767907s/51737.jpg", 51737), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 240, "Wall and Piece", "Banksy", 114683, [], "https://images.gr-assets.com/books/1327904853s/114683.jpg", 114683), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 375, "The Audacity of Hope: Thoughts on Reclaiming the American Dream", "Barack Obama", 9742, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 9742), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 322, "The Two Towers (The Lord of the Rings, #2)", "J.R.R. Tolkien", 15241, [], "https://images.gr-assets.com/books/1298415523s/15241.jpg", 15241), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 560, "Mansfield Park", "Jane Austen", 45032, [], "https://images.gr-assets.com/books/1397063295s/45032.jpg", 45032), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 510, "The Hunchback of Notre-Dame", "Victor Hugo", 30597, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 30597), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 896, "Doors of Stone (The Kingkiller Chronicle, #3)", "Patrick Rothfuss", 21032488, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 21032488), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 388, "The Wrath & the Dawn (The Wrath & the Dawn, #1)", "Renee Ahdieh", 18798983, [], "https://images.gr-assets.com/books/1417956963s/18798983.jpg", 18798983), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 386, "1776", "David McCullough", 1067, [], "https://images.gr-assets.com/books/1306787560s/1067.jpg", 1067), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 256, "Their Eyes Were Watching God", "Zora Neale Hurston", 37415, [], "https://images.gr-assets.com/books/1368072803s/37415.jpg", 37415), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 566, "The Bourne Identity (Jason Bourne, #1)", "Robert Ludlum", 7869, [], "https://images.gr-assets.com/books/1335860740s/7869.jpg", 7869), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 703, "The Origin of Species", "Charles Darwin", 22463, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 22463), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 432, "Angela's Ashes (Frank McCourt, #1)", "Frank McCourt", 252577, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 252577), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 199, "The Secret (The Secret, #1)", "Rhonda Byrne", 52529, [], "https://images.gr-assets.com/books/1482865039s/52529.jpg", 52529), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 578, "The Diviners (The Diviners, #1)", "Libba Bray", 7728889, [], "https://images.gr-assets.com/books/1336424966s/7728889.jpg", 7728889), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 104, "A Christmas Carol", "Charles Dickens", 5326, [], "https://images.gr-assets.com/books/1406512317s/5326.jpg", 5326), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 178, "Breakfast at Tiffany's", "Truman Capote", 251688, [], "https://images.gr-assets.com/books/1477015353s/251688.jpg", 251688), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 528, "Stranger in a Strange Land", "Robert A. Heinlein", 350, [], "https://images.gr-assets.com/books/1156897088s/350.jpg", 350), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 550, "Cress (The Lunar Chronicles, #3)", "Marissa Meyer", 13206828, [], "https://images.gr-assets.com/books/1470057005s/13206828.jpg", 13206828), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 416, "The Republic", "Plato", 30289, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 30289), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 311, "Treasure Island", "Robert Louis Stevenson", 295, [], "https://images.gr-assets.com/books/1485248909s/295.jpg", 295), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1614, "The Rise and Fall of the Third Reich: A History of Nazi Germany", "William L. Shirer", 767171, [], "https://images.gr-assets.com/books/1331223772s/767171.jpg", 767171), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 400, "The Night Circus", "Erin Morgenstern", 9361589, [], "https://images.gr-assets.com/books/1387124618s/9361589.jpg", 9361589), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Importance of Being Earnest", "Oscar Wilde", 92303, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 92303), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1007, "The Way of Kings (The Stormlight Archive, #1)", "Brandon Sanderson", 7235533, [], "https://images.gr-assets.com/books/1489368762s/7235533.jpg", 7235533), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 429, "Schindler's List", "Thomas Keneally", 375013, [], "https://images.gr-assets.com/books/1348163457s/375013.jpg", 375013), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 344, "Amy & Roger's Epic Detour", "Morgan Matson", 7664334, [], "https://images.gr-assets.com/books/1327989202s/7664334.jpg", 7664334), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 263, "Perfume: The Story of a Murderer", "Patrick Süskind", 343, [], "https://images.gr-assets.com/books/1409112276s/343.jpg", 343), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 340, "The God of Small Things", "Arundhati Roy", 9777, [], "https://images.gr-assets.com/books/1436217001s/9777.jpg", 9777), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 390, "Fates and Furies", "Lauren Groff", 24612118, [], "https://images.gr-assets.com/books/1434750235s/24612118.jpg", 24612118), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 228, "The Color of Magic (Discworld, #1; Rincewind #1)", "Terry Pratchett", 34497, [], "https://images.gr-assets.com/books/1407111017s/34497.jpg", 34497), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 672, "The Woman in White", "Wilkie Collins", 5890, [], "https://images.gr-assets.com/books/1295661017s/5890.jpg", 5890), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 407, "The Master and Margarita", "Mikhail Bulgakov", 117833, [], "https://images.gr-assets.com/books/1327867963s/117833.jpg", 117833), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 370, "Misery", "Stephen King", 10614, [], "https://images.gr-assets.com/books/1270545451s/10614.jpg", 10614), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 499, "Thinking, Fast and Slow", "Daniel Kahneman", 11468377, [], "https://images.gr-assets.com/books/1317793965s/11468377.jpg", 11468377), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 275, "The Psychopath Test: A Journey Through the Madness Industry", "Jon Ronson", 12391521, [], "https://images.gr-assets.com/books/1364166270s/12391521.jpg", 12391521), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 360, "I Am the Messenger", "Markus Zusak", 19057, [], "https://images.gr-assets.com/books/1398483261s/19057.jpg", 19057), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 814, "The Eye of the World (Wheel of Time, #1)", "Robert Jordan", 228665, [], "https://images.gr-assets.com/books/1337818095s/228665.jpg", 228665), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 340, "The Woman in Cabin 10", "Ruth Ware", 28187230, [], "https://images.gr-assets.com/books/1465878007s/28187230.jpg", 28187230), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 296, "All Quiet on the Western Front", "Erich Maria Remarque", 355697, [], "https://images.gr-assets.com/books/1441227765s/355697.jpg", 355697), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 360, "The Phantom of the Opera", "Gaston Leroux", 480204, [], "https://images.gr-assets.com/books/1327867727s/480204.jpg", 480204), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 515, "The Art Book", "Phaidon Press", 567616, [], "https://images.gr-assets.com/books/1411210646s/567616.jpg", 567616), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 518, "Tess of the D'Urbervilles", "Thomas Hardy", 32261, [], "https://images.gr-assets.com/books/1434302708s/32261.jpg", 32261), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 447, "Sweet Evil (Sweet, #1)", "Wendy Higgins", 11808950, [], "https://images.gr-assets.com/books/1337613719s/11808950.jpg", 11808950), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 276, "The Summer I Turned Pretty (Summer, #1)", "Jenny Han", 5821978, [], "https://images.gr-assets.com/books/1361666855s/5821978.jpg", 5821978), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 530, "Thoughtless (Thoughtless, #1)", "S.C. Stephens", 13517535, [], "https://images.gr-assets.com/books/1331254339s/13517535.jpg", 13517535), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 213, "The Life-Changing Magic of Tidying Up: The Japanese Art of Decluttering and Organizing", "Marie Kondō", 22318578, [], "https://images.gr-assets.com/books/1418767178s/22318578.jpg", 22318578), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 492, "The Kiss of Deception (The Remnant Chronicles, #1)", "Mary E. Pearson", 16429619, [], "https://images.gr-assets.com/books/1389804901s/16429619.jpg", 16429619), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 361, "The Battle of the Labyrinth (Percy Jackson and the Olympians, #4)", "Rick Riordan", 2120932, [], "https://images.gr-assets.com/books/1443142158s/2120932.jpg", 2120932), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 305, "The Age of Innocence", "Edith Wharton", 53835, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 53835), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "On Writing: A Memoir of the Craft", "Stephen King", 10569, [], "https://images.gr-assets.com/books/1436735207s/10569.jpg", 10569), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 270, "I Was Here", "Gayle Forman", 18879761, [], "https://images.gr-assets.com/books/1405960366s/18879761.jpg", 18879761), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 435, "Uprooted", "Naomi Novik", 22544764, [], "https://images.gr-assets.com/books/1480121122s/22544764.jpg", 22544764), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 848, "The Luminaries", "Eleanor Catton", 17333230, [], "https://images.gr-assets.com/books/1410524246s/17333230.jpg", 17333230), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 438, "Uncle Tom's Cabin", "Harriet Beecher Stowe", 46787, [], "https://images.gr-assets.com/books/1414349231s/46787.jpg", 46787), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 470, "Snow Crash", "Neal Stephenson", 830, [], "https://images.gr-assets.com/books/1477624625s/830.jpg", 830), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 453, "Heartless", "Marissa Meyer", 18584855, [], "https://images.gr-assets.com/books/1477740245s/18584855.jpg", 18584855), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 460, "The Storyteller", "Jodi Picoult", 15753740, [], "https://images.gr-assets.com/books/1356328634s/15753740.jpg", 15753740), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 499, "Seraphina (Seraphina, #1)", "Rachel Hartman", 19549841, [], "https://images.gr-assets.com/books/1387577872s/19549841.jpg", 19549841), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 289, "The Silver Linings Playbook", "Matthew Quick", 13539044, [], "https://images.gr-assets.com/books/1358277412s/13539044.jpg", 13539044), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 258, "The Remains of the Day", "Kazuo Ishiguro", 28921, [], "https://images.gr-assets.com/books/1327128714s/28921.jpg", 28921), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 230, "The Absolutely True Diary of a Part-Time Indian", "Sherman Alexie", 693208, [], "https://images.gr-assets.com/books/1327908992s/693208.jpg", 693208), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 667, "The Idiot", "Fyodor Dostoyevsky", 12505, [], "https://images.gr-assets.com/books/1327865902s/12505.jpg", 12505), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 506, "The Demon King (Seven Realms, #1)", "Cinda Williams Chima", 6342491, [], "https://images.gr-assets.com/books/1379482652s/6342491.jpg", 6342491), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 400, "We Need to Talk About Kevin", "Lionel Shriver", 80660, [], "https://images.gr-assets.com/books/1327865017s/80660.jpg", 80660), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 127, "The Prophet", "Kahlil Gibran", 2547, [], "https://images.gr-assets.com/books/1355046521s/2547.jpg", 2547), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 661, "The Other Boleyn Girl (The Plantagenet and Tudor Novels, #9)", "Philippa Gregory", 37470, [], "https://images.gr-assets.com/books/1355932638s/37470.jpg", 37470), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 267, "As I Lay Dying", "William Faulkner", 77013, [], "https://images.gr-assets.com/books/1451810782s/77013.jpg", 77013), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 648, "A Court of Wings and Ruin (A Court of Thorns and Roses, #3)", "Sarah J. Maas", 23766634, [], "https://images.gr-assets.com/books/1485528243s/23766634.jpg", 23766634), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 259, "Enclave (Razorland, #1)", "Ann Aguirre", 7137327, [], "https://images.gr-assets.com/books/1327877657s/7137327.jpg", 7137327), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 302, "Breakfast of Champions", "Kurt Vonnegut", 4980, [], "https://images.gr-assets.com/books/1327934446s/4980.jpg", 4980), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 298, "A Midsummer Night's Dream", "William Shakespeare", 1622, [], "https://images.gr-assets.com/books/1327874534s/1622.jpg", 1622), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 464, "Library of Souls (Miss Peregrine's Peculiar Children, #3)", "Ransom Riggs", 24120519, [], "https://images.gr-assets.com/books/1472783347s/24120519.jpg", 24120519), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 367, "Crossed (Matched, #2)", "Ally Condie", 15812814, [], "https://images.gr-assets.com/books/1374335939s/15812814.jpg", 15812814), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 426, "The Edge of Never (The Edge of Never, #1)", "J.A. Redmerski", 16081272, [], "https://images.gr-assets.com/books/1358810128s/16081272.jpg", 16081272), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 448, "The Queen of the Tearling (The Queen of the Tearling, #1)", "Erika Johansen", 18712886, [], "https://images.gr-assets.com/books/1417685148s/18712886.jpg", 18712886), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 412, "Falling Kingdoms (Falling Kingdoms, #1)", "Morgan Rhodes", 12954620, [], "https://images.gr-assets.com/books/1337026387s/12954620.jpg", 12954620), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 484, "Salt: A World History", "Mark Kurlansky", 2715, [], "https://images.gr-assets.com/books/1414608893s/2715.jpg", 2715), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 382, "Reconstructing Amelia", "Kimberly McCreight", 15776309, [], "https://images.gr-assets.com/books/1350193583s/15776309.jpg", 15776309), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Zombie Room", "R.D. Ronald", 29908754, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 29908754), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 280, "The Thief (The Queen's Thief, #1)", "Megan Whalen Turner", 448873, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 448873), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 490, "Inferno (The Divine Comedy #1)", "Dante Alighieri", 15645, [], "https://images.gr-assets.com/books/1333579470s/15645.jpg", 15645), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 229, "A Long Way Gone: Memoirs of a Boy Soldier", "Ishmael Beah", 43015, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 43015), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 821, "The Complete Stories and Poems", "Edgar Allan Poe", 23919, [], "https://images.gr-assets.com/books/1327942676s/23919.jpg", 23919), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 317, "Tender Is the Night", "F. Scott Fitzgerald", 46164, [], "https://images.gr-assets.com/books/1438797669s/46164.jpg", 46164), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 361, "Birthmarked (Birthmarked, #1)", "Caragh M. O'Brien", 6909544, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 6909544), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 159, "Maus I: A Survivor's Tale: My Father Bleeds History (Maus, #1)", "Art Spiegelman", 15196, [], "https://images.gr-assets.com/books/1327884972s/15196.jpg", 15196), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 452, "Nightshade (Nightshade #1; Nightshade World #4)", "Andrea Cremer", 7402393, [], "https://images.gr-assets.com/books/1333400218s/7402393.jpg", 7402393), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 176, "A Light in the Attic", "Shel Silverstein", 30118, [], "https://images.gr-assets.com/books/1427169918s/30118.jpg", 30118), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 301, "The Tipping Point: How Little Things Can Make a Big Difference", "Malcolm Gladwell", 2612, [], "https://images.gr-assets.com/books/1473396980s/2612.jpg", 2612), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 279, "The Sea of Monsters (Percy Jackson and the Olympians, #2)", "Rick Riordan", 28186, [], "https://images.gr-assets.com/books/1400602661s/28186.jpg", 28186), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 486, "Passenger (Passenger, #1)", "Alexandra Bracken", 20983362, [], "https://images.gr-assets.com/books/1446749751s/20983362.jpg", 20983362), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 242, "A Little Princess", "Frances Hodgson Burnett", 3008, [], "https://images.gr-assets.com/books/1327868556s/3008.jpg", 3008), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 62, "Green Eggs and Ham", "Dr. Seuss", 23772, [], "https://images.gr-assets.com/books/1468680100s/23772.jpg", 23772), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 195, "Rich Dad, Poor Dad", "Robert T. Kiyosaki", 69571, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 69571), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 299, "The Lean Startup: How Today's Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses", "Eric Ries", 10127019, [], "https://images.gr-assets.com/books/1333576876s/10127019.jpg", 10127019), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 626, "A Court of Mist and Fury (A Court of Thorns and Roses, #2)", "Sarah J. Maas", 17927395, [], "https://images.gr-assets.com/books/1485259138s/17927395.jpg", 17927395), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 208, "The Opposite of Loneliness: Essays and Stories", "Marina Keegan", 18143905, [], "https://images.gr-assets.com/books/1401056149s/18143905.jpg", 18143905), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 26, "The Very Hungry Caterpillar", "Eric Carle", 4948, [], "https://images.gr-assets.com/books/1327878225s/4948.jpg", 4948), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 599, "Feed (Newsflesh Trilogy, #1)", "Mira Grant", 7094569, [], "https://images.gr-assets.com/books/1408500437s/7094569.jpg", 7094569), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 517, "The Blade Itself (The First Law #1)", "Joe Abercrombie", 944073, [], "https://images.gr-assets.com/books/1284167912s/944073.jpg", 944073), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 337, "Beautiful Ruins", "Jess Walter", 11447921, [], "https://images.gr-assets.com/books/1338161553s/11447921.jpg", 11447921), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 337, "Life As We Knew It (Last Survivors, #1)", "Susan Beth Pfeffer", 213753, [], "https://images.gr-assets.com/books/1328012816s/213753.jpg", 213753), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 435, "Along Came a Spider (Alex Cross, #1)", "James Patterson", 13145, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 13145), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 302, "My Heart and Other Black Holes", "Jasmine Warga", 18336965, [], "https://images.gr-assets.com/books/1415056175s/18336965.jpg", 18336965), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 332, "Wait for You (Wait for You, #1)", "J. Lynn", 17314430, [], "https://images.gr-assets.com/books/1363819713s/17314430.jpg", 17314430), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 408, "The White Queen (The Plantagenet and Tudor Novels, #2)", "Philippa Gregory", 5971165, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 5971165), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 1796, "The Complete Sherlock Holmes", "Arthur Conan Doyle", 188572, [], "https://images.gr-assets.com/books/1465539139s/188572.jpg", 188572), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 468, "Partials (Partials Sequence, #1)", "Dan Wells", 12476820, [], "https://images.gr-assets.com/books/1337468746s/12476820.jpg", 12476820), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 462, "1st to Die (Women's Murder Club, #1)", "James Patterson", 13137, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 13137), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 416, "The Boys in the Boat: Nine Americans and Their Epic Quest for Gold at the 1936 Berlin Olympics", "Daniel James Brown", 16158542, [], "https://images.gr-assets.com/books/1354683116s/16158542.jpg", 16158542), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 259, "The Man in the High Castle", "Philip K. Dick", 216363, [], "https://images.gr-assets.com/books/1448756803s/216363.jpg", 216363), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 422, "A Tale for the Time Being", "Ruth Ozeki", 15811545, [], "https://images.gr-assets.com/books/1463767452s/15811545.jpg", 15811545), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 217, "This Is How You Lose Her", "Junot Díaz", 13503109, [], "https://images.gr-assets.com/books/1342596676s/13503109.jpg", 13503109), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Winds of Winter (A Song of Ice and Fire, #6)", "George R.R. Martin", 12111823, [], "https://images.gr-assets.com/books/1465341854s/12111823.jpg", 12111823), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 693, "Empire of Storms (Throne of Glass, #5)", "Sarah J. Maas", 28260587, [], "https://images.gr-assets.com/books/1463107108s/28260587.jpg", 28260587), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 306, "Gulliver's Travels", "Jonathan Swift", 7733, [], "https://images.gr-assets.com/books/1427829692s/7733.jpg", 7733), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 341, "Die for Me (Revenants, #1)", "Amy Plum", 9462812, [], "https://images.gr-assets.com/books/1358427893s/9462812.jpg", 9462812), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 304, "Naked", "David Sedaris", 4138, [], "https://images.gr-assets.com/books/1394178867s/4138.jpg", 4138), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 525, "Killing Floor (Jack Reacher, #1)", "Lee Child", 78129, [], "https://images.gr-assets.com/books/1399313258s/78129.jpg", 78129), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 288, "A Visit from the Goon Squad", "Jennifer Egan", 7331435, [], "https://images.gr-assets.com/books/1356844046s/7331435.jpg", 7331435), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 396, "The Neverending Story", "Michael Ende", 27712, [], "https://images.gr-assets.com/books/1327871159s/27712.jpg", 27712), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "Men Are from Mars, Women Are from Venus", "John Gray", 1274, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 1274), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 186, "Stargirl (Stargirl, #1)", "Jerry Spinelli", 22232, [], "https://images.gr-assets.com/books/1335947642s/22232.jpg", 22232), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 563, "New Moon (Twilight, #2)", "Stephenie Meyer", 49041, [], "https://images.gr-assets.com/books/1361039440s/49041.jpg", 49041), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 357, "Soulless (Parasol Protectorate, #1)", "Gail Carriger", 6381205, [], "https://images.gr-assets.com/books/1314020848s/6381205.jpg", 6381205), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 446, "White Oleander", "Janet Fitch", 32234, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 32234), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 252, "The Elephant Tree", "R.D. Ronald", 9293020, [], "https://images.gr-assets.com/books/1327248026s/9293020.jpg", 9293020), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Sandman, Vol. 1: Preludes and Nocturnes", "Neil Gaiman", 23754, [], "https://images.gr-assets.com/books/1411609637s/23754.jpg", 23754), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 391, "Surely You're Joking, Mr. Feynman!: Adventures of a Curious Character", "Richard Feynman", 5544, [], "https://images.gr-assets.com/books/1348445281s/5544.jpg", 5544), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 468, "Carve the Mark (Carve the Mark, #1)", "Veronica Roth", 30117284, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 30117284), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 430, "Golden Son (Red Rising, #2)", "Pierce Brown", 18966819, [], "https://images.gr-assets.com/books/1394684475s/18966819.jpg", 18966819), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 549, "James Potter and the Hall of Elders' Crossing (James Potter, #1)", "G. Norman Lippert", 2548866, [], "https://images.gr-assets.com/books/1369410178s/2548866.jpg", 2548866), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 880, "The Complete Grimm's Fairy Tales", "Jacob Grimm", 22917, [], "https://images.gr-assets.com/books/1369540060s/22917.jpg", 22917), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 181, "A Moveable Feast", "Ernest Hemingway", 4631, [], "https://images.gr-assets.com/books/1427463201s/4631.jpg", 4631), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 565, "Heir of Fire (Throne of Glass, #3)", "Sarah J. Maas", 20613470, [], "https://images.gr-assets.com/books/1460846511s/20613470.jpg", 20613470), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 452, "Dorothy Must Die (Dorothy Must Die, #1)", "Danielle  Paige", 18053060, [], "https://images.gr-assets.com/books/1381437107s/18053060.jpg", 18053060), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 407, "Caraval (Caraval, #1)", "Stephanie Garber", 27883214, [], "https://images.gr-assets.com/books/1465563623s/27883214.jpg", 27883214), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 327, "The Body Finder (The Body Finder, #1)", "Kimberly Derting", 6261522, [], "https://images.gr-assets.com/books/1358266631s/6261522.jpg", 6261522), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 369, "Champion (Legend, #3)", "Marie Lu", 14290364, [], "https://images.gr-assets.com/books/1382652310s/14290364.jpg", 14290364), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 489, "The Tenant of Wildfell Hall", "Anne Brontë", 337113, [], "https://images.gr-assets.com/books/1479652419s/337113.jpg", 337113), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 459, "Blood Red Road (Dust Lands, #1)", "Moira Young", 9917938, [], "https://images.gr-assets.com/books/1293651959s/9917938.jpg", 9917938), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 384, "All the Missing Girls", "Megan Miranda", 23212667, [], "https://images.gr-assets.com/books/1452098621s/23212667.jpg", 23212667), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 994, "The Wise Man's Fear (The Kingkiller Chronicle, #2)", "Patrick Rothfuss", 1215032, [], "https://images.gr-assets.com/books/1452624392s/1215032.jpg", 1215032), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 317, "I Am Legend and Other Stories", "Richard Matheson", 547094, [], "https://images.gr-assets.com/books/1317791583s/547094.jpg", 547094), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 406, "The Marriage Plot", "Jeffrey Eugenides", 10964693, [], "https://images.gr-assets.com/books/1328736940s/10964693.jpg", 10964693), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 224, "Smile", "Raina Telgemeier", 6393631, [], "https://images.gr-assets.com/books/1438206850s/6393631.jpg", 6393631), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 467, "The History of the Hobbit, Part One: Mr. Baggins", "John D. Rateliff", 1081560, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 1081560), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 815, "The Ultimate Hitchhiker's Guide to the Galaxy (Hitchhiker's Guide to the Galaxy #1-5)", "Douglas Adams", 13, [], "https://images.gr-assets.com/books/1404613595s/13.jpg", 13), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 309, "Darkfever (Fever, #1)", "Karen Marie Moning", 112750, [], "https://images.gr-assets.com/books/1392579949s/112750.jpg", 112750), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 466, "The Bone Season (The Bone Season, #1)", "Samantha Shannon", 17199504, [], "https://images.gr-assets.com/books/1421412990s/17199504.jpg", 17199504), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 643, "The Six Wives of Henry VIII", "Alison Weir", 10104, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 10104), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 322, "Something Borrowed (Darcy & Rachel, #1)", "Emily Giffin", 42156, [], "https://images.gr-assets.com/books/1305063535s/42156.jpg", 42156), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "A Heartbreaking Work of Staggering Genius", "Dave Eggers", 4953, [], "https://images.gr-assets.com/books/1327714834s/4953.jpg", 4953), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 391, "Requiem (Delirium, #3)", "Lauren Oliver", 9593913, [], "https://images.gr-assets.com/books/1340992438s/9593913.jpg", 9593913), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 337, "P.S. I Still Love You (To All the Boys I've Loved Before, #2)", "Jenny Han", 20698530, [], "https://images.gr-assets.com/books/1422881430s/20698530.jpg", 20698530), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 517, "Days of Blood & Starlight (Daughter of Smoke & Bone, #2)", "Laini Taylor", 12812550, [], "https://images.gr-assets.com/books/1461353798s/12812550.jpg", 12812550), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 272, "Hillbilly Elegy: A Memoir of a Family and Culture in Crisis", "J.D. Vance", 27161156, [], "https://images.gr-assets.com/books/1463569814s/27161156.jpg", 27161156), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 287, "Daring Greatly: How the Courage to Be Vulnerable Transforms the Way We Live, Love, Parent, and Lead", "Brené Brown", 13588356, [], "https://images.gr-assets.com/books/1337110319s/13588356.jpg", 13588356), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 495, "The Lake House", "Kate Morton", 21104828, [], "https://images.gr-assets.com/books/1455089249s/21104828.jpg", 21104828), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 208, "The Witches", "Roald Dahl", 6327, [], "https://images.gr-assets.com/books/1351707720s/6327.jpg", 6327), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 146, "James and the Giant Peach", "Roald Dahl", 6689, [], "https://images.gr-assets.com/books/1320412586s/6689.jpg", 6689), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 302, "Blue Bloods (Blue Bloods, #1)", "Melissa de la Cruz", 872333, [], "https://images.gr-assets.com/books/1322281515s/872333.jpg", 872333), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 416, "Fried Green Tomatoes at the Whistle Stop Cafe", "Fannie Flagg", 9375, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 9375), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 462, "A Gentleman in Moscow", "Amor Towles", 29430012, [], "https://images.gr-assets.com/books/1459524472s/29430012.jpg", 29430012), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 825, "Written in My Own Heart's Blood (Outlander, #8)", "Diana Gabaldon", 11710373, [], "https://images.gr-assets.com/books/1365173799s/11710373.jpg", 11710373), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Guardian", "Nicholas Sparks", 15925, [], "https://images.gr-assets.com/books/1388195339s/15925.jpg", 15925), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 430, "Trainspotting", "Irvine Welsh", 135836, [], "https://images.gr-assets.com/books/1353033083s/135836.jpg", 135836), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 160, "We Have Always Lived in the Castle", "Shirley Jackson", 89724, [], "https://images.gr-assets.com/books/1415357189s/89724.jpg", 89724), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 435, "Unearthly (Unearthly, #1)", "Cynthia Hand", 7488244, [], "https://images.gr-assets.com/books/1324782984s/7488244.jpg", 7488244), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "The Purpose Driven Life: What on Earth Am I Here for?", "Rick Warren", 56495, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 56495), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 370, "Everneath (Everneath, #1)", "Brodi Ashton", 9413044, [], "https://images.gr-assets.com/books/1340210035s/9413044.jpg", 9413044), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 287, "Heist Society (Heist Society, #1)", "Ally Carter", 6574102, [], "https://images.gr-assets.com/books/1359254479s/6574102.jpg", 6574102), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 159, "Never Never (Never Never, #1)", "Colleen Hoover", 24378015, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 24378015), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 182, "The Martian Chronicles", "Ray Bradbury", 76778, [], "https://images.gr-assets.com/books/1374049948s/76778.jpg", 76778), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 421, "Bloodlines (Bloodlines, #1)", "Richelle Mead", 8709527, [], "https://images.gr-assets.com/books/1297199431s/8709527.jpg", 8709527), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 405, "Moloka'i", "Alan Brennert", 3273, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 3273), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "Robinson Crusoe", "Daniel Defoe", 2932, [], "https://images.gr-assets.com/books/1403180114s/2932.jpg", 2932), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 352, "The Song of Achilles", "Madeline Miller", 11250317, [], "https://images.gr-assets.com/books/1331154660s/11250317.jpg", 11250317), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 384, "Anansi Boys (American Gods, #2)", "Neil Gaiman", 2744, [], "https://images.gr-assets.com/books/1479778049s/2744.jpg", 2744), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 702, "Untitled (Throne of Glass, #7)", "Sarah J. Maas", 33590260, [], "https://images.gr-assets.com/books/1488914165s/33590260.jpg", 33590260), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 432, "History of Beauty", "Umberto Eco", 10505, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 10505), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 552, "The Book Thief", "Markus Zusak", 19063, [], "https://images.gr-assets.com/books/1390053681s/19063.jpg", 19063), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 320, "The Boston Girl", "Anita Diamant", 22450859, [], "https://images.gr-assets.com/books/1418103945s/22450859.jpg", 22450859), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 381, "The Romanov Sisters: The Lost Lives of the Daughters of Nicholas and Alexandra", "Helen Rappaport", 18404173, [], "https://images.gr-assets.com/books/1396818138s/18404173.jpg", 18404173), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 384, "Prince of Thorns (The Broken Empire, #1)", "Mark  Lawrence", 9579634, [], "https://images.gr-assets.com/books/1327917754s/9579634.jpg", 9579634), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 215, "Understanding Comics: The Invisible Art", "Scott McCloud", 102920, [], "https://images.gr-assets.com/books/1328408101s/102920.jpg", 102920), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 201, "Franny and Zooey", "J.D. Salinger", 5113, [], "https://images.gr-assets.com/books/1355037988s/5113.jpg", 5113), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 314, "Othello", "William Shakespeare", 12996, [], "https://images.gr-assets.com/books/1459795105s/12996.jpg", 12996), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 328, "Eleanor & Park", "Rainbow Rowell", 15745753, [], "https://images.gr-assets.com/books/1341952742s/15745753.jpg", 15745753), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 368, "Every Last Word", "Tamara Ireland Stone", 23341894, [], "https://images.gr-assets.com/books/1431016937s/23341894.jpg", 23341894), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 223, "Boy Meets Boy", "David Levithan", 23228, [], "https://images.gr-assets.com/books/1356335082s/23228.jpg", 23228), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "Shantaram", "Gregory David Roberts", 33600, [], "https://images.gr-assets.com/books/1333482282s/33600.jpg", 33600), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 501, "The Signature of All Things", "Elizabeth Gilbert", 17465453, [], "https://images.gr-assets.com/books/1364277893s/17465453.jpg", 17465453), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 107, "A Streetcar Named Desire", "Tennessee Williams", 12220, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 12220), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 432, "End of Watch (Bill Hodges Trilogy, #3)", "Stephen King", 25526965, [], "https://images.gr-assets.com/books/1468705472s/25526965.jpg", 25526965), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 391, "Before the Fall", "Noah Hawley", 26245850, [], "https://images.gr-assets.com/books/1462515889s/26245850.jpg", 26245850), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 401, "The Black Swan: The Impact of the Highly Improbable", "Nassim Nicholas Taleb", 242472, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 242472), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 427, "Crescendo (Hush, Hush, #2)", "Becca Fitzpatrick", 7791997, [], "https://images.gr-assets.com/books/1362408146s/7791997.jpg", 7791997), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 452, "Torment (Fallen, #2)", "Lauren Kate", 7740152, [], "https://images.gr-assets.com/books/1362339749s/7740152.jpg", 7740152), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 406, "The Thirteenth Tale", "Diane Setterfield", 40440, [], "https://images.gr-assets.com/books/1346267826s/40440.jpg", 40440), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 960, "How to Cook Everything: Simple Recipes for Great Food", "Mark Bittman", 603204, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 603204), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 374, "Incarnate (Newsoul, #1)", "Jodi Meadows", 8573642, [], "https://images.gr-assets.com/books/1358271343s/8573642.jpg", 8573642), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 264, "Midnight Sun (Twilight, #1.5)", "Stephenie Meyer", 4502877, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 4502877), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 224, "The Time Keeper", "Mitch Albom", 13624688, [], "https://images.gr-assets.com/books/1340478576s/13624688.jpg", 13624688), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 295, "The Iron Trial (Magisterium, #1)", "Cassandra Clare", 20578940, [], "https://images.gr-assets.com/books/1396560808s/20578940.jpg", 20578940), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 483, "'Salem's Lot", "Stephen King", 11590, [], "https://images.gr-assets.com/books/1327891565s/11590.jpg", 11590), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 0, "Scott Pilgrim, Volume 1: Scott Pilgrim's Precious Little Life", "Bryan Lee O'Malley", 29800, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 29800), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 364, "Vicious (Vicious, #1)", "V.E. Schwab", 13638125, [], "https://images.gr-assets.com/books/1362495700s/13638125.jpg", 13638125), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 292, "The Best of Me", "Nicholas Sparks", 10766509, [], "https://images.gr-assets.com/books/1301685366s/10766509.jpg", 10766509), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 352, "Bel Canto", "Ann Patchett", 5826, [], "https://images.gr-assets.com/books/1352997328s/5826.jpg", 5826), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 160, "The Marriage Bargain (Marriage to a Billionaire, #1)", "Jennifer Probst", 13486122, [], "https://images.gr-assets.com/books/1329319988s/13486122.jpg", 13486122), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 272, "Dress Your Family in Corduroy and Denim", "David Sedaris", 10176, [], "https://images.gr-assets.com/books/1352983006s/10176.jpg", 10176), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 256, "The Wind in the Willows", "Kenneth Grahame", 5659, [], "https://images.gr-assets.com/books/1423183570s/5659.jpg", 5659), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 372, "Under the Banner of Heaven: A Story of Violent Faith", "Jon Krakauer", 10847, [], "https://images.gr-assets.com/books/1356441391s/10847.jpg", 10847), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 534, "The Invention of Hugo Cabret", "Brian Selznick", 9673436, [], "https://images.gr-assets.com/books/1422312376s/9673436.jpg", 9673436), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 160, "Saga, Vol. 1", "Brian K. Vaughan", 15704307, [], "https://images.gr-assets.com/books/1486028947s/15704307.jpg", 15704307), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 420, "The Madman’s Daughter (The Madman’s Daughter, #1)", "Megan Shepherd", 12291438, [], "https://images.gr-assets.com/books/1354155885s/12291438.jpg", 12291438), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 296, "The Diary of Frida Kahlo: An Intimate Self-Portrait", "Frida Kahlo", 91760, [], "https://images.gr-assets.com/books/1407009131s/91760.jpg", 91760), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 345, "Rebel Belle (Rebel Belle, #1)", "Rachel Hawkins", 8475505, [], "https://images.gr-assets.com/books/1371650817s/8475505.jpg", 8475505), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 460, "A History of God: The 4,000-Year Quest of Judaism, Christianity, and Islam", "Karen Armstrong", 3873, [], "https://s.gr-assets.com/assets/nophoto/book/50x75-a91bf249278a81aabab721ef782c4a74.png", 3873), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 260, "Magic Bites (Kate Daniels, #1)", "Ilona Andrews", 38619, [], "https://images.gr-assets.com/books/1331612872s/38619.jpg", 38619), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 468, "Swann's Way (In Search of Lost Time, #1)", "Marcel Proust", 12749, [], "https://images.gr-assets.com/books/1452956236s/12749.jpg", 12749), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["i" /* ReadBook */](null, 369, "Matched (Matched, #1)", "Ally Condie", 7735333, [], "https://images.gr-assets.com/books/1367706191s/7735333.jpg", 7735333)], Array);
}
function bookDetails() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Array__["b" /* map */])(function (d) {
        var Language = randomLanguage();
        return new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](d.Id, d.Genres, d.OriginalPublicationYear, Language);
    }, [new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2767052, ["action", "adventure", "coming-of-age", "contemporary", "drama", "dystopia", "fantasy", "fiction", "futuristic", "love", "novels", "post-apocalyptic", "romance", "science-fiction", "speculative-fiction", "survival", "suspense", "teen", "thriller", "young-adult"], 2008, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](865, ["20th-century", "adult", "adult-fiction", "adventure", "africa", "brazil", "classics", "contemporary", "drama", "fantasy", "fiction", "historical-fiction", "inspirational", "latin-american", "literary-fiction", "literature", "magical-realism", "modern-classics", "non-fiction", "novels", "personal-development", "philosophy", "read-for-school", "religion", "romance", "school", "self-help", "spain", "spirituality", "travel", "young-adult"], 1988, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22557272, ["adult", "adult-fiction", "contemporary", "crime", "dark", "drama", "fiction", "murder-mystery", "mystery", "mystery-thriller", "novels", "psychological-thriller", "realistic-fiction", "suspense", "thriller"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24280, ["19th-century", "adult", "adult-fiction", "classic-literature", "classics", "drama", "epic", "fiction", "france", "french-literature", "french-revolution", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "movies", "novels", "plays", "read-for-school", "romance", "school", "war"], 1862, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18143977, ["adult", "adult-fiction", "coming-of-age", "contemporary", "drama", "family", "fiction", "france", "germany", "historical", "historical-fiction", "history", "holocaust", "literary-fiction", "literature", "novels", "war", "world-war-ii", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11235712, ["adventure", "aliens", "cinderella", "dystopia", "fairy-tale-retellings", "fairy-tales", "fantasy", "fiction", "futuristic", "magic", "paranormal", "retellings", "romance", "science-fiction", "steampunk", "teen", "urban-fantasy", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](21787, ["20th-century", "action", "adult", "adult-fiction", "adventure", "children-s", "childrens", "classics", "comedy", "fairy-tales", "fantasy", "fiction", "funny", "high-fantasy", "historical", "historical-fiction", "historical-romance", "humor", "literature", "love", "magic", "movies", "novels", "pirates", "romance", "science-fiction-fantasy", "young-adult"], 1973, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17470674, ["20th-century", "adult", "adult-fiction", "american", "banned-books", "books-about-books", "classic-literature", "classics", "dystopia", "fantasy", "fiction", "futuristic", "high-school", "literary-fiction", "literature", "modern-classics", "novels", "philosophy", "politics", "read-for-school", "school", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "young-adult"], 1953, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15823480, ["19th-century", "adult", "adult-fiction", "classic-literature", "classics", "drama", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "love", "novels", "romance", "russia", "russian-literature", "school"], 1877, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](320, ["20th-century", "adult", "adult-fiction", "classic-literature", "classics", "contemporary", "drama", "family", "fantasy", "fiction", "historical", "historical-fiction", "latin-american", "latin-american-literature", "literary-fiction", "literature", "magical-realism", "modern-classics", "novels", "romance", "school", "spanish-literature"], 1967, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7624, ["20th-century", "adult", "adult-fiction", "adventure", "banned-books", "british-literature", "childrens", "classic-literature", "classics", "coming-of-age", "contemporary", "dark", "drama", "dystopia", "english-literature", "fantasy", "fiction", "high-school", "historical-fiction", "horror", "literary-fiction", "literature", "modern-classics", "novels", "philosophy", "psychology", "read-for-school", "realistic-fiction", "school", "science-fiction", "survival", "teen", "thriller", "young-adult"], 1954, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1953, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "drama", "english-literature", "fiction", "france", "french-revolution", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "read-for-school", "romance", "school", "victorian", "war", "young-adult"], 1859, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6186357, ["action", "adventure", "apocalyptic", "dystopia", "fantasy", "fiction", "futuristic", "mystery", "novels", "post-apocalyptic", "romance", "science-fiction", "survival", "suspense", "teen", "thriller", "young-adult"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4374400, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "death", "drama", "family", "fantasy", "fiction", "high-school", "love", "music", "new-adult", "novels", "paranormal", "realistic-fiction", "romance", "teen", "tragedy", "young-adult"], 2009, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7171637, ["action", "adventure", "angels", "demons", "fantasy", "fiction", "historical", "historical-fiction", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "science-fiction", "steampunk", "supernatural", "teen", "urban-fantasy", "vampires", "victorian", "werewolves", "young-adult"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7126, ["19th-century", "adult", "adult-fiction", "adventure", "classic-literature", "classics", "crime", "drama", "epic", "fantasy", "fiction", "france", "french-literature", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "mystery", "novels", "read-for-school", "romance", "school", "thriller"], 1844, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1934, ["19th-century", "adult", "adult-fiction", "american", "chick-lit", "children-s", "childrens", "civil-war", "classic-literature", "classics", "coming-of-age", "drama", "family", "fiction", "historical", "historical-fiction", "history", "juvenile", "literary-fiction", "literature", "middle-grade", "novels", "realistic-fiction", "romance", "school", "teen", "young-adult"], 1868, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14935, ["19th-century", "adult", "adult-fiction", "british-literature", "chick-lit", "classic-literature", "classics", "drama", "english-literature", "family", "fiction", "historical", "historical-fiction", "historical-romance", "history", "literary-fiction", "literature", "love", "novels", "regency", "romance", "romantic", "school", "victorian"], 1811, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9418327, ["adult", "american", "autobiography", "biography", "biography-memoir", "chick-lit", "comedy", "contemporary", "essays", "feminism", "fiction", "funny", "humor", "memoir", "non-fiction", "pop-culture"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](332613, ["20th-century", "adult", "adult-fiction", "american", "banned-books", "classic-literature", "classics", "contemporary", "drama", "fiction", "high-school", "historical-fiction", "humor", "literary-fiction", "literature", "medical", "mental-health", "mental-illness", "modern", "modern-classics", "movies", "novels", "psychology", "read-for-school", "realistic-fiction", "school"], 1962, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2187, ["21st-century", "adult", "adult-fiction", "american", "classics", "coming-of-age", "contemporary", "drama", "family", "fiction", "gender", "glbt", "greece", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "queer", "realistic-fiction", "sexuality"], 2002, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20910157, ["adult", "american", "autobiography", "biography", "biography-memoir", "chick-lit", "comedy", "contemporary", "essays", "feminism", "funny", "humor", "memoir", "non-fiction", "pop-culture"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8664353, ["adult", "adventure", "american", "american-history", "asia", "autobiography", "biography", "biography-memoir", "christian", "fiction", "historical", "historical-fiction", "history", "inspirational", "japan", "memoir", "military", "military-history", "non-fiction", "sports", "survival", "true-story", "war", "world-war-ii"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](37435, ["adult", "adult-fiction", "african-american", "american", "chick-lit", "classics", "coming-of-age", "contemporary", "drama", "family", "feminism", "fiction", "high-school", "historical", "historical-fiction", "literary-fiction", "literature", "movies", "novels", "race", "read-for-school", "realistic-fiction", "romance", "school", "southern", "young-adult"], 2001, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17245, ["19th-century", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "dark", "english-literature", "fantasy", "fiction", "gothic", "gothic-horror", "historical", "historical-fiction", "horror", "literature", "mystery", "novels", "paranormal", "read-for-school", "romance", "school", "science-fiction", "supernatural", "suspense", "thriller", "vampires", "victorian"], 1897, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7144, ["19th-century", "adult", "adult-fiction", "classic-literature", "classics", "crime", "drama", "fiction", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "mystery", "novels", "philosophy", "psychology", "read-for-school", "russia", "russian-literature", "school"], 1866, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7896527, ["action", "adventure", "demons", "dystopia", "epic-fantasy", "fae", "fantasy", "fiction", "high-fantasy", "love", "magic", "mystery", "paranormal", "romance", "supernatural", "teen", "young-adult", "young-adult-fantasy"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18135, ["16th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "death", "drama", "english-literature", "fiction", "high-school", "historical", "historical-fiction", "historical-romance", "history", "italy", "literary-fiction", "literature", "love", "movies", "novels", "plays", "poetry", "read-for-school", "romance", "romantic", "school", "theatre", "tragedy", "young-adult"], 1595, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](119322, ["20th-century", "adventure", "animals", "banned-books", "children-s", "childrens", "classics", "coming-of-age", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "juvenile", "literature", "magic", "middle-grade", "mystery", "novels", "paranormal", "religion", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "steampunk", "supernatural", "teen", "urban-fantasy", "young-adult", "young-adult-fantasy"], 1995, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16101128, ["action", "adventure", "aliens", "apocalyptic", "dystopia", "fantasy", "fiction", "horror", "mystery", "paranormal", "post-apocalyptic", "romance", "science-fiction", "survival", "suspense", "teen", "thriller", "war", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](186074, ["adult", "adult-fiction", "adventure", "coming-of-age", "dragons", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "novels", "romance", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](345627, ["action", "adventure", "boarding-school", "contemporary", "fantasy", "fiction", "high-school", "horror", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "young-adult"], 2007, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8490112, ["action", "adventure", "angels", "contemporary", "demons", "dystopia", "fantasy", "fiction", "love", "magic", "mystery", "mythology", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "war", "young-adult", "young-adult-fantasy"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12262741, ["adult", "adventure", "american", "autobiography", "biography", "biography-memoir", "chick-lit", "contemporary", "family", "feminism", "fiction", "inspirational", "memoir", "nature", "non-fiction", "outdoors", "survival", "travel", "wilderness"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](100915, ["20th-century", "adventure", "animals", "children-s", "childrens", "christian", "christian-fiction", "christianity", "classic-literature", "classics", "epic-fantasy", "family", "fantasy", "fiction", "high-fantasy", "juvenile", "literature", "magic", "middle-grade", "novels", "read-for-school", "religion", "school", "science-fiction", "science-fiction-fantasy", "teen", "young-adult"], 1950, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4137, ["adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "comedy", "contemporary", "essays", "family", "fiction", "france", "funny", "gay", "glbt", "humor", "literature", "memoir", "non-fiction", "novels", "queer", "short-stories"], 2000, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](237209, ["adult", "adult-fiction", "contemporary", "crime", "dark", "detective", "fiction", "horror", "ireland", "murder-mystery", "mystery", "mystery-thriller", "novels", "psychological-thriller", "suspense", "thriller"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18007564, ["action", "adult", "adult-fiction", "adventure", "american", "contemporary", "drama", "fantasy", "fiction", "funny", "humor", "movies", "novels", "science", "science-fiction", "science-fiction-fantasy", "space", "speculative-fiction", "survival", "suspense", "thriller"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](49750, ["adventure", "comedy", "coming-of-age", "contemporary", "fiction", "funny", "high-school", "humor", "love", "novels", "realistic-fiction", "relationships", "road-trip", "romance", "teen", "young-adult"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10335308, ["adult", "american", "autobiography", "biography", "biography-memoir", "chick-lit", "comedy", "contemporary", "essays", "feminism", "funny", "humor", "memoir", "non-fiction", "pop-culture"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16160797, ["21st-century", "adult", "adult-fiction", "contemporary", "crime", "detective", "fiction", "murder-mystery", "mystery", "mystery-thriller", "novels", "realistic-fiction", "suspense", "thriller"], 2013, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6969, ["19th-century", "adult", "adult-fiction", "british-literature", "chick-lit", "classic-literature", "classics", "drama", "english-literature", "fiction", "historical", "historical-fiction", "historical-romance", "history", "humor", "literary-fiction", "literature", "love", "novels", "regency", "romance", "romantic", "school", "victorian"], 1815, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1381, ["adult", "adult-fiction", "adventure", "ancient", "ancient-history", "classic-literature", "classics", "college", "drama", "epic", "epic-poetry", "fantasy", "fiction", "greece", "greek-mythology", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "mythology", "non-fiction", "novels", "philosophy", "plays", "poetry", "read-for-school", "school", "travel", "war"], -800, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](234225, ["20th-century", "adult", "adult-fiction", "adventure", "american", "classics", "dystopia", "epic", "fantasy", "fiction", "literature", "novels", "philosophy", "politics", "religion", "science", "science-fiction", "science-fiction-fantasy", "space", "space-opera", "speculative-fiction", "war"], 1965, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9969571, ["action", "adult", "adult-fiction", "adventure", "coming-of-age", "contemporary", "cyberpunk", "dystopia", "fantasy", "fiction", "futuristic", "games", "gaming", "humor", "mystery", "novels", "pop-culture", "post-apocalyptic", "romance", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "technology", "teen", "thriller", "video-games", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2623, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "coming-of-age", "drama", "english-literature", "fiction", "high-school", "historical", "historical-fiction", "literary-fiction", "literature", "novels", "read-for-school", "romance", "school", "victorian", "young-adult"], 1860, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2213661, ["adventure", "children-s", "childrens", "coming-of-age", "contemporary", "dark", "dark-fantasy", "death", "family", "fantasy", "fiction", "ghost-stories", "ghosts", "gothic", "horror", "juvenile", "magic", "magical-realism", "middle-grade", "mystery", "novels", "paranormal", "science-fiction", "science-fiction-fantasy", "supernatural", "teen", "urban-fantasy", "vampires", "young-adult"], 2008, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14891, ["20th-century", "adult", "adult-fiction", "american", "childrens", "classic-literature", "classics", "coming-of-age", "contemporary", "drama", "family", "fiction", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "memoir", "modern-classics", "new-york", "novels", "poverty", "read-for-school", "realistic-fiction", "school", "teen", "young-adult"], 1943, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2156, ["19th-century", "adult", "adult-fiction", "british-literature", "chick-lit", "classic-literature", "classics", "drama", "english-literature", "fiction", "historical", "historical-fiction", "historical-romance", "history", "literary-fiction", "literature", "love", "novels", "regency", "romance", "romantic", "school", "victorian"], 1817, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2998, ["20th-century", "adventure", "british-literature", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "coming-of-age", "family", "fantasy", "fiction", "historical", "historical-fiction", "juvenile", "literature", "middle-grade", "mystery", "novels", "realistic-fiction", "school", "young-adult"], 1911, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8235178, ["adventure", "dystopia", "fantasy", "fiction", "futuristic", "love", "mystery", "paranormal", "post-apocalyptic", "romance", "science-fiction", "space", "teen", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2165, ["20th-century", "adult", "adult-fiction", "adventure", "american", "american-classics", "classic-literature", "classics", "drama", "fiction", "high-school", "historical-fiction", "literary-fiction", "literature", "modern-classics", "novella", "novels", "read-for-school", "realistic-fiction", "school", "short-stories", "young-adult"], 1952, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5043, ["12th-century", "20th-century", "adult", "adult-fiction", "adventure", "architecture", "british-literature", "classics", "contemporary", "drama", "epic", "fantasy", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "medieval", "middle-ages", "mystery", "novels", "religion", "romance", "suspense", "thriller"], 1989, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4268157, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "crime", "drama", "family", "fiction", "high-school", "love", "new-adult", "realistic-fiction", "romance", "romantic", "school", "teen", "young-adult", "young-adult-romance"], 2008, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](49552, ["20th-century", "adult", "adult-fiction", "africa", "classic-literature", "classics", "college", "contemporary", "crime", "drama", "fiction", "france", "french-literature", "high-school", "literary-fiction", "literature", "modern", "modern-classics", "novella", "novels", "philosophy", "psychology", "read-for-school", "roman", "school"], 1942, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6567017, ["coming-of-age", "contemporary", "fiction", "funny", "gay", "glbt", "high-school", "humor", "love", "novels", "queer", "realistic-fiction", "relationships", "romance", "school", "teen", "young-adult"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](248704, ["21st-century", "american", "coming-of-age", "contemporary", "drama", "fiction", "funny", "high-school", "humor", "love", "mental-health", "mental-illness", "movies", "new-york", "novels", "psychology", "realistic-fiction", "romance", "teen", "young-adult"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17675462, ["adventure", "contemporary", "fantasy", "fiction", "ghosts", "high-school", "magic", "magical-realism", "mystery", "mythology", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "witches", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4934, ["19th-century", "adult", "adult-fiction", "christianity", "classic-literature", "classics", "crime", "drama", "family", "fiction", "historical", "historical-fiction", "literary-fiction", "literature", "mystery", "novels", "philosophy", "psychology", "religion", "romance", "russia", "russian-literature", "school"], 1880, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](830502, ["20th-century", "adult", "adult-fiction", "american", "classics", "coming-of-age", "contemporary", "dark", "fantasy", "fiction", "horror", "movies", "mystery", "mystery-thriller", "novels", "paranormal", "science-fiction", "supernatural", "suspense", "thriller"], 1986, "English (United Kingdom)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10917, ["adult", "adult-fiction", "chick-lit", "coming-of-age", "contemporary", "death", "drama", "family", "fiction", "high-school", "illness", "literary-fiction", "literature", "medical", "movies", "novels", "realistic-fiction", "relationships", "romance", "womens-fiction", "young-adult"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8667848, ["adult", "adult-fiction", "adventure", "alchemy", "books-about-books", "chick-lit", "contemporary", "demons", "fantasy", "fiction", "ghosts", "historical", "historical-fiction", "history", "horror", "magic", "magical-realism", "mystery", "novels", "paranormal", "paranormal-romance", "romance", "science-fiction", "supernatural", "time-travel", "urban-fantasy", "vampires", "witchcraft", "witches", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15839976, ["action", "adult", "adult-fiction", "adventure", "dystopia", "fantasy", "fiction", "futuristic", "mythology", "novels", "romance", "science-fiction", "science-fiction-fantasy", "space", "space-opera", "speculative-fiction", "teen", "thriller", "war", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](764347, ["action", "adventure", "coming-of-age", "dark", "death", "dystopia", "fantasy", "fiction", "futuristic", "horror", "mystery", "post-apocalyptic", "romance", "school", "science-fiction", "speculative-fiction", "survival", "suspense", "teen", "thriller", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4069, ["20th-century", "adult", "autobiography", "biography", "biography-memoir", "business", "classics", "faith", "fiction", "germany", "historical", "history", "holocaust", "inspirational", "jewish", "leadership", "literature", "memoir", "mental-health", "non-fiction", "personal-development", "philosophy", "psychology", "religion", "school", "science", "self-help", "sociology", "spirituality", "theology", "war", "world-war-ii"], 1946, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10534, ["adult", "ancient", "asia", "business", "china", "chinese-literature", "classic-literature", "classics", "eastern-philosophy", "fiction", "historical", "history", "leadership", "literature", "management", "military", "military-history", "non-fiction", "novels", "personal-development", "philosophy", "political-science", "politics", "psychology", "reference", "research", "science", "self-help", "war"], -450, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](136251, ["adventure", "children-s", "childrens", "classics", "coming-of-age", "contemporary", "dragons", "fantasy", "fiction", "juvenile", "magic", "middle-grade", "mystery", "novels", "paranormal", "romance", "science-fiction-fantasy", "supernatural", "teen", "urban-fantasy", "witches", "wizards", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](26247008, ["adult", "adult-fiction", "australia", "chick-lit", "contemporary", "drama", "family", "fiction", "literary-fiction", "marriage", "mystery", "mystery-thriller", "novels", "realistic-fiction", "romance", "suspense", "thriller", "womens-fiction"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23437156, ["action", "adventure", "crime", "dark", "fantasy", "fiction", "high-fantasy", "magic", "mystery", "paranormal", "romance", "teen", "thriller", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](39999, ["adult", "children-s", "childrens", "classics", "contemporary", "drama", "family", "fiction", "germany", "historical", "historical-fiction", "history", "holocaust", "jewish", "juvenile", "literature", "middle-grade", "movies", "novels", "poland", "read-for-school", "realistic-fiction", "school", "teen", "war", "world-war-ii", "young-adult"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16096824, ["action", "adult", "adventure", "beauty-and-the-beast", "fae", "fairies", "fairy-tale-retellings", "fairy-tales", "fantasy", "fantasy-romance", "fiction", "high-fantasy", "love", "magic", "new-adult", "paranormal", "paranormal-romance", "retellings", "romance", "supernatural", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](439288, ["abuse", "adult", "banned-books", "classics", "coming-of-age", "contemporary", "dark", "drama", "feminism", "fiction", "high-school", "mental-health", "mental-illness", "novels", "psychology", "read-for-school", "realistic-fiction", "school", "social-issues", "teen", "young-adult"], 1999, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](370493, ["20th-century", "children-s", "childrens", "classics", "fantasy", "fiction", "inspirational", "juvenile", "literature", "love", "nature", "philosophy", "picture-books", "poetry", "school", "short-stories", "young-adult", "young-readers"], 1964, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5139, ["adult", "adult-fiction", "american", "chick-lit", "classics", "comedy", "contemporary", "contemporary-romance", "drama", "fiction", "funny", "humor", "literature", "modern", "movies", "new-york", "novels", "realistic-fiction", "romance", "womens-fiction", "young-adult"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2865, ["17th-century", "20th-century", "adult", "adult-fiction", "american", "art", "art-history", "chick-lit", "classics", "coming-of-age", "contemporary", "drama", "fiction", "high-school", "historical", "historical-fiction", "historical-romance", "history", "holland", "literary-fiction", "literature", "movies", "novels", "read-for-school", "romance", "school", "young-adult"], 1999, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3876, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "banned-books", "classic-literature", "classics", "college", "drama", "fiction", "france", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "modern-classics", "novels", "read-for-school", "romance", "school", "spain", "travel", "war"], 1926, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16793, ["20th-century", "adult", "adult-fiction", "adventure", "classics", "comics", "coming-of-age", "contemporary", "fairy-tales", "fantasy", "fiction", "graphic-novels", "high-fantasy", "historical", "humor", "love", "magic", "magical-realism", "movies", "novels", "paranormal", "romance", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "supernatural", "urban-fantasy", "witches", "young-adult"], 1999, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16056408, ["abuse", "adult", "chick-lit", "college", "contemporary", "contemporary-romance", "drama", "fiction", "love", "love-story", "new-adult", "realistic-fiction", "romance", "romantic", "teen", "young-adult", "young-adult-romance"], 2012, "English (Canada)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22055262, ["adult", "adult-fiction", "adventure", "alternate-history", "fantasy", "fiction", "high-fantasy", "historical", "historical-fantasy", "historical-fiction", "magic", "novels", "paranormal", "romance", "science-fiction", "supernatural", "time-travel", "urban-fantasy", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2203, ["18th-century", "adult", "american", "american-history", "autobiography", "biography", "biography-memoir", "government", "historical", "historical-fiction", "history", "leadership", "non-fiction", "politics", "presidents", "united-states", "us-presidents", "war"], 2001, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9717, ["20th-century", "adult", "adult-fiction", "classic-literature", "classics", "contemporary", "czech-literature", "drama", "european-literature", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "love", "modern", "modern-classics", "novels", "philosophy", "roman", "romance", "school"], 1984, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8909152, ["adult", "adult-fiction", "chick-lit", "comedy", "contemporary", "contemporary-romance", "fiction", "funny", "humor", "love", "new-adult", "novels", "realistic-fiction", "romance", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](46170, ["20th-century", "adult", "adult-fiction", "adventure", "american", "american-classics", "american-fiction", "banned-books", "classic-literature", "classics", "drama", "fiction", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "military", "modern-classics", "novels", "romance", "school", "spain", "war"], 1940, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](149267, ["20th-century", "adult", "adult-fiction", "adventure", "american", "apocalyptic", "classics", "contemporary", "dark", "dystopia", "epic", "fantasy", "fiction", "horror", "literature", "mystery", "mystery-thriller", "novels", "paranormal", "post-apocalyptic", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "supernatural", "survival", "suspense", "thriller", "urban-fantasy"], 1978, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1, ["adventure", "children-s", "childrens", "classics", "coming-of-age", "contemporary", "fantasy", "fiction", "juvenile", "magic", "middle-grade", "mystery", "novels", "paranormal", "romance", "science-fiction-fantasy", "supernatural", "teen", "urban-fantasy", "witches", "wizards", "young-adult"], 2005, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10664113, ["action", "adult", "adult-fiction", "adventure", "american", "contemporary", "dark-fantasy", "dragons", "drama", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical-fiction", "magic", "medieval", "novels", "politics", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12294652, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "funny", "high-school", "love", "new-adult", "realistic-fiction", "romance", "teen", "young-adult", "young-adult-romance"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2767, ["20th-century", "academic", "activism", "adult", "american", "american-history", "americana", "classics", "economics", "education", "high-school", "historical", "history", "non-fiction", "philosophy", "political-science", "politics", "race", "read-for-school", "reference", "school", "science", "social", "social-justice", "social-science", "society", "sociology", "teaching", "united-states", "war"], 1980, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](135479, ["20th-century", "adult", "adult-fiction", "american", "apocalyptic", "banned-books", "classic-literature", "classics", "comedy", "contemporary", "dystopia", "fantasy", "fiction", "funny", "high-school", "humor", "literary-fiction", "literature", "modern-classics", "novels", "philosophy", "post-apocalyptic", "religion", "school", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction"], 1963, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5526, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "fiction", "love", "love-story", "military", "movies", "novels", "realistic-fiction", "relationships", "romance", "romantic", "war", "young-adult"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17212231, ["action", "adult", "adult-fiction", "adventure", "american", "art", "contemporary", "crime", "detective", "drama", "fantasy", "fiction", "historical", "historical-fiction", "history", "italy", "literature", "mystery", "mystery-thriller", "novels", "religion", "science-fiction", "suspense", "thriller"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10357575, ["21st-century", "adult", "adult-fiction", "asia", "asian-literature", "classics", "contemporary", "cultural", "dystopia", "fantasy", "fiction", "japan", "japanese-literature", "literary-fiction", "literature", "magical-realism", "mystery", "novels", "romance", "science-fiction", "speculative-fiction"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18692431, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "high-school", "illness", "love", "mental-health", "mental-illness", "realistic-fiction", "romance", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8755776, ["action", "adventure", "angels", "contemporary", "demons", "fae", "fairies", "fantasy", "fiction", "love", "magic", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "witches", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24800, ["21st-century", "adult", "adult-fiction", "american", "books-about-books", "classics", "contemporary", "dark", "fantasy", "fiction", "gothic", "halloween", "horror", "literary-fiction", "literature", "magical-realism", "mystery", "mystery-thriller", "novels", "paranormal", "science-fiction", "speculative-fiction", "supernatural", "surreal", "suspense", "thriller"], 2000, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24583, ["19th-century", "adult", "adventure", "american", "american-classics", "americana", "banned-books", "children-s", "childrens", "classic-literature", "classics", "coming-of-age", "fiction", "high-school", "historical", "historical-fiction", "history", "humor", "juvenile", "literary-fiction", "literature", "middle-grade", "novels", "read-for-school", "realistic-fiction", "school", "southern", "young-adult"], 1876, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](70401, ["20th-century", "adult", "adult-fiction", "adventure", "american", "american-classics", "americana", "autobiography", "biography", "classic-literature", "classics", "contemporary", "fiction", "literary-fiction", "literature", "memoir", "modern", "modern-classics", "non-fiction", "novels", "philosophy", "poetry", "road-trip", "school", "travel"], 1957, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12000020, ["coming-of-age", "contemporary", "family", "fiction", "gay", "glbt", "high-school", "historical-fiction", "love", "m-m-romance", "novels", "queer", "realistic-fiction", "romance", "teen", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](25494343, ["action", "adventure", "angels", "contemporary", "demons", "fae", "fairies", "fantasy", "fiction", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3836, ["17th-century", "adult", "adult-fiction", "adventure", "classic-literature", "classics", "college", "comedy", "fantasy", "fiction", "high-school", "historical", "historical-fiction", "history", "humor", "literary-fiction", "literature", "novels", "read-for-school", "romance", "school", "spain", "spanish-literature"], 1605, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2493, ["19th-century", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "dystopia", "english-literature", "fantasy", "fiction", "historical", "historical-fiction", "horror", "literature", "novella", "novels", "post-apocalyptic", "read-for-school", "school", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "steampunk", "time-travel", "travel", "victorian", "young-adult"], 1895, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1582996, ["action", "adventure", "angels", "contemporary", "demons", "fae", "fairies", "fantasy", "fiction", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "witches", "young-adult", "young-adult-fantasy"], 2008, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18774964, ["adult", "adult-fiction", "comedy", "contemporary", "death", "drama", "family", "fiction", "funny", "humor", "literary-fiction", "literature", "novels", "realistic-fiction", "relationships", "sweden"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](29579, ["20th-century", "adult", "adventure", "american", "classics", "dystopia", "epic", "fantasy", "fiction", "literature", "novels", "philosophy", "planets", "politics", "science", "science-fiction", "science-fiction-fantasy", "short-stories", "space", "space-opera", "speculative-fiction"], 1951, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](242006, ["abuse", "adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "comedy", "coming-of-age", "contemporary", "drama", "family", "fiction", "funny", "gay", "glbt", "humor", "literature", "memoir", "mental-health", "mental-illness", "non-fiction", "novels", "psychology", "queer", "young-adult"], 2002, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](27774758, ["action", "adventure", "dark", "dystopia", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "love", "magic", "paranormal", "romance", "science-fiction", "supernatural", "teen", "war", "young-adult", "young-adult-fantasy"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20448515, ["abuse", "adult", "adult-fiction", "bdsm", "chick-lit", "contemporary", "contemporary-romance", "dark", "drama", "erotic-romance", "erotica", "fiction", "love", "new-adult", "romance", "romantic"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](42899, ["action", "adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "dark", "erotic-romance", "erotica", "fantasy", "fantasy-romance", "fiction", "horror", "new-adult", "paranormal", "paranormal-romance", "romance", "supernatural", "suspense", "urban-fantasy", "vampires"], 2005, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9378297, ["action", "contemporary", "dark", "death", "demons", "fantasy", "fiction", "ghost-stories", "ghosts", "gothic", "high-school", "horror", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "suspense", "teen", "thriller", "urban-fantasy", "witches", "young-adult"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14743, ["21st-century", "adult", "atheism", "biology", "christianity", "contemporary", "evolution", "fiction", "god", "history", "non-fiction", "philosophy", "politics", "popular-science", "psychology", "reference", "religion", "science", "skepticism", "social-science", "society", "sociology", "spirituality", "theology"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15818107, ["adoption", "adult", "adult-fiction", "coming-of-age", "contemporary", "drama", "family", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "realistic-fiction", "relationships", "survival", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](30268522, ["adult", "american", "autobiography", "biography", "biography-memoir", "chick-lit", "comedy", "contemporary", "essays", "feminism", "funny", "humor", "memoir", "non-fiction"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](366522, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "death", "drama", "family", "fiction", "humor", "ireland", "love", "love-story", "modern", "movies", "novels", "realistic-fiction", "romance", "romantic", "womens-fiction", "young-adult"], 2003, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13023, ["19th-century", "adventure", "british-literature", "children-s", "childrens", "classic-literature", "classics", "english-literature", "fairy-tales", "fantasy", "fiction", "humor", "juvenile", "literature", "magic", "middle-grade", "movies", "novels", "school", "victorian", "young-adult"], 1865, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8683812, ["20th-century", "adult", "adult-fiction", "american", "biography", "chick-lit", "contemporary", "drama", "fiction", "france", "historical", "historical-fiction", "history", "literary-fiction", "literature", "love", "love-story", "marriage", "memoir", "non-fiction", "novels", "relationships", "romance", "travel"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6424171, ["20th-century", "action", "adult", "adult-fiction", "adventure", "american", "animals", "classics", "contemporary", "dinosaurs", "fantasy", "fiction", "high-school", "horror", "literature", "modern", "movies", "mystery", "mystery-thriller", "novels", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "survival", "suspense", "thriller", "young-adult"], 1991, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13497, ["action", "adult", "adult-fiction", "adventure", "american", "contemporary", "dark-fantasy", "dragons", "drama", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "magic", "medieval", "novels", "politics", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war"], 2005, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6752378, ["action", "adventure", "angels", "contemporary", "demons", "fae", "fairies", "fantasy", "fiction", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "shapeshifters", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "witches", "young-adult"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](26114135, ["abuse", "adult", "adult-fiction", "coming-of-age", "contemporary", "contemporary-romance", "crime", "dark", "drama", "family", "fiction", "literary-fiction", "love", "new-adult", "novels", "realistic-fiction", "romance", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18254, ["19th-century", "adult", "adult-fiction", "adventure", "british-literature", "children-s", "childrens", "classic-literature", "classics", "coming-of-age", "crime", "drama", "english-literature", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "read-for-school", "school", "victorian", "young-adult"], 1838, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10883, ["18th-century", "american", "american-history", "autobiography", "biography", "biography-memoir", "business", "classics", "france", "historical", "history", "leadership", "memoir", "non-fiction", "philosophy", "politics", "science", "war"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1420, ["17th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "college", "death", "denmark", "drama", "english-literature", "fantasy", "fiction", "ghosts", "high-school", "historical", "historical-fiction", "literature", "novels", "plays", "poetry", "read-for-school", "romance", "school", "theatre", "tragedy"], 1600, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1103, ["19th-century", "21st-century", "adult", "adult-fiction", "asia", "asian-literature", "chick-lit", "china", "coming-of-age", "contemporary", "cultural", "drama", "family", "fiction", "historical", "historical-fiction", "history", "international", "literary-fiction", "literature", "novels", "relationships", "romance", "school", "young-adult"], 2005, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6900, ["20th-century", "adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "classics", "contemporary", "death", "drama", "fiction", "high-school", "inspirational", "literature", "memoir", "non-fiction", "novels", "personal-development", "philosophy", "psychology", "read-for-school", "realistic-fiction", "relationships", "religion", "school", "self-help", "spirituality", "young-adult"], 1997, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](34324605, ["abuse", "adult", "adult-fiction", "art", "chick-lit", "contemporary", "contemporary-romance", "death", "drama", "fiction", "love", "new-adult", "novels", "realistic-fiction", "romance", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1812457, ["adult", "adult-fiction", "christian", "christian-fiction", "christianity", "contemporary", "drama", "faith", "family", "fantasy", "fiction", "god", "inspirational", "literature", "mystery", "non-fiction", "novels", "philosophy", "religion", "self-help", "spirituality", "suspense", "theology"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](76620, ["20th-century", "adult", "adult-fiction", "adventure", "animal-fiction", "animals", "british-literature", "children-s", "childrens", "classic-literature", "classics", "fantasy", "fiction", "high-school", "literary-fiction", "literature", "middle-grade", "modern-classics", "nature", "novels", "rabbits", "school", "speculative-fiction", "survival", "young-adult"], 1972, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17571564, ["adult", "american", "animals", "art", "autobiography", "biography", "biography-memoir", "comedy", "comics", "contemporary", "dogs", "essays", "fiction", "funny", "graphic-novels", "graphic-novels-comics", "humor", "memoir", "mental-health", "mental-illness", "non-fiction", "psychology", "short-stories"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3950967, ["21st-century", "adventure", "british-literature", "children-s", "childrens", "classics", "fairy-tales", "fantasy", "fiction", "juvenile", "magic", "middle-grade", "novels", "paranormal", "short-stories", "supernatural", "teen", "witches", "wizards", "young-adult"], 2007, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8127, ["20th-century", "canada", "canadian-literature", "chick-lit", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "coming-of-age", "family", "fiction", "historical", "historical-fiction", "juvenile", "literature", "middle-grade", "novels", "realistic-fiction", "romance", "school", "teen", "young-adult"], 1908, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15717943, ["abuse", "adult", "chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "dark", "drama", "fiction", "high-school", "love", "mystery", "new-adult", "realistic-fiction", "romance", "teen", "young-adult", "young-adult-romance"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1845, ["20th-century", "adult", "adventure", "american", "autobiography", "biography", "biography-memoir", "classics", "coming-of-age", "contemporary", "death", "drama", "environment", "fiction", "high-school", "history", "inspirational", "journalism", "literature", "memoir", "movies", "nature", "non-fiction", "novels", "outdoors", "philosophy", "read-for-school", "school", "survival", "travel", "true-story", "wilderness", "young-adult"], 1996, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4929, ["21st-century", "adult", "adult-fiction", "adventure", "asia", "asian-literature", "cats", "classics", "coming-of-age", "contemporary", "drama", "fantasy", "fiction", "japan", "japanese-literature", "literary-fiction", "literature", "magical-realism", "modern", "mystery", "novels", "philosophy", "romance", "speculative-fiction", "surreal"], 2002, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](556602, ["adult", "adult-fiction", "chick-lit", "contemporary", "cultural", "death", "drama", "family", "fiction", "france", "historical", "historical-fiction", "history", "holocaust", "jewish", "literary-fiction", "literature", "mystery", "novels", "realistic-fiction", "roman", "school", "tragedy", "war", "world-war-ii", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](19543, ["20th-century", "adventure", "american", "animals", "art", "children-s", "childrens", "classics", "family", "fantasy", "fiction", "humor", "juvenile", "picture-books", "school", "storytime", "young-adult"], 1963, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](51496, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "crime", "dark", "english-literature", "fantasy", "fiction", "gothic", "gothic-horror", "high-school", "historical", "historical-fiction", "horror", "literary-fiction", "literature", "mystery", "mystery-thriller", "novella", "novels", "paranormal", "psychology", "read-for-school", "school", "science-fiction", "short-stories", "supernatural", "suspense", "thriller", "victorian"], 1886, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](485894, ["20th-century", "adult", "adult-fiction", "classic-literature", "classics", "college", "drama", "european-literature", "fantasy", "fiction", "german-literature", "germany", "high-school", "horror", "literary-fiction", "literature", "magical-realism", "modern-classics", "novella", "novels", "philosophy", "read-for-school", "school", "science-fiction", "short-stories", "surreal"], 1912, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17383917, ["20th-century", "adult", "adult-fiction", "british-literature", "catholic", "christian", "christian-fiction", "christian-non-fiction", "christianity", "church", "classic-literature", "classics", "faith", "fantasy", "fiction", "humor", "inspirational", "literary-fiction", "literature", "non-fiction", "novels", "philosophy", "religion", "school", "spirituality", "supernatural", "theology"], 1942, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13099738, ["adult", "art", "art-design", "business", "design", "education", "essays", "graphic-novels", "how-to", "humor", "inspirational", "non-fiction", "personal-development", "philosophy", "photography", "productivity", "psychology", "reference", "self-help", "writing"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6892870, ["action", "adult", "adult-fiction", "adventure", "contemporary", "crime", "detective", "drama", "fiction", "journalism", "literature", "murder-mystery", "mystery", "mystery-thriller", "nordic-noir", "novels", "realistic-fiction", "suspense", "sweden", "thriller"], 2007, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16071764, ["adult", "autobiography", "biography", "biography-memoir", "business", "contemporary", "entrepreneurship", "feminism", "gender", "gender-roles", "gender-studies", "inspirational", "leadership", "management", "memoir", "non-fiction", "personal-development", "politics", "psychology", "self-help", "sociology"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](62291, ["action", "adult", "adult-fiction", "adventure", "american", "contemporary", "dark-fantasy", "dragons", "drama", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "magic", "medieval", "novels", "politics", "romance", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "supernatural", "war"], 2000, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2122, ["20th-century", "adult", "adult-fiction", "american", "architecture", "business", "classic-literature", "classics", "contemporary", "drama", "dystopia", "economics", "fiction", "high-school", "historical-fiction", "literary-fiction", "literature", "modern-classics", "non-fiction", "novels", "philosophy", "politics", "romance", "school", "science-fiction"], 1943, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15796700, ["21st-century", "adult", "adult-fiction", "africa", "african-american", "african-literature", "american", "coming-of-age", "contemporary", "cultural", "feminism", "fiction", "historical-fiction", "international", "literary-fiction", "literature", "novels", "race", "realistic-fiction", "relationships", "romance", "social-justice"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7937843, ["abuse", "adult", "adult-fiction", "contemporary", "crime", "dark", "drama", "family", "fiction", "horror", "literary-fiction", "literature", "mental-health", "mystery", "novels", "psychology", "realistic-fiction", "survival", "suspense", "thriller", "young-adult"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6149, ["20th-century", "adult", "adult-fiction", "african-american", "african-american-literature", "american", "banned-books", "classic-literature", "classics", "college", "contemporary", "drama", "fantasy", "feminism", "fiction", "ghosts", "high-school", "historical", "historical-fiction", "history", "horror", "literary-fiction", "literature", "magical-realism", "modern-classics", "novels", "paranormal", "race", "read-for-school", "school", "southern", "supernatural"], 1987, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](28676, ["20th-century", "adult", "adult-fiction", "american", "banned-books", "classics", "contemporary", "crime", "dark", "drama", "fiction", "horror", "humor", "literary-fiction", "literature", "mental-illness", "modern", "modern-classics", "movies", "mystery", "mystery-thriller", "new-york", "novels", "psychology", "suspense", "thriller"], 1991, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10194514, ["abuse", "chick-lit", "contemporary", "contemporary-romance", "drama", "family", "fiction", "high-school", "love", "mental-illness", "mystery", "new-adult", "realistic-fiction", "romance", "teen", "young-adult", "young-adult-romance"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9791, ["20th-century", "adult", "adventure", "american", "autobiography", "biography", "biography-memoir", "comedy", "contemporary", "environment", "essays", "fiction", "funny", "history", "humor", "memoir", "nature", "non-fiction", "outdoors", "science", "travel", "travelogue", "walking", "wilderness"], 1997, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](50398, ["19th-century", "adult", "adult-fiction", "british-literature", "chick-lit", "classic-literature", "classics", "coming-of-age", "drama", "english-literature", "fiction", "gothic", "historical", "historical-fiction", "historical-romance", "history", "humor", "literary-fiction", "literature", "mystery", "novels", "read-for-school", "regency", "romance", "romantic", "school", "victorian"], 1817, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](480479, ["adult", "adult-fiction", "adventure", "autobiography", "biography", "biography-memoir", "chick-lit", "classics", "contemporary", "contemporary-romance", "cookbooks", "cooking", "cultural", "drama", "fiction", "food", "food-and-drink", "foodie", "humor", "italy", "literature", "memoir", "movies", "non-fiction", "novels", "romance", "travel", "travelogue"], 1996, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](27362503, ["abuse", "adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "dark", "drama", "family", "fiction", "love", "new-adult", "realistic-fiction", "romance", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](32145, ["adult", "anthropology", "biology", "comedy", "death", "essays", "fiction", "funny", "health", "history", "humor", "journalism", "medical", "medicine", "memoir", "microhistory", "non-fiction", "popular-science", "psychology", "reference", "research", "school", "science", "sociology"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17623975, ["adventure", "chick-lit", "college", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "france", "love", "new-adult", "realistic-fiction", "road-trip", "romance", "teen", "travel", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](236093, ["20th-century", "adventure", "american", "chapter-books", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "fairy-tales", "fantasy", "fiction", "juvenile", "literature", "magic", "middle-grade", "movies", "novels", "school", "witches", "young-adult"], 1900, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10799, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "american-fiction", "banned-books", "classic-literature", "classics", "college", "drama", "fiction", "high-school", "historical", "historical-fiction", "history", "italy", "literary-fiction", "literature", "military", "modern-classics", "novels", "read-for-school", "romance", "school", "war", "world-war-i"], 1929, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4900, ["19th-century", "20th-century", "adult", "adult-fiction", "adventure", "africa", "british-literature", "classic-literature", "classics", "college", "dark", "drama", "english-literature", "fiction", "high-school", "historical", "historical-fiction", "history", "horror", "literary-fiction", "literature", "novella", "novels", "philosophy", "read-for-school", "school", "travel", "victorian"], 1899, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14201, ["19th-century", "21st-century", "adult", "adult-fiction", "adventure", "alternate-history", "british-literature", "classics", "contemporary", "fairies", "fantasy", "fiction", "gothic", "historical", "historical-fantasy", "historical-fiction", "history", "literary-fiction", "literature", "magic", "magical-realism", "mystery", "novels", "paranormal", "regency", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "supernatural", "urban-fantasy", "victorian"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14748, ["adult", "adult-fiction", "chick-lit", "comedy", "contemporary", "contemporary-romance", "drama", "family", "fiction", "funny", "humor", "novels", "realistic-fiction", "relationships", "romance", "womens-fiction"], 2001, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13547180, ["adult", "american", "autobiography", "biography", "biography-memoir", "brain", "contemporary", "fiction", "health", "illness", "journalism", "medical", "medicine", "memoir", "mental-health", "mental-illness", "mystery", "neuroscience", "new-york", "non-fiction", "psychology", "science", "true-story"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18512, ["20th-century", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "literature", "magic", "modern-classics", "movies", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war", "wizards", "young-adult"], 1955, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3591262, ["adult", "adult-fiction", "africa", "coming-of-age", "contemporary", "cultural", "drama", "family", "fiction", "historical", "historical-fiction", "history", "india", "international", "literary-fiction", "literature", "medical", "medicine", "non-fiction", "novels", "realistic-fiction", "relationships"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3109, ["adult", "agriculture", "anthropology", "biology", "cookbooks", "cooking", "culinary", "ecology", "economics", "environment", "fitness", "food", "food-and-drink", "food-writing", "foodie", "health", "history", "journalism", "medical", "memoir", "nature", "non-fiction", "nutrition", "philosophy", "politics", "reference", "school", "science", "social", "social-issues", "social-science", "society", "sociology", "sustainability", "young-adult"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](33, ["20th-century", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "english-literature", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "literature", "magic", "modern-classics", "movies", "mythology", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war", "young-adult"], 1955, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23807, ["20th-century", "adult", "adult-fiction", "american", "classics", "contemporary", "crime", "dark", "detective", "drama", "fiction", "horror", "literature", "movies", "murder-mystery", "mystery", "mystery-thriller", "novels", "psychological-thriller", "psychology", "suspense", "thriller"], 1988, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7812659, ["abuse", "adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "family", "fiction", "love", "love-story", "movies", "mystery", "novels", "realistic-fiction", "relationships", "romance", "romantic", "suspense", "thriller", "young-adult"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2175, ["19th-century", "adult", "adult-fiction", "banned-books", "classic-literature", "classics", "college", "drama", "feminism", "fiction", "france", "french-literature", "high-school", "historical", "historical-fiction", "literary-fiction", "literature", "love", "novels", "read-for-school", "romance", "school", "victorian"], 1856, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17690, ["20th-century", "adult", "adult-fiction", "classic-literature", "classics", "crime", "czech-literature", "drama", "dystopia", "european-literature", "fantasy", "fiction", "german-literature", "germany", "horror", "law", "literary-fiction", "literature", "modern", "modern-classics", "mystery", "novels", "philosophy", "politics", "psychology", "read-for-school", "roman", "school", "science-fiction"], 1925, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](51737, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "death", "drama", "family", "fiction", "high-school", "love", "novels", "realistic-fiction", "romance", "romantic", "teen", "young-adult", "young-adult-romance"], 2004, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](114683, ["activism", "adult", "art", "art-design", "art-history", "biography", "contemporary", "design", "funny", "graffiti", "graphic-novels", "humor", "memoir", "modern", "non-fiction", "philosophy", "photography", "poetry", "politics", "pop-culture", "reference", "street-art", "visual-art"], 1988, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9742, ["adult", "african-american", "american", "american-history", "autobiography", "biography", "biography-memoir", "contemporary", "essays", "ethnic", "government", "historical", "history", "inspirational", "international", "leadership", "memoir", "non-fiction", "philosophy", "political-science", "politics", "presidents", "race", "science", "social"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15241, ["20th-century", "action", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "literature", "magic", "modern-classics", "movies", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war", "wizards", "young-adult"], 1954, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](45032, ["19th-century", "adult", "adult-fiction", "british-literature", "chick-lit", "classic-literature", "classics", "drama", "english-literature", "fiction", "historical", "historical-fiction", "historical-romance", "literary-fiction", "literature", "love", "novels", "regency", "romance", "romantic", "school", "victorian"], 1814, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](30597, ["19th-century", "adult", "adult-fiction", "adventure", "classic-literature", "classics", "drama", "fantasy", "fiction", "france", "french-literature", "gothic", "historical", "historical-fiction", "history", "horror", "literary-fiction", "literature", "love", "medieval", "movies", "novels", "romance", "school", "tragedy"], 1831, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](21032488, ["adult", "adult-fiction", "adventure", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "novels", "science-fiction", "science-fiction-fantasy"], null, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18798983, ["adventure", "fairy-tale-retellings", "fairy-tales", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "magic", "mystery", "mythology", "paranormal", "retellings", "romance", "teen", "young-adult", "young-adult-fantasy"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1067, ["18th-century", "adult", "american", "american-history", "biography", "classics", "fiction", "historical", "historical-fiction", "history", "military", "military-history", "non-fiction", "politics", "presidents", "school", "united-states", "war"], 2005, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](37415, ["20th-century", "adult", "adult-fiction", "african-american", "african-american-literature", "american", "banned-books", "classic-literature", "classics", "college", "contemporary", "cultural", "feminism", "fiction", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "love", "modern-classics", "novels", "race", "read-for-school", "realistic-fiction", "romance", "school", "southern", "young-adult"], 1937, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7869, ["20th-century", "action", "adult", "adult-fiction", "adventure", "american", "classics", "contemporary", "crime", "drama", "espionage", "fiction", "military", "movies", "mystery", "mystery-thriller", "novels", "spy-thriller", "suspense", "thriller"], 1980, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22463, ["19th-century", "academic", "adult", "animals", "anthropology", "banned-books", "biology", "classic-literature", "classics", "college", "ecology", "environment", "essays", "evolution", "fiction", "historical", "history", "history-of-science", "literature", "natural-history", "nature", "non-fiction", "philosophy", "popular-science", "read-for-school", "reference", "religion", "school", "science", "science-nature", "theory"], 1859, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](252577, ["20th-century", "adult", "adult-fiction", "autobiography", "biography", "biography-memoir", "classics", "coming-of-age", "contemporary", "cultural", "drama", "family", "fiction", "high-school", "historical", "historical-fiction", "history", "ireland", "irish-literature", "literature", "memoir", "non-fiction", "novels", "poverty", "read-for-school", "school", "true-story"], 1996, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](52529, ["adult", "business", "fiction", "inspirational", "metaphysics", "new-age", "non-fiction", "novels", "personal-development", "philosophy", "psychology", "reference", "religion", "self-help", "spirituality"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7728889, ["adventure", "crime", "fantasy", "fiction", "ghosts", "gothic", "historical", "historical-fantasy", "historical-fiction", "history", "horror", "magic", "magical-realism", "mystery", "mystery-thriller", "new-york", "paranormal", "romance", "science-fiction", "supernatural", "suspense", "teen", "thriller", "urban-fantasy", "young-adult"], 2012, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5326, ["19th-century", "adult", "adult-fiction", "british-literature", "children-s", "childrens", "christmas", "classic-literature", "classics", "drama", "english-literature", "fantasy", "fiction", "ghosts", "historical", "historical-fiction", "holiday", "literary-fiction", "literature", "novella", "novels", "paranormal", "read-for-school", "school", "short-stories", "supernatural", "time-travel", "victorian", "young-adult"], 1843, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](251688, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "chick-lit", "classic-literature", "classics", "contemporary", "drama", "fiction", "historical-fiction", "literary-fiction", "literature", "love", "modern", "modern-classics", "movies", "new-york", "novella", "novels", "romance", "short-stories"], 1958, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](350, ["20th-century", "adult", "adult-fiction", "aliens", "american", "classics", "dystopia", "fantasy", "fiction", "literature", "novels", "philosophy", "religion", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction"], 1961, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13206828, ["action", "adventure", "aliens", "dystopia", "fairy-tale-retellings", "fairy-tales", "fantasy", "fiction", "funny", "futuristic", "magic", "paranormal", "retellings", "romance", "science-fiction", "space", "steampunk", "teen", "urban-fantasy", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](30289, ["academic", "ancient", "ancient-history", "classic-literature", "classical-studies", "classics", "college", "education", "fiction", "greece", "historical", "history", "literature", "non-fiction", "philosophy", "political-science", "politics", "psychology", "read-for-school", "reference", "religion", "school", "science", "society", "sociology", "theory"], -380, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](295, ["19th-century", "action", "adventure", "british-literature", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "english-literature", "fantasy", "fiction", "historical", "historical-fiction", "history", "juvenile", "literary-fiction", "literature", "middle-grade", "novels", "pirates", "read-for-school", "school", "victorian", "young-adult"], 1882, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](767171, ["20th-century", "biography", "classics", "european-history", "germany", "historical", "history", "holocaust", "military", "military-history", "non-fiction", "political-science", "politics", "reference", "war", "world-history", "world-war-ii"], 1960, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9361589, ["adult", "adult-fiction", "adventure", "contemporary", "fantasy", "fiction", "historical", "historical-fantasy", "historical-fiction", "literary-fiction", "literature", "love", "magic", "magical-realism", "mystery", "novels", "paranormal", "romance", "supernatural", "urban-fantasy", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](92303, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "college", "comedy", "drama", "english-literature", "fiction", "funny", "high-school", "historical", "historical-fiction", "humor", "ireland", "irish-literature", "literary-fiction", "literature", "novels", "plays", "read-for-school", "romance", "school", "short-stories", "theatre", "victorian"], 1899, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7235533, ["action", "adult", "adult-fiction", "adventure", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](375013, ["20th-century", "adult", "adult-fiction", "australia", "banned-books", "biography", "biography-memoir", "classics", "contemporary", "drama", "european-history", "fiction", "film", "germany", "historical", "historical-fiction", "history", "holocaust", "jewish", "literature", "memoir", "modern-classics", "movies", "non-fiction", "novels", "poland", "survival", "true-story", "war", "world-war-ii"], 1982, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7664334, ["adventure", "chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "death", "family", "fiction", "funny", "high-school", "love", "music", "new-adult", "realistic-fiction", "road-trip", "romance", "teen", "travel", "young-adult"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](343, ["20th-century", "adult", "adult-fiction", "classics", "contemporary", "crime", "dark", "drama", "european-literature", "fantasy", "fiction", "france", "german-literature", "germany", "gothic", "historical", "historical-fiction", "history", "horror", "literary-fiction", "literature", "magical-realism", "modern-classics", "movies", "mystery", "mystery-thriller", "novels", "read-for-school", "roman", "school", "suspense", "thriller"], 1985, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9777, ["20th-century", "adult", "adult-fiction", "asia", "asian-literature", "classics", "contemporary", "cultural", "drama", "family", "fiction", "historical", "historical-fiction", "india", "indian-literature", "international", "literary-fiction", "literature", "love", "magical-realism", "modern-classics", "novels", "read-for-school", "romance", "school"], 1997, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24612118, ["21st-century", "adult", "adult-fiction", "american", "contemporary", "drama", "family", "fiction", "literary-fiction", "literature", "love", "marriage", "new-york", "novels", "realistic-fiction", "relationships", "romance"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](34497, ["20th-century", "adult", "adult-fiction", "adventure", "british-literature", "classics", "comedy", "dragons", "epic-fantasy", "fantasy", "fiction", "funny", "high-fantasy", "humor", "magic", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "wizards", "young-adult"], 1983, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5890, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "crime", "detective", "english-literature", "fiction", "gothic", "historical", "historical-fiction", "horror", "literary-fiction", "literature", "mystery", "mystery-thriller", "novels", "romance", "school", "suspense", "thriller", "victorian"], 1859, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](117833, ["20th-century", "adult", "adult-fiction", "classic-literature", "classics", "contemporary", "fantasy", "fiction", "historical", "historical-fiction", "history", "horror", "humor", "literary-fiction", "literature", "magic", "magical-realism", "modern", "modern-classics", "mystery", "novels", "philosophy", "politics", "religion", "romance", "russia", "russian-literature", "school", "supernatural"], 1966, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10614, ["20th-century", "adult", "adult-fiction", "american", "classics", "contemporary", "crime", "dark", "drama", "fantasy", "fiction", "horror", "movies", "mystery", "mystery-thriller", "novels", "psychological-thriller", "suspense", "thriller"], 1987, "English (United Kingdom)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11468377, ["academic", "brain", "business", "design", "economics", "education", "finance", "leadership", "management", "neuroscience", "non-fiction", "personal-development", "philosophy", "popular-science", "productivity", "psychology", "science", "self-help", "social-science", "sociology"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12391521, ["adult", "biography", "contemporary", "crime", "essays", "fiction", "funny", "health", "history", "humor", "journalism", "medical", "medicine", "memoir", "mental-health", "mental-illness", "mystery", "neuroscience", "non-fiction", "philosophy", "politics", "popular-science", "psychology", "reference", "science", "self-help", "social-science", "society", "sociology", "true-crime"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](19057, ["adult", "adult-fiction", "adventure", "australia", "coming-of-age", "contemporary", "drama", "fantasy", "fiction", "funny", "high-school", "humor", "inspirational", "literature", "mystery", "mystery-thriller", "new-adult", "novels", "realistic-fiction", "romance", "teen", "young-adult"], 2002, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](228665, ["adult", "adult-fiction", "adventure", "american", "classics", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "young-adult"], 1990, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](28187230, ["adult", "adult-fiction", "contemporary", "crime", "drama", "fiction", "horror", "murder-mystery", "mystery", "mystery-thriller", "novels", "psychological-thriller", "suspense", "thriller", "travel"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](355697, ["20th-century", "adult", "adult-fiction", "banned-books", "classic-literature", "classics", "college", "drama", "fiction", "france", "german-literature", "germany", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "military", "modern-classics", "non-fiction", "novels", "read-for-school", "realistic-fiction", "school", "war", "world-war-i", "young-adult"], 1929, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](480204, ["19th-century", "20th-century", "adult", "adult-fiction", "adventure", "classic-literature", "classics", "crime", "dark", "drama", "fantasy", "fiction", "france", "french-literature", "gothic", "gothic-horror", "historical", "historical-fiction", "historical-romance", "history", "horror", "literary-fiction", "literature", "love", "movies", "music", "mystery", "novels", "paranormal", "plays", "romance", "supernatural", "suspense", "thriller"], 1909, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](567616, ["art", "art-and-photography", "art-design", "art-history", "design", "graphic-novels", "historical", "history", "non-fiction", "photography", "reference", "visual-art"], 1997, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](32261, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "drama", "english-literature", "feminism", "fiction", "high-school", "historical", "historical-fiction", "historical-romance", "literary-fiction", "literature", "love", "novels", "read-for-school", "romance", "school", "tragedy", "victorian"], 1891, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11808950, ["angels", "contemporary", "demons", "fantasy", "fiction", "high-school", "love", "magic", "mythology", "new-adult", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5821978, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "high-school", "love", "realistic-fiction", "romance", "teen", "young-adult", "young-adult-romance"], 2009, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13517535, ["adult", "chick-lit", "college", "contemporary", "contemporary-romance", "drama", "erotic-romance", "erotica", "fiction", "love", "music", "musicians", "new-adult", "realistic-fiction", "romance", "young-adult"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22318578, ["adult", "asia", "health", "how-to", "inspirational", "japan", "non-fiction", "personal-development", "philosophy", "productivity", "psychology", "reference", "self-help", "spirituality"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16429619, ["adventure", "dystopia", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "magic", "mystery", "paranormal", "romance", "teen", "young-adult", "young-adult-fantasy"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2120932, ["action", "adventure", "children-s", "childrens", "contemporary", "fantasy", "fiction", "funny", "gods", "greek-mythology", "humor", "juvenile", "magic", "middle-grade", "mystery", "mythology", "novels", "paranormal", "romance", "supernatural", "teen", "urban-fantasy", "young-adult"], 2008, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](53835, ["19th-century", "20th-century", "adult", "adult-fiction", "american", "american-classics", "classic-literature", "classics", "drama", "feminism", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "love", "new-york", "novels", "romance", "school", "victorian"], 1920, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10569, ["adult", "american", "art", "autobiography", "biography", "biography-memoir", "books-about-books", "contemporary", "education", "essays", "fiction", "horror", "how-to", "language", "literature", "memoir", "non-fiction", "reference", "research", "school", "self-help", "writing"], 1999, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18879761, ["chick-lit", "college", "coming-of-age", "contemporary", "death", "drama", "family", "fiction", "high-school", "mental-health", "mental-illness", "mystery", "new-adult", "novels", "realistic-fiction", "road-trip", "romance", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22544764, ["adult", "adult-fiction", "adventure", "coming-of-age", "dark", "dragons", "epic-fantasy", "fairy-tales", "fantasy", "fantasy-romance", "fiction", "folklore", "high-fantasy", "historical", "magic", "mythology", "new-adult", "novels", "paranormal", "retellings", "romance", "science-fiction", "science-fiction-fantasy", "supernatural", "teen", "witches", "wizards", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17333230, ["19th-century", "21st-century", "adult", "adult-fiction", "australia", "contemporary", "crime", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "mystery", "mystery-thriller", "novels"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](46787, ["19th-century", "adult", "adult-fiction", "adventure", "african-american", "american", "american-classics", "american-history", "banned-books", "christian", "civil-war", "classic-literature", "classics", "college", "drama", "fiction", "high-school", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "politics", "race", "read-for-school", "religion", "school", "southern", "young-adult"], 1852, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](830, ["20th-century", "adult", "adult-fiction", "adventure", "american", "classics", "contemporary", "cyberpunk", "dystopia", "fantasy", "fiction", "humor", "literature", "mystery", "mythology", "novels", "religion", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "technology", "thriller"], 1992, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18584855, ["adventure", "fairy-tale-retellings", "fairy-tales", "fantasy", "fiction", "high-fantasy", "magic", "novels", "retellings", "romance", "teen", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15753740, ["adult", "adult-fiction", "chick-lit", "contemporary", "drama", "family", "fiction", "historical", "historical-fiction", "history", "holocaust", "literary-fiction", "literature", "mystery", "novels", "realistic-fiction", "romance", "survival", "war", "world-war-ii", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](19549841, ["adventure", "coming-of-age", "dragons", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "magic", "medieval", "music", "mystery", "paranormal", "romance", "science-fiction", "shapeshifters", "supernatural", "teen", "young-adult", "young-adult-fantasy"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13539044, ["adult", "adult-fiction", "american", "contemporary", "contemporary-romance", "drama", "family", "fiction", "funny", "humor", "literary-fiction", "literature", "love", "mental-health", "mental-illness", "movies", "novels", "psychology", "realistic-fiction", "relationships", "romance", "sports", "young-adult"], 2008, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](28921, ["20th-century", "adult", "adult-fiction", "british-literature", "classics", "contemporary", "drama", "english-literature", "fiction", "historical", "historical-fiction", "history", "japan", "japanese-literature", "literary-fiction", "literature", "modern", "modern-classics", "novels", "romance", "school", "war", "world-war-ii"], 1989, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](693208, ["american", "banned-books", "biography", "childrens", "classics", "comedy", "coming-of-age", "contemporary", "cultural", "death", "family", "fiction", "funny", "high-school", "humor", "literature", "memoir", "middle-grade", "native-americans", "non-fiction", "novels", "race", "read-for-school", "realistic-fiction", "school", "sports", "teen", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12505, ["19th-century", "classic-literature", "classics", "drama", "fiction", "historical", "historical-fiction", "literary-fiction", "literature", "novels", "philosophy", "psychology", "romance", "russia", "russian-literature", "social"], 1868, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6342491, ["action", "adventure", "demons", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "medieval", "mystery", "paranormal", "romance", "supernatural", "teen", "witches", "wizards", "young-adult", "young-adult-fantasy"], 2009, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](80660, ["21st-century", "adult", "adult-fiction", "american", "contemporary", "crime", "dark", "drama", "family", "fiction", "horror", "literary-fiction", "literature", "mental-health", "mental-illness", "modern", "mystery", "mystery-thriller", "novels", "parenting", "psychology", "realistic-fiction", "relationships", "suspense", "thriller"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2547, ["20th-century", "adult", "classic-literature", "classics", "eastern-philosophy", "essays", "faith", "fiction", "inspirational", "islam", "lebanon", "literature", "love", "modern-classics", "mysticism", "non-fiction", "novels", "personal-development", "philosophy", "poetry", "psychology", "religion", "self-help", "spirituality", "theology"], 1923, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](37470, ["16th-century", "21st-century", "adult", "adult-fiction", "chick-lit", "classics", "contemporary", "drama", "fiction", "historical", "historical-fiction", "historical-romance", "history", "literature", "movies", "novels", "romance", "tudor", "young-adult"], 2001, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](77013, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "americana", "banned-books", "classic-literature", "classics", "college", "death", "drama", "family", "fiction", "gothic", "high-school", "historical", "historical-fiction", "literary-fiction", "literature", "modern-classics", "novels", "read-for-school", "school", "southern", "southern-gothic"], 1930, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23766634, ["fae", "fairies", "fairy-tales", "fantasy", "fiction", "high-fantasy", "magic", "new-adult", "paranormal", "retellings", "romance", "young-adult"], 2017, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7137327, ["action", "adventure", "apocalyptic", "dystopia", "fantasy", "fiction", "futuristic", "horror", "paranormal", "post-apocalyptic", "romance", "science-fiction", "supernatural", "survival", "teen", "urban-fantasy", "young-adult", "zombies"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4980, ["20th-century", "adult", "adult-fiction", "american", "classic-literature", "classics", "comedy", "contemporary", "fantasy", "fiction", "funny", "high-school", "humor", "literary-fiction", "literature", "modern", "modern-classics", "novels", "philosophy", "science", "science-fiction", "speculative-fiction"], 1973, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1622, ["16th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "college", "comedy", "drama", "english-literature", "fae", "fairies", "fantasy", "fiction", "funny", "high-school", "historical", "historical-fiction", "humor", "literature", "love", "magic", "mythology", "novels", "plays", "poetry", "read-for-school", "romance", "school", "theatre"], 1595, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24120519, ["adventure", "childrens", "coming-of-age", "contemporary", "fantasy", "fiction", "historical", "historical-fiction", "horror", "magic", "mystery", "paranormal", "romance", "science-fiction", "supernatural", "suspense", "teen", "thriller", "time-travel", "urban-fantasy", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15812814, ["action", "adventure", "dystopia", "fantasy", "fiction", "futuristic", "love", "post-apocalyptic", "romance", "science-fiction", "survival", "teen", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16081272, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "erotica", "fiction", "love", "love-story", "music", "new-adult", "realistic-fiction", "road-trip", "romance", "travel", "young-adult"], 2012, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18712886, ["adult", "adult-fiction", "adventure", "coming-of-age", "dystopia", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "historical-fiction", "magic", "new-adult", "post-apocalyptic", "romance", "science-fiction", "teen", "young-adult", "young-adult-fantasy"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12954620, ["action", "adventure", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical", "magic", "medieval", "paranormal", "romance", "teen", "war", "witches", "young-adult", "young-adult-fantasy"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2715, ["adult", "anthropology", "biography", "business", "cookbooks", "cooking", "culinary", "economics", "food", "food-and-drink", "food-history", "food-writing", "foodie", "historical", "history", "microhistory", "natural-history", "nature", "non-fiction", "politics", "popular-science", "reference", "school", "science", "sociology", "travel", "world-history"], 2002, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15776309, ["adult", "adult-fiction", "chick-lit", "coming-of-age", "contemporary", "crime", "death", "drama", "family", "fiction", "high-school", "murder-mystery", "mystery", "mystery-thriller", "new-york", "novels", "psychological-thriller", "realistic-fiction", "suspense", "thriller", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](29908754, ["21st-century", "adult", "adult-fiction", "adventure", "contemporary", "crime", "dark", "drama", "fiction", "horror", "literary-fiction", "literature", "modern", "mystery", "mystery-thriller", "new-adult", "noir", "novels", "psychological-thriller", "psychology", "realistic-fiction", "sociology", "speculative-fiction", "supernatural", "suspense", "teen", "thriller", "young-adult", "zombies"], 2012, "English (United Kingdom)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](448873, ["action", "adventure", "children-s", "childrens", "epic-fantasy", "fantasy", "fiction", "folklore", "high-fantasy", "historical", "historical-fantasy", "historical-fiction", "juvenile", "magic", "medieval", "middle-grade", "mystery", "mythology", "novels", "romance", "speculative-fiction", "teen", "young-adult", "young-adult-fantasy"], 1996, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15645, ["14th-century", "adult", "adult-fiction", "adventure", "christian", "christianity", "classic-literature", "classics", "college", "epic", "epic-poetry", "european-literature", "fantasy", "fiction", "high-school", "historical", "historical-fiction", "history", "horror", "italian-literature", "italy", "literary-fiction", "literature", "medieval", "mythology", "novels", "philosophy", "poetry", "read-for-school", "religion", "school", "spirituality", "theology"], 1320, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](43015, ["adult", "africa", "african-literature", "autobiography", "biography", "biography-memoir", "civil-war", "coming-of-age", "contemporary", "cultural", "fiction", "high-school", "historical", "historical-fiction", "history", "inspirational", "international", "memoir", "military", "non-fiction", "novels", "politics", "read-for-school", "school", "social-justice", "survival", "true-story", "war", "young-adult"], 2007, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23919, ["19th-century", "adult", "adult-fiction", "american", "anthologies", "classic-literature", "classics", "collections", "crime", "dark", "fantasy", "fiction", "gothic", "gothic-horror", "halloween", "historical-fiction", "horror", "literary-fiction", "literature", "mystery", "mystery-thriller", "novels", "paranormal", "poetry", "school", "science-fiction", "short-stories", "supernatural", "suspense", "thriller", "victorian"], 1849, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](46164, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "americana", "classic-literature", "classics", "contemporary", "fiction", "france", "historical", "historical-fiction", "literary-fiction", "literature", "mental-illness", "modern", "modern-classics", "novels", "psychology", "romance", "school"], 1934, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6909544, ["action", "adventure", "apocalyptic", "dystopia", "family", "fantasy", "fiction", "futuristic", "love", "mystery", "paranormal", "post-apocalyptic", "romance", "science-fiction", "survival", "teen", "young-adult"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15196, ["20th-century", "adult", "american", "animals", "art", "autobiography", "biography", "biography-memoir", "classics", "college", "comics", "comics-manga", "comix", "family", "fiction", "germany", "graphic-novels", "graphic-novels-comics", "graphic-novels-manga", "high-school", "historical", "historical-fiction", "history", "holocaust", "horror", "jewish", "judaism", "literature", "manga", "memoir", "non-fiction", "poland", "politics", "read-for-school", "religion", "school", "sequential-art", "survival", "teen", "war", "world-war-ii", "young-adult"], 1985, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7402393, ["action", "adventure", "fantasy", "fiction", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "shapeshifters", "supernatural", "teen", "urban-fantasy", "werewolves", "witches", "wolves", "young-adult", "young-adult-fantasy"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](30118, ["20th-century", "american", "banned-books", "children-s", "childrens", "classics", "comedy", "fantasy", "fiction", "funny", "humor", "juvenile", "literature", "middle-grade", "non-fiction", "picture-books", "poetry", "school", "young-adult", "young-readers"], 1981, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2612, ["adult", "business", "communication", "contemporary", "economics", "education", "entrepreneurship", "essays", "fiction", "history", "inspirational", "journalism", "leadership", "management", "non-fiction", "personal-development", "philosophy", "politics", "popular-science", "psychology", "school", "science", "self-help", "social", "social-science", "society", "sociology"], 2000, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](28186, ["action", "adventure", "children-s", "childrens", "contemporary", "fantasy", "fiction", "funny", "gods", "greek-mythology", "humor", "juvenile", "magic", "middle-grade", "mythology", "novels", "paranormal", "romance", "supernatural", "teen", "urban-fantasy", "young-adult"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20983362, ["adventure", "fantasy", "fiction", "historical", "historical-fiction", "mystery", "paranormal", "pirates", "romance", "science-fiction", "teen", "time-travel", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3008, ["19th-century", "20th-century", "boarding-school", "british-literature", "chapter-books", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "coming-of-age", "drama", "fantasy", "fiction", "historical", "historical-fiction", "juvenile", "literature", "middle-grade", "novels", "realistic-fiction", "school", "victorian", "young-adult"], 1902, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23772, ["20th-century", "children-s", "childrens", "classics", "comedy", "fantasy", "fiction", "food", "funny", "humor", "juvenile", "literature", "picture-books", "poetry", "school", "young-adult"], 1960, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](69571, ["adult", "biography", "business", "economics", "education", "entrepreneurship", "fiction", "finance", "how-to", "inspirational", "leadership", "management", "money", "money-management", "non-fiction", "parenting", "personal-development", "personal-finance", "philosophy", "productivity", "psychology", "reference", "self-help"], 1998, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10127019, ["business", "design", "economics", "entrepreneurship", "how-to", "leadership", "management", "non-fiction", "personal-development", "productivity", "programming", "reference", "self-help", "software", "technology"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17927395, ["action", "adult", "adventure", "epic-fantasy", "fae", "fairies", "fairy-tales", "fantasy", "fantasy-romance", "fiction", "high-fantasy", "love", "magic", "new-adult", "paranormal", "paranormal-romance", "retellings", "romance", "supernatural", "teen", "young-adult"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18143905, ["21st-century", "adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "coming-of-age", "contemporary", "essays", "fiction", "literature", "memoir", "non-fiction", "short-stories", "short-story-collection", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4948, ["animals", "children-s", "childrens", "classics", "fantasy", "fiction", "food", "juvenile", "nature", "picture-books", "school", "science", "storytime"], 1969, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7094569, ["action", "adult", "adult-fiction", "adventure", "apocalyptic", "dystopia", "fantasy", "fiction", "futuristic", "horror", "mystery", "novels", "paranormal", "politics", "post-apocalyptic", "science", "science-fiction", "speculative-fiction", "supernatural", "survival", "suspense", "thriller", "urban-fantasy", "young-adult", "zombies"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](944073, ["action", "adult", "adult-fiction", "adventure", "dark", "dark-fantasy", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "low-fantasy", "magic", "novels", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "sword-and-sorcery", "war"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11447921, ["21st-century", "adult", "adult-fiction", "american", "chick-lit", "contemporary", "drama", "family", "fiction", "historical", "historical-fiction", "humor", "italy", "literary-fiction", "literature", "novels", "realistic-fiction", "relationships", "romance", "travel"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](213753, ["adventure", "apocalyptic", "coming-of-age", "contemporary", "diary", "dystopia", "family", "fantasy", "fiction", "futuristic", "high-school", "novels", "post-apocalyptic", "realistic-fiction", "school", "science", "science-fiction", "speculative-fiction", "survival", "suspense", "teen", "young-adult"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13145, ["action", "adult", "adult-fiction", "american", "contemporary", "crime", "detective", "fiction", "horror", "movies", "murder-mystery", "mystery", "mystery-thriller", "novels", "police", "suspense", "thriller"], 1993, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18336965, ["coming-of-age", "contemporary", "dark", "death", "drama", "family", "fiction", "high-school", "love", "mental-health", "mental-illness", "novels", "psychology", "realistic-fiction", "romance", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17314430, ["abuse", "adult", "chick-lit", "college", "contemporary", "contemporary-romance", "drama", "erotica", "fiction", "funny", "love", "new-adult", "realistic-fiction", "romance", "romantic", "young-adult", "young-adult-romance"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5971165, ["15th-century", "adult", "adult-fiction", "chick-lit", "drama", "fantasy", "fiction", "historical", "historical-fiction", "historical-romance", "history", "magic", "medieval", "novels", "plantagenet", "romance", "tudor", "war"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](188572, ["19th-century", "adult", "adult-fiction", "adventure", "british-literature", "classic-literature", "classics", "collections", "crime", "detective", "english-literature", "fiction", "historical", "historical-fiction", "literature", "mystery", "mystery-thriller", "novels", "short-stories", "suspense", "thriller", "victorian"], 1894, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12476820, ["action", "adventure", "apocalyptic", "dystopia", "fantasy", "fiction", "futuristic", "mystery", "paranormal", "post-apocalyptic", "romance", "science-fiction", "survival", "teen", "urban-fantasy", "young-adult"], 2012, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13137, ["action", "adult", "adult-fiction", "classics", "contemporary", "crime", "detective", "fiction", "murder-mystery", "mystery", "mystery-thriller", "novels", "romance", "suspense", "thriller"], 2001, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](16158542, ["adult", "adventure", "american", "american-history", "biography", "biography-memoir", "fiction", "germany", "historical", "historical-fiction", "history", "inspirational", "memoir", "non-fiction", "sports", "war", "world-war-ii"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](216363, ["20th-century", "adult", "adult-fiction", "alternate-history", "american", "classics", "dystopia", "fantasy", "fiction", "historical", "historical-fiction", "history", "literature", "modern-classics", "novels", "politics", "science", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "war", "world-war-ii"], 1962, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15811545, ["21st-century", "adult", "adult-fiction", "american", "asia", "asian-literature", "buddhism", "canada", "coming-of-age", "contemporary", "cultural", "death", "family", "fantasy", "fiction", "historical", "historical-fiction", "history", "japan", "japanese-literature", "literary-fiction", "literature", "magical-realism", "mystery", "novels", "philosophy", "realistic-fiction", "religion", "war"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13503109, ["21st-century", "adult", "adult-fiction", "american", "contemporary", "drama", "fiction", "latin-american", "literary-fiction", "literature", "love", "novels", "realistic-fiction", "relationships", "romance", "short-stories", "short-story-collection"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12111823, ["adult", "adult-fiction", "adventure", "dark-fantasy", "dragons", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "historical-fiction", "magic", "novels", "science-fiction"], null, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](28260587, ["action", "adult", "adventure", "demons", "dragons", "epic-fantasy", "fae", "fairies", "fantasy", "fiction", "high-fantasy", "magic", "new-adult", "paranormal", "romance", "shapeshifters", "supernatural", "teen", "war", "witches", "young-adult", "young-adult-fantasy"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7733, ["18th-century", "adult", "adult-fiction", "adventure", "british-literature", "children-s", "childrens", "classic-literature", "classics", "college", "english-literature", "fantasy", "fiction", "high-school", "historical", "historical-fiction", "humor", "ireland", "irish-literature", "literary-fiction", "literature", "novels", "philosophy", "politics", "read-for-school", "school", "science-fiction", "travel", "young-adult"], 1726, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9462812, ["angels", "contemporary", "death", "fantasy", "fiction", "france", "ghosts", "horror", "love", "magic", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "young-adult", "zombies"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4138, ["20th-century", "adult", "american", "autobiography", "biography", "biography-memoir", "comedy", "coming-of-age", "contemporary", "essays", "family", "fiction", "funny", "gay", "glbt", "humor", "literature", "memoir", "non-fiction", "novels", "queer", "short-stories"], 1997, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](78129, ["action", "adult", "adult-fiction", "adventure", "contemporary", "crime", "detective", "fiction", "government", "hard-boiled", "military", "murder-mystery", "mystery", "mystery-thriller", "novels", "suspense", "thriller"], 1997, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7331435, ["21st-century", "adult", "adult-fiction", "american", "contemporary", "drama", "fiction", "literary-fiction", "literature", "music", "new-york", "novels", "realistic-fiction", "relationships", "short-stories"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](27712, ["20th-century", "adventure", "books-about-books", "children-s", "childrens", "classics", "coming-of-age", "dragons", "epic-fantasy", "fairy-tales", "fantasy", "fiction", "german-literature", "germany", "high-fantasy", "juvenile", "literature", "magic", "middle-grade", "movies", "novels", "teen", "young-adult"], 1979, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1274, ["adult", "american", "chick-lit", "classics", "communication", "contemporary", "family", "fiction", "gender", "health", "inspirational", "love", "marriage", "non-fiction", "novels", "personal-development", "philosophy", "psychology", "reference", "relationships", "romance", "self-help", "social", "sociology"], 1992, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22232, ["chapter-books", "chick-lit", "children-s", "childrens", "classics", "coming-of-age", "contemporary", "fiction", "high-school", "juvenile", "love", "middle-grade", "novels", "read-for-school", "realistic-fiction", "romance", "school", "teen", "young-adult"], 2000, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](49041, ["chick-lit", "contemporary", "drama", "fantasy", "fiction", "high-school", "horror", "love", "movies", "novels", "paranormal", "paranormal-romance", "romance", "science-fiction", "shapeshifters", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "young-adult"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6381205, ["adult", "adult-fiction", "adventure", "alternate-history", "chick-lit", "comedy", "fantasy", "fiction", "funny", "ghosts", "historical", "historical-fantasy", "historical-fiction", "historical-romance", "horror", "humor", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "science-fiction", "shapeshifters", "speculative-fiction", "steampunk", "supernatural", "urban-fantasy", "vampires", "victorian", "werewolves", "young-adult"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](32234, ["20th-century", "abuse", "adult", "adult-fiction", "american", "chick-lit", "classics", "coming-of-age", "contemporary", "crime", "dark", "drama", "family", "fiction", "literary-fiction", "literature", "mental-health", "mental-illness", "movies", "novels", "realistic-fiction", "relationships", "womens-fiction", "young-adult"], 1999, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9293020, ["21st-century", "adult", "adult-fiction", "adventure", "contemporary", "crime", "dark", "drama", "fiction", "horror", "literary-fiction", "literature", "modern", "mystery", "mystery-thriller", "new-adult", "noir", "novels", "psychology", "realistic-fiction", "sociology", "speculative-fiction", "suspense", "teen", "thriller", "young-adult"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23754, ["20th-century", "adult", "art", "classics", "comic-book", "comics", "comics-manga", "comix", "contemporary", "dark", "dark-fantasy", "dc-comics", "fantasy", "fiction", "gothic", "graphic-novels", "graphic-novels-comics", "graphic-novels-manga", "horror", "magic", "mythology", "paranormal", "science-fiction", "sequential-art", "speculative-fiction", "supernatural", "urban-fantasy", "young-adult"], 1989, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5544, ["20th-century", "american", "autobiography", "biography", "biography-memoir", "classics", "comedy", "essays", "fiction", "funny", "history", "humor", "inspirational", "mathematics", "memoir", "non-fiction", "philosophy", "physics", "popular-science", "science", "science-nature", "short-stories", "technology"], 1984, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](30117284, ["adventure", "dystopia", "fantasy", "fiction", "magic", "romance", "science-fiction", "space", "teen", "young-adult"], 2017, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18966819, ["action", "adult", "adult-fiction", "adventure", "dystopia", "epic", "fantasy", "fiction", "futuristic", "military", "mythology", "novels", "politics", "romance", "science-fiction", "science-fiction-fantasy", "space", "space-opera", "speculative-fiction", "thriller", "war", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2548866, ["adventure", "children-s", "childrens", "fantasy", "fiction", "juvenile", "magic", "middle-grade", "mystery", "novels", "paranormal", "school", "teen", "urban-fantasy", "witches", "wizards", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22917, ["19th-century", "adventure", "anthologies", "children-s", "childrens", "classic-literature", "classics", "collections", "fairy-tales", "fantasy", "fiction", "folklore", "german-literature", "germany", "horror", "juvenile", "literature", "magic", "mythology", "novels", "reference", "romance", "short-stories", "young-adult"], 1812, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4631, ["20th-century", "adult", "american", "american-classics", "autobiography", "biography", "biography-memoir", "classic-literature", "classics", "essays", "fiction", "france", "historical", "historical-fiction", "history", "literary-fiction", "literature", "memoir", "modern-classics", "non-fiction", "novels", "short-stories", "travel", "writing"], 1964, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20613470, ["action", "adventure", "demons", "dragons", "epic-fantasy", "fae", "fairies", "fantasy", "fiction", "high-fantasy", "magic", "mystery", "paranormal", "romance", "supernatural", "teen", "witches", "young-adult", "young-adult-fantasy"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18053060, ["action", "adventure", "dystopia", "fairy-tale-retellings", "fairy-tales", "fantasy", "fiction", "horror", "magic", "mystery", "paranormal", "retellings", "romance", "teen", "witches", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](27883214, ["adventure", "family", "fantasy", "fiction", "high-fantasy", "magic", "magical-realism", "mystery", "paranormal", "romance", "teen", "young-adult", "young-adult-fantasy"], 2017, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6261522, ["contemporary", "crime", "death", "fantasy", "fiction", "ghosts", "high-school", "horror", "magic", "murder-mystery", "mystery", "mystery-thriller", "paranormal", "paranormal-romance", "romance", "supernatural", "suspense", "teen", "thriller", "urban-fantasy", "young-adult"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](14290364, ["action", "adventure", "dystopia", "fantasy", "fiction", "futuristic", "love", "novels", "post-apocalyptic", "romance", "science-fiction", "teen", "thriller", "war", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](337113, ["19th-century", "adult", "adult-fiction", "british-literature", "classic-literature", "classics", "drama", "english-literature", "feminism", "fiction", "gothic", "historical", "historical-fiction", "historical-romance", "literary-fiction", "literature", "mystery", "novels", "romance", "school", "victorian"], 1848, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9917938, ["action", "adventure", "apocalyptic", "coming-of-age", "dystopia", "family", "fantasy", "fiction", "futuristic", "post-apocalyptic", "romance", "science-fiction", "speculative-fiction", "survival", "teen", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23212667, ["adult", "adult-fiction", "contemporary", "crime", "fiction", "mystery", "mystery-thriller", "novels", "psychological-thriller", "suspense", "thriller"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1215032, ["adult", "adult-fiction", "adventure", "coming-of-age", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "magic", "novels", "romance", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](547094, ["20th-century", "adult", "adult-fiction", "american", "anthologies", "apocalyptic", "classics", "dark", "dystopia", "fantasy", "fiction", "horror", "literature", "movies", "novels", "occult", "paranormal", "post-apocalyptic", "science", "science-fiction", "science-fiction-fantasy", "short-stories", "speculative-fiction", "supernatural", "survival", "suspense", "thriller", "urban-fantasy", "vampires", "zombies"], 1954, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10964693, ["21st-century", "academia", "adult", "adult-fiction", "american", "books-about-books", "chick-lit", "college", "coming-of-age", "contemporary", "drama", "fiction", "historical-fiction", "literary-fiction", "literature", "love", "marriage", "mental-health", "mental-illness", "novels", "realistic-fiction", "relationships", "religion", "romance", "spirituality"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6393631, ["autobiography", "biography", "biography-memoir", "children-s", "childrens", "comics", "coming-of-age", "contemporary", "family", "fiction", "funny", "graphic-novels", "graphic-novels-comics", "graphic-novels-manga", "high-school", "humor", "juvenile", "manga", "memoir", "middle-grade", "non-fiction", "realistic-fiction", "school", "teen", "young-adult"], 2009, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](1081560, ["academic", "adventure", "biography", "books-about-books", "classics", "criticism", "fantasy", "fiction", "high-fantasy", "history", "literature", "magic", "non-fiction", "novels", "reference", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13, ["20th-century", "adult", "adult-fiction", "adventure", "aliens", "british-literature", "classics", "comedy", "contemporary", "fantasy", "fiction", "funny", "humor", "literature", "novels", "science", "science-fiction", "science-fiction-fantasy", "space", "space-opera", "speculative-fiction", "time-travel", "young-adult"], 1996, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](112750, ["action", "adult", "adult-fiction", "adventure", "contemporary", "dark", "fae", "fairies", "fantasy", "fantasy-romance", "fiction", "horror", "ireland", "magic", "mystery", "mythology", "new-adult", "paranormal", "paranormal-romance", "paranormal-urban-fantasy", "romance", "supernatural", "suspense", "urban", "urban-fantasy", "vampires", "young-adult"], 2006, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17199504, ["action", "adult", "adult-fiction", "adventure", "aliens", "alternate-history", "dystopia", "fantasy", "fiction", "futuristic", "ghosts", "magic", "mystery", "new-adult", "paranormal", "romance", "science-fiction", "science-fiction-fantasy", "supernatural", "thriller", "urban-fantasy", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10104, ["16th-century", "20th-century", "adult", "biography", "biography-memoir", "classics", "european-history", "fiction", "historical", "historical-fiction", "history", "medieval", "non-fiction", "politics", "religion", "tudor", "world-history"], 1980, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](42156, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "fiction", "funny", "humor", "love", "movies", "new-york", "novels", "realistic-fiction", "relationships", "romance", "romantic", "womens-fiction", "young-adult"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4953, ["21st-century", "adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "classics", "coming-of-age", "contemporary", "death", "family", "fiction", "funny", "humor", "literary-fiction", "literature", "memoir", "non-fiction", "novels"], 2000, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9593913, ["action", "adventure", "coming-of-age", "dystopia", "fantasy", "fiction", "futuristic", "love", "post-apocalyptic", "romance", "science-fiction", "survival", "teen", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20698530, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "funny", "high-school", "love", "realistic-fiction", "romance", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12812550, ["action", "adventure", "angels", "contemporary", "dark", "demons", "dystopia", "fantasy", "fiction", "high-fantasy", "love", "magic", "mythology", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "war", "young-adult", "young-adult-fantasy"], 2012, "English (Canada)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](27161156, ["21st-century", "adult", "american", "american-history", "americana", "anthropology", "autobiography", "biography", "biography-memoir", "contemporary", "economics", "education", "family", "fiction", "historical", "history", "memoir", "non-fiction", "politics", "poverty", "psychology", "race", "social-issues", "social-justice", "social-science", "society", "sociology", "southern", "united-states"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13588356, ["adult", "business", "education", "family", "health", "inspirational", "leadership", "mental-health", "non-fiction", "parenting", "personal-development", "philosophy", "psychology", "relationships", "science", "self-help", "sociology", "spirituality"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](21104828, ["20th-century", "adult", "adult-fiction", "chick-lit", "contemporary", "crime", "drama", "family", "fiction", "gothic", "historical", "historical-fiction", "historical-mystery", "history", "literary-fiction", "literature", "mystery", "mystery-thriller", "novels", "romance", "suspense", "thriller", "war"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6327, ["20th-century", "adventure", "banned-books", "chapter-books", "children-s", "childrens", "classics", "comedy", "fantasy", "fiction", "funny", "horror", "humor", "juvenile", "magic", "middle-grade", "novels", "paranormal", "school", "supernatural", "witches", "young-adult", "young-readers"], 1983, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6689, ["20th-century", "adventure", "animals", "banned-books", "chapter-books", "children-s", "childrens", "childrens-classics", "classics", "fantasy", "fiction", "funny", "humor", "juvenile", "literature", "magic", "middle-grade", "movies", "novels", "school", "young-adult", "young-readers"], 1961, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](872333, ["angels", "chick-lit", "contemporary", "fantasy", "fiction", "high-school", "horror", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "young-adult", "young-adult-fantasy"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9375, ["20th-century", "adult", "adult-fiction", "american", "chick-lit", "classics", "coming-of-age", "contemporary", "drama", "family", "feminism", "fiction", "food", "funny", "glbt", "historical", "historical-fiction", "history", "humor", "lesbian", "literary-fiction", "literature", "movies", "mystery", "novels", "queer", "realistic-fiction", "romance", "southern", "womens-fiction"], 1987, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](29430012, ["20th-century", "adult", "adult-fiction", "american", "contemporary", "cultural", "drama", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "russia"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11710373, ["18th-century", "adult", "adult-fiction", "adventure", "american-history", "chick-lit", "drama", "epic", "fantasy", "fiction", "historical", "historical-fantasy", "historical-fiction", "historical-romance", "history", "novels", "paranormal", "romance", "romantic", "science-fiction", "scotland", "time-travel", "war"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15925, ["adult", "adult-fiction", "animals", "chick-lit", "contemporary", "contemporary-romance", "death", "drama", "fiction", "love", "love-story", "mystery", "novels", "realistic-fiction", "relationships", "romance", "romantic", "romantic-suspense", "southern", "suspense", "thriller", "young-adult"], 2003, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](135836, ["20th-century", "adult", "adult-fiction", "british-literature", "classics", "comedy", "contemporary", "crime", "dark", "drama", "english-literature", "fiction", "film", "funny", "humor", "literary-fiction", "literature", "modern", "modern-classics", "movies", "mystery", "novels", "scotland", "thriller"], 1993, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](89724, ["20th-century", "adult", "adult-fiction", "american", "classics", "contemporary", "crime", "dark", "death", "drama", "family", "fantasy", "fiction", "gothic", "gothic-horror", "halloween", "horror", "literary-fiction", "literature", "mental-illness", "modern-classics", "mystery", "mystery-thriller", "novella", "novels", "short-stories", "suspense", "thriller", "young-adult"], 1962, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7488244, ["angels", "contemporary", "demons", "fantasy", "fiction", "high-school", "love", "magic", "mystery", "mythology", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "young-adult", "young-adult-fantasy"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](56495, ["adult", "business", "christian", "christian-non-fiction", "christianity", "church", "discipleship", "faith", "fiction", "god", "inspirational", "leadership", "non-fiction", "personal-development", "philosophy", "psychology", "reference", "religion", "self-help", "spirituality", "theology"], 2002, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9413044, ["adventure", "contemporary", "demons", "fantasy", "fiction", "greek-mythology", "magic", "mystery", "mythology", "paranormal", "paranormal-romance", "retellings", "romance", "supernatural", "teen", "urban-fantasy", "young-adult"], 2012, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](6574102, ["action", "adventure", "art", "chick-lit", "contemporary", "crime", "espionage", "family", "fiction", "funny", "high-school", "humor", "mystery", "mystery-thriller", "realistic-fiction", "romance", "suspense", "teen", "thriller", "young-adult"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](24378015, ["chick-lit", "contemporary", "contemporary-romance", "drama", "fantasy", "fiction", "high-school", "love", "mystery", "mystery-thriller", "new-adult", "novella", "paranormal", "paranormal-romance", "romance", "short-stories", "supernatural", "suspense", "thriller", "young-adult"], 2015, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](76778, ["20th-century", "adult", "adult-fiction", "adventure", "aliens", "american", "classic-literature", "classics", "dystopia", "fantasy", "fiction", "high-school", "horror", "literature", "novels", "post-apocalyptic", "school", "science", "science-fiction", "science-fiction-fantasy", "short-stories", "short-story-collection", "space", "speculative-fiction", "young-adult"], 1949, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8709527, ["adventure", "boarding-school", "contemporary", "fantasy", "fiction", "high-school", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "vampires", "witches", "young-adult"], 2011, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3273, ["19th-century", "adult", "adult-fiction", "american-history", "coming-of-age", "contemporary", "cultural", "drama", "family", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "medical", "novels", "realistic-fiction", "relationships", "romance", "travel", "young-adult"], 2003, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2932, ["18th-century", "adult", "adult-fiction", "adventure", "british-literature", "children-s", "childrens", "classic-literature", "classics", "college", "english-literature", "fantasy", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "novels", "read-for-school", "school", "survival", "travel", "young-adult"], 1719, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11250317, ["adult", "adult-fiction", "adventure", "ancient-history", "classics", "contemporary", "fantasy", "fiction", "gay", "glbt", "greece", "greek-mythology", "historical", "historical-fantasy", "historical-fiction", "historical-romance", "history", "literary-fiction", "literature", "love", "m-m-romance", "mythology", "novels", "queer", "queer-lit", "retellings", "romance", "war", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](2744, ["adult", "adult-fiction", "adventure", "comedy", "contemporary", "dark-fantasy", "family", "fantasy", "fiction", "folklore", "funny", "gods", "horror", "humor", "literature", "magic", "magical-realism", "mythology", "novels", "paranormal", "religion", "science-fiction", "science-fiction-fantasy", "speculative-fiction", "supernatural", "urban-fantasy", "young-adult"], 2005, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](33590260, ["fae", "fantasy", "fiction", "high-fantasy", "magic", "new-adult", "paranormal", "romance", "young-adult"], 2018, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10505, ["21st-century", "academic", "art", "art-design", "art-history", "classics", "contemporary", "criticism", "design", "essays", "fiction", "historical", "historical-fiction", "history", "italian-literature", "italy", "literary-criticism", "literature", "microhistory", "non-fiction", "philosophy", "psychology", "reference", "sociology", "theory", "visual-art"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](19063, ["adult", "books-about-books", "classics", "coming-of-age", "contemporary", "death", "drama", "family", "fantasy", "fiction", "germany", "historical", "historical-fiction", "history", "holocaust", "literary-fiction", "literature", "novels", "realistic-fiction", "school", "teen", "war", "world-war-ii", "young-adult"], 2005, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](22450859, ["20th-century", "adult", "adult-fiction", "american", "chick-lit", "coming-of-age", "contemporary", "family", "feminism", "fiction", "historical", "historical-fiction", "history", "jewish", "judaism", "literary-fiction", "literature", "memoir", "novels", "relationships", "romance"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](18404173, ["20th-century", "adult", "biography", "biography-memoir", "cultural", "european-history", "family", "historical", "historical-fiction", "history", "memoir", "non-fiction", "romanovs", "russia", "russian-history", "war"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9579634, ["action", "adult", "adult-fiction", "adventure", "apocalyptic", "dark", "dark-fantasy", "dystopia", "epic", "epic-fantasy", "fantasy", "fiction", "high-fantasy", "horror", "low-fantasy", "magic", "novels", "post-apocalyptic", "science-fiction", "science-fiction-fantasy", "war", "young-adult"], 2011, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](102920, ["20th-century", "adult", "american", "art", "art-design", "books-about-books", "classics", "college", "comic-book", "comics", "comics-manga", "comix", "criticism", "design", "drawing", "education", "essays", "fiction", "game-design", "graphic-novels", "graphic-novels-comics", "graphic-novels-manga", "history", "how-to", "language", "literary-criticism", "literature", "manga", "non-fiction", "philosophy", "pop-culture", "psychology", "read-for-school", "reference", "research", "school", "sequential-art", "teaching", "textbooks", "theory", "writing", "young-adult"], 1993, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5113, ["20th-century", "adult", "adult-fiction", "american", "americana", "classic-literature", "classics", "college", "coming-of-age", "contemporary", "family", "fiction", "high-school", "literary-fiction", "literature", "modern-classics", "new-york", "novella", "novels", "philosophy", "realistic-fiction", "religion", "short-stories", "young-adult"], 1957, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12996, ["17th-century", "adult", "british-literature", "classic-literature", "classics", "college", "drama", "english-literature", "fiction", "high-school", "historical", "historical-fiction", "italy", "literature", "novels", "plays", "poetry", "race", "read-for-school", "romance", "school", "theatre", "tragedy"], 1603, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15745753, ["abuse", "chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "family", "fiction", "high-school", "historical-fiction", "love", "love-story", "music", "novels", "realistic-fiction", "relationships", "romance", "teen", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23341894, ["chick-lit", "coming-of-age", "contemporary", "contemporary-romance", "drama", "fiction", "high-school", "love", "mental-health", "mental-illness", "poetry", "psychology", "realistic-fiction", "romance", "teen", "young-adult"], 2015, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](23228, ["american", "coming-of-age", "contemporary", "fantasy", "fiction", "funny", "gay", "glbt", "high-school", "humor", "love", "m-m-romance", "novels", "queer", "queer-lit", "realistic-fiction", "relationships", "romance", "school", "teen", "young-adult"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](33600, ["adult", "adult-fiction", "adventure", "asia", "australia", "autobiography", "biography", "biography-memoir", "classics", "contemporary", "crime", "cultural", "drama", "fiction", "historical-fiction", "india", "literary-fiction", "literature", "memoir", "modern", "mystery", "non-fiction", "novels", "philosophy", "romance", "thriller", "travel"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](17465453, ["19th-century", "adult", "adult-fiction", "adventure", "american", "contemporary", "evolution", "family", "fiction", "historical", "historical-fiction", "history", "literary-fiction", "literature", "nature", "novels", "romance", "science", "spirituality", "travel"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12220, ["20th-century", "adult", "adult-fiction", "american", "american-classics", "class", "classic-literature", "classics", "college", "contemporary", "drama", "fiction", "high-school", "historical", "historical-fiction", "literary-fiction", "literature", "mental-illness", "modern-classics", "novels", "plays", "read-for-school", "realistic-fiction", "romance", "school", "southern", "southern-gothic", "theatre", "tragedy"], 1947, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](25526965, ["adult", "adult-fiction", "contemporary", "crime", "detective", "fantasy", "fiction", "horror", "mystery", "mystery-thriller", "novels", "paranormal", "science-fiction", "supernatural", "suspense", "thriller"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](26245850, ["adult", "adult-fiction", "american", "contemporary", "crime", "death", "drama", "fiction", "literary-fiction", "mystery", "mystery-thriller", "new-york", "novels", "realistic-fiction", "survival", "suspense", "thriller"], 2016, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](242472, ["academic", "business", "economics", "entrepreneurship", "fiction", "finance", "history", "leadership", "management", "mathematics", "non-fiction", "personal-development", "philosophy", "politics", "popular-science", "psychology", "science", "self-help", "social-science", "society", "sociology", "theory"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7791997, ["action", "angels", "contemporary", "fantasy", "fiction", "high-school", "love", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "young-adult", "young-adult-fantasy"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7740152, ["angels", "boarding-school", "contemporary", "demons", "fantasy", "fiction", "high-school", "love", "magic", "mystery", "paranormal", "paranormal-romance", "romance", "supernatural", "teen", "urban-fantasy", "young-adult", "young-adult-fantasy"], 2010, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](40440, ["21st-century", "adult", "adult-fiction", "books-about-books", "british-literature", "chick-lit", "contemporary", "drama", "family", "fantasy", "fiction", "ghosts", "gothic", "historical", "historical-fiction", "historical-mystery", "horror", "literary-fiction", "literature", "mystery", "mystery-thriller", "novels", "paranormal", "romance", "suspense", "thriller", "young-adult"], 2006, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](603204, ["adult", "american", "cookbooks", "cooking", "cuisine", "culinary", "food", "food-and-drink", "food-writing", "foodie", "health", "how-to", "non-fiction", "reference", "self-help"], 1998, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8573642, ["adventure", "dragons", "dystopia", "fantasy", "fiction", "futuristic", "high-fantasy", "magic", "paranormal", "paranormal-romance", "romance", "science-fiction", "supernatural", "teen", "young-adult"], 2012, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](4502877, ["chick-lit", "contemporary", "fantasy", "fantasy-romance", "fiction", "high-school", "love", "love-story", "novella", "novels", "paranormal", "paranormal-romance", "romance", "romantic", "science-fiction", "short-stories", "supernatural", "teen", "urban-fantasy", "vampires", "werewolves", "young-adult", "young-adult-fantasy"], 2008, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13624688, ["adult", "adult-fiction", "adventure", "christian", "christian-fiction", "classics", "contemporary", "death", "drama", "fantasy", "fiction", "historical-fiction", "inspirational", "literature", "love", "magical-realism", "novels", "philosophy", "science-fiction", "self-help", "spirituality", "time-travel", "young-adult"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](20578940, ["action", "adventure", "boarding-school", "children-s", "childrens", "fantasy", "fiction", "juvenile", "magic", "middle-grade", "mystery", "paranormal", "school", "supernatural", "teen", "urban-fantasy", "witches", "wizards", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](11590, ["20th-century", "adult", "adult-fiction", "american", "classics", "contemporary", "dark", "fantasy", "fiction", "gothic", "halloween", "horror", "mystery", "mystery-thriller", "paranormal", "science-fiction", "supernatural", "suspense", "thriller", "urban-fantasy", "vampires"], 1975, "English (United Kingdom)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](29800, ["21st-century", "action", "adult", "adventure", "canada", "comedy", "comic-book", "comics", "comics-manga", "comix", "contemporary", "fantasy", "fiction", "funny", "graphic-novels", "graphic-novels-comics", "graphic-novels-manga", "humor", "manga", "music", "romance", "science-fiction", "sequential-art", "teen", "video-games", "young-adult"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13638125, ["action", "adult", "adult-fiction", "adventure", "contemporary", "crime", "dark", "fantasy", "fiction", "magic", "mystery", "new-adult", "novels", "paranormal", "science-fiction", "superheroes", "supernatural", "thriller", "urban-fantasy", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10766509, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "family", "fiction", "love", "love-story", "movies", "novels", "realistic-fiction", "relationships", "romance", "romantic", "young-adult"], 2010, "English (United States)"), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5826, ["adult", "adult-fiction", "american", "classics", "contemporary", "drama", "fiction", "historical-fiction", "literary-fiction", "literature", "love", "magical-realism", "music", "mystery", "novels", "realistic-fiction", "relationships", "romance", "suspense", "terrorism"], 2001, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](13486122, ["adult", "adult-fiction", "chick-lit", "contemporary", "contemporary-romance", "drama", "erotic-romance", "erotica", "fiction", "funny", "humor", "love", "marriage", "new-adult", "realistic-fiction", "romance", "romantic"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10176, ["21st-century", "adult", "adult-fiction", "american", "autobiography", "biography", "biography-memoir", "collections", "comedy", "contemporary", "essays", "family", "fiction", "funny", "gay", "glbt", "humor", "literature", "memoir", "non-fiction", "queer", "short-stories"], 2004, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](5659, ["20th-century", "adventure", "animals", "british-literature", "chapter-books", "children-s", "childrens", "childrens-classics", "classic-literature", "classics", "english-literature", "fantasy", "fiction", "humor", "juvenile", "literature", "middle-grade", "novels", "school", "young-adult"], 1908, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](10847, ["adult", "american", "american-history", "biography", "christianity", "crime", "cults", "faith", "fiction", "historical", "history", "journalism", "lds", "memoir", "mormonism", "mystery", "non-fiction", "philosophy", "politics", "psychology", "religion", "sociology", "spirituality", "true-crime"], 2003, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](9673436, ["adventure", "art", "chapter-books", "children-s", "childrens", "classics", "comics", "family", "fantasy", "fiction", "film", "france", "graphic-novels", "historical", "historical-fiction", "history", "juvenile", "middle-grade", "movies", "mystery", "novels", "picture-books", "realistic-fiction", "school", "science-fiction", "steampunk", "young-adult"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](15704307, ["action", "adult", "adult-fiction", "adventure", "aliens", "comic-book", "comics", "comics-manga", "comix", "dystopia", "family", "fantasy", "fiction", "funny", "ghosts", "graphic-novels", "graphic-novels-comics", "graphic-novels-comics-manga", "graphic-novels-manga", "magic", "manga", "romance", "science-fiction", "sequential-art", "space", "space-opera", "speculative-fiction", "war"], 2012, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12291438, ["adventure", "dark", "death", "fantasy", "fiction", "gothic", "gothic-horror", "historical", "historical-fiction", "history", "horror", "mystery", "mystery-thriller", "paranormal", "retellings", "romance", "science-fiction", "steampunk", "supernatural", "suspense", "teen", "thriller", "victorian", "young-adult"], 2013, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](91760, ["20th-century", "adult", "art", "art-and-photography", "art-history", "autobiography", "biography", "biography-memoir", "classics", "contemporary", "diary", "feminism", "historical", "history", "memoir", "non-fiction", "poetry"], 1995, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](8475505, ["action", "adventure", "chick-lit", "contemporary", "fantasy", "fiction", "funny", "high-school", "humor", "magic", "mystery", "mythology", "paranormal", "paranormal-romance", "romance", "southern", "supernatural", "teen", "urban-fantasy", "witches", "young-adult"], 2014, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](3873, ["20th-century", "academic", "ancient-history", "atheism", "christian", "christianity", "church-history", "faith", "god", "historical", "history", "islam", "jewish", "judaism", "mythology", "non-fiction", "philosophy", "politics", "reference", "religion", "science", "sociology", "spirituality", "theology", "world-history"], 1975, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](38619, ["action", "adult", "adult-fiction", "adventure", "contemporary", "dystopia", "fantasy", "fiction", "funny", "horror", "humor", "magic", "mystery", "mythology", "paranormal", "paranormal-romance", "paranormal-urban-fantasy", "post-apocalyptic", "romance", "shapeshifters", "supernatural", "urban", "urban-fantasy", "vampires", "werewolves", "witches", "young-adult", "zombies"], 2007, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](12749, ["20th-century", "classic-literature", "classics", "european-literature", "fiction", "france", "french-literature", "historical-fiction", "literary-fiction", "literature", "memoir", "modern-classics", "novels", "philosophy", "roman", "romance", "school"], 1913, null), new __WEBPACK_IMPORTED_MODULE_2__Model_fs__["d" /* BookDetail */](7735333, ["adventure", "chick-lit", "coming-of-age", "dystopia", "fantasy", "fiction", "futuristic", "love", "post-apocalyptic", "romance", "science-fiction", "teen", "young-adult"], 2010, null)], Array);
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(60);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(9),l=__webpack_require__(62),B=__webpack_require__(30),C=__webpack_require__(15),ba=__webpack_require__(63),da=__webpack_require__(64),ea=__webpack_require__(65),fa=__webpack_require__(66),ia=__webpack_require__(69),D=__webpack_require__(31);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(30),n=__webpack_require__(31),p=__webpack_require__(15),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(15);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(67);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(68);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HtmlPropExtensions */
/* unused harmony export Footer */
/* unused harmony export Header */
/* unused harmony export Navigation */
/* unused harmony export AllBooksSection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Filtering_fs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Statistics_StatisticsComponents_fs__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReadBooksStorage_fs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils_fs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Model_fs__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















var HtmlPropExtensions = function () {
    function HtmlPropExtensions(tag, data) {
        _classCallCheck(this, HtmlPropExtensions);

        this.tag = tag;
        this.data = data;
    }

    _createClass(HtmlPropExtensions, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Components.HtmlPropExtensions",
                interfaces: ["FSharpUnion", "System.IEquatable", "System.IComparable", "Fable.Helpers.React.Props.IHTMLProp"],
                cases: [["data-target", "string"]]
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return this === other || this.tag === other.tag && Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(this.data, other.data);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["m" /* compareUnions */])(this, other) | 0;
        }
    }]);

    return HtmlPropExtensions;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.HtmlPropExtensions", HtmlPropExtensions);
var Footer = function (_Component) {
    _inherits(Footer, _Component);

    _createClass(Footer, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(Footer, {
                type: "Components.Footer",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function Footer(props) {
        _classCallCheck(this, Footer);

        var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        return _this;
    }

    _createClass(Footer, [{
        key: "render",
        value: function render() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("footer", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "row"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "col-md-6"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("span", {
                className: "copyright"
            }, Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("Copyright © Goodreads Stats %i", 1))(function () {
                var copyOfStruct = Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["l" /* today */])();
                return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(copyOfStruct) | 0;
            }()))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "col-md-6"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("ul", {
                className: "list-inline social-buttons"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                href: "https://twitter.com/miroveith",
                target: "_blank"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("i", {
                className: "fa fa-twitter"
            }))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                href: "https://github.com/mveith/GoodreadsStats",
                target: "_blank"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("i", {
                className: "fa fa-github"
            }))))))));
        }
    }]);

    return Footer;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.Footer", Footer);
var Header = function (_Component2) {
    _inherits(Header, _Component2);

    _createClass(Header, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(Header, {
                type: "Components.Header",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this2 = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        _this2["init@42-6"] = 1;
        return _this2;
    }

    _createClass(Header, [{
        key: "render",
        value: function render() {
            var _this3 = this;

            var loginButton = !this.props.Logged ? Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("button", {
                id: "login-button",
                className: "btn btn-xl",
                onClick: function onClick(event) {
                    _this3.login(event);
                }
            }, "Login") : " ";
            var demoButton = !this.props.Logged ? Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("button", {
                id: "demo-button",
                className: "btn btn-xl",
                onClick: function onClick(event_1) {
                    _this3.startDemo(event_1);
                }
            }, "Try Demo") : " ";
            var showStatsButton = this.props.Logged ? Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                href: "#basic-stats",
                className: "page-scroll btn btn-xl"
            }, "Show") : " ";
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("header", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "intro-text"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "intro-lead-in"
            }, "Welcome To Bookworm Statistics!"), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "intro-heading"
            }, "Discover bookworm in you."), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "intro-description"
            }, "Based on Goodreads.com profile."), loginButton, " ", demoButton, showStatsButton)));
        }
    }, {
        key: "login",
        value: function login(event) {
            this.props.OnLogin();
        }
    }, {
        key: "startDemo",
        value: function startDemo(event) {
            this.props.StartDemo();
        }
    }]);

    return Header;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.Header", Header);
var Navigation = function (_Component3) {
    _inherits(Navigation, _Component3);

    _createClass(Navigation, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(Navigation, {
                type: "Components.Navigation",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function Navigation(props) {
        _classCallCheck(this, Navigation);

        var _this4 = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        _this4["init@82-7"] = 1;
        return _this4;
    }

    _createClass(Navigation, [{
        key: "render",
        value: function render() {
            var _this5 = this,
                _createElement;

            var menuItems = function menuItems() {
                var menuItemsForLoggedUser = _this5.props.Logged ? Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    className: "page-scroll",
                    href: "#basic-stats"
                }, "Basic statistics")), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    className: "page-scroll",
                    href: "#top-ten"
                }, "Top ten")), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    className: "page-scroll",
                    href: "#charts"
                }, "Charts")), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    className: "page-scroll",
                    href: "#books"
                }, "Books")), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    className: "logout-button",
                    href: "#logout",
                    onClick: function onClick(event) {
                        _this5.logout(event);
                    }
                }, _this5.props.LoggedUserName + " (Logout)"))]) : new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
                var topButton = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("li", {
                    className: "hidden"
                }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                    href: "#page-top"
                }));
                return new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](topButton, menuItemsForLoggedUser);
            };

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("nav", {
                id: "mainNav",
                className: "navbar navbar-default navbar-custom navbar-fixed-top affix-top"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "navbar-header page-scroll"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("button", (_createElement = {
                className: "navbar-toggle"
            }, _defineProperty(_createElement, "data-toggle", "collapse"), _defineProperty(_createElement, "data-target", "#bs-navbar-collapse"), _createElement), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("span", {
                className: "sr-only"
            }, "Toggle navigation"), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("i", {
                className: "fa fa-bars"
            })), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("a", {
                className: "navbar-brand page-scroll",
                href: "#page-top"
            }, "Bookworm Statistics")), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "collapse navbar-collapse",
                id: "bs-navbar-collapse"
            }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"].apply(undefined, ["ul", {
                className: "nav navbar-nav navbar-right"
            }].concat(_toConsumableArray(menuItems()))))));
        }
    }, {
        key: "logout",
        value: function logout(event) {
            this.props.OnLogout();
        }
    }]);

    return Navigation;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.Navigation", Navigation);
var AllBooksSection = function (_Component4) {
    _inherits(AllBooksSection, _Component4);

    _createClass(AllBooksSection, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(AllBooksSection, {
                type: "Components.AllBooksSection",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function AllBooksSection(props) {
        _classCallCheck(this, AllBooksSection);

        var _this6 = _possibleConstructorReturn(this, (AllBooksSection.__proto__ || Object.getPrototypeOf(AllBooksSection)).call(this, props));

        this.state = {
            SelectedFilters: new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]()
        };
        _this6["init@116-8"] = 1;
        return _this6;
    }

    _createClass(AllBooksSection, [{
        key: "render",
        value: function render() {
            var _this7 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("section", {
                id: "books"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "row"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "col-lg-12 text-center"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("h2", {
                className: "section-heading"
            }, "Books"))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "col-md-3  hidden-xs  hidden-sm"
            }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("h4", {}, "Filters"), function () {
                var values = Object(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["f" /* yearFilters */])(_this7.props.ReadBooks);
                return _this7.filterSection(values, "Year");
            }(), function () {
                var values_1 = Object(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["d" /* languageFilters */])(_this7.props.Details);
                return _this7.filterSection(values_1, "Language");
            }(), function () {
                var values_2 = Object(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["e" /* periodFilters */])(_this7.props.Details);
                return _this7.filterSection(values_2, "Period");
            }(), function () {
                var values_3 = Object(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["c" /* genreFilters */])(_this7.props.Details);
                return _this7.filterSection(values_3, "Genre");
            }())), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
                className: "col-md-9"
            }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"].apply(undefined, ["div", {}].concat(_toConsumableArray(function () {
                var clo0 = function clo0(books) {
                    return _this7.images(books);
                };

                return function (arg00) {
                    return clo0(arg00);
                };
            }()(this.props.ReadBooks)))))));
        }
    }, {
        key: "filterSection",
        value: function filterSection(values, title) {
            var _this8 = this;

            var props = {
                ActualFilters: function ActualFilters() {
                    return _this8.state.SelectedFilters;
                },
                OnFilterSelected: function OnFilterSelected(f) {
                    _this8.setState(function () {
                        var inputRecord = _this8.state;
                        return {
                            SelectedFilters: new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](f, _this8.state.SelectedFilters)
                        };
                    }());
                },
                OnFilterUnselected: function OnFilterUnselected(f_1) {
                    _this8.setState(function () {
                        var inputRecord_1 = _this8.state;
                        return {
                            SelectedFilters: Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["g" /* except */])(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([f_1]), _this8.state.SelectedFilters))
                        };
                    }());
                },
                ReadBooks: this.props.ReadBooks,
                Values: values,
                Title: title
            };
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["a" /* FilterSection */], props);
        }
    }, {
        key: "bookImage",
        value: function bookImage(filteredBooks, book) {
            var className = !filteredBooks.has(book.BookId) ? "book-image disabled" : "book-image";
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("img", {
                src: book.SmallImageUrl,
                alt: book.BookTitle,
                title: book.BookTitle,
                className: className
            });
        }
    }, {
        key: "readDate",
        value: function readDate(book) {
            if (book.ReadData == null) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["f" /* minValue */])();
            } else {
                return book.ReadData.ReadAt;
            }
        }
    }, {
        key: "images",
        value: function images(books) {
            var _this9 = this;

            var filteredBooks = Object(__WEBPACK_IMPORTED_MODULE_6__Filtering_fs__["b" /* filterBooks */])(books, this.state.SelectedFilters);
            return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (book) {
                return _this9.bookImage(filteredBooks, book);
            }, Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var1, $var2) {
                return -Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function (book_1) {
                    return _this9.readDate(book_1);
                }($var1), function (book_1) {
                    return _this9.readDate(book_1);
                }($var2));
            }, books)));
        }
    }]);

    return AllBooksSection;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.AllBooksSection", AllBooksSection);
var App = function (_Component5) {
    _inherits(App, _Component5);

    _createClass(App, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(App, {
                type: "Components.App",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function App(props) {
        _classCallCheck(this, App);

        var _this10 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        var objectArg = this.props.Store;

        _this10.dispatch = function (arg00) {
            objectArg.dispatch(arg00);
        };

        this.state = this.getState();
        this.props.Store.subscribe(function ($var3) {
            return function () {
                var objectArg_1 = _this10;
                return function (arg00_1) {
                    objectArg_1.setState(arg00_1);
                };
            }()(function () {
                return _this10.getState();
            }($var3));
        });
        _this10["init@171-9"] = 1;
        return _this10;
    }

    _createClass(App, [{
        key: "render",
        value: function render() {
            var _this11 = this;

            var state = this.getState().State;
            var statsComponents = void 0;

            if (state.Logged) {
                var readBooksWrapper = {
                    ReadBooks: state.ReadBooks,
                    Details: state.BooksDetails
                };
                statsComponents = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__Statistics_StatisticsComponents_fs__["a" /* BasicStatsSection */], readBooksWrapper), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__Statistics_StatisticsComponents_fs__["c" /* TopTenSection */], readBooksWrapper), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__Statistics_StatisticsComponents_fs__["b" /* ChartsSection */], readBooksWrapper), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(AllBooksSection, readBooksWrapper)]);
            } else {
                statsComponents = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
            }

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {}, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Navigation, {
                Logged: state.Logged,
                LoggedUserName: state.LoggedUserName,
                OnLogout: function OnLogout() {
                    _this11.logout();
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Header, {
                OnLogin: function OnLogin() {
                    _this11.login();
                },
                Logged: state.Logged,
                StartDemo: function StartDemo() {
                    _this11.startDemo();
                }
            }), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"].apply(undefined, ["div", {}].concat(_toConsumableArray(statsComponents))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Footer, new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]()));
        }
    }, {
        key: "getState",
        value: function getState() {
            return {
                State: this.props.Store.getState(),
                Dispatch: this.dispatch
            };
        }
    }, {
        key: "saveAndReturnAuthorizationUrl",
        value: function saveAndReturnAuthorizationUrl(authData) {
            Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__["b" /* setCookie */])("authorizationToken", authData.Token, 1);
            Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__["b" /* setCookie */])("authorizationTokenSecret", authData.TokenSecret, 1);
            return authData.Url;
        }
    }, {
        key: "clearData",
        value: function clearData() {
            Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__["a" /* removeCookie */])("accessToken");
            Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__["a" /* removeCookie */])("accessTokenSecret");
            Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Global_fs__["a" /* removeCookie */])("userName");
            Object(__WEBPACK_IMPORTED_MODULE_10__ReadBooksStorage_fs__["b" /* clearReadBooks */])();
            Object(__WEBPACK_IMPORTED_MODULE_10__ReadBooksStorage_fs__["a" /* clearDetails */])();
        }
    }, {
        key: "login",
        value: function login() {
            var _this12 = this;

            this.clearData();
            var url = Object(__WEBPACK_IMPORTED_MODULE_11__Utils_fs__["b" /* completeUrlWithClientUrl */])("authorizationUrl");
            Object(__WEBPACK_IMPORTED_MODULE_12_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__["a" /* fetchAs */])(url, new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](), {
                T: __WEBPACK_IMPORTED_MODULE_13__Model_fs__["b" /* AuthorizationUserData */]
            }).then(function ($var4) {
                return function (url_1) {
                    Object(__WEBPACK_IMPORTED_MODULE_11__Utils_fs__["e" /* navigateTo */])(url_1);
                }(function (authData) {
                    return _this12.saveAndReturnAuthorizationUrl(authData);
                }($var4));
            });
        }
    }, {
        key: "startDemo",
        value: function startDemo() {
            this.clearData();
            this.dispatch({
                type: "StartDemo"
            });
        }
    }, {
        key: "logout",
        value: function logout() {
            this.clearData();
            Object(__WEBPACK_IMPORTED_MODULE_11__Utils_fs__["e" /* navigateTo */])("/");
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Components.App", App);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Filter */
/* unused harmony export optionLabel */
/* unused harmony export year */
/* harmony export (immutable) */ __webpack_exports__["f"] = yearFilters;
/* harmony export (immutable) */ __webpack_exports__["d"] = languageFilters;
/* unused harmony export bookInPeriod */
/* unused harmony export periodBooks */
/* harmony export (immutable) */ __webpack_exports__["e"] = periodFilters;
/* unused harmony export genreAndBookTuples */
/* harmony export (immutable) */ __webpack_exports__["c"] = genreFilters;
/* harmony export (immutable) */ __webpack_exports__["b"] = filterBooks;
/* unused harmony export FilterItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Periods_fs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Comparer__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
















var Filter = function () {
    function Filter(books, category) {
        _classCallCheck(this, Filter);

        this.Books = books;
        this.Category = category;
    }

    _createClass(Filter, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "Filtering.Filter",
                interfaces: ["FSharpRecord", "System.IEquatable", "System.IComparable"],
                properties: {
                    Books: Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["v" /* makeGeneric */])(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */], {
                        T: "number"
                    }),
                    Category: "string"
                }
            };
        }
    }, {
        key: "Equals",
        value: function Equals(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["q" /* equalsRecords */])(this, other);
        }
    }, {
        key: "CompareTo",
        value: function CompareTo(other) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["l" /* compareRecords */])(this, other) | 0;
        }
    }]);

    return Filter;
}();
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Filtering.Filter", Filter);
function optionLabel(_arg1) {
    if (_arg1 == null) {
        return "Empty";
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%O", 1))(_arg1);
    }
}
function year(book) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["o" /* defaultArg */])(book.ReadData, null, function (rd) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(rd.ReadAt);
    });
}
function yearFilters(books) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var1, $var2) {
        return -Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function (tuple) {
            return tuple[0];
        }($var1), function (tuple) {
            return tuple[0];
        }($var2));
    }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tupledArg) {
        return [optionLabel(tupledArg[0]), new Filter(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (b) {
            return b.BookId;
        }, tupledArg[1])), "Years")];
    }, function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(function (book) {
            return year(book);
        }, source);
    }(books))));
}
function languageFilters(details) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tupledArg) {
        return [optionLabel(tupledArg[0]), new Filter(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (d) {
            return d.Id;
        }, tupledArg[1])), "Languages")];
    }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var4, $var5) {
        return -Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function ($var3) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var3[1]);
        }($var4), function ($var3) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var3[1]);
        }($var5));
    }, Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(function (d_1) {
        return d_1.Language;
    }, details))));
}
function bookInPeriod(book, periodLabel, min, max) {
    if (book.OriginalPublicationYear == null) {
        return false;
    } else if (min <= book.OriginalPublicationYear) {
        return book.OriginalPublicationYear <= max;
    } else {
        return false;
    }
}
function periodBooks(allBooks, period) {
    if (period == null) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (b) {
            return b.OriginalPublicationYear == null;
        }, allBooks));
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (b_1) {
            return bookInPeriod(b_1, period[0], period[1], period[2]);
        }, allBooks));
    }
}
function periodFilters(details) {
    var periodLabel = function periodLabel(_arg1) {
        if (_arg1 == null) {
            return "Empty";
        } else {
            var label = _arg1[0];
            return label;
        }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (tupledArg) {
        return !Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["n" /* isEmpty */])(tupledArg[1].Books);
    }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (p) {
        return [periodLabel(p), new Filter(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (b) {
            return b.Id;
        }, periodBooks(details, p))), "Periods")];
    }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["v" /* reverse */])(new __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](null, Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["d" /* map */])(function (arg0) {
        return arg0;
    }, __WEBPACK_IMPORTED_MODULE_7__Periods_fs__["a" /* periods */]))))));
}
function genreAndBookTuples(detail) {
    if (detail.Genres.length === 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([[null, detail.Id]]);
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (g) {
            return [g, detail.Id];
        }, detail.Genres));
    }
}
function genreFilters(details) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tupledArg) {
        return [optionLabel(tupledArg[0]), new Filter(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tuple) {
            return tuple[1];
        }, tupledArg[1])), "Genres")];
    }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var7, $var8) {
        return -Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function ($var6) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var6[1]);
        }($var7), function ($var6) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var6[1]);
        }($var8));
    }, Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(function (tuple_1) {
        return tuple_1[0];
    }, function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(function (detail) {
            return genreAndBookTuples(detail);
        }, source);
    }(details)))));
}
function filterBooks(books, filters) {
    var books_1 = Object(__WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__["a" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (b) {
        return b.BookId;
    }, books), new __WEBPACK_IMPORTED_MODULE_9_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Comparer__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["k" /* comparePrimitives */]));

    if (filters.tail == null) {
        return books_1;
    } else {
        var groupedFilters = Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(function (f) {
            return f.Category;
        }, filters);
        var availableBooksByCategories = Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tupledArg) {
            return Object(__WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__["a" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(function (f_1) {
                return f_1.Books;
            }, tupledArg[1]), new __WEBPACK_IMPORTED_MODULE_9_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Comparer__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["k" /* comparePrimitives */]));
        }, groupedFilters);
        return function () {
            var folder = function folder(set1, set2) {
                return Object(__WEBPACK_IMPORTED_MODULE_8_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Set__["d" /* intersect */])(set1, set2);
            };

            return function (source) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["j" /* fold */])(folder, books_1, source);
            };
        }()(availableBooksByCategories);
    }
}
var FilterItem = function (_Component) {
    _inherits(FilterItem, _Component);

    _createClass(FilterItem, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(FilterItem, {
                type: "Filtering.FilterItem",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function FilterItem(props) {
        _classCallCheck(this, FilterItem);

        var _this = _possibleConstructorReturn(this, (FilterItem.__proto__ || Object.getPrototypeOf(FilterItem)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        _this["init@85"] = 1;
        return _this;
    }

    _createClass(FilterItem, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var id = void 0;
            var copyOfStruct = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["b" /* newGuid */])();
            id = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["y" /* toString */])(copyOfStruct);
            var badgeLabel = void 0;
            var withFilter = this.props.WithFilterBooksCount() | 0;
            var withoutFilter = this.props.WithoutFilterBooksCount() | 0;

            if (withFilter > withoutFilter) {
                badgeLabel = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("+%i", 1))(withFilter - withoutFilter);
            } else {
                badgeLabel = Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["y" /* toString */])(withFilter);
            }

            var badge = this.props.IsSelected ? new __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]() : Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([badgeLabel]);
            return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("li", {
                className: "list-group-item no-wrap"
            }, Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("input", {
                id: id,
                type: "checkbox",
                onChange: function onChange(e) {
                    _this2.onChange(e);
                },
                checked: this.props.IsSelected
            }), Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("label", {
                htmlFor: id,
                className: "filter-label"
            }, this.props.Title), __WEBPACK_IMPORTED_MODULE_10_react__["createElement"].apply(undefined, ["span", {
                className: "badge"
            }].concat(_toConsumableArray(badge))));
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            if (this.props.IsSelected) {
                this.props.OnUnselected();
            } else {
                this.props.OnSelected();
            }
        }
    }]);

    return FilterItem;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Filtering.FilterItem", FilterItem);
var FilterSection = function (_Component2) {
    _inherits(FilterSection, _Component2);

    _createClass(FilterSection, [{
        key: __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(FilterSection, {
                type: "Filtering.FilterSection",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function FilterSection(props) {
        _classCallCheck(this, FilterSection);

        var _this3 = _possibleConstructorReturn(this, (FilterSection.__proto__ || Object.getPrototypeOf(FilterSection)).call(this, props));

        this.state = {
            AllItemsVisible: false
        };
        _this3.maxVisibleFilterItems = 5;
        _this3["init@125-1"] = 1;
        return _this3;
    }

    _createClass(FilterSection, [{
        key: "render",
        value: function render() {
            var _this4 = this;

            var items = function () {
                var clo0 = function clo0(values, actualFilters, allItemsVisible) {
                    return _this4.visibleItems(values, actualFilters, allItemsVisible);
                };

                return Object(__WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function (arg00) {
                    var clo1 = Object(__WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["b" /* partialApply */])(clo0, [arg00]);
                    return function (arg10) {
                        var clo2 = Object(__WEBPACK_IMPORTED_MODULE_11_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["b" /* partialApply */])(clo1, [arg10]);
                        return function (arg20) {
                            return clo2(arg20);
                        };
                    };
                });
            }()(this.props.Values, this.props.ActualFilters(), this.state.AllItemsVisible);

            var changeItemsVisibility = function changeItemsVisibility(_arg1) {
                _this4.setState(function () {
                    var inputRecord = _this4.state;
                    return {
                        AllItemsVisible: !_this4.state.AllItemsVisible
                    };
                }());
            };

            var changeItemsVisibilityLink = void 0;
            var label = this.state.AllItemsVisible ? "Show less" : "Show all";
            changeItemsVisibilityLink = Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("li", {
                className: "list-group-item change-visibility-link",
                onClick: changeItemsVisibility
            }, Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("a", {}, label));
            var items_1 = this.props.Values.length > this.maxVisibleFilterItems ? Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["a" /* append */])(items, Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([changeItemsVisibilityLink])) : items;
            return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("div", {}, Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])("h5", {}, this.props.Title), __WEBPACK_IMPORTED_MODULE_10_react__["createElement"].apply(undefined, ["ul", {
                className: "list-group"
            }].concat(_toConsumableArray(items_1))));
        }
    }, {
        key: "filter",
        value: function filter(title, f) {
            var _this5 = this;

            var actualFilters = this.props.ActualFilters();
            var props = {
                Title: title,
                OnSelected: function OnSelected() {
                    _this5.props.OnFilterSelected(f);
                },
                OnUnselected: function OnUnselected() {
                    _this5.props.OnFilterUnselected(f);
                },
                WithFilterBooksCount: function WithFilterBooksCount() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(filterBooks(_this5.props.ReadBooks, new __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](f, actualFilters)));
                },
                WithoutFilterBooksCount: function WithoutFilterBooksCount() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(filterBooks(_this5.props.ReadBooks, actualFilters));
                },
                IsSelected: Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["h" /* exists */])(function ($var9) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(f, $var9);
                }, actualFilters)
            };
            return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])(FilterItem, props);
        }
    }, {
        key: "visibleItems",
        value: function visibleItems(values, actualFilters, allItemsVisible) {
            var _this6 = this;

            var items = Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (tupledArg) {
                return [tupledArg[1], _this6.filter(tupledArg[0], tupledArg[1])];
            }, values));

            if (allItemsVisible) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["d" /* map */])(function (tuple) {
                    return tuple[1];
                }, items);
            } else {
                var selectedItems = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["d" /* map */])(function (tuple_1) {
                    return tuple_1[1];
                }, Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["c" /* filter */])(function (tupledArg_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["h" /* exists */])(function ($var10) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(tupledArg_1[0], $var10);
                    }, actualFilters);
                }, items));
                var notSelectedItems = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["d" /* map */])(function (tuple_2) {
                    return tuple_2[1];
                }, Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["c" /* filter */])(function (tupledArg_2) {
                    return !Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["h" /* exists */])(function ($var11) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(tupledArg_2[0], $var11);
                    }, actualFilters);
                }, items));
                var notSelectedItemsToShow = Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(this.maxVisibleFilterItems - selectedItems.length, notSelectedItems));
                return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["c" /* filter */])(function (el) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["h" /* exists */])(function ($var12) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(el, $var12);
                    }, selectedItems) ? true : Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["h" /* exists */])(function ($var13) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["p" /* equals */])(el, $var13);
                    }, notSelectedItemsToShow);
                }, Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["d" /* map */])(function (tuple_3) {
                    return tuple_3[1];
                }, items));
            }
        }
    }]);

    return FilterSection;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Filtering.FilterSection", FilterSection);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BasicStatsTable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasicStatsSection; });
/* unused harmony export TopDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TopTenSection; });
/* unused harmony export ChartDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChartsSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicStatsCalculator_fs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TopTables_fs__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Charts_fs__ = __webpack_require__(74);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var BasicStatsTable = function (_Component) {
    _inherits(BasicStatsTable, _Component);

    _createClass(BasicStatsTable, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(BasicStatsTable, {
                type: "StatisticsComponents.BasicStatsTable",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function BasicStatsTable(props) {
        _classCallCheck(this, BasicStatsTable);

        var _this = _possibleConstructorReturn(this, (BasicStatsTable.__proto__ || Object.getPrototypeOf(BasicStatsTable)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        _this["init@17-2"] = 1;
        return _this;
    }

    _createClass(BasicStatsTable, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var stats = this.props.BasicStats;
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "row text-center"
            }, function () {
                var content = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([stats.BooksCount]);
                return _this2.valueBox("Books count", "book", content);
            }(), function () {
                var content_1 = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([stats.PagesCount]);
                return _this2.valueBox("Number of pages", "database", content_1);
            }(), function () {
                var content_2 = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%.1f pages", 1))(stats.AveragePagesCount)]);
                return _this2.valueBox("Average book", "arrows-h", content_2);
            }(), function () {
                var content_3 = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%.2f pages / day", 1))(stats.AverageSpeed)]);
                return _this2.valueBox("Average speed", "bolt", content_3);
            }(), function () {
                var content_4 = _this2.bookDescription(stats.FastestBook);

                return _this2.valueBox("Fastest book", "thumbs-up", content_4);
            }(), function () {
                var content_5 = _this2.bookDescription(stats.SlowestBook);

                return _this2.valueBox("Slowest book", "bed", content_5);
            }());
        }
    }, {
        key: "image",
        value: function image(icon) {
            var iconStyle = Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("fa fa-%s fa-stack-1x fa-inverse", 1))(icon);
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {
                className: "fa-stack fa-4x"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("i", {
                className: "fa fa-circle fa-stack-2x text-primary"
            }), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("i", {
                className: iconStyle
            }));
        }
    }, {
        key: "bookDescription",
        value: function bookDescription(book) {
            if (book == null) {
                return new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
            } else {
                return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {}, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("b", {}, book.Book.BookTitle)), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("i", {}, "by"), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {}, book.Book.AuthorName), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("(%.2f pages / day)", 1))(book.Book.NumPages / book.DaysCount)]);
            }
        }
    }, {
        key: "valueBox",
        value: function valueBox(label, icon, content) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-md-2"
            }, this.image(icon), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h4", {
                className: "service-heading"
            }, label), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, ["p", {
                className: "text-muted"
            }].concat(_toConsumableArray(content))));
        }
    }]);

    return BasicStatsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.BasicStatsTable", BasicStatsTable);
var BasicStatsSection = function (_Component2) {
    _inherits(BasicStatsSection, _Component2);

    _createClass(BasicStatsSection, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(BasicStatsSection, {
                type: "StatisticsComponents.BasicStatsSection",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function BasicStatsSection(props) {
        _classCallCheck(this, BasicStatsSection);

        var _this3 = _possibleConstructorReturn(this, (BasicStatsSection.__proto__ || Object.getPrototypeOf(BasicStatsSection)).call(this, props));

        this.state = new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
        _this3["init@59-3"] = 1;
        return _this3;
    }

    _createClass(BasicStatsSection, [{
        key: "render",
        value: function render() {
            var _this4 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("section", {
                id: "basic-stats"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "row"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-lg-12 text-center"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h2", {
                className: "section-heading"
            }, "Basic statistics"), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h3", {
                className: "section-subheading text-muted"
            }, "Basic statistics for read books."))), function () {
                var readBooks = _this4.props.ReadBooks;
                return _this4.statsTable(readBooks);
            }()));
        }
    }, {
        key: "statsTable",
        value: function statsTable(readBooks) {
            if (readBooks.length === 0) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                    className: "row text-center"
                }, "Building stats...");
            } else {
                var stats = Object(__WEBPACK_IMPORTED_MODULE_5__BasicStatsCalculator_fs__["b" /* basicStats */])(readBooks);
                return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(BasicStatsTable, {
                    BasicStats: stats
                });
            }
        }
    }]);

    return BasicStatsSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.BasicStatsSection", BasicStatsSection);
var TopDescription = function () {
    function TopDescription(key, tableFactory, title) {
        _classCallCheck(this, TopDescription);

        this.Key = key;
        this.TableFactory = tableFactory;
        this.Title = title;
    }

    _createClass(TopDescription, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "StatisticsComponents.TopDescription",
                interfaces: ["FSharpRecord"],
                properties: {
                    Key: "string",
                    TableFactory: Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["c" /* Function */])([Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["h" /* Tuple */])([Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_6__Model_fs__["i" /* ReadBook */]), Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_6__Model_fs__["d" /* BookDetail */])]), Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["e" /* Interface */])("Fable.Import.React.ReactElement")]),
                    Title: "string"
                }
            };
        }
    }]);

    return TopDescription;
}();
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.TopDescription", TopDescription);
var TopTenSection = function (_Component3) {
    _inherits(TopTenSection, _Component3);

    _createClass(TopTenSection, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(TopTenSection, {
                type: "StatisticsComponents.TopTenSection",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function TopTenSection(props) {
        _classCallCheck(this, TopTenSection);

        var _this5 = _possibleConstructorReturn(this, (TopTenSection.__proto__ || Object.getPrototypeOf(TopTenSection)).call(this, props));

        this.state = {
            SelectedKey: "Fastest"
        };
        _this5.tops = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new TopDescription("Fastest", function ($var2) {
            return function (rows) {
                return _this5.table(rows);
            }(function ($var1) {
                return function (source) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["g" /* booksBySpeed */])($var1));
            }($var2));
        }, "Fastest books"), new TopDescription("Slowest", function ($var5) {
            return function (rows_1) {
                return _this5.table(rows_1);
            }(function ($var4) {
                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_1);
                }(function ($var3) {
                    return function (list) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["f" /* reverse */])(list);
                    }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["g" /* booksBySpeed */])($var3));
                }($var4));
            }($var5));
        }, "Slowest books"), new TopDescription("Longest", function ($var7) {
            return function (rows_2) {
                return _this5.table(rows_2);
            }(function ($var6) {
                return function (source_2) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_2);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["d" /* booksByLength */])($var6));
            }($var7));
        }, "Longest books*"), new TopDescription("Shortest", function ($var10) {
            return function (rows_3) {
                return _this5.table(rows_3);
            }(function ($var9) {
                return function (source_3) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_3);
                }(function ($var8) {
                    return function (list_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["f" /* reverse */])(list_1);
                    }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["d" /* booksByLength */])($var8));
                }($var9));
            }($var10));
        }, "Shortest books*"), new TopDescription("Authors", function ($var12) {
            return function (rows_4) {
                return _this5.table(rows_4);
            }(function ($var11) {
                return function (source_4) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_4);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["a" /* booksByAuthors */])($var11));
            }($var12));
        }, "Top authors*"), new TopDescription("Genres", function ($var14) {
            return function (rows_5) {
                return _this5.table(rows_5);
            }(function ($var13) {
                return function (source_5) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_5);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["b" /* booksByGenres */])($var13));
            }($var14));
        }, "Top genres*"), new TopDescription("Shelves", function ($var16) {
            return function (rows_6) {
                return _this5.table(rows_6);
            }(function ($var15) {
                return function (source_6) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_6);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["f" /* booksByShelves */])($var15));
            }($var16));
        }, "Top shelves*"), new TopDescription("Periods", function ($var18) {
            return function (rows_7) {
                return _this5.table(rows_7);
            }(function ($var17) {
                return function (source_7) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_7);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["e" /* booksByPeriods */])($var17));
            }($var18));
        }, "Top periods*"), new TopDescription("Language", function ($var20) {
            return function (rows_8) {
                return _this5.table(rows_8);
            }(function ($var19) {
                return function (source_8) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["C" /* truncate */])(10, source_8);
                }(Object(__WEBPACK_IMPORTED_MODULE_8__TopTables_fs__["c" /* booksByLanguages */])($var19));
            }($var20));
        }, "Top language*")]);
        _this5["init@84-4"] = 1;
        return _this5;
    }

    _createClass(TopTenSection, [{
        key: "render",
        value: function render() {
            var _this6 = this;

            var topMenuItems = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (t) {
                return _this6.topMenuItem(t);
            }, this.tops));
            var selectedTop = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["m" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (t_1) {
                return t_1.Key === _this6.state.SelectedKey;
            }, this.tops));
            var selectedTopTable = selectedTop.TableFactory([this.props.ReadBooks, this.props.Details]);
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("section", {
                id: "top-ten"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "row"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-lg-12 text-center"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h2", {
                className: "section-heading"
            }, "TOP 10"))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-md-3"
            }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, ["ul", {
                className: "nav nav-pills nav-stacked"
            }].concat(_toConsumableArray(topMenuItems))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {}, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("i", {}, Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("* From all %i read books ", 1))(this.props.ReadBooks.length)))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-md-9"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h4", {
                className: "service-heading"
            }, selectedTop.Title), selectedTopTable)));
        }
    }, {
        key: "table",
        value: function table(rows) {
            var createRow = function createRow(rank, rowContent, value) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("tr", {}, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("td", {}, rank), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, ["td", {}].concat(_toConsumableArray(rowContent))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("td", {}, value));
            };

            var rows_1 = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["r" /* mapIndexed */])(function (index, tupledArg) {
                return createRow(index + 1, tupledArg[0], tupledArg[1]);
            }, rows));
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("table", {
                className: "table table-hover"
            }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, ["tbody", {}].concat(_toConsumableArray(rows_1))));
        }
    }, {
        key: "selectTop",
        value: function selectTop(t) {
            this.setState({
                SelectedKey: t.Key
            });
        }
    }, {
        key: "topMenuItem",
        value: function topMenuItem(t) {
            var _this7 = this;

            var className = this.state.SelectedKey === t.Key ? "active" : "";
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("li", {
                role: "presentation",
                onClick: function onClick(_arg1) {
                    _this7.selectTop(t);
                },
                className: className
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("a", {}, t.Title));
        }
    }]);

    return TopTenSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.TopTenSection", TopTenSection);
var ChartDescription = function () {
    function ChartDescription(key, dataFactory, title, legend) {
        _classCallCheck(this, ChartDescription);

        this.Key = key;
        this.DataFactory = dataFactory;
        this.Title = title;
        this.Legend = legend;
    }

    _createClass(ChartDescription, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return {
                type: "StatisticsComponents.ChartDescription",
                interfaces: ["FSharpRecord"],
                properties: {
                    Key: "string",
                    DataFactory: Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["c" /* Function */])([Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["h" /* Tuple */])([Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_6__Model_fs__["i" /* ReadBook */]), Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["b" /* Array */])(__WEBPACK_IMPORTED_MODULE_6__Model_fs__["d" /* BookDetail */])]), __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["c" /* ChartData */]]),
                    Title: "string",
                    Legend: Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["g" /* Option */])(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["f" /* ChartLegend */])
                }
            };
        }
    }]);

    return ChartDescription;
}();
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.ChartDescription", ChartDescription);
var ChartsSection = function (_Component4) {
    _inherits(ChartsSection, _Component4);

    _createClass(ChartsSection, [{
        key: __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
        value: function value() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["s" /* extendInfo */])(ChartsSection, {
                type: "StatisticsComponents.ChartsSection",
                interfaces: [],
                properties: {}
            });
        }
    }]);

    function ChartsSection(props) {
        _classCallCheck(this, ChartsSection);

        var _this8 = _possibleConstructorReturn(this, (ChartsSection.__proto__ || Object.getPrototypeOf(ChartsSection)).call(this, props));

        this.state = {
            SelectedKey: "BooksCount",
            Chart: null
        };
        _this8.charts = Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([new ChartDescription("BooksCount", function ($var21) {
            return function (data) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["b" /* barChartData */])(data);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["e" /* booksByYearOfRead */])($var21));
        }, "Books count", null), new ChartDescription("PagesCount", function ($var22) {
            return function (data_1) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["b" /* barChartData */])(data_1);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["i" /* pagesCountByYearOfRead */])($var22));
        }, "Pages count", null), new ChartDescription("NewAuthors", function ($var23) {
            return function (data_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["b" /* barChartData */])(data_2);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["h" /* newAuthorsByYears */])($var23));
        }, "New authors", null), new ChartDescription("AverageSpeed", function ($var24) {
            return function (data_3) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["g" /* lineChartData */])(data_3);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["a" /* averageSpeedByYears */])($var24));
        }, "Average speed", null), new ChartDescription("Shelves", function ($var25) {
            return function (data_4) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["j" /* pieChartData */])(data_4);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["d" /* booksByShelves */])($var25));
        }, "Shelves", new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["f" /* ChartLegend */](new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["k" /* LegendPosition */](3), null)), new ChartDescription("Periods", function ($var26) {
            return function (data_5) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["j" /* pieChartData */])(data_5);
            }(Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["c" /* booksByPeriods */])($var26));
        }, "Periods", new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["f" /* ChartLegend */](new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["k" /* LegendPosition */](3), null))]);
        _this8["init@141-5"] = 1;
        return _this8;
    }

    _createClass(ChartsSection, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this9 = this;

            var selectedChart = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["m" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (ch) {
                return ch.Key === _this9.state.SelectedKey;
            }, this.charts));
            var chart = Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["k" /* renderChart */])(selectedChart.DataFactory([this.props.ReadBooks, this.props.Details]), "myChart", selectedChart.Legend);
            this.setState(function () {
                var inputRecord = _this9.state;
                var Chart = chart;
                return {
                    SelectedKey: inputRecord.SelectedKey,
                    Chart: Chart
                };
            }());
        }
    }, {
        key: "render",
        value: function render() {
            var _this10 = this;

            var selectedChart = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["m" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (ch) {
                return ch.Key === _this10.state.SelectedKey;
            }, this.charts));
            var chartItems = Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (ch_1) {
                return _this10.chartMenuItem(ch_1);
            }, this.charts));
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("section", {
                id: "charts"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "container"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "row"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-lg-12 text-center"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h2", {
                className: "section-heading"
            }, "Charts"))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-md-3"
            }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, ["ul", {
                className: "nav nav-pills nav-stacked"
            }].concat(_toConsumableArray(chartItems)))), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
                className: "col-md-9"
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h4", {
                className: "service-heading"
            }, selectedChart.Title), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("canvas", {
                id: "myChart"
            }))));
        }
    }, {
        key: "selectChart",
        value: function selectChart(ch) {
            var _this11 = this;

            Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["f" /* destroyExistingChart */])(this.state.Chart);
            var chart = Object(__WEBPACK_IMPORTED_MODULE_10__Charts_fs__["k" /* renderChart */])(ch.DataFactory([this.props.ReadBooks, this.props.Details]), "myChart", ch.Legend);
            this.setState(function () {
                var inputRecord = _this11.state;
                return {
                    SelectedKey: ch.Key,
                    Chart: chart
                };
            }());
        }
    }, {
        key: "chartMenuItem",
        value: function chartMenuItem(ch) {
            var _this12 = this;

            var className = this.state.SelectedKey === ch.Key ? "active" : "";
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("li", {
                role: "presentation",
                onClick: function onClick(_arg2) {
                    _this12.selectChart(ch);
                },
                className: className
            }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("a", {}, ch.Title));
        }
    }]);

    return ChartsSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("StatisticsComponents.ChartsSection", ChartsSection);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getBookContent */
/* unused harmony export readBooks */
/* unused harmony export details */
/* unused harmony export validBooks */
/* unused harmony export booksSpeed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return booksBySpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return booksByLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return booksByAuthors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return booksByGenres; });
/* unused harmony export yearPeriods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return booksByPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return booksByLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return booksByShelves; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BasicStatsCalculator_fs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Periods_fs__ = __webpack_require__(16);










function getBookContent(book) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("b", {}, book.BookTitle), Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("i", {}, "by"), Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("br", {}), Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, book.AuthorName)]);
}
function readBooks(_arg1_0, _arg1_1) {
    var _arg1 = [_arg1_0, _arg1_1];
    return _arg1[0];
}
function details(_arg1_0, _arg1_1) {
    var _arg1 = [_arg1_0, _arg1_1];
    return _arg1[1];
}
var validBooks = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var1) {
    return function (readBooks_1) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__BasicStatsCalculator_fs__["d" /* validBooks */])(readBooks_1);
    }(function (tupledArg) {
        return readBooks(tupledArg[0], tupledArg[1]);
    }($var1));
});
var booksSpeed = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var2) {
    return function (validBooks_1) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__BasicStatsCalculator_fs__["c" /* booksSpeed */])(validBooks_1);
    }(validBooks($var2));
});
var booksBySpeed = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var4) {
    return function (source_1) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_1);
    }(function ($var3) {
        return function () {
            var mapping = function mapping(b) {
                return [getBookContent(b.Book), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%.2f pages / day", 1))(b.Speed)];
            };

            return function (source) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source);
            };
        }()(booksSpeed($var3));
    }($var4));
});
var booksByLength = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var10) {
    return function (source_3) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_3);
    }(function ($var9) {
        return function () {
            var mapping = function mapping(b_2) {
                return [getBookContent(b_2), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i pages", 1))(b_2.NumPages)];
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
            };
        }()(function ($var8) {
            return function () {
                var projection = function projection(b_1) {
                    return b_1.NumPages | 0;
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var6, $var7) {
                        return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection($var6), projection($var7));
                    }, source_1);
                };
            }()(function ($var5) {
                return function () {
                    var predicate = function predicate(b) {
                        return b.NumPages > 0;
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(predicate, source);
                    };
                }()(function (tupledArg) {
                    return readBooks(tupledArg[0], tupledArg[1]);
                }($var5));
            }($var8));
        }($var9));
    }($var10));
});
var booksByAuthors = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var17) {
    return function (source_3) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_3);
    }(function ($var16) {
        return function () {
            var mapping = function mapping(tupledArg_1) {
                return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, tupledArg_1[0])]), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i books", 1))(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1]))];
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
            };
        }()(function ($var15) {
            return function () {
                var projection_1 = function projection_1($var12) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var12[1]) | 0;
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var13, $var14) {
                        return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var13), projection_1($var14));
                    }, source_1);
                };
            }()(function ($var11) {
                return function () {
                    var projection = function projection(b) {
                        return b.AuthorName;
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source);
                    };
                }()(function (tupledArg) {
                    return readBooks(tupledArg[0], tupledArg[1]);
                }($var11));
            }($var15));
        }($var16));
    }($var17));
});
var booksByGenres = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var24) {
    return function () {
        var mapping_1 = function mapping_1(tupledArg_1) {
            return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, tupledArg_1[0])]), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i books", 1))(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1]))];
        };

        return function (source_3) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping_1, source_3);
        };
    }()(function ($var23) {
        return function () {
            var projection_1 = function projection_1($var20) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var20[1]) | 0;
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var21, $var22) {
                    return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var21), projection_1($var22));
                }, source_2);
            };
        }()(function ($var19) {
            return function () {
                var projection = function projection(tuple) {
                    return tuple[0];
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                };
            }()(function ($var18) {
                return function () {
                    var mapping = function mapping(d) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (s) {
                            return [s, d.Id];
                        }, d.Genres);
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(mapping, source);
                    };
                }()(function (tupledArg) {
                    return details(tupledArg[0], tupledArg[1]);
                }($var18));
            }($var19));
        }($var23));
    }($var24));
});
function yearPeriods(year) {
    if (year == null) {
        return new __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (tupledArg) {
            return tupledArg[1] <= year ? year <= tupledArg[2] : false;
        }, __WEBPACK_IMPORTED_MODULE_8__Periods_fs__["a" /* periods */]));
    }
}
var booksByPeriods = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var31) {
    return function () {
        var mapping_1 = function mapping_1(tupledArg_1) {
            return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, tupledArg_1[0][0])]), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i books", 1))(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1]))];
        };

        return function (source_3) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping_1, source_3);
        };
    }()(function ($var30) {
        return function () {
            var projection_1 = function projection_1($var27) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var27[1]) | 0;
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var28, $var29) {
                    return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var28), projection_1($var29));
                }, source_2);
            };
        }()(function ($var26) {
            return function () {
                var projection = function projection(tuple) {
                    return tuple[0];
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                };
            }()(function ($var25) {
                return function () {
                    var mapping = function mapping(d) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (p) {
                            return [p, d];
                        }, yearPeriods(d.OriginalPublicationYear));
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(mapping, source);
                    };
                }()(function (tupledArg) {
                    return details(tupledArg[0], tupledArg[1]);
                }($var25));
            }($var26));
        }($var30));
    }($var31));
});
var booksByLanguages = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function () {
    var label = function label(lang) {
        if (lang != null) {
            return lang;
        } else {
            return "Not set";
        }
    };

    return function ($var37) {
        return function () {
            var mapping = function mapping(tupledArg_1) {
                return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, label(tupledArg_1[0]))]), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i books", 1))(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1]))];
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
            };
        }()(function ($var36) {
            return function () {
                var projection_1 = function projection_1($var33) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var33[1]) | 0;
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var34, $var35) {
                        return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var34), projection_1($var35));
                    }, source_1);
                };
            }()(function ($var32) {
                return function () {
                    var projection = function projection(d) {
                        return d.Language;
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source);
                    };
                }()(function (tupledArg) {
                    return details(tupledArg[0], tupledArg[1]);
                }($var32));
            }($var36));
        }($var37));
    };
}());
var booksByShelves = Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function () {
    var shelveBookPairs = function shelveBookPairs(book) {
        if (book.Shelves.length === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["x" /* singleton */])(["no shelf", book]);
        } else {
            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (s) {
                return [s, book];
            }, book.Shelves);
        }
    };

    return function ($var45) {
        return function (source_4) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_4);
        }(function ($var44) {
            return function () {
                var mapping = function mapping(tupledArg_1) {
                    return [Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["e" /* ofArray */])([Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("span", {}, tupledArg_1[0])]), Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("%i books", 1))(Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1]))];
                };

                return function (source_3) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_3);
                };
            }()(function ($var43) {
                return function () {
                    var projection_1 = function projection_1($var40) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var40[1]) | 0;
                    };

                    return function (source_2) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var41, $var42) {
                            return -Object(__WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var41), projection_1($var42));
                        }, source_2);
                    };
                }()(function ($var39) {
                    return function () {
                        var projection = function projection(tuple) {
                            return tuple[0];
                        };

                        return function (source_1) {
                            return Object(__WEBPACK_IMPORTED_MODULE_7_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                        };
                    }()(function ($var38) {
                        return function (source) {
                            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(shelveBookPairs, source);
                        }(function (tupledArg) {
                            return readBooks(tupledArg[0], tupledArg[1]);
                        }($var38));
                    }($var39));
                }($var43));
            }($var44));
        }($var45));
    };
}());

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export readBooks */
/* unused harmony export details */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return booksByYearOfRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pagesCountByYearOfRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return newAuthorsByYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return averageSpeedByYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return booksByShelves; });
/* unused harmony export yearPeriods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return booksByPeriods; });
/* unused harmony export random */
/* unused harmony export randomColors */
/* harmony export (immutable) */ __webpack_exports__["b"] = barChartData;
/* harmony export (immutable) */ __webpack_exports__["g"] = lineChartData;
/* harmony export (immutable) */ __webpack_exports__["j"] = pieChartData;
/* unused harmony export scales */
/* harmony export (immutable) */ __webpack_exports__["k"] = renderChart;
/* harmony export (immutable) */ __webpack_exports__["f"] = destroyExistingChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicStatsCalculator_fs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Periods_fs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Colors_fs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__ = __webpack_require__(32);










function readBooks(_arg1_0, _arg1_1) {
    var _arg1 = [_arg1_0, _arg1_1];
    return _arg1[0];
}
function details(_arg1_0, _arg1_1) {
    var _arg1 = [_arg1_0, _arg1_1];
    return _arg1[1];
}
var booksByYearOfRead = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var7) {
    return function (source_4) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_4);
    }(function ($var6) {
        return function () {
            var projection_1 = function projection_1(tuple) {
                return tuple[0];
            };

            return function (source_3) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var4, $var5) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var4), projection_1($var5));
                }, source_3);
            };
        }()(function ($var3) {
            return function () {
                var mapping = function mapping(tupledArg_1) {
                    return [tupledArg_1[0].toString(), Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1])];
                };

                return function (source_2) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
                };
            }()(function ($var2) {
                return function () {
                    var projection = function projection(b_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(b_1.ReadData.ReadAt) | 0;
                    };

                    return function (source_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                    };
                }()(function ($var1) {
                    return function () {
                        var predicate = function predicate(b) {
                            return b.ReadData != null;
                        };

                        return function (source) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(predicate, source);
                        };
                    }()(function (tupledArg) {
                        return readBooks(tupledArg[0], tupledArg[1]);
                    }($var1));
                }($var2));
            }($var3));
        }($var6));
    }($var7));
});
var pagesCountByYearOfRead = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var14) {
    return function (source_4) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_4);
    }(function ($var13) {
        return function () {
            var projection_1 = function projection_1(tuple) {
                return tuple[0];
            };

            return function (source_3) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var11, $var12) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var11), projection_1($var12));
                }, source_3);
            };
        }()(function ($var10) {
            return function () {
                var mapping = function mapping(tupledArg_1) {
                    return [tupledArg_1[0].toString(), Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["z" /* sumBy */])(function (b_2) {
                        return b_2.NumPages;
                    }, tupledArg_1[1])];
                };

                return function (source_2) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
                };
            }()(function ($var9) {
                return function () {
                    var projection = function projection(b_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(b_1.ReadData.ReadAt) | 0;
                    };

                    return function (source_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                    };
                }()(function ($var8) {
                    return function () {
                        var predicate = function predicate(b) {
                            return b.ReadData != null;
                        };

                        return function (source) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(predicate, source);
                        };
                    }()(function (tupledArg) {
                        return readBooks(tupledArg[0], tupledArg[1]);
                    }($var8));
                }($var9));
            }($var10));
        }($var13));
    }($var14));
});
var newAuthorsByYears = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var25) {
    return function (source_6) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_6);
    }(function ($var24) {
        return function () {
            var projection_2 = function projection_2(tuple_1) {
                return tuple_1[0];
            };

            return function (source_5) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var22, $var23) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_2($var22), projection_2($var23));
                }, source_5);
            };
        }()(function ($var21) {
            return function () {
                var mapping_1 = function mapping_1(tupledArg_2) {
                    return [tupledArg_2[0].toString(), Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_2[1])];
                };

                return function (source_4) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping_1, source_4);
                };
            }()(function ($var20) {
                return function () {
                    var projection_1 = function projection_1(tuple) {
                        return tuple[1] | 0;
                    };

                    return function (source_3) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection_1, source_3);
                    };
                }()(function ($var19) {
                    return function () {
                        var mapping = function mapping(tupledArg_1) {
                            return [tupledArg_1[0], Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["m" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var17, $var18) {
                                return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])($var17, $var18);
                            }, Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (b_2) {
                                return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(b_2.ReadData.ReadAt);
                            }, tupledArg_1[1])))];
                        };

                        return function (source_2) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_2);
                        };
                    }()(function ($var16) {
                        return function () {
                            var projection = function projection(b_1) {
                                return b_1.AuthorName;
                            };

                            return function (source_1) {
                                return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                            };
                        }()(function ($var15) {
                            return function () {
                                var predicate = function predicate(b) {
                                    return b.ReadData != null;
                                };

                                return function (source) {
                                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(predicate, source);
                                };
                            }()(function (tupledArg) {
                                return readBooks(tupledArg[0], tupledArg[1]);
                            }($var15));
                        }($var16));
                    }($var19));
                }($var20));
            }($var21));
        }($var24));
    }($var25));
});
var averageSpeedByYears = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var32) {
    return function (source_3) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_3);
    }(function ($var31) {
        return function () {
            var projection_1 = function projection_1(tuple) {
                return tuple[0];
            };

            return function (source_2) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var29, $var30) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var29), projection_1($var30));
                }, source_2);
            };
        }()(function ($var28) {
            return function () {
                var mapping = function mapping(tupledArg_1) {
                    return [tupledArg_1[0].toString(), Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["x" /* round */])(Object(__WEBPACK_IMPORTED_MODULE_5__BasicStatsCalculator_fs__["a" /* averageSpeed */])(tupledArg_1[1]), 2)];
                };

                return function (source_1) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_1);
                };
            }()(function ($var27) {
                return function () {
                    var projection = function projection(b) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Date__["m" /* year */])(b.ReadData.ReadAt) | 0;
                    };

                    return function (source) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source);
                    };
                }()(function ($var26) {
                    return function (readBooks_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_5__BasicStatsCalculator_fs__["d" /* validBooks */])(readBooks_1);
                    }(function (tupledArg) {
                        return readBooks(tupledArg[0], tupledArg[1]);
                    }($var26));
                }($var27));
            }($var28));
        }($var31));
    }($var32));
});
var booksByShelves = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function () {
    var shelveBookPairs = function shelveBookPairs(book) {
        if (book.Shelves.length === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["x" /* singleton */])(["no shelf", book]);
        } else {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (s) {
                return [s, book];
            }, book.Shelves);
        }
    };

    return function ($var40) {
        return function (source_4) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_4);
        }(function ($var39) {
            return function () {
                var mapping = function mapping(tupledArg_1) {
                    return [tupledArg_1[0], Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1])];
                };

                return function (source_3) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping, source_3);
                };
            }()(function ($var38) {
                return function () {
                    var projection_1 = function projection_1($var35) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var35[1]) | 0;
                    };

                    return function (source_2) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var36, $var37) {
                            return -Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var36), projection_1($var37));
                        }, source_2);
                    };
                }()(function ($var34) {
                    return function () {
                        var projection = function projection(tuple) {
                            return tuple[0];
                        };

                        return function (source_1) {
                            return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                        };
                    }()(function ($var33) {
                        return function (source) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(shelveBookPairs, source);
                        }(function (tupledArg) {
                            return readBooks(tupledArg[0], tupledArg[1]);
                        }($var33));
                    }($var34));
                }($var38));
            }($var39));
        }($var40));
    };
}());
function yearPeriods(year) {
    if (year == null) {
        return new __WEBPACK_IMPORTED_MODULE_6_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */]();
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["i" /* filter */])(function (tupledArg) {
            return tupledArg[1] <= year ? year <= tupledArg[2] : false;
        }, __WEBPACK_IMPORTED_MODULE_7__Periods_fs__["a" /* periods */]));
    }
}
var booksByPeriods = Object(__WEBPACK_IMPORTED_MODULE_0_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_CurriedLambda__["a" /* default */])(function ($var48) {
    return function (source_4) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(source_4);
    }(function ($var47) {
        return function () {
            var mapping_1 = function mapping_1(tupledArg_1) {
                return [tupledArg_1[0][0], Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(tupledArg_1[1])];
            };

            return function (source_3) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(mapping_1, source_3);
            };
        }()(function ($var46) {
            return function () {
                var projection_1 = function projection_1($var43) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])($var43[1]) | 0;
                };

                return function (source_2) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var44, $var45) {
                        return -Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(projection_1($var44), projection_1($var45));
                    }, source_2);
                };
            }()(function ($var42) {
                return function () {
                    var projection = function projection(tuple) {
                        return tuple[0];
                    };

                    return function (source_1) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Map__["c" /* groupBy */])(projection, source_1);
                    };
                }()(function ($var41) {
                    return function () {
                        var mapping = function mapping(d) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (p) {
                                return [p, d];
                            }, yearPeriods(d.OriginalPublicationYear));
                        };

                        return function (source) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["c" /* collect */])(mapping, source);
                        };
                    }()(function (tupledArg) {
                        return details(tupledArg[0], tupledArg[1]);
                    }($var41));
                }($var42));
            }($var46));
        }($var47));
    }($var48));
});
function random() {
    var random_1 = {};
    return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["w" /* randomNext */])(0, 2147483647) | 0;
}
function randomColors(length) {
    return function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["A" /* take */])(length, source);
    }(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["y" /* sortWith */])(function ($var49, $var50) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Util__["j" /* compare */])(function (_arg1) {
            return random();
        }($var49), function (_arg1) {
            return random();
        }($var50));
    }, __WEBPACK_IMPORTED_MODULE_8__Colors_fs__["b" /* colors */]));
}
function barChartData(data) {
    var colors = Array.from(randomColors(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(data)));
    return new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["c" /* ChartData */](0, new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["d" /* ChartDataWrapper */](Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var51) {
        return $var51[0];
    }, data)), [new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["a" /* BarDataset */](null, Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var52) {
        return $var52[1];
    }, data)), Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (c) {
        return new __WEBPACK_IMPORTED_MODULE_8__Colors_fs__["a" /* Color */](c.R, c.G, c.B, 0.5);
    }, colors)), Array.from(colors), 1)]));
}
function lineChartData(data) {
    return new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["c" /* ChartData */](2, new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["d" /* ChartDataWrapper */](Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var53) {
        return $var53[0];
    }, data)), [new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["l" /* LineDataset */](null, Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var54) {
        return $var54[1];
    }, data)), false, new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["j" /* CubicInterpolationMode */](1))]));
}
function pieChartData(data) {
    var colors = Array.from(randomColors(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["f" /* count */])(data)));
    return new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["c" /* ChartData */](5, new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["d" /* ChartDataWrapper */](Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var55) {
        return $var55[0];
    }, data)), [new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["m" /* PieDataset */](null, Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function ($var56) {
        return $var56[1];
    }, data)), Array.from(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["q" /* map */])(function (c) {
        return new __WEBPACK_IMPORTED_MODULE_8__Colors_fs__["a" /* Color */](c.R, c.G, c.B, 0.5);
    }, colors)), Array.from(colors), 1)]));
}
function scales(_arg1) {
    if (_arg1.tag === 2) {
        return function () {
            var XAxes = [];
            return new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["h" /* ChartScales */]([new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["b" /* ChartAxis */](new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["i" /* ChartTicks */](false))], XAxes);
        }();
    } else if (_arg1.tag === 0) {
        return function () {
            var XAxes_1 = [];
            return new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["h" /* ChartScales */]([new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["b" /* ChartAxis */](new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["i" /* ChartTicks */](true))], XAxes_1);
        }();
    } else {
        return null;
    }
}
function renderChart(data, canvasId, legend) {
    var options = void 0;
    var Scales = scales(data);
    options = new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["g" /* ChartOptions */](Scales, null, legend);
    return Object(__WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["n" /* renderChart */])(new __WEBPACK_IMPORTED_MODULE_9__Fable_Import_Chartjs_fs__["e" /* ChartInfo */](options, data, canvasId));
}
function destroyExistingChart(chart) {
    if (chart == null) {} else {
        chart.Destroy();
    }
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _Promise; });
/* unused harmony export PromiseImpl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Result__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Symbol__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var _Promise = function (__exports) {
    var result = __exports.result = function (a) {
        return a.then(function ($var1) {
            return new __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Result__["a" /* default */](0, $var1);
        }, function ($var2) {
            return new __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Result__["a" /* default */](1, $var2);
        });
    };

    var mapResult = __exports.mapResult = function (fn, a) {
        return a.then(function (result_1) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Result__["b" /* map */])(fn, result_1);
        });
    };

    var bindResult = __exports.bindResult = function (fn, a) {
        return a.then(function (a_1) {
            return a_1.tag === 1 ? Promise.resolve(new __WEBPACK_IMPORTED_MODULE_0__fable_core_1_2_4_fable_core_Result__["a" /* default */](1, a_1.data)) : result(fn(a_1.data));
        });
    };

    var PromiseBuilder = __exports.PromiseBuilder = function () {
        _createClass(PromiseBuilder, [{
            key: __WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Symbol__["a" /* default */].reflection,
            value: function value() {
                return {
                    type: "Fable.PowerPack.Promise.PromiseBuilder",
                    properties: {}
                };
            }
        }]);

        function PromiseBuilder() {
            _classCallCheck(this, PromiseBuilder);
        }

        _createClass(PromiseBuilder, [{
            key: "For",
            value: function For(seq, body) {
                var p = Promise.resolve(null);

                var _loop = function _loop(a) {
                    p = p.then(function () {
                        return body(a);
                    });
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = seq[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var a = _step.value;

                        _loop(a);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return p;
            }
        }, {
            key: "While",
            value: function While(guard, p) {
                var _this = this;

                if (guard()) {
                    return p.then(function () {
                        return _this.While(guard, p);
                    });
                } else {
                    return Promise.resolve(null);
                }
            }
        }, {
            key: "TryFinally",
            value: function TryFinally(p, compensation) {
                return p.then(function (x) {
                    compensation();
                    return x;
                }, function (er) {
                    compensation();
                    throw er;
                });
            }
        }, {
            key: "Delay",
            value: function Delay(generator) {
                return {
                    then: function then(f1, f2) {
                        try {
                            return generator().then(f1, f2);
                        } catch (er) {
                            if (f2 == null) {
                                return Promise.reject(er);
                            } else {
                                try {
                                    return Promise.resolve(f2(er));
                                } catch (er_1) {
                                    return Promise.reject(er_1);
                                }
                            }
                        }
                    },
                    catch: function _catch(f) {
                        try {
                            return generator().catch(f);
                        } catch (er_2) {
                            try {
                                return Promise.resolve(f(er_2));
                            } catch (er_3) {
                                return Promise.reject(er_3);
                            }
                        }
                    }
                };
            }
        }, {
            key: "Using",
            value: function Using(resource, binder) {
                return this.TryFinally(binder(resource), function () {
                    resource.Dispose();
                });
            }
        }]);

        return PromiseBuilder;
    }();

    Object(__WEBPACK_IMPORTED_MODULE_1__fable_core_1_2_4_fable_core_Symbol__["c" /* setType */])("Fable.PowerPack.Promise.PromiseBuilder", PromiseBuilder);
    return __exports;
}({});


var PromiseImpl = function (__exports) {
    var promise = __exports.promise = new _Promise.PromiseBuilder();
    return __exports;
}({});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export booksPerPage */
/* unused harmony export downloadReadBooksOnPage */
/* unused harmony export downloadBooksDetailsOnPage */
/* unused harmony export pagesCount */
/* harmony export (immutable) */ __webpack_exports__["a"] = startDownloadReadBooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_fs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Model_fs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__ = __webpack_require__(2);






var booksPerPage = 50;
function downloadReadBooksOnPage(accessToken, accessTokenSecret, callback, page) {
    var url = Object(__WEBPACK_IMPORTED_MODULE_0__Utils_fs__["a" /* completeUrl */])("readBooks", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("?token=%s&tokenSecret=%s&perPage=%i&page=%i", 4))(accessToken, accessTokenSecret, ~~booksPerPage, page));

    (function (pr) {
        return pr.then(callback);
    })(Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__["a" /* fetchAs */])(url, new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](), {
        T: __WEBPACK_IMPORTED_MODULE_4__Model_fs__["j" /* ReadBooks */]
    }));
}
function downloadBooksDetailsOnPage(accessToken, accessTokenSecret, callback, page) {
    var url = Object(__WEBPACK_IMPORTED_MODULE_0__Utils_fs__["a" /* completeUrl */])("readBookDetails", Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["e" /* toText */])(Object(__WEBPACK_IMPORTED_MODULE_1_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_String__["c" /* printf */])("?token=%s&tokenSecret=%s&perPage=%i&page=%i", 4))(accessToken, accessTokenSecret, ~~booksPerPage, page));

    (function (pr) {
        return pr.then(callback);
    })(Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__["a" /* fetchAs */])(url, new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](), {
        T: __WEBPACK_IMPORTED_MODULE_4__Model_fs__["e" /* BookDetails */]
    }));
}
function pagesCount(booksCount) {
    return ~~Math.ceil(booksCount / booksPerPage) | 0;
}
function startDownloadReadBooks(accessToken, accessTokenSecret, callback, detailsCallback) {
    var getReadBooks = function getReadBooks(booksCount) {
        Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["o" /* iterate */])(function (page) {
            downloadReadBooksOnPage(accessToken, accessTokenSecret, callback, page);
        }, Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["B" /* toList */])(Object(__WEBPACK_IMPORTED_MODULE_5_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_Seq__["t" /* range */])(1, pagesCount(booksCount.Count))));
    };

    var readBooksCountUrl = Object(__WEBPACK_IMPORTED_MODULE_0__Utils_fs__["c" /* completeUrlWithToken */])("readBooksCount", accessToken, accessTokenSecret);

    (function (pr) {
        return pr.then(getReadBooks);
    })(Object(__WEBPACK_IMPORTED_MODULE_2_C_Users_MV_nuget_packages_fable_powerpack_1_3_1_fable_src_Fetch_fs__["a" /* fetchAs */])(readBooksCountUrl, new __WEBPACK_IMPORTED_MODULE_3_C_Users_MV_nuget_packages_fable_core_1_2_4_fable_core_List__["b" /* default */](), {
        T: __WEBPACK_IMPORTED_MODULE_4__Model_fs__["g" /* BooksCount */]
    }));
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js